'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *               AutoNumeric.js
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @version      4.5.1
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @date         2018-10-28 UTC 07:14
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @authors      Bob Knothe, Alexandre Bonneau
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @contributors Sokolov Yura and others, cf. AUTHORS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @copyright    2009 Robert J. Knothe
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @since        2009-08-09
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @summary      autoNumeric is a standalone Javascript library
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *               that provides live *as-you-type* formatting for
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *               international numbers and currencies.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @link         http://autonumeric.org
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *               Note : Some functions are borrowed from big.js
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @see          https://github.com/MikeMcl/big.js/
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Please report any bugs to https://github.com/autoNumeric/autoNumeric
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @license      Released under the MIT License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @link         http://www.opensource.org/licenses/mit-license.php
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Permission is hereby granted, free of charge, to any person
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * obtaining a copy of this software and associated documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * files (the "Software"), to deal in the Software without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * restriction, including without limitation the rights to use,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * copy, modify, merge, publish, distribute, sub license, and/or sell
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * copies of the Software, and to permit persons to whom the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Software is furnished to do so, subject to the following
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * conditions:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * The above copyright notice and this permission notice shall be
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * included in all copies or substantial portions of the Software.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OTHER DEALINGS IN THE SOFTWARE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

//TODO Prevent having to enter relative path in the js files (ie. using `./AutoNumericHelper` instead of just `AutoNumericHelper`) (cf. http://moduscreate.com/es6-es2015-import-no-relative-path-webpack/)


var _AutoNumericHelper = require('./AutoNumericHelper');

var _AutoNumericHelper2 = _interopRequireDefault(_AutoNumericHelper);

var _AutoNumericEnum = require('./AutoNumericEnum');

var _AutoNumericEnum2 = _interopRequireDefault(_AutoNumericEnum);

var _Evaluator = require('./maths/Evaluator');

var _Evaluator2 = _interopRequireDefault(_Evaluator);

var _Parser = require('./maths/Parser');

var _Parser2 = _interopRequireDefault(_Parser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class declaration for the AutoNumeric object.
 *
 * An AutoNumeric element is an object wrapper that keeps a reference to the DOM element it manages (usually an <input> one), and provides autoNumeric-specific variables and functions.
 */
var AutoNumeric = function () {
    /**
     * Initialize the AutoNumeric object onto the given DOM element, and attach the settings and related event listeners to it.
     * The options passed as a parameter is an object that contains the settings (ie. {digitGroupSeparator: ".", decimalCharacter: ",", currencySymbol: '€ '})
     *
     * @example
     * anElement = new AutoNumeric(domElement); // With the default options
     * anElement = new AutoNumeric(domElement, { options }); // With one option object
     * anElement = new AutoNumeric(domElement, 'euroPos'); // With a named pre-defined string
     * anElement = new AutoNumeric(domElement, [{ options1 }, 'euroPos', { options2 }]); // With multiple option objects (the latest option overwriting the previous ones)
     * anElement = new AutoNumeric(domElement, null, { options }); // With one option object, and a failed initial value
     * anElement = new AutoNumeric(domElement).french(); // With one pre-defined language object
     * anElement = new AutoNumeric(domElement).french({ options });// With one pre-defined language object and additional options that will override the defaults
     *
     * // ...or init and set the value in one call :
     * anElement = new AutoNumeric(domElement, 12345.789); // With the default options, and an initial value
     * anElement = new AutoNumeric(domElement, 12345.789, { options });
     * anElement = new AutoNumeric(domElement, '12345.789', { options });
     * anElement = new AutoNumeric(domElement, 12345.789, 'euroPos');
     * anElement = new AutoNumeric(domElement, 12345.789, [{ options1 }, 'euroPos', { options2 }]);
     * anElement = new AutoNumeric(domElement, 12345.789).french({ options });
     * anElement = new AutoNumeric(domElement, 12345.789, { options }).french({ options }); // Not really helpful, but possible
     *
     * // The AutoNumeric constructor class can also accept a string as a css selector. Under the hood this use `QuerySelector` and limit itself to only the first element it finds.
     * anElement = new AutoNumeric('.myCssClass > input');
     * anElement = new AutoNumeric('.myCssClass > input', { options });
     * anElement = new AutoNumeric('.myCssClass > input', 'euroPos');
     * anElement = new AutoNumeric('.myCssClass > input', [{ options1 }, 'euroPos', { options2 }]);
     * anElement = new AutoNumeric('.myCssClass > input', 12345.789);
     * anElement = new AutoNumeric('.myCssClass > input', 12345.789, { options });
     * anElement = new AutoNumeric('.myCssClass > input', 12345.789, 'euroPos');
     * anElement = new AutoNumeric('.myCssClass > input', 12345.789, [{ options1 }, 'euroPos', { options2 }]);
     * anElement = new AutoNumeric('.myCssClass > input', null, { options }); // With a failed initial value
     * anElement = new AutoNumeric('.myCssClass > input', 12345.789).french({ options });
     *
     * @param {object|Array|number|string} arg1
     * @param {object|Array|number|string|null} arg2
     * @param {object|Array|number|string|null} arg3
     * @throws
     */
    function AutoNumeric() {
        var arg1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        var _this = this;

        var arg2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var arg3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        _classCallCheck(this, AutoNumeric);

        // --------------------------------------------------------
        // -------------- Initialization
        // Initialize the arguments
        var _AutoNumeric$_setArgu = AutoNumeric._setArgumentsValues(arg1, arg2, arg3),
            domElement = _AutoNumeric$_setArgu.domElement,
            initialValue = _AutoNumeric$_setArgu.initialValue,
            userOptions = _AutoNumeric$_setArgu.userOptions;

        // Initialize the element


        this.domElement = domElement;

        // Generate the settings
        this.defaultRawValue = ''; // The default raw value to set when initializing an AutoNumeric object
        this._setSettings(userOptions, false);
        //TODO If `styleRules` is not null, add by default a class 'autoNumeric' that adds transition to color, background-color, border-color properties
        // Check if the DOM element is supported
        this._checkElement();

        // Store the additional attributes inside the AutoNumeric object
        // Note: This variable is needed and not a duplicate of `initialValueOnKeydown` nor `valueOnFocus` since it serves a different purpose and has a different lifecycle
        this.savedCancellableValue = null;

        // Initialize the undo/redo variables
        this.historyTable = []; // Keep track of *all* valid states of the element value
        this.historyTableIndex = -1; // Pointer to the current undo/redo state. This will be set to '0' during initialization since it first adds itself.
        this.onGoingRedo = false; // Variable that keeps track if a 'redo' is ongoing (in order to prevent an 'undo' to be launch when releasing the shift key before the ctrl key after a 'redo' shortcut)

        // Initialize the parent form element, if any
        this.parentForm = this._getParentForm();

        // Set the initial value if it exists and if the `formatOnPageLoad` option will allow it
        if (!this.runOnce && this.settings.formatOnPageLoad) {
            // Format the element value if needed
            this._formatDefaultValueOnPageLoad(initialValue);
        } else {
            // Otherwise set the `rawValue` and the element value, but do not format the latter yet
            var valueToSet = void 0;
            if (_AutoNumericHelper2.default.isNull(initialValue)) {
                switch (this.settings.emptyInputBehavior) {
                    case AutoNumeric.options.emptyInputBehavior.min:
                        valueToSet = this.settings.minimumValue;
                        break;
                    case AutoNumeric.options.emptyInputBehavior.max:
                        valueToSet = this.settings.maximumValue;
                        break;
                    case AutoNumeric.options.emptyInputBehavior.zero:
                        valueToSet = '0';
                        break;
                    // In order to stay consistent when `formatOnPageLoad` is set to `true`, it's still impossible to set the `null` value as the initial value
                    case AutoNumeric.options.emptyInputBehavior.focus:
                    case AutoNumeric.options.emptyInputBehavior.press:
                    case AutoNumeric.options.emptyInputBehavior.always:
                    case AutoNumeric.options.emptyInputBehavior.null:
                        valueToSet = '';
                        break;
                    // When `emptyInputBehavior` is a number or a string representing a number
                    default:
                        valueToSet = this.settings.emptyInputBehavior;
                }
            } else {
                valueToSet = initialValue;
            }

            this._setElementAndRawValue(valueToSet);
        }

        this.runOnce = true;

        // Add the events listeners only on input or editable elements
        this.hasEventListeners = false;
        if (this.isInputElement || this.isContentEditable) {
            if (!this.settings.noEventListeners) {
                //XXX Here we make sure the global list is created after creating the event listeners, to only create the event listeners on `document` once
                this._createEventListeners();
            }

            this._setWritePermissions(true);
        }

        // Save the initial values (html attribute + element.value) for the pristine test
        this._saveInitialValues(initialValue);

        // Setup the data for the persistent storage solution (ie. sessionStorage or cookies)
        this.sessionStorageAvailable = this.constructor._storageTest();
        this.storageNamePrefix = 'AUTO_'; // The prefix for the raw value storage name variable can be modified here
        this._setPersistentStorageName();

        // --------------------------------------------------------
        // -------------- Tracking
        // Keep track if the element is currently focused
        this.isFocused = false;
        // Keep track if a mouse wheel event is currently ongoing
        this.isWheelEvent = false;
        // Keep track if a drop event is currently ongoing
        this.isDropEvent = false;
        // Keep track if the user is currently editing the element
        this.isEditing = false;
        // Keep track of the rawValue (needed to define if a change event must be sent on blur or enter key)
        this.rawValueOnFocus = void 0;
        // Watch any external changes to the element value/textContent/nodeValue and `set()` the new value so that it gets formatted/saved in the history
        this.internalModification = false; // This is temporarily set to `true` only when the AutoNumeric object does update the element value
        this.attributeToWatch = this._getAttributeToWatch();
        this.getterSetter = Object.getOwnPropertyDescriptor(this.domElement.__proto__, this.attributeToWatch);
        this._addWatcher();

        if (this.settings.createLocalList) {
            // Keep track of every AutoNumeric elements that this object initialized
            this._createLocalList();
        }

        // Keep track of all AutoNumeric elements in the current web page
        this.constructor._addToGlobalList(this);

        // --------------------------------------------------------
        // -------------- Methods
        // Create the global functions
        this.global = {
            /**
             * Set the same given element value for each elements in the local AutoNumeric element list, and format those elements immediately
             *
             * @param {number|string} newValue The value must be a number or a numeric string
             * @param {object} options A settings object that will override the current settings. Note: the update is done only if the `newValue` is defined.
             */
            set: function set(newValue) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                _this.autoNumericLocalList.forEach(function (aNObject) {
                    aNObject.set(newValue, options);
                });
            },

            /**
             * Set the value given value directly as the DOM element value, without formatting it beforehand.
             * This sets the same unformatted value for each elements in the local AutoNumeric element list.
             *
             * @param {number|string} value
             * @param {object} options
             */
            setUnformatted: function setUnformatted(value) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                _this.autoNumericLocalList.forEach(function (aNObject) {
                    aNObject.setUnformatted(value, options);
                });
            },

            /**
             * This is an alias of the `getNumericString()` function, and should not be used anymore.
             *
             * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
             * @returns {Array<string>}
             * @deprecated
             */
            get: function get() {
                var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                var result = [];
                _this.autoNumericLocalList.forEach(function (aNObject) {
                    result.push(aNObject.get());
                });
                _this._executeCallback(result, callback);

                return result;
            },

            /**
             * Return an array of the unformatted values (as a string) of each AutoNumeric element of the local AutoNumeric element list
             *
             * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
             * @returns {Array<string>}
             */
            getNumericString: function getNumericString() {
                var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                var result = [];
                _this.autoNumericLocalList.forEach(function (aNObject) {
                    result.push(aNObject.getNumericString());
                });
                _this._executeCallback(result, callback);

                return result;
            },

            /**
             * Return an array of the current formatted values (as a string) of each AutoNumeric element of the local AutoNumeric element list
             *
             * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
             * @returns {Array<string>}
             */
            getFormatted: function getFormatted() {
                var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                var result = [];
                _this.autoNumericLocalList.forEach(function (aNObject) {
                    result.push(aNObject.getFormatted());
                });
                _this._executeCallback(result, callback);

                return result;
            },

            /**
             * Return an array of the element unformatted values (as a real Javascript number), for each element of the local AutoNumeric element list
             *
             * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
             * @returns {Array<number>}
             */
            getNumber: function getNumber() {
                var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                var result = [];
                _this.autoNumericLocalList.forEach(function (aNObject) {
                    result.push(aNObject.getNumber());
                });
                _this._executeCallback(result, callback);

                return result;
            },

            /**
             * Returns the unformatted values (following the `outputFormat` setting) of each element of the local AutoNumeric element list into an array
             *
             * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
             * @returns {Array<string>}
             */
            getLocalized: function getLocalized() {
                var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                var result = [];
                _this.autoNumericLocalList.forEach(function (aNObject) {
                    result.push(aNObject.getLocalized());
                });
                _this._executeCallback(result, callback);

                return result;
            },

            /**
             * Force each element of the local AutoNumeric element list to reformat its value
             */
            reformat: function reformat() {
                _this.autoNumericLocalList.forEach(function (aNObject) {
                    aNObject.reformat();
                });
            },

            /**
             * Remove the formatting and keep only the raw unformatted value (as a numericString) in each elements of the local AutoNumeric element list
             */
            unformat: function unformat() {
                _this.autoNumericLocalList.forEach(function (aNObject) {
                    aNObject.unformat();
                });
            },

            /**
             * Remove the formatting and keep only the localized unformatted value in the element, with the option to override the default outputFormat if needed
             *
             * @param {null|string} forcedOutputFormat If set to something different than `null`, then this is used as an overriding outputFormat option
             */
            unformatLocalized: function unformatLocalized() {
                var forcedOutputFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                _this.autoNumericLocalList.forEach(function (aNObject) {
                    aNObject.unformatLocalized(forcedOutputFormat);
                });
            },

            /**
             * Updates the AutoNumeric settings, and immediately format the elements accordingly, for each elements of the local AutoNumeric element list
             *
             * @param {object} newOptions This can be either one or more option objects
             */
            update: function update() {
                for (var _len = arguments.length, newOptions = Array(_len), _key = 0; _key < _len; _key++) {
                    newOptions[_key] = arguments[_key];
                }

                _this.autoNumericLocalList.forEach(function (aNObject) {
                    aNObject.update.apply(aNObject, newOptions);
                });
            },

            /**
             * Return `true` if *all* the autoNumeric-managed elements are pristine, if their raw value hasn't changed.
             * By default, this returns `true` if the raw unformatted value is still the same even if the formatted one has changed (due to a configuration update for instance).
             *
             * @param {boolean} checkOnlyRawValue If set to `true`, the pristine value is done on the raw unformatted value, not the formatted one. If set to `false`, this also checks that the formatted value hasn't changed.
             * @returns {boolean}
             */
            isPristine: function isPristine() {
                var checkOnlyRawValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                var isPristine = true;
                _this.autoNumericLocalList.forEach(function (aNObject) {
                    if (isPristine && !aNObject.isPristine(checkOnlyRawValue)) {
                        isPristine = false;
                    }
                });

                return isPristine;
            },

            /**
             * Execute the `clear()` method on each AutoNumeric object in the local AutoNumeric element list
             *
             * @param {boolean} forceClearAll
             */
            clear: function clear() {
                var forceClearAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                _this.autoNumericLocalList.forEach(function (aNObject) {
                    aNObject.clear(forceClearAll);
                });
            },

            /**
             * Execute the `remove()` method on each AutoNumeric object in the local AutoNumeric element list
             */
            remove: function remove() {
                _this.autoNumericLocalList.forEach(function (aNObject) {
                    aNObject.remove();
                });
            },

            /**
             * Execute the `wipe()` method on each AutoNumeric object in the local AutoNumeric element list
             */
            wipe: function wipe() {
                _this.autoNumericLocalList.forEach(function (aNObject) {
                    aNObject.wipe();
                });
            },

            /**
             * Execute the `nuke()` method on each AutoNumeric object in the local AutoNumeric element list
             */
            nuke: function nuke() {
                _this.autoNumericLocalList.forEach(function (aNObject) {
                    aNObject.nuke();
                });
            },

            /**
             * Return `true` if the given AutoNumeric object (or DOM element) is in the local AutoNumeric element list
             *
             * @param {HTMLElement|HTMLInputElement|AutoNumeric} domElementOrAutoNumericObject
             * @returns {*}
             */
            has: function has(domElementOrAutoNumericObject) {
                var result = void 0;
                if (domElementOrAutoNumericObject instanceof AutoNumeric) {
                    result = _this.autoNumericLocalList.has(domElementOrAutoNumericObject.node());
                } else {
                    result = _this.autoNumericLocalList.has(domElementOrAutoNumericObject);
                }

                return result;
            },

            /**
             * Add an existing AutoNumeric object (or DOM element) to the local AutoNumeric element list, using the DOM element as the key.
             * This manages the case where `addObject` is used on an AutoNumeric object that already has multiple elements in its local list.
             *
             * @param {HTMLElement|HTMLInputElement|AutoNumeric} domElementOrAutoNumericObject
             */
            addObject: function addObject(domElementOrAutoNumericObject) {
                // Start with the same data, whatever the user passed as arguments
                var domElement = void 0;
                var otherAutoNumericObject = void 0;
                if (domElementOrAutoNumericObject instanceof AutoNumeric) {
                    domElement = domElementOrAutoNumericObject.node();
                    otherAutoNumericObject = domElementOrAutoNumericObject;
                } else {
                    domElement = domElementOrAutoNumericObject;
                    otherAutoNumericObject = AutoNumeric.getAutoNumericElement(domElement);
                }

                // Check if the current autoNumeric object has a local list
                if (!_this._hasLocalList()) {
                    _this._createLocalList();
                }

                // Check if the other autoNumeric object has a local list...
                var otherANLocalList = otherAutoNumericObject._getLocalList();
                if (otherANLocalList.size === 0) {
                    // Special case if the other AutoNumeric object has an empty local list, then populate itself to it
                    otherAutoNumericObject._createLocalList();
                    otherANLocalList = otherAutoNumericObject._getLocalList(); // Update the other local list
                }

                var mergedLocalLists = void 0;
                if (otherANLocalList instanceof Map) {
                    // ...If it does, merge the local lists together
                    mergedLocalLists = _AutoNumericHelper2.default.mergeMaps(_this._getLocalList(), otherANLocalList);
                } else {
                    // ...If not, just set the current local list onto the other AutoNumeric object
                    // We need to specify the AutoNumeric object, otherwise the `_addToLocalList` function would not correctly add the AutoNumeric object since we would not have a reference to it, but a reference to the current AutoNumeric object on which is called this method.
                    _this._addToLocalList(domElement, otherAutoNumericObject);
                    mergedLocalLists = _this._getLocalList();
                }

                // Update the resulting list, on all the objects of that local list (so that we can indifferently use `init()` on any object belonging to that list)
                mergedLocalLists.forEach(function (aNObject) {
                    aNObject._setLocalList(mergedLocalLists);
                });
            },

            /**
             * Remove the given AutoNumeric object (or DOM element) from the local AutoNumeric element list, using the DOM element as the key.
             * If this function attempts to remove the current AutoNumeric object from the local list, a warning is shown, but the deletion is still done.
             *
             * Special cases :
             * - If the current object removes itself, then it's removed from the shared local list, then a new empty local list is used/created
             * - If another object remove this object, then a local list with only this object is used/created
             *
             * @param {HTMLElement|HTMLInputElement|AutoNumeric} domElementOrAutoNumericObject
             * @param {boolean} keepCurrentANObject If set to `false`, then the function will also remove the current AutoNumeric object if asked, otherwise it will ignore it and print a warning message
             */
            removeObject: function removeObject(domElementOrAutoNumericObject) {
                var keepCurrentANObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                // Start with the same data, whatever the user passed as arguments
                var domElement = void 0;
                var otherAutoNumericObject = void 0;
                if (domElementOrAutoNumericObject instanceof AutoNumeric) {
                    domElement = domElementOrAutoNumericObject.node();
                    otherAutoNumericObject = domElementOrAutoNumericObject;
                } else {
                    domElement = domElementOrAutoNumericObject;
                    otherAutoNumericObject = AutoNumeric.getAutoNumericElement(domElement);
                }

                // Remove the other object from the local list
                var initialCompleteLocalList = _this.autoNumericLocalList;
                _this.autoNumericLocalList.delete(domElement);

                // Update the local list for all objects in it
                initialCompleteLocalList.forEach(function (aNObject) {
                    aNObject._setLocalList(_this.autoNumericLocalList);
                });

                if (!keepCurrentANObject && domElement === _this.node()) {
                    // This object is removed by itself
                    // Empty the object local list
                    otherAutoNumericObject._setLocalList(new Map());
                } else {
                    // This object is removed by another object
                    // Set the local list for the removed object, with only this object in it
                    otherAutoNumericObject._createLocalList();
                }
            },

            /**
             * Remove all elements from the shared list, effectively emptying it.
             * This is the equivalent of calling `detach()` on each of its elements.
             *
             * @param {boolean} keepEachANObjectInItsOwnList If set to `true`, then instead of completely emptying the local list of each AutoNumeric objects, each one of those keeps itself in its own local list
             */
            empty: function empty() {
                var keepEachANObjectInItsOwnList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                var initialCompleteLocalList = _this.autoNumericLocalList;

                // Update the local list for all objects in it
                initialCompleteLocalList.forEach(function (aNObject) {
                    if (keepEachANObjectInItsOwnList) {
                        aNObject._createLocalList();
                    } else {
                        aNObject._setLocalList(new Map());
                    }
                });
            },

            /**
             * Return an array containing all the AutoNumeric DOM elements that have been initialized by each other
             *
             * @returns {Array<HTMLElement>}
             */
            elements: function elements() {
                var result = [];
                _this.autoNumericLocalList.forEach(function (aNObject) {
                    result.push(aNObject.node());
                });

                return result;
            },

            /**
             * Return the `Map` object directly
             * @returns {Map}
             */
            getList: function getList() {
                return _this.autoNumericLocalList;
            },

            /**
             * Return the number of element in the local AutoNumeric element list
             * @returns {number}
             */
            size: function size() {
                return _this.autoNumericLocalList.size;
            }
        };

        // Create the functions that will allow to change each setting one by one
        /**
         * For each options, we define if we need to reformat the element content (does changing the options should change the way its value is displayed?).
         * If yes, then we use the `update()` for force a reformat, otherwise, we just update the `settings` object.
         */
        this.options = {
            /**
             * Reset any options set previously, by overwriting them with the default settings
             *
             * @returns {AutoNumeric}
             */
            reset: function reset() {
                //TODO Add a `settings` parameter so that the user can reset to a specific set of settings. This is different than update since it drops any non-default settings before using those new settings.
                _this.settings = { rawValue: _this.defaultRawValue }; // Here we pass the default rawValue in order to prevent showing a warning that we try to set an `undefined` value
                _this.update(AutoNumeric.defaultSettings);

                return _this;
            },
            allowDecimalPadding: function allowDecimalPadding(_allowDecimalPadding) {
                _this.update({ allowDecimalPadding: _allowDecimalPadding });

                return _this;
            },
            alwaysAllowDecimalCharacter: function alwaysAllowDecimalCharacter(_alwaysAllowDecimalCharacter) {
                //FIXME Test this
                _this.update({ alwaysAllowDecimalCharacter: _alwaysAllowDecimalCharacter });

                return _this;
            },
            caretPositionOnFocus: function caretPositionOnFocus(_caretPositionOnFocus) {
                //FIXME test this
                _this.settings.caretPositionOnFocus = _caretPositionOnFocus;

                return _this;
            },
            createLocalList: function createLocalList(_createLocalList2) {
                _this.settings.createLocalList = _createLocalList2;

                // Delete the local list when this is set to `false`, create it if this is set to `true` and there is not pre-existing list
                if (_this.settings.createLocalList) {
                    if (!_this._hasLocalList()) {
                        _this._createLocalList();
                    }
                } else {
                    _this._deleteLocalList();
                }

                return _this;
            },
            currencySymbol: function currencySymbol(_currencySymbol) {
                _this.update({ currencySymbol: _currencySymbol });

                return _this;
            },
            currencySymbolPlacement: function currencySymbolPlacement(_currencySymbolPlacement) {
                _this.update({ currencySymbolPlacement: _currencySymbolPlacement });

                return _this;
            },
            decimalCharacter: function decimalCharacter(_decimalCharacter) {
                _this.update({ decimalCharacter: _decimalCharacter });

                return _this;
            },
            decimalCharacterAlternative: function decimalCharacterAlternative(_decimalCharacterAlternative) {
                _this.settings.decimalCharacterAlternative = _decimalCharacterAlternative;

                return _this;
            },
            /**
             * Update the decimal places globally, which means this override any previously set number of decimal shown on focus, on blur, or in the raw value.
             *
             * @param {int} decimalPlaces
             * @returns {AutoNumeric}
             */
            decimalPlaces: function decimalPlaces(_decimalPlaces) {
                _AutoNumericHelper2.default.warning('Using `options.decimalPlaces()` instead of calling the specific `options.decimalPlacesRawValue()`, `options.decimalPlacesShownOnFocus()` and `options.decimalPlacesShownOnBlur()` methods will reset those options.\nPlease call the specific methods if you do not want to reset those.', _this.settings.showWarnings);
                _this.update({ decimalPlaces: _decimalPlaces });

                return _this;
            },
            decimalPlacesRawValue: function decimalPlacesRawValue(_decimalPlacesRawValue) {
                //FIXME test this
                _this.update({ decimalPlacesRawValue: _decimalPlacesRawValue });

                return _this;
            },
            decimalPlacesShownOnBlur: function decimalPlacesShownOnBlur(_decimalPlacesShownOnBlur) {
                _this.update({ decimalPlacesShownOnBlur: _decimalPlacesShownOnBlur });

                return _this;
            },
            decimalPlacesShownOnFocus: function decimalPlacesShownOnFocus(_decimalPlacesShownOnFocus) {
                _this.update({ decimalPlacesShownOnFocus: _decimalPlacesShownOnFocus });

                return _this;
            },
            defaultValueOverride: function defaultValueOverride(_defaultValueOverride) {
                _this.update({ defaultValueOverride: _defaultValueOverride });

                return _this;
            },
            digitalGroupSpacing: function digitalGroupSpacing(_digitalGroupSpacing) {
                _this.update({ digitalGroupSpacing: _digitalGroupSpacing });

                return _this;
            },
            digitGroupSeparator: function digitGroupSeparator(_digitGroupSeparator) {
                _this.update({ digitGroupSeparator: _digitGroupSeparator });

                return _this;
            },
            divisorWhenUnfocused: function divisorWhenUnfocused(_divisorWhenUnfocused) {
                _this.update({ divisorWhenUnfocused: _divisorWhenUnfocused });

                return _this;
            },
            emptyInputBehavior: function emptyInputBehavior(_emptyInputBehavior) {
                if (_this.rawValue === null && _emptyInputBehavior !== AutoNumeric.options.emptyInputBehavior.null) {
                    // Special case : if the current `rawValue` is `null` and the `emptyInputBehavior` is changed to something else than `'null'`, then it makes that `rawValue` invalid.
                    // Here we can either prevent the option update and throw an error, or still accept the option update and update the value from `null` to `''`.
                    // We cannot keep `rawValue` to `null` since if `emptyInputBehavior` is not set to `null`, lots of function assume `rawValue` is a string.
                    _AutoNumericHelper2.default.warning('You are trying to modify the `emptyInputBehavior` option to something different than `\'null\'` (' + _emptyInputBehavior + '), but the element raw value is currently set to `null`. This would result in an invalid `rawValue`. In order to fix that, the element value has been changed to the empty string `\'\'`.', _this.settings.showWarnings);
                    _this.rawValue = '';
                }

                _this.update({ emptyInputBehavior: _emptyInputBehavior });

                return _this;
            },
            eventBubbles: function eventBubbles(_eventBubbles) {
                _this.settings.eventBubbles = _eventBubbles;

                return _this;
            },
            eventIsCancelable: function eventIsCancelable(_eventIsCancelable) {
                _this.settings.eventIsCancelable = _eventIsCancelable;

                return _this;
            },
            failOnUnknownOption: function failOnUnknownOption(_failOnUnknownOption) {
                _this.settings.failOnUnknownOption = _failOnUnknownOption; //FIXME test this

                return _this;
            },
            formatOnPageLoad: function formatOnPageLoad(_formatOnPageLoad) {
                _this.settings.formatOnPageLoad = _formatOnPageLoad; //FIXME test this

                return _this;
            },
            formulaMode: function formulaMode(_formulaMode) {
                _this.settings.formulaMode = _formulaMode; //FIXME Test this

                return _this;
            },
            historySize: function historySize(_historySize) {
                _this.settings.historySize = _historySize;

                return _this;
            },
            isCancellable: function isCancellable(_isCancellable) {
                _this.settings.isCancellable = _isCancellable; //FIXME test this

                return _this;
            },
            leadingZero: function leadingZero(_leadingZero) {
                _this.update({ leadingZero: _leadingZero });

                return _this;
            },
            maximumValue: function maximumValue(_maximumValue) {
                _this.update({ maximumValue: _maximumValue });

                return _this;
            },
            minimumValue: function minimumValue(_minimumValue) {
                _this.update({ minimumValue: _minimumValue });

                return _this;
            },
            modifyValueOnWheel: function modifyValueOnWheel(_modifyValueOnWheel) {
                _this.settings.modifyValueOnWheel = _modifyValueOnWheel; //FIXME test this

                return _this;
            },
            negativeBracketsTypeOnBlur: function negativeBracketsTypeOnBlur(_negativeBracketsTypeOnBlur) {
                _this.update({ negativeBracketsTypeOnBlur: _negativeBracketsTypeOnBlur });

                return _this;
            },
            negativePositiveSignPlacement: function negativePositiveSignPlacement(_negativePositiveSignPlacement) {
                _this.update({ negativePositiveSignPlacement: _negativePositiveSignPlacement });

                return _this;
            },
            negativeSignCharacter: function negativeSignCharacter(_negativeSignCharacter) {
                _this.update({ negativeSignCharacter: _negativeSignCharacter });

                return _this;
            },
            noEventListeners: function noEventListeners(_noEventListeners) {
                //FIXME test this
                if (_noEventListeners === AutoNumeric.options.noEventListeners.noEvents && _this.settings.noEventListeners === AutoNumeric.options.noEventListeners.addEvents) {
                    // Remove the events once
                    _this._removeEventListeners();
                }

                _this.update({ noEventListeners: _noEventListeners });

                return _this;
            },
            onInvalidPaste: function onInvalidPaste(_onInvalidPaste) {
                _this.settings.onInvalidPaste = _onInvalidPaste; //FIXME test this

                return _this;
            },
            outputFormat: function outputFormat(_outputFormat) {
                _this.settings.outputFormat = _outputFormat;

                return _this;
            },
            overrideMinMaxLimits: function overrideMinMaxLimits(_overrideMinMaxLimits) {
                _this.update({ overrideMinMaxLimits: _overrideMinMaxLimits });

                return _this;
            },
            positiveSignCharacter: function positiveSignCharacter(_positiveSignCharacter) {
                _this.update({ positiveSignCharacter: _positiveSignCharacter });

                return _this;
            },
            rawValueDivisor: function rawValueDivisor(_rawValueDivisor) {
                _this.update({ rawValueDivisor: _rawValueDivisor });

                return _this;
            },
            readOnly: function readOnly(_readOnly) {
                // When changing the readOnly attribute, the raw and formatted values do not change, so no need to call the costly 'update()` method
                _this.settings.readOnly = _readOnly;
                _this._setWritePermissions();

                return _this;
            },
            roundingMethod: function roundingMethod(_roundingMethod) {
                _this.update({ roundingMethod: _roundingMethod });

                return _this;
            },
            saveValueToSessionStorage: function saveValueToSessionStorage(_saveValueToSessionStorage) {
                _this.update({ saveValueToSessionStorage: _saveValueToSessionStorage });

                return _this;
            },
            symbolWhenUnfocused: function symbolWhenUnfocused(_symbolWhenUnfocused) {
                _this.update({ symbolWhenUnfocused: _symbolWhenUnfocused });

                return _this;
            },
            selectNumberOnly: function selectNumberOnly(_selectNumberOnly) {
                _this.settings.selectNumberOnly = _selectNumberOnly; //FIXME test this

                return _this;
            },
            selectOnFocus: function selectOnFocus(_selectOnFocus) {
                _this.settings.selectOnFocus = _selectOnFocus; //FIXME test this

                return _this;
            },
            serializeSpaces: function serializeSpaces(_serializeSpaces) {
                _this.settings.serializeSpaces = _serializeSpaces; //FIXME test this

                return _this;
            },
            showOnlyNumbersOnFocus: function showOnlyNumbersOnFocus(_showOnlyNumbersOnFocus) {
                _this.update({ showOnlyNumbersOnFocus: _showOnlyNumbersOnFocus });

                return _this;
            },
            showPositiveSign: function showPositiveSign(_showPositiveSign) {
                _this.update({ showPositiveSign: _showPositiveSign });

                return _this;
            },
            showWarnings: function showWarnings(_showWarnings) {
                _this.settings.showWarnings = _showWarnings; //FIXME test this

                return _this;
            },
            styleRules: function styleRules(_styleRules) {
                _this.update({ styleRules: _styleRules });

                return _this;
            },
            suffixText: function suffixText(_suffixText) {
                _this.update({ suffixText: _suffixText });

                return _this;
            },
            unformatOnHover: function unformatOnHover(_unformatOnHover) {
                _this.settings.unformatOnHover = _unformatOnHover; //FIXME test this

                return _this;
            },
            unformatOnSubmit: function unformatOnSubmit(_unformatOnSubmit2) {
                _this.settings.unformatOnSubmit = _unformatOnSubmit2; //FIXME test this

                return _this;
            },
            valuesToStrings: function valuesToStrings(_valuesToStrings) {
                _this.update({ valuesToStrings: _valuesToStrings });

                return _this;
            },
            watchExternalChanges: function watchExternalChanges(_watchExternalChanges) {
                //FIXME test this
                _this.update({ watchExternalChanges: _watchExternalChanges });

                return _this;
            },
            wheelOn: function wheelOn(_wheelOn) {
                _this.settings.wheelOn = _wheelOn; //FIXME test this

                return _this;
            },
            wheelStep: function wheelStep(_wheelStep) {
                _this.settings.wheelStep = _wheelStep; //FIXME test this

                return _this;
            }
        };

        // Once the autoNumeric element has been initialized, broadcast that message with additional info.
        // Note: When using `AutoNumeric.multiple()`, one event is sent *per* element initialized
        this._triggerEvent(AutoNumeric.events.initialized, this.domElement, {
            newValue: _AutoNumericHelper2.default.getElementValue(this.domElement),
            newRawValue: this.rawValue,
            error: null,
            aNElement: this
        });
    }

    /**
     * Return the autoNumeric version number (for debugging purpose)
     *
     * @returns {string}
     */


    _createClass(AutoNumeric, [{
        key: '_saveInitialValues',


        /**
         * Save the initial element values for later use in the pristine test.
         * Those values are :
         * - the html attribute (ie. <input value='42'>), and
         * - the script `value` (ie. `let domElement.value`)
         *
         * @param {null|number|string} initialValue
         * @private
         */
        value: function _saveInitialValues(initialValue) {
            // Keep the very first initial values (in the html attribute and set by the script). This is needed to check if the element is pristine.
            // Save the html attribute 'value'
            this.initialValueHtmlAttribute = _AutoNumericHelper2.default.scientificToDecimal(this.domElement.getAttribute('value'));
            if (_AutoNumericHelper2.default.isNull(this.initialValueHtmlAttribute)) {
                // Set the default empty value attribute instead of `null`, since if the initial value is null, the empty string is used
                this.initialValueHtmlAttribute = '';
            }

            // Save the 'script' value
            this.initialValue = initialValue;
            if (_AutoNumericHelper2.default.isNull(this.initialValue)) {
                // Same as above
                this.initialValue = '';
            }
        }

        /**
         * Generate all the event listeners for the given DOM element
         * @private
         */

    }, {
        key: '_createEventListeners',
        value: function _createEventListeners() {
            var _this2 = this;

            this.formulaMode = false;
            // Create references to the event handler functions, so we can then cleanly removes those listeners if needed
            // That would not be possible if we used closures directly in the event handler declarations
            this._onFocusInFunc = function (e) {
                _this2._onFocusIn(e);
            };
            this._onFocusInAndMouseEnterFunc = function (e) {
                _this2._onFocusInAndMouseEnter(e);
            };
            this._onFocusFunc = function () {
                _this2._onFocus();
            };
            this._onKeydownFunc = function (e) {
                _this2._onKeydown(e);
            };
            this._onKeypressFunc = function (e) {
                _this2._onKeypress(e);
            };
            this._onKeyupFunc = function (e) {
                _this2._onKeyup(e);
            };
            this._onFocusOutAndMouseLeaveFunc = function (e) {
                _this2._onFocusOutAndMouseLeave(e);
            };
            this._onPasteFunc = function (e) {
                _this2._onPaste(e);
            };
            this._onWheelFunc = function (e) {
                _this2._onWheel(e);
            };
            this._onDropFunc = function (e) {
                _this2._onDrop(e);
            };
            this._onKeydownGlobalFunc = function (e) {
                _this2._onKeydownGlobal(e);
            };
            this._onKeyupGlobalFunc = function (e) {
                _this2._onKeyupGlobal(e);
            };

            // Add the event listeners
            this.domElement.addEventListener('focusin', this._onFocusInFunc, false);
            this.domElement.addEventListener('focus', this._onFocusInAndMouseEnterFunc, false);
            this.domElement.addEventListener('focus', this._onFocusFunc, false);
            this.domElement.addEventListener('mouseenter', this._onFocusInAndMouseEnterFunc, false);
            this.domElement.addEventListener('keydown', this._onKeydownFunc, false);
            this.domElement.addEventListener('keypress', this._onKeypressFunc, false);
            this.domElement.addEventListener('keyup', this._onKeyupFunc, false);
            this.domElement.addEventListener('blur', this._onFocusOutAndMouseLeaveFunc, false);
            this.domElement.addEventListener('mouseleave', this._onFocusOutAndMouseLeaveFunc, false);
            this.domElement.addEventListener('paste', this._onPasteFunc, false);
            this.domElement.addEventListener('wheel', this._onWheelFunc, false);
            this.domElement.addEventListener('drop', this._onDropFunc, false);
            this._setupFormListener();

            // Keep track if the event listeners have been initialized on this object
            this.hasEventListeners = true;

            // Create one global event listener for the keyup event on the document object, which will be shared by all the autoNumeric elements
            if (!AutoNumeric._doesGlobalListExists()) {
                document.addEventListener('keydown', this._onKeydownGlobalFunc, false);
                document.addEventListener('keyup', this._onKeyupGlobalFunc, false);
            }
        }

        /**
         * Remove all the autoNumeric-related event listeners for the given DOM element
         * @private
         */

    }, {
        key: '_removeEventListeners',
        value: function _removeEventListeners() {
            this.domElement.removeEventListener('focusin', this._onFocusInFunc, false);
            this.domElement.removeEventListener('focus', this._onFocusInAndMouseEnterFunc, false);
            this.domElement.removeEventListener('focus', this._onFocusFunc, false);
            this.domElement.removeEventListener('mouseenter', this._onFocusInAndMouseEnterFunc, false);
            this.domElement.removeEventListener('blur', this._onFocusOutAndMouseLeaveFunc, false);
            this.domElement.removeEventListener('mouseleave', this._onFocusOutAndMouseLeaveFunc, false);
            this.domElement.removeEventListener('keydown', this._onKeydownFunc, false);
            this.domElement.removeEventListener('keypress', this._onKeypressFunc, false);
            this.domElement.removeEventListener('keyup', this._onKeyupFunc, false);
            this.domElement.removeEventListener('paste', this._onPasteFunc, false);
            this.domElement.removeEventListener('wheel', this._onWheelFunc, false);
            this.domElement.removeEventListener('drop', this._onDropFunc, false);
            this._removeFormListener();

            // Keep track if the event listeners have been initialized on this object
            this.hasEventListeners = false;

            document.removeEventListener('keydown', this._onKeydownGlobalFunc, false);
            document.removeEventListener('keyup', this._onKeyupGlobalFunc, false);
        }

        /**
         * Toggle the event listeners according to the `noEventListeners` option, if those were not activated/deactivated before
         * @private
         */

    }, {
        key: '_updateEventListeners',
        value: function _updateEventListeners() {
            if (!this.settings.noEventListeners && !this.hasEventListeners) {
                // Special case where an update is done on an element that did not activate its event listeners in the first place
                // ie. when an element is first created with `contenteditable="false"`, then an update is done with `anElement.french()`
                this._createEventListeners();
            }

            if (this.settings.noEventListeners && this.hasEventListeners) {
                this._removeEventListeners();
            }
        }

        /**
         * Mark the parent <form> so that other AutoNumeric object will not add more listeners.
         * Add a counter so that when removing the AutoNumeric object, we only remove the submit listener if that count is equal to 0.
         * Also keep a reference to the 'submit' event handler function to be able to remove that handler later if the `_removeFormListener()` function is called from another AutoNumeric object.
         *
         * @private
         */

    }, {
        key: '_setupFormListener',
        value: function _setupFormListener() {
            var _this3 = this;

            if (!_AutoNumericHelper2.default.isNull(this.parentForm)) {
                // Setup the handler function
                this._onFormSubmitFunc = function () {
                    _this3._onFormSubmit();
                };
                this._onFormResetFunc = function () {
                    _this3._onFormReset();
                };

                // Check if the parent form already has the AutoNumeric mark
                if (this._hasParentFormCounter()) {
                    this._incrementParentFormCounter();
                } else {
                    // If not, add the counter
                    this._initializeFormCounterToOne();
                    // And add the submit and reset event listeners
                    this.parentForm.addEventListener('submit', this._onFormSubmitFunc, false);
                    this.parentForm.addEventListener('reset', this._onFormResetFunc, false);
                    // Also keep a reference to the handler function so that we can remove it later
                    this._storeFormHandlerFunction();
                }
            }
        }

        /**
         * Remove the form 'submit' event listener, as well as the `dataset` info (`anCount` and `anFormHandler`) from the parent form, only when there are only one AutoNumeric child element left in that <form>.
         * Otherwise decrement the `anCount`.
         *
         * @private
         */

    }, {
        key: '_removeFormListener',
        value: function _removeFormListener() {
            if (!_AutoNumericHelper2.default.isNull(this.parentForm)) {
                // Check the parent form counter value
                var anCount = this._getParentFormCounter();

                if (anCount === 1) {
                    // If it's 1, remove the listeners
                    this.parentForm.removeEventListener('submit', this._getFormHandlerFunction().submitFn, false);
                    this.parentForm.removeEventListener('reset', this._getFormHandlerFunction().resetFn, false);
                    // Also remove the dataset info
                    this._removeFormDataSetInfo();
                } else if (anCount > 1) {
                    // Otherwise if it's >1 decrement the counter
                    this._decrementParentFormCounter();
                } else {
                    // If it's <1, throw an error
                    _AutoNumericHelper2.default.throwError('The AutoNumeric object count on the form is incoherent.');
                }
            }
        }

        /**
         * Return `true` if the parent form has the form counter attribute
         *
         * @returns {boolean}
         * @private
         */

    }, {
        key: '_hasParentFormCounter',
        value: function _hasParentFormCounter() {
            return 'anCount' in this.parentForm.dataset;
        }

        /**
         * Return the count of AutoNumeric form children
         *
         * @returns {number}
         * @private
         */

    }, {
        key: '_getParentFormCounter',
        value: function _getParentFormCounter() {
            return Number(this.parentForm.dataset.anCount);
        }

        /**
         * Set the count of AutoNumeric form children to 1 for the given form element, or if none are passed, the current `this.parentForm` one.
         *
         * @param {HTMLFormElement|null} formElement
         * @private
         */

    }, {
        key: '_initializeFormCounterToOne',
        value: function _initializeFormCounterToOne() {
            var formElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this._getFormElement(formElement).dataset.anCount = 1;
        }

        /**
         * Increment the AutoNumeric form children count for the given form element, or if none are passed, the current `this.parentForm` one.
         *
         * @param {HTMLFormElement|null} formElement
         * @private
         */

    }, {
        key: '_incrementParentFormCounter',
        value: function _incrementParentFormCounter() {
            var formElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this._getFormElement(formElement).dataset.anCount++;
        }

        /**
         * Decrement the AutoNumeric form children count for the current `this.parentForm` form element.
         *
         * @private
         */

    }, {
        key: '_decrementParentFormCounter',
        value: function _decrementParentFormCounter() {
            this.parentForm.dataset.anCount--;
        }

        /**
         * Return `true` if the global form handler list exists on the `window` object.
         *
         * @returns {boolean}
         * @private
         */

    }, {
        key: '_hasFormHandlerFunction',


        /**
         * Return `true` if the given form element, or if none are passed, the current `this.parentForm` one has a form handler name.
         *
         * @param {HTMLFormElement|null} formElement
         * @returns {boolean}
         * @private
         */
        value: function _hasFormHandlerFunction() {
            var formElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            return 'anFormHandler' in this._getFormElement(formElement).dataset;
        }

        /**
         * Return the given form element, or defaults to `this.parentForm` if no argument is passed.
         *
         * @param {HTMLFormElement|null} formElement
         * @returns {*}
         * @private
         */

    }, {
        key: '_getFormElement',
        value: function _getFormElement() {
            var formElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var formElementToUse = void 0;
            if (!_AutoNumericHelper2.default.isNull(formElement)) {
                formElementToUse = formElement;
            } else {
                formElementToUse = this.parentForm;
            }

            return formElementToUse;
        }

        /**
         * Generate a form handler unique name and store it in the global form handler list.
         * This also save that name in the dataset of the given form element.
         *
         * @param {HTMLFormElement|null} formElement
         * @private
         */

    }, {
        key: '_storeFormHandlerFunction',
        value: function _storeFormHandlerFunction() {
            var formElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            // Create the weakMap if it does not exist
            if (!this.constructor._doesFormHandlerListExists()) {
                this.constructor._createFormHandlerList();
            }

            // Generate a unique name and save it in the form dataset
            var formHandlerName = _AutoNumericHelper2.default.randomString();
            this._getFormElement(formElement).dataset.anFormHandler = formHandlerName;

            // Add the form handler name and handle function reference to the WeakMap
            window.aNFormHandlerMap.set(formHandlerName, { submitFn: this._onFormSubmitFunc, resetFn: this._onFormResetFunc });
        }

        /**
         * Return the form handler key name from the parent form element, for the global form handler list.
         *
         * @returns {string|*}
         * @private
         */

    }, {
        key: '_getFormHandlerKey',
        value: function _getFormHandlerKey() {
            if (!this._hasFormHandlerFunction()) {
                _AutoNumericHelper2.default.throwError('Unable to retrieve the form handler name');
            }

            var formHandlerName = this.parentForm.dataset.anFormHandler;
            if (formHandlerName === '') {
                _AutoNumericHelper2.default.throwError('The form handler name is invalid');
            }

            return formHandlerName;
        }

        /**
         * Return the 'submit' event handler function used for the parent form.
         *
         * @returns {function}
         * @private
         */

    }, {
        key: '_getFormHandlerFunction',
        value: function _getFormHandlerFunction() {
            var formHandlerName = this._getFormHandlerKey();

            return window.aNFormHandlerMap.get(formHandlerName);
        }

        /**
         * Remove the dataset attributes `data-an-count` and `data-an-form-handler` from the parent form element.
         *
         * @private
         */

    }, {
        key: '_removeFormDataSetInfo',
        value: function _removeFormDataSetInfo() {
            // Just in case, set the counter to 0
            this._decrementParentFormCounter();
            // Remove the form handler function from the FormHandlerFunction Map
            window.aNFormHandlerMap.delete(this._getFormHandlerKey());
            // Lastly, remove the dataset attributes
            this.parentForm.removeAttribute('data-an-count');
            this.parentForm.removeAttribute('data-an-form-handler');
        }

        /**
         * Set the DOM element write permissions according to the current settings, by setting the `readonly` or `contenteditable` attributes depending of its tag type.
         * If the `useHtmlAttribute` parameter is set to `true`, then the `readonly` html attribute is used and has precedence over the `readOnly` option to set the element as read-only.
         *
         * @param {boolean} useHtmlAttribute If set to `true`, then the write permissions are set by taking into account the html 'readonly' attribute, even if the `readOnly` option is set to false
         * @private
         */

    }, {
        key: '_setWritePermissions',
        value: function _setWritePermissions() {
            var useHtmlAttribute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (useHtmlAttribute && this.domElement.readOnly || this.settings.readOnly) {
                this._setReadOnly();
            } else {
                this._setReadWrite();
            }
        }

        /**
         * Set the element to be read-only.
         * If the DOM element tag is not an `input`, then it `contenteditable` attribute is set to `false`.
         *
         * @private
         */

    }, {
        key: '_setReadOnly',
        value: function _setReadOnly() {
            if (this.isInputElement) {
                this.domElement.readOnly = true;
            } else {
                this.domElement.setAttribute('contenteditable', false);
            }
        }

        /**
         * Set the element to be read-write.
         *
         * @private
         */

    }, {
        key: '_setReadWrite',
        value: function _setReadWrite() {
            if (this.isInputElement) {
                this.domElement.readOnly = false;
            } else {
                this.domElement.setAttribute('contenteditable', true);
            }
        }

        /**
         * Add a watcher so that any external change to the AutoNumeric-managed element would be detected.
         * As soon as such change is detected, AutoNumeric then tries to `set()` the value so that it gets formatted and stored in the history.
         * //XXX For now, this only works when watching the `value` attribute, not the `textContent` one
         * @private
         */

    }, {
        key: '_addWatcher',
        value: function _addWatcher() {
            var _this4 = this;

            // `getterSetter` can be undefined when a non-input element is used
            if (!_AutoNumericHelper2.default.isUndefined(this.getterSetter)) {
                var _getterSetter = this.getterSetter,
                    setter = _getterSetter.set,
                    getter = _getterSetter.get;

                Object.defineProperty(this.domElement, this.attributeToWatch, {
                    configurable: true, // This is needed in some rare cases
                    get: function get() {
                        return getter.call(_this4.domElement);
                    },
                    set: function set(val) {
                        setter.call(_this4.domElement, val);
                        // Only `set()` the value if the modification comes from an external source
                        if (_this4.settings.watchExternalChanges && !_this4.internalModification) {
                            _this4.set(val);
                        }
                    }
                });
            }

            //FIXME The code above fails for the `textContent` attribute since `this.getterSetter` is undefined when using `getOwnPropertyDescriptor()`
            /* //XXX The code below *almost* work for the textContent, but breaks some unit tests
            this.valueWatched = this.domElement[this.attributeToWatch];
            Object.defineProperty(this.domElement, this.attributeToWatch, {
                configurable: true, // This is needed in some rare cases
                get         : () => this.valueWatched,
                set         : val => {
                    this.valueWatched = val;
                    // Only `set()` the value if the modification comes from an external source
                    if (this.settings.watchExternalChanges && !this.internalModification) {
                        this.set(val);
                    }
                },
            });
            */
        }

        /**
         * Remove the watcher on the AutoNumeric-managed element
         * Note: This needs to be called when the AutoNumeric element is 'removed', otherwise the getter/setter stays on the DOM element and that can lead to problem if the user initialize another AutoNumeric object on it.
         * @private
         */

    }, {
        key: '_removeWatcher',
        value: function _removeWatcher() {
            var _this5 = this;

            // `getterSetter` can be undefined when a non-input element is used
            if (!_AutoNumericHelper2.default.isUndefined(this.getterSetter)) {
                var _getterSetter2 = this.getterSetter,
                    setter = _getterSetter2.set,
                    getter = _getterSetter2.get;

                Object.defineProperty(this.domElement, this.attributeToWatch, {
                    configurable: true, // This is needed in some rare cases
                    get: function get() {
                        return getter.call(_this5.domElement);
                    },
                    set: function set(val) {
                        setter.call(_this5.domElement, val);
                    }
                });
            }

            //FIXME The code above fails for the `textContent` attribute since `this.getterSetter` is undefined when using `getOwnPropertyDescriptor()`
            /* //XXX The code below *almost* work for the textContent, but breaks some unit tests
            this.valueWatched = this.domElement[this.attributeToWatch];
            Object.defineProperty(this.domElement, this.attributeToWatch, {
                configurable: true, // This is needed in some rare cases
                get         : () => this.valueWatched,
                set         : val => {
                    this.valueWatched = val;
                },
            });
            */
        }

        /**
         * Return the name of the object attribute that store the current formatted data in the DOM element.
         *
         * @returns {string}
         * @private
         */

    }, {
        key: '_getAttributeToWatch',
        value: function _getAttributeToWatch() {
            var attributeToWatch = void 0;
            if (this.isInputElement) {
                attributeToWatch = 'value';
            } else {
                var nodeType = this.domElement.nodeType;
                if (nodeType === Node.ELEMENT_NODE || nodeType === Node.DOCUMENT_NODE || nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                    attributeToWatch = 'textContent';
                } else if (nodeType === Node.TEXT_NODE) {
                    attributeToWatch = 'nodeValue';
                }
            }

            return attributeToWatch;
        }

        /**
         * Save the current raw value into the history table, along with the selection information.
         *
         * If the user has done some undos and tries to enter:
         * - a new and different number than the 'next' state, this drops the rest of the history table
         * - the very same number that result in the same rawValue than the 'next' state, we only move the history table pointer to the next state
         *
         * @private
         */

    }, {
        key: '_historyTableAdd',
        value: function _historyTableAdd() {
            //TODO Add a `this.settings.saveSelectionsIntoHistory` option to prevent saving the selections (in order to gain performance)
            var isEmptyHistoryTable = this.historyTable.length === 0;
            // Only add a new value if it's different than the previous one (to prevent infinitely adding values on mouseover for instance)
            if (isEmptyHistoryTable || this.rawValue !== this._historyTableCurrentValueUsed()) {
                // Trim the history table if the user changed the value of an intermediary state
                var addNewHistoryState = true;
                if (!isEmptyHistoryTable) {
                    // If some undo has been done and the user type the exact same data than the next entry after the current history pointer, do no drop the rest of the 'redo' list, and just advance the historyTableIndex
                    var nextHistoryStateIndex = this.historyTableIndex + 1;
                    if (nextHistoryStateIndex < this.historyTable.length && this.rawValue === this.historyTable[nextHistoryStateIndex].value) {
                        // If the character input result in the same state than the next one, do not remove the next history states nor add a new one
                        addNewHistoryState = false;
                    } else {
                        // First remove anything that is after the current index
                        _AutoNumericHelper2.default.arrayTrim(this.historyTable, this.historyTableIndex + 1);
                    }
                }

                // Update the history pointer
                this.historyTableIndex++;

                // Add the new history state, if needed
                if (addNewHistoryState) {
                    // Save the selection info
                    var selection = _AutoNumericHelper2.default.getElementSelection(this.domElement);
                    this.selectionStart = selection.start;
                    this.selectionEnd = selection.end;

                    // Then add the new raw value
                    this.historyTable.push({
                        // Save the rawValue and selection start/end
                        value: this.rawValue,
                        // The selection for this element is temporary, and will be updated when the next history state will be recorded.
                        // That way, we are always sure we save the last caret or selection positions just before the value is changed. Otherwise we would only save those positions when the value is first changed, and would not take into account that the user could move the caret around afterward.
                        // For instance, this is needed if the user change the element value, and immediately undo it ; if he then does a redo, he'll see the value and the right selection
                        // To sum up; The selection position are not always +1 character, since it could also be '2' if a group separator is added when entering one character. That's why the current history state caret/selection position is updated on each `keyup` event.
                        start: this.selectionStart + 1, // Here we add one since the user added one character too
                        end: this.selectionEnd + 1
                    });

                    // Update the selection in the previous entry, in order to keep track of the updated caret/selection positions
                    if (this.historyTable.length > 1) {
                        this.historyTable[this.historyTableIndex - 1].start = this.selectionStart;
                        this.historyTable[this.historyTableIndex - 1].end = this.selectionEnd;
                    }
                }

                // Limit the history table size according to the `historySize` option
                if (this.historyTable.length > this.settings.historySize) {
                    this._historyTableForget();
                }
            }
        }

        /**
         * Debug function for the history table
         * @private
         */
        /*
        _debugHistoryTable() {
            let i = 0;
            let mark;
            this.historyTable.forEach(history => {
                if (this.historyTableIndex === i) {
                    mark = '> ';
                } else {
                    mark = '';
                }
                console.log(`${mark}${i++}: ${history.value} ${history.start}|${history.end} [onGoingRedo: ${this.onGoingRedo}]`); //DEBUG
            });
        }
        */

        /**
         * 'Undo' or 'Redo' the last/next user entry in the history table.
         * This does not modify the history table, only the pointer to the current state.
         *
         * @param {boolean} undo If set to `true`, then this function does an 'Undo', otherwise it does a 'Redo'
         * @private
         */

    }, {
        key: '_historyTableUndoOrRedo',
        value: function _historyTableUndoOrRedo() {
            var undo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            var check = void 0;
            if (undo) {
                // Only 'undo' if there are some info to undo
                check = this.historyTableIndex > 0;
                if (check) {
                    this.historyTableIndex--;
                }
            } else {
                // Only 'redo' if there are some info to redo at the end of the history table
                check = this.historyTableIndex + 1 < this.historyTable.length;
                if (check) {
                    this.historyTableIndex++;
                }
            }

            if (check) {
                // Set the value back
                var undoInfo = this.historyTable[this.historyTableIndex];
                this.set(undoInfo.value, null, false); // next or previous raw value

                // Set the selection back
                _AutoNumericHelper2.default.setElementSelection(this.domElement, undoInfo.start, undoInfo.end);
            }
        }

        /**
         * 'Undo' the last user entry by going back one entry in the history table.
         * This keeps the following entries in order to allow for a 'redo'.
         * This does not modify the history table, only the pointer to the current state.
         * @private
         */

    }, {
        key: '_historyTableUndo',
        value: function _historyTableUndo() {
            this._historyTableUndoOrRedo(true);
        }

        /**
         * 'Redo' the next user entry in the history table.
         * This does not modify the history table, only the pointer to the current state.
         * @private
         */

    }, {
        key: '_historyTableRedo',
        value: function _historyTableRedo() {
            this._historyTableUndoOrRedo(false);
        }

        /**
         * Reset the history table to its initial state, and select the value.
         * @private
         */
        /*
        resetHistoryTable() { //FIXME Test this
            this.set(this.rawValue, null, false);
            this.select();
            const selection = AutoNumericHelper.getElementSelection(this.domElement);
            this.historyTableIndex = 0;
            this.historyTable = [{
                // Save the rawValue and selection start/end
                value: this.rawValue,
                start: selection.start,
                end  : selection.end,
            }];
        }
        */

        /**
         * Make the history table forget its first N elements, shifting its indexes in the process.
         * `N` being given as the `numberOfEntriesToForget` parameter.
         *
         * @param {Number} numberOfEntriesToForget
         * @returns {object|Array<object>} The discarded objects, in an Array.
         * @private
         */

    }, {
        key: '_historyTableForget',
        value: function _historyTableForget() {
            var numberOfEntriesToForget = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            var shiftedAway = [];
            for (var i = 0; i < numberOfEntriesToForget; i++) {
                shiftedAway.push(this.historyTable.shift());
                // Update the history table index accordingly
                this.historyTableIndex--;
                if (this.historyTableIndex < 0) {
                    // In case this function is called more times than there is states in the history table
                    this.historyTableIndex = 0;
                }
            }

            if (shiftedAway.length === 1) {
                return shiftedAway[0];
            }

            return shiftedAway;
        }

        /**
         * Return the currently used value from the history table.
         *
         * @returns {string|number}
         * @private
         */

    }, {
        key: '_historyTableCurrentValueUsed',
        value: function _historyTableCurrentValueUsed() {
            var indexToUse = this.historyTableIndex;
            if (indexToUse < 0) {
                indexToUse = 0;
            }

            var result = void 0;
            if (_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(this.historyTable[indexToUse])) {
                result = '';
            } else {
                result = this.historyTable[indexToUse].value;
            }

            return result;
        }

        /**
         * Parse the `styleRules` option and run the test for each given rules, either pre-defined ones like `positive`, `negative` and `ranges`, or user defined callbacks within the `userDefined` attribute.
         * @private
         */

    }, {
        key: '_parseStyleRules',
        value: function _parseStyleRules() {
            var _this6 = this;

            if (_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(this.settings.styleRules) || this.rawValue === '') {
                return;
            }

            // 'positive' attribute
            if (!_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(this.settings.styleRules.positive)) {
                if (this.rawValue >= 0) {
                    this._addCSSClass(this.settings.styleRules.positive);
                } else {
                    this._removeCSSClass(this.settings.styleRules.positive);
                }
            }

            // 'negative' attribute
            if (!_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(this.settings.styleRules.negative)) {
                if (this.rawValue < 0) {
                    this._addCSSClass(this.settings.styleRules.negative);
                } else {
                    this._removeCSSClass(this.settings.styleRules.negative);
                }
            }

            // 'ranges' attribute
            if (!_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(this.settings.styleRules.ranges) && this.settings.styleRules.ranges.length !== 0) {
                this.settings.styleRules.ranges.forEach(function (range) {
                    if (_this6.rawValue >= range.min && _this6.rawValue < range.max) {
                        _this6._addCSSClass(range.class);
                    } else {
                        _this6._removeCSSClass(range.class);
                    }
                });
            }

            // 'userDefined' attribute
            //TODO Also pass the old raw value as a parameter, and not only the new raw value
            if (!_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(this.settings.styleRules.userDefined) && this.settings.styleRules.userDefined.length !== 0) {
                this.settings.styleRules.userDefined.forEach(function (userObject) {
                    if (_AutoNumericHelper2.default.isFunction(userObject.callback)) {
                        // Test for the type of the `classes` attribute, which changes the function behavior
                        if (_AutoNumericHelper2.default.isString(userObject.classes)) {
                            // If 'classes' is a string, set it if `true`, remove it if `false`
                            if (userObject.callback(_this6.rawValue)) {
                                _this6._addCSSClass(userObject.classes);
                            } else {
                                _this6._removeCSSClass(userObject.classes);
                            }
                        } else if (_AutoNumericHelper2.default.isArray(userObject.classes)) {
                            if (userObject.classes.length === 2) {
                                // If 'classes' is an array with only 2 elements, set the first class if `true`, the second if `false`
                                if (userObject.callback(_this6.rawValue)) {
                                    _this6._addCSSClass(userObject.classes[0]);
                                    _this6._removeCSSClass(userObject.classes[1]);
                                } else {
                                    _this6._removeCSSClass(userObject.classes[0]);
                                    _this6._addCSSClass(userObject.classes[1]);
                                }
                            } else if (userObject.classes.length > 2) {
                                // The callback returns an array of indexes to use on the `classes` array
                                var callbackResult = userObject.callback(_this6.rawValue);
                                if (_AutoNumericHelper2.default.isArray(callbackResult)) {
                                    // If multiple indexes are returned
                                    userObject.classes.forEach(function (userClass, index) {
                                        if (_AutoNumericHelper2.default.isInArray(index, callbackResult)) {
                                            _this6._addCSSClass(userClass);
                                        } else {
                                            _this6._removeCSSClass(userClass);
                                        }
                                    });
                                } else if (_AutoNumericHelper2.default.isInt(callbackResult)) {
                                    // If only one index is returned
                                    userObject.classes.forEach(function (userClass, index) {
                                        if (index === callbackResult) {
                                            _this6._addCSSClass(userClass);
                                        } else {
                                            _this6._removeCSSClass(userClass);
                                        }
                                    });
                                } else if (_AutoNumericHelper2.default.isNull(callbackResult)) {
                                    // Remove all the classes
                                    userObject.classes.forEach(function (userClass) {
                                        _this6._removeCSSClass(userClass);
                                    });
                                } else {
                                    _AutoNumericHelper2.default.throwError('The callback result is not an array nor a valid array index, ' + (typeof callbackResult === 'undefined' ? 'undefined' : _typeof(callbackResult)) + ' given.');
                                }
                            } else {
                                _AutoNumericHelper2.default.throwError('The classes attribute is not valid for the `styleRules` option.');
                            }
                        } else if (_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(userObject.classes)) {
                            // If 'classes' is `undefined` or `null`, then the callback is called with the AutoNumeric object passed as a parameter
                            userObject.callback(_this6);
                        } else {
                            _AutoNumericHelper2.default.throwError('The callback/classes structure is not valid for the `styleRules` option.');
                        }
                    } else {
                        _AutoNumericHelper2.default.warning('The given `styleRules` callback is not a function, ' + (typeof callback === 'undefined' ? 'undefined' : _typeof(callback)) + ' given.', _this6.settings.showWarnings);
                    }
                });
            }
        }

        /**
         * Add the given CSS class to the DOM element.
         *
         * @param {string} cssClassName
         * @private
         */

    }, {
        key: '_addCSSClass',
        value: function _addCSSClass(cssClassName) {
            this.domElement.classList.add(cssClassName);
        }

        /**
         * Remove the given CSS class from the DOM element.
         *
         * @param {string} cssClassName
         * @private
         */

    }, {
        key: '_removeCSSClass',
        value: function _removeCSSClass(cssClassName) {
            this.domElement.classList.remove(cssClassName);
        }

        // This are the public function available on each autoNumeric-managed element

        /**
         * Method that updates the AutoNumeric settings, and immediately format the element accordingly.
         * The options passed as parameter(s) is either one or many objects that each contains some settings, ie. :
         * {
         *     digitGroupSeparator: ".",
         *     decimalCharacter: ",",
         *     currencySymbol: '€ ',
         * }
         * If multiple options are passed, the latter overwrite the previous ones.
         *
         * Note: If the new settings are not validated, or the call to `set()` fails, then the previous valid settings are reverted back to.
         *
         * @example anElement.update({ options }) // Updates the settings
         * @example anElement.update({ options1 }, { options2 }) // Updates the settings with multiple option objects
         * @example anElement.update([{ options1 }, { options2 }]) // Updates the settings with multiple option objects in a single array
         *
         * @param {object|string|array} newOptions
         * @returns {AutoNumeric}
         */

    }, {
        key: 'update',
        value: function update() {
            var _this7 = this;

            for (var _len2 = arguments.length, newOptions = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                newOptions[_key2] = arguments[_key2];
            }

            if (Array.isArray(newOptions) && Array.isArray(newOptions[0])) {
                // Allows to pass a single array of options
                newOptions = newOptions[0];
            }

            // Keep a copy of the original settings before changing them, in case they do not validate correctly, so we can switch back to them
            var originalSettings = _AutoNumericHelper2.default.cloneObject(this.settings); //TODO Check that the `styleRules` option is correctly cloned (due to depth cloning limitation)

            // Store the current unformatted input value
            var numericString = this.rawValue;

            // Generate a single option object with the settings from the latter overwriting those from the former
            var optionsToUse = {};
            if (_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(newOptions) || newOptions.length === 0) {
                optionsToUse = null;
            } else if (newOptions.length >= 1) {
                newOptions.forEach(function (optionObject) {
                    if (_this7.constructor._isPreDefinedOptionValid(optionObject)) {
                        // The option object is a predefined option name (ie. 'euro')
                        optionObject = _this7.constructor._getOptionObject(optionObject);
                    }

                    _extends(optionsToUse, optionObject);
                });
            }

            // Update the settings
            try {
                this._setSettings(optionsToUse, true);
                this._setWritePermissions(); // Update the read/write permissions
                this._updateEventListeners();

                // Reformat the input value with the new settings
                // Note: we always `set`, even when `numericString` is the empty string '', since `emptyInputBehavior` (set to `always` or `zero`) can change how the empty input is formatted
                this.set(numericString);
            } catch (error) {
                // If the settings validation fails, then we switch back to the previous valid settings
                this._setSettings(originalSettings, true); // `_setSettings()` is used here instead of directly doing `this.settings = originalSettings;` since lots of side variables are calculated from the settings, and we need to get those back to their previous state. Note: `_setSettings()` is called in the 'update' mode in order to correctly set back the `originalDecimalPlacesRawValue` value.
                _AutoNumericHelper2.default.throwError('Unable to update the settings, those are invalid: [' + error + ']');

                return this;
            }

            return this;
        }

        /**
         * Return the options object containing all the current autoNumeric settings in effect.
         * You can then directly access each option by using its name : `anElement.getSettings().optionNameAutoCompleted`.
         *
         * @example
         * anElement.getSettings()
         * anElement.getSettings().decimalCharacter // Return the decimalCharacter setting as a string - any valid option name can be used
         *
         * @returns {object}
         */

    }, {
        key: 'getSettings',
        value: function getSettings() {
            return this.settings;
        }

        /**
         * Set the given element value, and format it immediately.
         * Additionally, this `set()` method can accept options that will be merged into the current AutoNumeric element, taking precedence over any previous settings.
         *
         * @example anElement.set('12345.67') // Formats the value
         * @example anElement.set(12345.67) // Formats the value
         * @example anElement.set(12345.67, { decimalCharacter : ',' }) // Update the settings and formats the value in one go
         * @example anElement.northAmerican().set('$12,345.67') // Set an already formatted value (this does not _exactly_ respect the currency symbol/negative placements, but only remove all non-numbers characters, according to the ones given in the settings)
         * @example anElement.set(null) // Set the rawValue and element value to `null`
         *
         * @param {number|string|null} newValue The value must be a Number, a numeric string or `null` (if `emptyInputBehavior` is set to `'null'`)
         * @param {object} options A settings object that will override the current settings. Note: the update is done only if the `newValue` is defined.
         * @param {boolean} saveChangeToHistory If set to `true`, then the change is recorded in the history table
         * @returns {AutoNumeric}
         * @throws
         */

    }, {
        key: 'set',
        value: function set(newValue) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var saveChangeToHistory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            //TODO Add the `saveSettings` options. If `true`, then when `options` is passed, then it overwrite the current `this.settings`. If `false` the `options` are only used once and `this.settings` is not modified
            if (_AutoNumericHelper2.default.isUndefined(newValue)) {
                _AutoNumericHelper2.default.warning('You are trying to set an \'undefined\' value ; an error could have occurred.', this.settings.showWarnings);
                return this;
            }

            // The options update is done only if the `newValue` is not `undefined`
            if (!_AutoNumericHelper2.default.isNull(options)) {
                this._setSettings(options, true); // We do not call `update` here since this would call `set` too
            }

            if (newValue === null && this.settings.emptyInputBehavior !== AutoNumeric.options.emptyInputBehavior.null) {
                _AutoNumericHelper2.default.warning('You are trying to set the `null` value while the `emptyInputBehavior` option is set to ' + this.settings.emptyInputBehavior + '. If you want to be able to set the `null` value, you need to change the \'emptyInputBehavior\' option to `\'null\'`.', this.settings.showWarnings);
                return this;
            }

            var value = void 0;
            if (newValue === null) {
                //TODO Merge this into a global `if (newValue === null) {` test, with the test above
                // Here this.settings.emptyInputBehavior === AutoNumeric.options.emptyInputBehavior.null
                this._setElementAndRawValue(null, null, saveChangeToHistory);
                this._saveValueToPersistentStorage();

                return this;
            }

            value = this.constructor._toNumericValue(newValue, this.settings);
            if (isNaN(Number(value))) {
                //TODO Do not modify the element value if the newValue results in `NaN`. Make sure the settings, if modified, are revert back too.
                _AutoNumericHelper2.default.warning('The value you are trying to set results in `NaN`. The element value is set to the empty string instead.', this.settings.showWarnings);
                this.setValue('', saveChangeToHistory);

                return this;
            }

            if (value === '') {
                switch (this.settings.emptyInputBehavior) {
                    case AutoNumeric.options.emptyInputBehavior.zero:
                        value = 0;
                        break;
                    case AutoNumeric.options.emptyInputBehavior.min:
                        value = this.settings.minimumValue;
                        break;
                    case AutoNumeric.options.emptyInputBehavior.max:
                        value = this.settings.maximumValue;
                        break;
                    default:
                        if (_AutoNumericHelper2.default.isNumber(this.settings.emptyInputBehavior)) {
                            value = Number(this.settings.emptyInputBehavior);
                        }
                }
            }

            if (value !== '') {
                var _constructor$_checkIf = this.constructor._checkIfInRangeWithOverrideOption(value, this.settings),
                    _constructor$_checkIf2 = _slicedToArray(_constructor$_checkIf, 2),
                    minTest = _constructor$_checkIf2[0],
                    maxTest = _constructor$_checkIf2[1];

                // Modify the formatted value if the rawValue is found in the `valuesToStrings` option


                if (minTest && maxTest && this.settings.valuesToStrings && this._checkValuesToStrings(value)) {
                    // Set the raw value normally, and the formatted value with the corresponding string
                    this._setElementAndRawValue(this.settings.valuesToStrings[value], value, saveChangeToHistory);
                    this._saveValueToPersistentStorage();

                    return this;
                }

                // This test is needed by the `showPositiveSign` option
                var isZero = _AutoNumericHelper2.default.isZeroOrHasNoValue(value);
                if (isZero) {
                    value = '0';
                }

                if (minTest && maxTest) {
                    var forcedRawValue = this.constructor._roundRawValue(value, this.settings);
                    forcedRawValue = this._trimLeadingAndTrailingZeros(forcedRawValue.replace(this.settings.decimalCharacter, '.')); // Move the `setRawValue` call after the `setElementValue` one
                    value = this._getRawValueToFormat(value); // Multiply the raw value to obtain the formatted value

                    // Round the given value according to the object state (focused/unfocused)
                    if (this.isFocused) {
                        value = this.constructor._roundFormattedValueShownOnFocus(value, this.settings);
                    } else {
                        if (this.settings.divisorWhenUnfocused) {
                            value = value / this.settings.divisorWhenUnfocused;
                            value = value.toString();
                        }

                        value = this.constructor._roundFormattedValueShownOnBlur(value, this.settings);
                    }

                    value = this.constructor._modifyNegativeSignAndDecimalCharacterForFormattedValue(value, this.settings);
                    value = this.constructor._addGroupSeparators(value, this.settings, this.isFocused, this.rawValue, forcedRawValue);
                    if (!this.isFocused && this.settings.symbolWhenUnfocused) {
                        value = '' + value + this.settings.symbolWhenUnfocused;
                    }

                    if (this.settings.decimalPlacesShownOnFocus || this.settings.divisorWhenUnfocused) {
                        this._saveValueToPersistentStorage();
                    }

                    this._setElementAndRawValue(value, forcedRawValue, saveChangeToHistory);

                    return this;
                } else {
                    if (!minTest) {
                        this._triggerEvent(AutoNumeric.events.minRangeExceeded, this.domElement);
                    }

                    if (!maxTest) {
                        this._triggerEvent(AutoNumeric.events.maxRangeExceeded, this.domElement);
                    }

                    _AutoNumericHelper2.default.throwError('The value [' + value + '] being set falls outside of the minimumValue [' + this.settings.minimumValue + '] and maximumValue [' + this.settings.maximumValue + '] range set for this element');

                    this._removeValueFromPersistentStorage();
                    this.setValue('', saveChangeToHistory); //TODO Shouldn't we just drop that faulty newValue and keep the previous one? This is behind a `throwError()` call anyway..

                    return this;
                }
            } else {
                // Here, `value` equal the empty string `''`
                var result = void 0;
                if (this.settings.emptyInputBehavior === AutoNumeric.options.emptyInputBehavior.always) {
                    // Keep the currency symbol as per emptyInputBehavior
                    result = this.settings.currencySymbol;
                } else {
                    result = '';
                }

                this._setElementAndRawValue(result, '', saveChangeToHistory);

                return this;
            }
        }

        /**
         * Set the given value directly as the DOM element value, without formatting it beforehand.
         * You can also set the value and update the setting in one go (the value will again not be formatted immediately).
         *
         * @param {number|string} value
         * @param {object} options
         * @returns {AutoNumeric}
         * @throws
         */

    }, {
        key: 'setUnformatted',
        value: function setUnformatted(value) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            //TODO Should we use `AutoNumeric.unformat()` here and set the unformatted result in case `value` is formatted?
            if (value === null || _AutoNumericHelper2.default.isUndefined(value)) {
                return this;
            }

            // The options update is done only if the `value` is not null
            if (!_AutoNumericHelper2.default.isNull(options)) {
                this._setSettings(options, true); // We do not call `update` here since this would call `set` too
            }

            var strippedValue = this.constructor._removeBrackets(value, this.settings);
            var normalizedValue = this.constructor._stripAllNonNumberCharacters(strippedValue, this.settings, true, this.isFocused);
            if (!_AutoNumericHelper2.default.isNumber(normalizedValue)) {
                _AutoNumericHelper2.default.throwError('The value is not a valid one, it\'s not a numeric string nor a recognized currency.');
            }

            var _constructor$_checkIf3 = this.constructor._checkIfInRangeWithOverrideOption(normalizedValue, this.settings),
                _constructor$_checkIf4 = _slicedToArray(_constructor$_checkIf3, 2),
                minTest = _constructor$_checkIf4[0],
                maxTest = _constructor$_checkIf4[1];

            if (minTest && maxTest) {
                // If the `normalizedValue` is in the range
                this.setValue(value);
            } else {
                _AutoNumericHelper2.default.throwError('The value is out of the range limits [' + this.settings.minimumValue + ', ' + this.settings.maximumValue + '].');
            }

            return this;
        }

        /**
         * Set the given value directly as the DOM element value, without formatting it beforehand, and without checking its validity.
         * This also updates the `rawValue` with the given `newValue`, without checking it too ; if it's not formatted like a number recognized by Javascript, this *will* likely make other AutoNumeric methods fail.
         *
         * @param {string|number|null} newValue The new value to set on the element
         * @param {boolean} saveChangeToHistory If set to `true`, then the change is recorded in the history array, otherwise it is not
         * @returns {AutoNumeric}
         */

    }, {
        key: 'setValue',
        value: function setValue(newValue) {
            var saveChangeToHistory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            this._setElementAndRawValue(newValue, saveChangeToHistory);

            return this;
        }

        /**
         * Save the raw value inside the AutoNumeric object.
         *
         * @param {number|string|null} rawValue The numeric value as understood by Javascript like a `Number`
         * @param {boolean} saveChangeToHistory If set to `true`, then the change is recorded in the history array, otherwise it is not
         * @private
         */

    }, {
        key: '_setRawValue',
        value: function _setRawValue(rawValue) {
            var saveChangeToHistory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            // Only set the raw value if the given value is different than the current one
            if (this.rawValue !== rawValue) {
                //TODO Manage the case where one value is a string while the other is a number?
                var oldRawValue = this.rawValue;
                // Update the raw value
                this.rawValue = rawValue; // By default, if the `rawValue` is changed programmatically

                if (!_AutoNumericHelper2.default.isNull(this.settings.rawValueDivisor) && this.settings.rawValueDivisor !== 0 && // Only divide if the `rawValueDivisor` option is set
                rawValue !== '' && rawValue !== null && // Do not modify the `rawValue` if it's an empty string or null
                this._isUserManuallyEditingTheValue()) {
                    // If the user is manually changing the element value
                    this.rawValue /= this.settings.rawValueDivisor;
                }

                // Broadcast the `rawValueModified` event since the `rawValue` has been modified
                this._triggerEvent(AutoNumeric.events.rawValueModified, this.domElement, {
                    oldRawValue: oldRawValue,
                    newRawValue: this.rawValue,
                    isPristine: this.isPristine(true),
                    error: null,
                    aNElement: this
                });

                // Change the element style or use the relevant callbacks
                this._parseStyleRules();

                if (saveChangeToHistory) {
                    // Save in the history the last known raw value and formatted result selection
                    this._historyTableAdd();
                }
            }
        }

        /**
         * Set the given value on the DOM element, without affecting the `rawValue`.
         * This send an 'autoNumeric:formatted' event if the new value is different than the old one.
         *
         * @param {number|string} newElementValue
         * @param {boolean} sendFormattedEvent If set to `true`, then the `AutoNumeric.events.formatted` event is sent if the value has changed
         * @returns {AutoNumeric}
         * @private
         */

    }, {
        key: '_setElementValue',
        value: function _setElementValue(newElementValue) {
            var sendFormattedEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            //TODO Use an internal attribute to track the current value of the element `formattedValue` (like its counterpart `rawValue`). This would allow us to avoid calling `getElementValue` many times
            var oldElementValue = _AutoNumericHelper2.default.getElementValue(this.domElement);

            // Only update the value if it's different from the current one
            if (newElementValue !== oldElementValue) {
                this.internalModification = true;
                _AutoNumericHelper2.default.setElementValue(this.domElement, newElementValue);
                this.internalModification = false;

                if (sendFormattedEvent) {
                    this._triggerEvent(AutoNumeric.events.formatted, this.domElement, {
                        oldValue: oldElementValue,
                        newValue: newElementValue,
                        oldRawValue: this.rawValue,
                        newRawValue: this.rawValue,
                        isPristine: this.isPristine(false),
                        error: null,
                        aNElement: this
                    });
                }
            }

            return this;
        }

        /**
         * Set the given value on the DOM element, and the raw value on `this.rawValue`, if both are given.
         * If only one value is given, then both the DOM element value and the raw value are set with that value.
         * The third argument `saveChangeToHistory` defines if the change should be recorded in the history array.
         * Note: if the second argument `rawValue` is a boolean, we consider that is really is the `saveChangeToHistory` argument.
         *
         * @param {number|string|null} newElementValue
         * @param {number|string|null|boolean} rawValue
         * @param {boolean} saveChangeToHistory
         * @returns {AutoNumeric}
         * @private
         */

    }, {
        key: '_setElementAndRawValue',
        value: function _setElementAndRawValue(newElementValue) {
            var rawValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var saveChangeToHistory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            if (_AutoNumericHelper2.default.isNull(rawValue)) {
                rawValue = newElementValue;
            } else if (_AutoNumericHelper2.default.isBoolean(rawValue)) {
                saveChangeToHistory = rawValue;
                rawValue = newElementValue;
            }

            //XXX The order here is important ; the value should first be set on the element, then and only then we should update the raw value
            // In the `set()` function, we make sure to call `_setRawValue` *after* `setElementValue` so that if `_setRawValue` calls a callback that modify the `rawValue`, then the new value is set correctly (after `setElementValue` briefly set its value first)
            this._setElementValue(newElementValue);
            this._setRawValue(rawValue, saveChangeToHistory);

            return this;
        }

        /**
         * Return the multiplied raw value with the `rawValueDivisor`.
         * This is used to display different values between the raw and formatted values.
         *
         * @param {number|string|null} rawValue The numeric value as understood by Javascript like a `Number`
         * @returns {number|string|null}
         * @private
         */

    }, {
        key: '_getRawValueToFormat',
        value: function _getRawValueToFormat(rawValue) {
            var rawValueForTheElementValue = void 0;
            if (!_AutoNumericHelper2.default.isNull(this.settings.rawValueDivisor) && this.settings.rawValueDivisor !== 0 && // Only multiply if the `rawValueDivisor` option is set
            rawValue !== '' && rawValue !== null) {
                // Do not modify the `rawValue` if it's an empty string or null
                // !this._isUserManuallyEditingTheValue()) { // If the user is NOT manually changing the element value, but that is done programmatically
                rawValueForTheElementValue = rawValue * this.settings.rawValueDivisor;
            } else {
                rawValueForTheElementValue = rawValue;
            }

            return rawValueForTheElementValue;
        }

        /**
         * Check if the given value has a corresponding key in the `valuesToStrings` option object.
         *
         * @param {number|string} value
         * @returns {boolean} Returns `true` if such a key is found.
         * @private
         */

    }, {
        key: '_checkValuesToStrings',
        value: function _checkValuesToStrings(value) {
            return this.constructor._checkValuesToStringsArray(value, this.valuesToStringsKeys);
        }

        /**
         * Check if the given value has a corresponding key in the `stringsArray` array.
         *
         * @param {number|string} key
         * @param {array} stringsArray Array where the `key` is checked against its keys
         * @returns {boolean} Returns `true` if such a key is found.
         * @private
         */

    }, {
        key: '_isUserManuallyEditingTheValue',


        /**
         * Return `true` if the user is currently modifying the element value manually.
         *
         * @returns {boolean}
         * @private
         */
        value: function _isUserManuallyEditingTheValue() {
            // return (this.isFocused && this.isEditing) || this.isWheelEvent || this.isDropEvent;
            return this.isFocused && this.isEditing || this.isDropEvent;
        }

        /**
         * Execute the given callback function using the given result as its first parameter, and the AutoNumeric object as its second.
         *
         * @param {number|string|Array|null} result
         * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
         * @private
         */

    }, {
        key: '_executeCallback',
        value: function _executeCallback(result, callback) {
            if (!_AutoNumericHelper2.default.isNull(callback) && _AutoNumericHelper2.default.isFunction(callback)) {
                callback(result, this);
            }
        }

        /**
         * Trigger the given event on the given element with the given detail.
         * This takes into account the `eventBubbles` and `eventIsCancelable` options.
         *
         * @param {string} eventName
         * @param {HTMLElement|HTMLDocument|EventTarget} element
         * @param {object} detail
         * @private
         */

    }, {
        key: '_triggerEvent',
        value: function _triggerEvent(eventName) {
            var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
            var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            _AutoNumericHelper2.default.triggerEvent(eventName, element, detail, this.settings.eventBubbles, this.settings.eventIsCancelable);
        }

        /**
         * Alias of the `getNumericString()` function.
         * Developers should use one of the more explicit function names to get what they want :
         * - a numeric string : `getNumericString()`
         * - a formatted string : `getFormatted()`
         * - a number : `getNumber()`, or
         * - a localized numeric string : `getLocalized()`
         *
         * @usage anElement.get();
         *
         * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
         *
         * @deprecated
         * @returns {string|null}
         */

    }, {
        key: 'get',
        value: function get() {
            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            return this.getNumericString(callback);
        }

        /**
         * Return the unformatted value as a string.
         * This can also return `null` if `rawValue` is null.
         *
         * @usage anElement.getNumericString();
         *
         * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
         *
         * @returns {string|null}
         */

    }, {
        key: 'getNumericString',
        value: function getNumericString() {
            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var result = void 0;
            if (_AutoNumericHelper2.default.isNull(this.rawValue)) {
                result = null;
            } else {
                // Always return a numeric string
                // The following statement gets rid of the trailing zeros in the decimal places since the current method does not pad decimals
                result = _AutoNumericHelper2.default.trimPaddedZerosFromDecimalPlaces(this.rawValue);
            }

            this._executeCallback(result, callback);

            return result;
        }

        /**
         * Return the current formatted value of the AutoNumeric element as a string
         *
         * @usage anElement.getFormatted()
         *
         * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
         *
         * @returns {string}
         */

    }, {
        key: 'getFormatted',
        value: function getFormatted() {
            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (!('value' in this.domElement || 'textContent' in this.domElement)) {
                // Make sure `.value` or `.textContent' exists before trying to access those properties
                _AutoNumericHelper2.default.throwError('Unable to get the formatted string from the element.');
            }

            var result = _AutoNumericHelper2.default.getElementValue(this.domElement);
            this._executeCallback(result, callback);

            return result;
        }

        /**
         * Return the element unformatted value as a real Javascript number.
         * Warning: This can lead to precision problems with big numbers that should be stored as strings.
         *
         * @usage anElement.getNumber()
         *
         * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
         *
         * @returns {number|null}
         */

    }, {
        key: 'getNumber',
        value: function getNumber() {
            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var result = void 0;
            if (this.rawValue === null) {
                result = null;
            } else {
                result = this.constructor._toLocale(this.getNumericString(), 'number', this.settings);
            }

            this._executeCallback(result, callback);

            return result;
        }

        /**
         * Returns the unformatted value, but following the `outputFormat` setting, which means the output can either be :
         * - a string (that could or could not represent a number (ie. "12345,67-")), or
         * - a plain number (if the setting 'number' is used).
         *
         * By default the returned values are an ISO numeric string "1234.56" or "-1234.56" where the decimal character is a period.
         * Check the "outputFormat" option definition for more details.
         *
         * @usage anElement.getLocalized();
         *
         * @param {null|string|function} forcedOutputFormat If set to something different than `null`, then this is used as an overriding outputFormat option
         * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
         *
         * @returns {*}
         */

    }, {
        key: 'getLocalized',
        value: function getLocalized() {
            var forcedOutputFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            // First, check if only a callback has been passed, and if so, sanitize the parameters
            if (_AutoNumericHelper2.default.isFunction(forcedOutputFormat) && _AutoNumericHelper2.default.isNull(callback)) {
                callback = forcedOutputFormat;
                forcedOutputFormat = null;
            }

            // Then get the localized value
            var value = void 0;
            if (_AutoNumericHelper2.default.isEmptyString(this.rawValue)) {
                value = '';
            } else {
                // Here I use `this.rawValue` instead of `this.getNumericString()` since the current input value could be unformatted with a localization (ie. '1234567,89-').
                // I also convert the rawValue to a number, then back to a string in order to drop the decimal part if the rawValue is an integer.
                value = '' + Number(this.rawValue);
            }

            if (value !== '' && Number(value) === 0 && this.settings.leadingZero !== AutoNumeric.options.leadingZero.keep) {
                value = '0';
            }

            var outputFormatToUse = void 0;
            if (_AutoNumericHelper2.default.isNull(forcedOutputFormat)) {
                outputFormatToUse = this.settings.outputFormat;
            } else {
                outputFormatToUse = forcedOutputFormat;
            }

            var result = this.constructor._toLocale(value, outputFormatToUse, this.settings);
            this._executeCallback(result, callback);

            return result;
        }

        /**
         * Force the element to reformat its value again (just in case the formatting has been lost).
         * This can be used right after a form submission for instance (after a previous call to `unformat`).
         *
         * @example anElement.reformat()
         *
         * @returns {AutoNumeric}
         */

    }, {
        key: 'reformat',
        value: function reformat() {
            // `this.rawValue` is used instead of `this.domElement.value` because when the content is `unformatLocalized`, it can become a string that cannot be converted to a number easily
            this.set(this.rawValue);

            return this;
        }

        /**
         * Remove the formatting and keep only the raw unformatted value in the element (as a numericString)
         * Note: this is loosely based on the previous 'unSet()' function
         *
         * By default, values are returned as ISO numeric strings (ie. "1234.56" or "-1234.56"), where the decimal character is a period.
         * @example anElement.unformat()
         *
         * @returns {AutoNumeric}
         */

    }, {
        key: 'unformat',
        value: function unformat() {
            this._setElementValue(this.getNumericString());

            return this;
        }

        /**
         * Remove the formatting and keep only the localized unformatted value in the element, with the option to override the default outputFormat if needed
         *
         * Locale formats are supported "1234.56-" or "1234,56" or "-1234,56 or "1234,56-", or even plain numbers.
         * Take a look at the `outputFormat` option definition in the default settings for more details.
         *
         * @param {null|string} forcedOutputFormat If set to something different than `null`, then this is used as an overriding outputFormat option
         * @returns {AutoNumeric}
         */

    }, {
        key: 'unformatLocalized',
        value: function unformatLocalized() {
            var forcedOutputFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this._setElementValue(this.getLocalized(forcedOutputFormat));

            return this;
        }

        /**
         * Return `true` if the current value is the same as when the element got initialized.
         * Note: By default, this returns `true` if the raw unformatted value is still the same even if the formatted one has changed (due to a configuration update for instance).
         * In order to test if the formatted value is the same (which means neither the raw value nor the settings have been changed), then you must pass `false` as its argument.
         *
         * @param {boolean} checkOnlyRawValue If set to `true`, the pristine value is done on the raw unformatted value, not the formatted one.  If set to `false`, this also checks that the formatted value hasn't changed.
         * @returns {boolean}
         */

    }, {
        key: 'isPristine',
        value: function isPristine() {
            var checkOnlyRawValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            var result = void 0;
            if (checkOnlyRawValue) {
                result = this.initialValue === this.getNumericString();
            } else {
                result = this.initialValueHtmlAttribute === this.getFormatted();
            }

            return result;
        }

        /**
         * Select the formatted element content, based on the `selectNumberOnly` option
         *
         * @returns {AutoNumeric}
         */

    }, {
        key: 'select',
        value: function select() {
            if (this.settings.selectNumberOnly) {
                this.selectNumber();
            } else {
                this._defaultSelectAll();
            }

            return this;
        }

        /**
         * Select the whole element content (including the currency symbol).
         * @private
         */

    }, {
        key: '_defaultSelectAll',
        value: function _defaultSelectAll() {
            _AutoNumericHelper2.default.setElementSelection(this.domElement, 0, _AutoNumericHelper2.default.getElementValue(this.domElement).length);
        }

        /**
         * Select only the numbers in the formatted element content, leaving out the currency symbol, whatever the value of the `selectNumberOnly` option
         *
         * @returns {AutoNumeric}
         */

    }, {
        key: 'selectNumber',
        value: function selectNumber() {
            //TODO Make sure the selection is ok when showPositiveSign is set to `true` (select the negative sign, but not the positive one)
            var unformattedValue = _AutoNumericHelper2.default.getElementValue(this.domElement);
            var valueLen = unformattedValue.length;
            var currencySymbolSize = this.settings.currencySymbol.length;
            var currencySymbolPlacement = this.settings.currencySymbolPlacement;
            var negLen = !_AutoNumericHelper2.default.isNegative(unformattedValue, this.settings.negativeSignCharacter) ? 0 : 1;
            var suffixTextLen = this.settings.suffixText.length;

            var start = void 0;
            if (currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.suffix) {
                start = 0;
            } else if (this.settings.negativePositiveSignPlacement === AutoNumeric.options.negativePositiveSignPlacement.left && negLen === 1 && currencySymbolSize > 0) {
                start = currencySymbolSize + 1;
            } else {
                start = currencySymbolSize;
            }

            var end = void 0;
            if (currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.prefix) {
                end = valueLen - suffixTextLen;
            } else {
                switch (this.settings.negativePositiveSignPlacement) {
                    case AutoNumeric.options.negativePositiveSignPlacement.left:
                        end = valueLen - (suffixTextLen + currencySymbolSize);
                        break;
                    case AutoNumeric.options.negativePositiveSignPlacement.right:
                        if (currencySymbolSize > 0) {
                            end = valueLen - (currencySymbolSize + negLen + suffixTextLen);
                        } else {
                            end = valueLen - (currencySymbolSize + suffixTextLen);
                        }
                        break;
                    default:
                        end = valueLen - (currencySymbolSize + suffixTextLen);
                }
            }

            _AutoNumericHelper2.default.setElementSelection(this.domElement, start, end);

            return this;
        }

        /**
         * Select only the integer part in the formatted element content, whatever the value of `selectNumberOnly`
         *
         * @returns {AutoNumeric}
         */

    }, {
        key: 'selectInteger',
        value: function selectInteger() {
            var start = 0;
            var isPositive = this.rawValue >= 0;

            // Negative or positive sign, if any
            if (this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.prefix || this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.suffix && (this.settings.negativePositiveSignPlacement === AutoNumeric.options.negativePositiveSignPlacement.prefix || this.settings.negativePositiveSignPlacement === AutoNumeric.options.negativePositiveSignPlacement.none)) {
                if (this.settings.showPositiveSign && isPositive || // This only exclude the positive sign from being selected
                !isPositive && this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.prefix && this.settings.negativePositiveSignPlacement === AutoNumeric.options.negativePositiveSignPlacement.left) {
                    // And this exclude the negative sign from being selected in this special case : '-€ 1.234,57suffixText'
                    start = start + 1;
                }
            }

            // Currency symbol
            if (this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.prefix) {
                start = start + this.settings.currencySymbol.length;
            }

            // Calculate the selection end position
            var elementValue = _AutoNumericHelper2.default.getElementValue(this.domElement);
            var end = elementValue.indexOf(this.settings.decimalCharacter);
            if (end === -1) {
                // No decimal character found
                if (this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.suffix) {
                    end = elementValue.length - this.settings.currencySymbol.length;
                } else {
                    end = elementValue.length;
                }

                // Trailing negative sign
                if (!isPositive && (this.settings.negativePositiveSignPlacement === AutoNumeric.options.negativePositiveSignPlacement.suffix || this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.suffix)) {
                    end = end - 1;
                }

                // Avoid selecting the suffix test
                end = end - this.settings.suffixText.length;
            }

            _AutoNumericHelper2.default.setElementSelection(this.domElement, start, end);

            return this;
        }

        /**
         * Select only the decimal part in the formatted element content, whatever the value of `selectNumberOnly`
         * Multiple cases are possible :
         * +1.234,57suffixText
         *
         * € +1.234,57suffixText
         * +€ 1.234,57suffixText
         * € 1.234,57+suffixText
         *
         * 1.234,57+ €suffixText
         * 1.234,57 €+suffixText
         * +1.234,57 €suffixText
         *
         * @returns {AutoNumeric}
         */

    }, {
        key: 'selectDecimal',
        value: function selectDecimal() {
            var start = _AutoNumericHelper2.default.getElementValue(this.domElement).indexOf(this.settings.decimalCharacter);
            var end = void 0;

            if (start === -1) {
                // The decimal character has not been found, we deselect all
                start = 0;
                end = 0;
            } else {
                // A decimal character has been found
                start = start + 1; // We add 1 to exclude the decimal character from the selection

                var decimalCount = void 0;
                if (this.isFocused) {
                    decimalCount = this.settings.decimalPlacesShownOnFocus;
                } else {
                    decimalCount = this.settings.decimalPlacesShownOnBlur;
                }

                end = start + Number(decimalCount);
            }

            _AutoNumericHelper2.default.setElementSelection(this.domElement, start, end);

            return this;
        }

        /**
         * Return the DOM element reference of the autoNumeric-managed element
         *
         * @returns {HTMLElement|HTMLInputElement}
         */

    }, {
        key: 'node',
        value: function node() {
            return this.domElement;
        }

        /**
         * Return the DOM element reference of the parent node of the autoNumeric-managed element
         *
         * @returns {HTMLElement|HTMLInputElement|Node}
         */

    }, {
        key: 'parent',
        value: function parent() {
            return this.domElement.parentNode;
        }

        /**
         * Detach the current AutoNumeric element from the shared local 'init' list.
         * This means any changes made on that local shared list will not be transmitted to that element anymore.
         * Note : The user can provide another AutoNumeric element, and detach this one instead of the current one.
         *
         * @param {AutoNumeric} otherAnElement
         * @returns {AutoNumeric}
         */

    }, {
        key: 'detach',
        value: function detach() {
            var otherAnElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            //FIXME test this
            var domElementToDetach = void 0;
            if (!_AutoNumericHelper2.default.isNull(otherAnElement)) {
                domElementToDetach = otherAnElement.node();
            } else {
                domElementToDetach = this.domElement;
            }

            this._removeFromLocalList(domElementToDetach); //FIXME What happens if the selected dom element does not exist in the list?

            return this;
        }

        /**
         * Attach the given AutoNumeric element to the shared local 'init' list.
         * When doing that, by default the DOM content is left untouched.
         * The user can force a reformat with the new shared list options by passing a second argument to `true`.
         *
         * @param {AutoNumeric} otherAnElement
         * @param {boolean} reFormat
         * @returns {AutoNumeric}
         */

    }, {
        key: 'attach',
        value: function attach(otherAnElement) {
            var reFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            //FIXME test this
            this._addToLocalList(otherAnElement.node()); //FIXME Should we make sure the element is not already in the list?
            if (reFormat) {
                otherAnElement.update(this.settings);
            }

            return this;
        }

        /**
         * Format and return the given value, or set the formatted value into the given DOM element if one is passed as an argument.
         * By default, this use the current element settings.
         * The user can override any option of its choosing by passing an option object.
         *
         * @param {number|HTMLElement|HTMLInputElement} valueOrElement
         * @param {null|object} optionOverride
         * @returns {string|null}
         */

    }, {
        key: 'formatOther',
        value: function formatOther(valueOrElement) {
            var optionOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            //FIXME test this
            return this._formatOrUnformatOther(true, valueOrElement, optionOverride);
        }

        /**
         * Unformat and return the raw numeric string corresponding to the given value, or directly set the unformatted value into the given DOM element if one is passed as an argument.
         * By default, this use the current element settings.
         * The user can override any option of its choosing by passing an option object.
          * @param {string|HTMLElement|HTMLInputElement} stringOrElement
         * @param {null|object} optionOverride
         * @returns {string|null}
         */

    }, {
        key: 'unformatOther',
        value: function unformatOther(stringOrElement) {
            var optionOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            //FIXME test this
            return this._formatOrUnformatOther(false, stringOrElement, optionOverride);
        }

        /**
         * Method that either format or unformat the value of another element.
         *
         * - Format and return the given value, or set the formatted value into the given DOM element if one is passed as an argument.
         * - Unformat and return the raw numeric string corresponding to the given value, or directly set the unformatted value into the given DOM element if one is passed as an argument.
         *
         * By default, this use the current element settings.
         * The user can override any option of its choosing by passing an option object.
         *
         * @param {boolean} isFormatting If set to `true`, then the method formats, otherwise if set to `false`, it unformats
         * @param {number|string|HTMLElement|HTMLInputElement} valueOrStringOrElement
         * @param {null|object} optionOverride
         * @returns {string|null}
         * @private
         */

    }, {
        key: '_formatOrUnformatOther',
        value: function _formatOrUnformatOther(isFormatting, valueOrStringOrElement) {
            var optionOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            //FIXME test this
            // If the user wants to override the current element settings temporarily
            var settingsToUse = void 0;
            if (!_AutoNumericHelper2.default.isNull(optionOverride)) {
                settingsToUse = this._cloneAndMergeSettings(optionOverride);
            } else {
                settingsToUse = this.settings;
            }

            // Then the unformatting is done...
            var result = void 0;
            if (_AutoNumericHelper2.default.isElement(valueOrStringOrElement)) {
                // ...either directly on the DOM element value
                var elementValue = _AutoNumericHelper2.default.getElementValue(valueOrStringOrElement);
                if (isFormatting) {
                    result = AutoNumeric.format(elementValue, settingsToUse);
                } else {
                    result = AutoNumeric.unformat(elementValue, settingsToUse);
                }

                _AutoNumericHelper2.default.setElementValue(valueOrStringOrElement, result); //TODO Use `unformatAndSet` and `formatAndSet`instead

                return null;
            }

            // ...or on the given value
            if (isFormatting) {
                result = AutoNumeric.format(valueOrStringOrElement, settingsToUse);
            } else {
                result = AutoNumeric.unformat(valueOrStringOrElement, settingsToUse);
            }

            return result;
        }

        /**
         * Use the current AutoNumeric element settings to initialize the DOM element(s) given as a parameter.
         * Doing so will *link* the AutoNumeric elements together since they will share the same local AutoNumeric element list.
         * (cf. prototype pattern : https://en.wikipedia.org/wiki/Prototype_pattern)
         *
         * You can `init` either a single DOM element (in that case an AutoNumeric object will be returned), or an array of DOM elements or a string that will be used as a CSS selector. In the latter cases, an array of AutoNumeric objects will then be returned (or an empty array if nothing gets selected by the CSS selector).
         *
         * Use case : Once you have an AutoNumeric element already setup correctly with the right options, you can use it as many times you want to initialize as many other DOM elements as needed.
         * Note : this works only on elements that can be managed by autoNumeric.
         *
         * @param {HTMLElement|HTMLInputElement|Array<HTMLElement|HTMLInputElement>|string} domElementOrArrayOrString
         * @param {boolean} attached If set to `false`, then the newly generated AutoNumeric element will not share the same local element list
         * @returns {AutoNumeric|[AutoNumeric]}
         */

    }, {
        key: 'init',
        value: function init(domElementOrArrayOrString) {
            var _this8 = this;

            var attached = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            var returnASingleAutoNumericObject = false; // By default, this function returns an array of AutoNumeric objects
            var domElementsArray = [];
            if (_AutoNumericHelper2.default.isString(domElementOrArrayOrString)) {
                domElementsArray = [].concat(_toConsumableArray(document.querySelectorAll(domElementOrArrayOrString))); // Convert a NodeList to an Array
            } else if (_AutoNumericHelper2.default.isElement(domElementOrArrayOrString)) {
                domElementsArray.push(domElementOrArrayOrString);
                returnASingleAutoNumericObject = true; // Special case when only one DOM element is passed as a parameter
            } else if (_AutoNumericHelper2.default.isArray(domElementOrArrayOrString)) {
                domElementsArray = domElementOrArrayOrString;
            } else {
                _AutoNumericHelper2.default.throwError('The given parameters to the \'init\' function are invalid.');
            }

            if (domElementsArray.length === 0) {
                _AutoNumericHelper2.default.warning('No valid DOM elements were given hence no AutoNumeric object were instantiated.', true);

                return [];
            }

            var currentLocalList = this._getLocalList();
            var autoNumericObjectsArray = [];

            // Instantiate (and link depending on `attached`) each AutoNumeric objects
            domElementsArray.forEach(function (domElement) {
                // Initialize the new AutoNumeric element
                var originalCreateLocalListSetting = _this8.settings.createLocalList;
                if (attached) {
                    // Temporary variable to know if we should create the local list during the initialization (since we'll remove it afterwards)
                    _this8.settings.createLocalList = false;
                }

                var newAutoNumericElement = new AutoNumeric(domElement, _AutoNumericHelper2.default.getElementValue(domElement), _this8.settings);

                // Set the common shared local list if needed
                // If the user wants to create a detached new AutoNumeric element, then skip the following step that bind the two elements together by default
                if (attached) {
                    // 1) Set the local list reference to point to the initializer's one
                    newAutoNumericElement._setLocalList(currentLocalList);

                    // 2) Add the new element to that existing list
                    _this8._addToLocalList(domElement, newAutoNumericElement); // Here we use the *new* AutoNumeric object reference to add to the local list, since we'll need the reference to `this` in the methods to points to that new AutoNumeric object.
                    _this8.settings.createLocalList = originalCreateLocalListSetting;
                }

                autoNumericObjectsArray.push(newAutoNumericElement);
            });

            if (returnASingleAutoNumericObject) {
                // If a single DOM element was used as the parameter, then we return an AutoNumeric object directly
                return autoNumericObjectsArray[0];
            }

            // ...otherwise we return an Array of AutoNumeric objects
            return autoNumericObjectsArray;
        }

        /**
         * Reset the element value either to the empty string '', or the currency sign, depending on the `emptyInputBehavior` option value.
         * If you set the `forceClearAll` argument to `true`, then the `emptyInputBehavior` option is overridden and the whole input is clear, including any currency sign.
         *
         * @param {boolean} forceClearAll
         * @returns {AutoNumeric}
         */

    }, {
        key: 'clear',
        value: function clear() {
            var forceClearAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (forceClearAll) {
                var temporaryForcedOptions = {
                    emptyInputBehavior: AutoNumeric.options.emptyInputBehavior.focus
                };
                this.set('', temporaryForcedOptions);
            } else {
                this.set('');
            }

            return this;
        }

        /**
         * Remove the autoNumeric data and event listeners from the element, but keep the element content intact.
         * This also clears the value from sessionStorage (or cookie, depending on browser supports).
         * Note: this does not remove the formatting.
         *
         * @example anElement.remove()
         */

    }, {
        key: 'remove',
        value: function remove() {
            this._removeValueFromPersistentStorage();
            this._removeEventListeners();
            this._removeWatcher();

            // Also remove the element from the local AutoNumeric list
            this._removeFromLocalList(this.domElement);
            // Also remove the element from the global AutoNumeric list
            this.constructor._removeFromGlobalList(this);
        }

        /**
         * Remove the autoNumeric data and event listeners from the element, and reset its value to the empty string ''.
         * This also clears the value from sessionStorage (or cookie, depending on browser supports).
         *
         * @example anElement.wipe()
         */

    }, {
        key: 'wipe',
        value: function wipe() {
            this._setElementValue('', false); // Do not send the 'AutoNumeric.events.formatted' event when wiping an AutoNumeric object
            this.remove();
        }

        /**
         * Remove the autoNumeric data and event listeners from the element, and delete the DOM element altogether
         */

    }, {
        key: 'nuke',
        value: function nuke() {
            this.remove();
            // Remove the element from the DOM
            this.domElement.parentNode.removeChild(this.domElement);
        }

        // Special functions that really work on the parent <form> element, instead of the <input> element itself

        /**
         * Return a reference to the parent <form> element if it exists, otherwise return `null`.
         * If the parent form element as already been found, this directly return a reference to it.
         * However, you can force AutoNumeric to search again for its reference by passing `true` as a parameter to this method.
         * This method updates the `this.parentForm` attribute.
         *
         * In either case, whenever a new parent form is set for the current AutoNumeric element, we make sure to update the anCount and anFormHandler attributes on both the old form and the new one (for instance in case the user moved the input elements with `appendChild()` since AutoNumeric cannot not detect that).
         *
         * @param {boolean} forceSearch If set to `true`, the parent form is searched again, even if `this.parentForm` is already set.
         *
         * @returns {HTMLFormElement|null}
         */

    }, {
        key: 'form',
        value: function form() {
            var forceSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (forceSearch || _AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(this.parentForm)) {
                var newParentForm = this._getParentForm();
                if (!_AutoNumericHelper2.default.isNull(newParentForm) && newParentForm !== this.parentForm) {
                    // If the current parent form exists and is different from the previous parent form

                    // Search for all the AutoNumeric elements in the old parent form
                    var oldANChildren = this._getFormAutoNumericChildren(this.parentForm);
                    // Update the anCount with the correct number of AutoNumeric elements
                    this.parentForm.dataset.anCount = oldANChildren.length;

                    // Check if the new parent form already has a anFormHandler name
                    if (this._hasFormHandlerFunction(newParentForm)) {
                        this._incrementParentFormCounter(newParentForm); // Increment its counter
                    } else {
                        // Create one and set the anCount to 1
                        this._storeFormHandlerFunction(newParentForm);
                        this._initializeFormCounterToOne(newParentForm);
                    }
                }

                this.parentForm = newParentForm;
            }

            return this.parentForm;
        }

        /**
         * Return an array of the AutoNumeric-managed elements for the given form element is passed, otherwise for the current `this.parentForm` element.
         *
         * @param {HTMLFormElement|null} formElement
         *
         * @returns {Array.<HTMLInputElement>}
         * @private
         */

    }, {
        key: '_getFormAutoNumericChildren',
        value: function _getFormAutoNumericChildren(formElement) {
            var _this9 = this;

            // Search for all the child AutoNumeric elements in that parent form
            //TODO This only search for <input> elements, not contenteditable non-input tag ones, for now. Add a parameter to allow this function to search on every tags.
            var inputList = [].concat(_toConsumableArray(formElement.querySelectorAll('input')));

            return inputList.filter(function (input) {
                return _this9.constructor.isManagedByAutoNumeric(input);
            });
        }

        /**
         * Return a reference to the parent <form> element if it exists, otherwise return `null`.
         *
         * @returns {HTMLFormElement|null}
         * @private
         */

    }, {
        key: '_getParentForm',
        value: function _getParentForm() {
            if (this.domElement.tagName.toLowerCase() === 'body') {
                return null;
            }

            var node = this.domElement;
            var tagName = void 0;
            do {
                node = node.parentNode;
                if (_AutoNumericHelper2.default.isNull(node)) {
                    // Special case when using templates with frameworks like Vue.js, where the input element can be 'detached' when initializing the DOM structure
                    return null;
                }

                if (node.tagName) {
                    tagName = node.tagName.toLowerCase();
                } else {
                    tagName = '';
                }

                if (tagName === 'body') {
                    // Get out of the loop if we get up to the `<body>` element
                    break;
                }
            } while (tagName !== 'form');

            if (tagName === 'form') {
                return node;
            } else {
                return null;
            }
        }

        /**
         * Return a string in standard URL-encoded notation with the form input values being unformatted.
         * This string can be used as a query for instance.
         *
         * @returns {string}
         */

    }, {
        key: 'formNumericString',
        value: function formNumericString() {
            return this.constructor._serializeNumericString(this.form(), this.settings.serializeSpaces);
        }

        /**
         * Return a string in standard URL-encoded notation with the form input values being formatted.
         *
         * @returns {string}
         */

    }, {
        key: 'formFormatted',
        value: function formFormatted() {
            return this.constructor._serializeFormatted(this.form(), this.settings.serializeSpaces);
        }

        /**
         * Return a string in standard URL-encoded notation with the form input values, with localized values.
         * The default output format can be overridden by passing the option as a parameter.
         *
         * @param {null|string} forcedOutputFormat If set to something different than `null`, then this is used as an overriding outputFormat option
         * @returns {string}
         */

    }, {
        key: 'formLocalized',
        value: function formLocalized() {
            var forcedOutputFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var outputFormatToUse = void 0;
            if (_AutoNumericHelper2.default.isNull(forcedOutputFormat)) {
                outputFormatToUse = this.settings.outputFormat;
            } else {
                outputFormatToUse = forcedOutputFormat;
            }

            return this.constructor._serializeLocalized(this.form(), this.settings.serializeSpaces, outputFormatToUse);
        }

        /**
         * Return an array containing an object for each form <input> element.
         * Those objects are of the following structure `{ name: foo, value: '42' }`, where the `name` is the DOM element name, and the `value` is an unformatted numeric string.
         *
         * @returns {Array}
         */

    }, {
        key: 'formArrayNumericString',
        value: function formArrayNumericString() {
            return this.constructor._serializeNumericStringArray(this.form(), this.settings.serializeSpaces);
        }

        /**
         * Return an array containing an object for each form <input> element.
         * Those objects are of the following structure `{ name: foo, value: '42' }`, where the `name` is the DOM element name, and the `value` is the formatted string.
         *
         * @returns {Array}
         */

    }, {
        key: 'formArrayFormatted',
        value: function formArrayFormatted() {
            return this.constructor._serializeFormattedArray(this.form(), this.settings.serializeSpaces);
        }

        /**
         * Return an array containing an object for each form <input> element.
         * Those objects are of the following structure `{ name: foo, value: '42' }`, where the `name` is the DOM element name, and the `value` is the localized numeric string.
         *
         * @param {null|string} forcedOutputFormat If set to something different than `null`, then this is used as an overriding outputFormat option
         * @returns {Array}
         */

    }, {
        key: 'formArrayLocalized',
        value: function formArrayLocalized() {
            var forcedOutputFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var outputFormatToUse = void 0;
            if (_AutoNumericHelper2.default.isNull(forcedOutputFormat)) {
                outputFormatToUse = this.settings.outputFormat;
            } else {
                outputFormatToUse = forcedOutputFormat;
            }

            return this.constructor._serializeLocalizedArray(this.form(), this.settings.serializeSpaces, outputFormatToUse);
        }

        /**
         * Return a JSON string containing an object representing the form input values.
         * This is based on the result of the `formArrayNumericString()` function.
         *
         * @returns {string}
         */

    }, {
        key: 'formJsonNumericString',
        value: function formJsonNumericString() {
            return JSON.stringify(this.formArrayNumericString());
        }

        /**
         * Return a JSON string containing an object representing the form input values.
         * This is based on the result of the `formArrayFormatted()` function.
         *
         * @returns {string}
         */

    }, {
        key: 'formJsonFormatted',
        value: function formJsonFormatted() {
            return JSON.stringify(this.formArrayFormatted());
        }

        /**
         * Return a JSON string containing an object representing the form input values.
         * This is based on the result of the `formArrayLocalized()` function.
         *
         * @param {null|string} forcedOutputFormat If set to something different than `null`, then this is used as an overriding outputFormat option
         * @returns {string}
         */

    }, {
        key: 'formJsonLocalized',
        value: function formJsonLocalized() {
            var forcedOutputFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            return JSON.stringify(this.formArrayLocalized(forcedOutputFormat));
        }

        /**
         * Unformat all the autoNumeric-managed elements that are a child of the parent <form> element of this DOM element, to numeric strings
         *
         * @returns {AutoNumeric}
         */

    }, {
        key: 'formUnformat',
        value: function formUnformat() {
            //FIXME test this
            var inputs = this.constructor._getChildANInputElement(this.form());
            inputs.forEach(function (input) {
                AutoNumeric.getAutoNumericElement(input).unformat();
            });

            return this;
        }

        /**
         * Unformat all the autoNumeric-managed elements that are a child of the parent <form> element of this DOM element, to localized strings
         *
         * @returns {AutoNumeric}
         */

    }, {
        key: 'formUnformatLocalized',
        value: function formUnformatLocalized() {
            //FIXME test this
            var inputs = this.constructor._getChildANInputElement(this.form());
            inputs.forEach(function (input) {
                AutoNumeric.getAutoNumericElement(input).unformatLocalized();
            });

            return this;
        }

        /**
         * Reformat all the autoNumeric-managed elements that are a child of the parent <form> element of this DOM element
         *
         * @returns {AutoNumeric}
         */

    }, {
        key: 'formReformat',
        value: function formReformat() {
            //FIXME test this
            var inputs = this.constructor._getChildANInputElement(this.form());
            inputs.forEach(function (input) {
                AutoNumeric.getAutoNumericElement(input).reformat();
            });

            return this;
        }

        /**
         * Convert the input values to numeric strings, submit the form, then reformat those back.
         * The function can either take a callback, or not. If it doesn't, the default `form.submit()` function will be called.
         * Otherwise, it runs `callback(value)` with `value` being equal to the result of `formNumericString()`.
         *
         * @param {function|null} callback
         * @returns {AutoNumeric}
         */

    }, {
        key: 'formSubmitNumericString',
        value: function formSubmitNumericString() {
            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            //FIXME test this
            if (_AutoNumericHelper2.default.isNull(callback)) {
                this.formUnformat();
                this.form().submit();
                this.formReformat();
            } else if (_AutoNumericHelper2.default.isFunction(callback)) {
                callback(this.formNumericString());
            } else {
                _AutoNumericHelper2.default.throwError('The given callback is not a function.');
            }

            return this;
        }

        /**
         * Submit the form with the current formatted values.
         * The function can either take a callback, or not. If it doesn't, the default `form.submit()` function will be called.
         * Otherwise, it runs `callback(value)` with `value` being equal to the result of `formFormatted()`.
         *
         * @param {function|null} callback
         * @returns {AutoNumeric}
         */

    }, {
        key: 'formSubmitFormatted',
        value: function formSubmitFormatted() {
            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            //FIXME test this
            if (_AutoNumericHelper2.default.isNull(callback)) {
                this.form().submit();
            } else if (_AutoNumericHelper2.default.isFunction(callback)) {
                callback(this.formFormatted());
            } else {
                _AutoNumericHelper2.default.throwError('The given callback is not a function.');
            }

            return this;
        }

        /**
         * Convert the input values to localized strings, submit the form, then reformat those back.
         * The function can either take a callback, or not. If it doesn't, the default `form.submit()` function will be called.
         * Otherwise, it runs `callback(value)` with `value` being equal to the result of `formLocalized()`.
         *
         * @param {null|string} forcedOutputFormat If set to something different than `null`, then this is used as an overriding outputFormat option
         * @param {function|null} callback
         * @returns {AutoNumeric}
         */

    }, {
        key: 'formSubmitLocalized',
        value: function formSubmitLocalized() {
            var forcedOutputFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            //FIXME test this
            if (_AutoNumericHelper2.default.isNull(callback)) {
                this.formUnformatLocalized();
                this.form().submit();
                this.formReformat();
            } else if (_AutoNumericHelper2.default.isFunction(callback)) {
                callback(this.formLocalized(forcedOutputFormat));
            } else {
                _AutoNumericHelper2.default.throwError('The given callback is not a function.');
            }

            return this;
        }

        /**
         * Generate an array of numeric strings from the `<input>` elements, and pass it to the given callback.
         * Under the hood, the array is generated via a call to `formArrayNumericString()`.
         *
         * @param {function} callback
         * @returns {AutoNumeric}
         */

    }, {
        key: 'formSubmitArrayNumericString',
        value: function formSubmitArrayNumericString(callback) {
            //FIXME test this
            if (_AutoNumericHelper2.default.isFunction(callback)) {
                callback(this.formArrayNumericString());
            } else {
                _AutoNumericHelper2.default.throwError('The given callback is not a function.');
            }

            return this;
        }

        /**
         * Generate an array of the current formatted values from the `<input>` elements, and pass it to the given callback.
         * Under the hood, the array is generated via a call to `formArrayFormatted()`.
         *
         * @param {function} callback
         * @returns {AutoNumeric}
         */

    }, {
        key: 'formSubmitArrayFormatted',
        value: function formSubmitArrayFormatted(callback) {
            //FIXME test this
            if (_AutoNumericHelper2.default.isFunction(callback)) {
                callback(this.formArrayFormatted());
            } else {
                _AutoNumericHelper2.default.throwError('The given callback is not a function.');
            }

            return this;
        }

        /**
         * Generate an array of localized strings from the `<input>` elements, and pass it to the given callback.
         * Under the hood, the array is generated via a call to `formArrayLocalized()`.
         *
         * @param {function} callback
         * @param {null|string} forcedOutputFormat If set to something different than `null`, then this is used as an overriding outputFormat option
         * @returns {AutoNumeric}
         */

    }, {
        key: 'formSubmitArrayLocalized',
        value: function formSubmitArrayLocalized(callback) {
            var forcedOutputFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            //FIXME test this
            if (_AutoNumericHelper2.default.isFunction(callback)) {
                callback(this.formArrayLocalized(forcedOutputFormat));
            } else {
                _AutoNumericHelper2.default.throwError('The given callback is not a function.');
            }

            return this;
        }

        /**
         * Generate a JSON string with the numeric strings values from the `<input>` elements, and pass it to the given callback.
         * Under the hood, the array is generated via a call to `formJsonNumericString()`.
         *
         * @param {function} callback
         * @returns {AutoNumeric}
         */

    }, {
        key: 'formSubmitJsonNumericString',
        value: function formSubmitJsonNumericString(callback) {
            //FIXME test this
            if (_AutoNumericHelper2.default.isFunction(callback)) {
                callback(this.formJsonNumericString());
            } else {
                _AutoNumericHelper2.default.throwError('The given callback is not a function.');
            }

            return this;
        }

        /**
         * Generate a JSON string with the current formatted values from the `<input>` elements, and pass it to the given callback.
         * Under the hood, the array is generated via a call to `formJsonFormatted()`.
         *
         * @param {function} callback
         * @returns {AutoNumeric}
         */

    }, {
        key: 'formSubmitJsonFormatted',
        value: function formSubmitJsonFormatted(callback) {
            //FIXME test this
            if (_AutoNumericHelper2.default.isFunction(callback)) {
                callback(this.formJsonFormatted());
            } else {
                _AutoNumericHelper2.default.throwError('The given callback is not a function.');
            }

            return this;
        }

        /**
         * Generate a JSON string with the localized strings values from the `<input>` elements, and pass it to the given callback.
         * Under the hood, the array is generated via a call to `formJsonLocalized()`.
         *
         * @param {function} callback
         * @param {null|string} forcedOutputFormat If set to something different than `null`, then this is used as an overriding outputFormat option
         * @returns {AutoNumeric}
         */

    }, {
        key: 'formSubmitJsonLocalized',
        value: function formSubmitJsonLocalized(callback) {
            var forcedOutputFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            //FIXME test this
            if (_AutoNumericHelper2.default.isFunction(callback)) {
                callback(this.formJsonLocalized(forcedOutputFormat));
            } else {
                _AutoNumericHelper2.default.throwError('The given callback is not a function.');
            }

            return this;
        }

        /**
         * Unformat the given AutoNumeric element, and update the `hoveredWithAlt` variable.
         *
         * @param {AutoNumeric} anElement
         * @private
         */

    }, {
        key: '_createLocalList',


        /**
         * Create a `Map` that will stores all the autoNumeric elements that are initialized from this current element.
         * @private
         */
        value: function _createLocalList() {
            this.autoNumericLocalList = new Map();
            this._addToLocalList(this.domElement);
        }

        /**
         * In some rare cases, you could want to delete the local list generated during the element initialization (in order to use another one instead for instance).
         * @private
         */

    }, {
        key: '_deleteLocalList',
        value: function _deleteLocalList() {
            delete this.autoNumericLocalList;
        }

        /**
         * Set the local list with the given Map object.
         *
         * @param {Map} localList
         * @private
         */

    }, {
        key: '_setLocalList',
        value: function _setLocalList(localList) {
            this.autoNumericLocalList = localList;
        }

        /**
         * Return the local list Map object.
         *
         * @returns {*|Map}
         * @private
         */

    }, {
        key: '_getLocalList',
        value: function _getLocalList() {
            return this.autoNumericLocalList;
        }

        /**
         * Return `true` if the AutoNumeric object has a local list defined already and has at least one element in it (itself usually).
         *
         * @returns {boolean}
         * @private
         */

    }, {
        key: '_hasLocalList',
        value: function _hasLocalList() {
            return this.autoNumericLocalList instanceof Map && this.autoNumericLocalList.size !== 0;
        }

        /**
         * Add the given object to the local autoNumeric element list.
         * Note: in order to keep a coherent list, we only add DOM elements in it, not the autoNumeric object.
         *
         * @param {HTMLElement|HTMLInputElement} domElement
         * @param {AutoNumeric} autoNumericObject A reference to the AutoNumeric object that manage the given DOM element
         * @throws
         * @private
         */

    }, {
        key: '_addToLocalList',
        value: function _addToLocalList(domElement) {
            var autoNumericObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (_AutoNumericHelper2.default.isNull(autoNumericObject)) {
                autoNumericObject = this;
            }

            if (!_AutoNumericHelper2.default.isUndefined(this.autoNumericLocalList)) {
                this.autoNumericLocalList.set(domElement, autoNumericObject); // Use the DOM element as key, and the AutoNumeric object as the value
            } else {
                _AutoNumericHelper2.default.throwError('The local list provided does not exists when trying to add an element. [' + this.autoNumericLocalList + '] given.');
            }
        }

        /**
         * Remove the given object from the local autoNumeric element list.
         *
         * @param {HTMLElement|HTMLInputElement} domElement
         * @private
         */

    }, {
        key: '_removeFromLocalList',
        value: function _removeFromLocalList(domElement) {
            if (!_AutoNumericHelper2.default.isUndefined(this.autoNumericLocalList)) {
                this.autoNumericLocalList.delete(domElement);
            } else if (this.settings.createLocalList) {
                _AutoNumericHelper2.default.throwError('The local list provided does not exists when trying to remove an element. [' + this.autoNumericLocalList + '] given.');
            }
        }

        /**
         * Merge the `newSettings` given as parameters into the current element settings.
         *
         * WARNING: Using `Object.assign()` here means the merge is not recursive and only one depth is merged.
         * cf. http://stackoverflow.com/a/39188108/2834898
         * cf. tests on http://codepen.io/AnotherLinuxUser/pen/KaJORq?editors=0011
         *
         * @param {object} newSettings
         * @private
         */

    }, {
        key: '_mergeSettings',
        value: function _mergeSettings() {
            for (var _len3 = arguments.length, newSettings = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                newSettings[_key3] = arguments[_key3];
            }

            _extends.apply(undefined, [this.settings].concat(newSettings));
        }

        /**
         * Return a new object with the current element settings merged with the new settings.
         *
         * @param {object} newSettings
         * @returns {object}
         * @private
         */

    }, {
        key: '_cloneAndMergeSettings',
        value: function _cloneAndMergeSettings() {
            var result = {};

            for (var _len4 = arguments.length, newSettings = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                newSettings[_key4] = arguments[_key4];
            }

            _extends.apply(undefined, [result, this.settings].concat(newSettings));

            return result;
        }

        /**
         * Validate the given option object.
         * If the options are valid, this function returns nothing, otherwise if the options are invalid, this function throws an error.
         *
         * This tests if the options are not conflicting and are well formatted.
         * This function is lenient since it only tests the settings properties ; it ignores any other properties the options object could have.
         *
         * @param {*} userOptions
         * @param {Boolean} shouldExtendDefaultOptions If `true`, then this function will extends the `userOptions` passed by the user, with the default options.
         * @param {object|null} originalOptions The user can pass the original options (and not the one that are generated from the default settings and the various usability corrections), in order to add compatibility and conflicts checks.
         * @throws Error This throws if the `userOptions` are not valid
         */

    }, {
        key: '_updatePredefinedOptions',


        // Pre-defined options can be called to update the current default options with their specificities
        //XXX A better way would be to not initialize first, but that's not possible since `new` is called first and we do not pass the language options (ie. `French`) to the constructor

        /**
         * Update the AutoNumeric object with the predefined options, and possibly some option overrides.
         *
         * @param {object} predefinedOption
         * @param {object} optionOverride
         * @private
         * @returns {AutoNumeric}
         */
        value: function _updatePredefinedOptions(predefinedOption) {
            var optionOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (!_AutoNumericHelper2.default.isNull(optionOverride)) {
                this._mergeSettings(predefinedOption, optionOverride);
                this.update(this.settings);
            } else {
                this.update(predefinedOption);
            }

            return this;
        }

        /**
         * Update the settings to use the French pre-defined language options.
         * Those pre-defined options can be overridden by passing an option object as a parameter.
         *
         * @param {object} optionOverride
         * @returns {AutoNumeric}
         */

    }, {
        key: 'french',
        value: function french() {
            var optionOverride = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this._updatePredefinedOptions(AutoNumeric.getPredefinedOptions().French, optionOverride);

            return this;
        }

        /**
         * Update the settings to use the North American pre-defined language options.
         * Those pre-defined options can be overridden by passing an option object as a parameter.
         *
         * @param {object} optionOverride
         * @returns {AutoNumeric}
         */

    }, {
        key: 'northAmerican',
        value: function northAmerican() {
            var optionOverride = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this._updatePredefinedOptions(AutoNumeric.getPredefinedOptions().NorthAmerican, optionOverride);

            return this;
        }

        /**
         * Update the settings to use the British pre-defined language options.
         * Those pre-defined options can be overridden by passing an option object as a parameter.
         *
         * @param {object} optionOverride
         * @returns {AutoNumeric}
         */

    }, {
        key: 'british',
        value: function british() {
            var optionOverride = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this._updatePredefinedOptions(AutoNumeric.getPredefinedOptions().British, optionOverride);

            return this;
        }

        /**
         * Update the settings to use the Swiss pre-defined language options.
         * Those pre-defined options can be overridden by passing an option object as a parameter.
         *
         * @param {object} optionOverride
         * @returns {AutoNumeric}
         */

    }, {
        key: 'swiss',
        value: function swiss() {
            var optionOverride = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this._updatePredefinedOptions(AutoNumeric.getPredefinedOptions().Swiss, optionOverride);

            return this;
        }

        /**
         * Update the settings to use the Japanese pre-defined language options.
         * Those pre-defined options can be overridden by passing an option object as a parameter.
         *
         * @param {object} optionOverride
         * @returns {AutoNumeric}
         */

    }, {
        key: 'japanese',
        value: function japanese() {
            var optionOverride = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this._updatePredefinedOptions(AutoNumeric.getPredefinedOptions().Japanese, optionOverride);

            return this;
        }

        /**
         * Update the settings to use the Spanish pre-defined language options.
         * Those pre-defined options can be overridden by passing an option object as a parameter.
         *
         * @param {object} optionOverride
         * @returns {AutoNumeric}
         */

    }, {
        key: 'spanish',
        value: function spanish() {
            var optionOverride = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this._updatePredefinedOptions(AutoNumeric.getPredefinedOptions().Spanish, optionOverride);

            return this;
        }

        /**
         * Update the settings to use the Chinese pre-defined language options.
         * Those pre-defined options can be overridden by passing an option object as a parameter.
         *
         * @param {object} optionOverride
         * @returns {AutoNumeric}
         */

    }, {
        key: 'chinese',
        value: function chinese() {
            var optionOverride = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this._updatePredefinedOptions(AutoNumeric.getPredefinedOptions().Chinese, optionOverride);

            return this;
        }

        /**
         * Update the settings to use the Brazilian pre-defined language options.
         * Those pre-defined options can be overridden by passing an option object as a parameter.
         *
         * @param {object} optionOverride
         * @returns {AutoNumeric}
         */

    }, {
        key: 'brazilian',
        value: function brazilian() {
            var optionOverride = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this._updatePredefinedOptions(AutoNumeric.getPredefinedOptions().Brazilian, optionOverride);

            return this;
        }

        // Internal private functions
        /**
         * Run any callbacks found in the settings object in order to set the settings value back.
         * Any parameter can have a callback defined.
         * The callback takes the current AutoNumeric element as the first argument, and the key name as the second.
         * @example callback(this, 'currencySymbol')
         */

    }, {
        key: '_runCallbacksFoundInTheSettingsObject',
        value: function _runCallbacksFoundInTheSettingsObject() {
            //FIXME test this
            // Loops through the this.settings object (option array) to find the following
            for (var key in this.settings) {
                if (this.settings.hasOwnProperty(key)) {
                    var value = this.settings[key];

                    if (typeof value === 'function') {
                        this.settings[key] = value(this, key);
                    } else {
                        // Calls the attached function from the html5 data. For instance: <tag data-currency-symbol="functionName"></tag>
                        var htmlAttribute = this.domElement.getAttribute(key); //TODO Use `dataset` instead of `getAttribute` when we won't need to support obsolete browsers
                        htmlAttribute = _AutoNumericHelper2.default.camelize(htmlAttribute);
                        if (typeof this.settings[htmlAttribute] === 'function') {
                            this.settings[key] = htmlAttribute(this, key);
                        }
                    }
                }
            }
        }

        /**
         * Keep track if the settings configuration leads to a trailing negative sign (only when the raw value is negative), so we do not have to test the settings values every time we need to know that.
         * `isTrailingNegative` is set to `true` if the settings result in a trailing negative character, `false` otherwise.
         * Note: This returns `true` even if the raw value is positive.
         * @private
         */

    }, {
        key: '_setTrailingNegativeSignInfo',
        value: function _setTrailingNegativeSignInfo() {
            this.isTrailingNegative = this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.prefix && this.settings.negativePositiveSignPlacement === AutoNumeric.options.negativePositiveSignPlacement.suffix || this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.suffix && (this.settings.negativePositiveSignPlacement === AutoNumeric.options.negativePositiveSignPlacement.left || this.settings.negativePositiveSignPlacement === AutoNumeric.options.negativePositiveSignPlacement.right);
        }

        /**
         * Strip all the unwanted non-number characters.
         * However it does not reorder the localized negative sign.
         *
         * @param {string} s
         * @param {object} settings
         * @param {boolean} stripZeros If set to `false`, then the leading zero(s) are not stripped, otherwise if set to `true`, the `leadingZero` option is followed
         * @param {boolean} isFocused If the element is focused, then this is `true`
         * @returns {string}
         * @private
         */

    }, {
        key: '_modifyNegativeSignAndDecimalCharacterForRawValue',


        /**
         * Modify the negative sign and the decimal character of the given string value to an hyphen (-) and a dot (.) in order to make that value 'typecastable' to a real number.
         *
         * @param {string} s The formatted value
         * @returns {string} The value with the 'normal' minus sign and decimal character
         */
        value: function _modifyNegativeSignAndDecimalCharacterForRawValue(s) {
            if (this.settings.decimalCharacter !== '.') {
                s = s.replace(this.settings.decimalCharacter, '.');
            }

            if (this.settings.negativeSignCharacter !== '-' && this.settings.isNegativeSignAllowed) {
                s = s.replace(this.settings.negativeSignCharacter, '-');
            }

            if (!s.match(/\d/)) {
                // The default value returned by `get` is not formatted with decimals
                s += '0';
            }

            return s;
        }

        /**
         * Modify the negative sign and the decimal character to use those defined in the settings.
         *
         * @param {string} s
         * @param {object} settings
         * @returns {string}
         */

    }, {
        key: '_initialCaretPosition',


        /**
         * Calculate where to put the caret position on focus if the element content is not selected.
         * This calculation is affected by the `caretPositionOnFocus` option which can be either `null`, `'start'`, `'end'`, `'decimalLeft'` or 'decimalRight'`, and will decide where to put the caret (on the left or right of the value or the decimal character, respectively) :
         * - `null` : the caret position is not forced
         * - `'start'` : the caret is positioned on the left hand side of the value
         * - `'end'` : the caret is positioned on the right hand side of the value
         * - `'decimalLeft'` : the caret is positioned on the left side of the decimal character
         * - `'decimalRight'` : the caret is positioned on the right side of the decimal character
         *
         * @param {string} value The formatted string stripped of the currency symbol and negative/positive sign
         * @returns {number}
         * @throws
         * @private
         */
        value: function _initialCaretPosition(value) {
            if (_AutoNumericHelper2.default.isNull(this.settings.caretPositionOnFocus) && this.settings.selectOnFocus === AutoNumeric.options.selectOnFocus.doNotSelect) {
                _AutoNumericHelper2.default.throwError('`_initialCaretPosition()` should never be called when the `caretPositionOnFocus` option is `null`.');
            }

            var isValueNegative = this.rawValue < 0;
            var isZeroOrHasNoValue = _AutoNumericHelper2.default.isZeroOrHasNoValue(value);
            var totalLength = value.length;

            var valueSize = 0;
            var integerSize = 0;
            var hasDecimalChar = false;
            var offsetDecimalChar = 0;
            if (this.settings.caretPositionOnFocus !== AutoNumeric.options.caretPositionOnFocus.start) {
                value = value.replace(this.settings.negativeSignCharacter, '');
                value = value.replace(this.settings.positiveSignCharacter, '');
                value = value.replace(this.settings.currencySymbol, '');
                valueSize = value.length;
                hasDecimalChar = _AutoNumericHelper2.default.contains(value, this.settings.decimalCharacter);

                if (this.settings.caretPositionOnFocus === AutoNumeric.options.caretPositionOnFocus.decimalLeft || this.settings.caretPositionOnFocus === AutoNumeric.options.caretPositionOnFocus.decimalRight) {
                    if (hasDecimalChar) {
                        integerSize = value.indexOf(this.settings.decimalCharacter);
                        offsetDecimalChar = this.settings.decimalCharacter.length;
                    } else {
                        integerSize = valueSize;
                        offsetDecimalChar = 0;
                    }
                }
            }

            var signToUse = '';
            if (isValueNegative) {
                signToUse = this.settings.negativeSignCharacter;
            } else if (this.settings.showPositiveSign && !isZeroOrHasNoValue) {
                signToUse = this.settings.positiveSignCharacter;
            }

            var positiveNegativeSignSize = signToUse.length;
            var currencySymbolSize = this.settings.currencySymbol.length;

            // Calculate the caret position based on `currencySymbolPlacement`, `negativePositiveSignPlacement` and `caretPositionOnFocus`
            var caretPosition = void 0;
            if (this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.prefix) {
                if (this.settings.caretPositionOnFocus === AutoNumeric.options.caretPositionOnFocus.start) {
                    if (this.settings.negativePositiveSignPlacement !== AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
                        switch (this.settings.negativePositiveSignPlacement) {
                            case AutoNumeric.options.negativePositiveSignPlacement.prefix: // +€|12.34
                            case AutoNumeric.options.negativePositiveSignPlacement.left: // +€|12.34
                            case AutoNumeric.options.negativePositiveSignPlacement.right:
                                // €+|12.34
                                caretPosition = positiveNegativeSignSize + currencySymbolSize;
                                break;
                            case AutoNumeric.options.negativePositiveSignPlacement.suffix:
                                // €|12.34+
                                caretPosition = currencySymbolSize;
                                break;
                        }
                    } else {
                        // €|12.34
                        caretPosition = currencySymbolSize;
                    }
                } else if (this.settings.caretPositionOnFocus === AutoNumeric.options.caretPositionOnFocus.end) {
                    if (this.settings.negativePositiveSignPlacement !== AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
                        switch (this.settings.negativePositiveSignPlacement) {
                            case AutoNumeric.options.negativePositiveSignPlacement.prefix: // +€12.34|
                            case AutoNumeric.options.negativePositiveSignPlacement.left: // +€12.34|
                            case AutoNumeric.options.negativePositiveSignPlacement.right:
                                // €+12.34|
                                caretPosition = totalLength;
                                break;
                            case AutoNumeric.options.negativePositiveSignPlacement.suffix:
                                // €12.34|+
                                caretPosition = currencySymbolSize + valueSize;
                                break;
                        }
                    } else {
                        // €12.34|
                        caretPosition = totalLength;
                    }
                } else if (this.settings.caretPositionOnFocus === AutoNumeric.options.caretPositionOnFocus.decimalLeft) {
                    if (this.settings.negativePositiveSignPlacement !== AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
                        switch (this.settings.negativePositiveSignPlacement) {
                            case AutoNumeric.options.negativePositiveSignPlacement.prefix: // +€12|.34
                            case AutoNumeric.options.negativePositiveSignPlacement.left: // +€12|.34
                            case AutoNumeric.options.negativePositiveSignPlacement.right:
                                // €+12|.34
                                caretPosition = positiveNegativeSignSize + currencySymbolSize + integerSize;
                                break;
                            case AutoNumeric.options.negativePositiveSignPlacement.suffix:
                                // €12|.34+
                                caretPosition = currencySymbolSize + integerSize;
                                break;
                        }
                    } else {
                        // €12|.34
                        caretPosition = currencySymbolSize + integerSize;
                    }
                } else if (this.settings.caretPositionOnFocus === AutoNumeric.options.caretPositionOnFocus.decimalRight) {
                    if (this.settings.negativePositiveSignPlacement !== AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
                        switch (this.settings.negativePositiveSignPlacement) {
                            case AutoNumeric.options.negativePositiveSignPlacement.prefix: // +€12.|34
                            case AutoNumeric.options.negativePositiveSignPlacement.left: // +€12.|34
                            case AutoNumeric.options.negativePositiveSignPlacement.right:
                                // €+12.|34
                                caretPosition = positiveNegativeSignSize + currencySymbolSize + integerSize + offsetDecimalChar;
                                break;
                            case AutoNumeric.options.negativePositiveSignPlacement.suffix:
                                // €12.|34+
                                caretPosition = currencySymbolSize + integerSize + offsetDecimalChar;
                                break;
                        }
                    } else {
                        // €12.|34
                        caretPosition = currencySymbolSize + integerSize + offsetDecimalChar;
                    }
                }
            } else if (this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.suffix) {
                if (this.settings.caretPositionOnFocus === AutoNumeric.options.caretPositionOnFocus.start) {
                    if (this.settings.negativePositiveSignPlacement !== AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
                        switch (this.settings.negativePositiveSignPlacement) {
                            case AutoNumeric.options.negativePositiveSignPlacement.suffix: // |12.34€+
                            case AutoNumeric.options.negativePositiveSignPlacement.right: // |12.34€+
                            case AutoNumeric.options.negativePositiveSignPlacement.left:
                                // |12.34+€
                                caretPosition = 0;
                                break;
                            case AutoNumeric.options.negativePositiveSignPlacement.prefix:
                                // +|12.34€
                                caretPosition = positiveNegativeSignSize;
                                break;
                        }
                    } else {
                        // |12.34€
                        caretPosition = 0;
                    }
                } else if (this.settings.caretPositionOnFocus === AutoNumeric.options.caretPositionOnFocus.end) {
                    if (this.settings.negativePositiveSignPlacement !== AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
                        switch (this.settings.negativePositiveSignPlacement) {
                            case AutoNumeric.options.negativePositiveSignPlacement.suffix: // 12.34|€+
                            case AutoNumeric.options.negativePositiveSignPlacement.right: // 12.34|€+
                            case AutoNumeric.options.negativePositiveSignPlacement.left:
                                // 12.34|+€
                                caretPosition = valueSize;
                                break;
                            case AutoNumeric.options.negativePositiveSignPlacement.prefix:
                                // +12.34|€
                                caretPosition = positiveNegativeSignSize + valueSize;
                                break;
                        }
                    } else {
                        // 12.34|€
                        caretPosition = valueSize;
                    }
                } else if (this.settings.caretPositionOnFocus === AutoNumeric.options.caretPositionOnFocus.decimalLeft) {
                    if (this.settings.negativePositiveSignPlacement !== AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
                        switch (this.settings.negativePositiveSignPlacement) {
                            case AutoNumeric.options.negativePositiveSignPlacement.suffix: // 12|.34€+
                            case AutoNumeric.options.negativePositiveSignPlacement.right: // 12|.34€+
                            case AutoNumeric.options.negativePositiveSignPlacement.left:
                                // 12|.34+€
                                caretPosition = integerSize;
                                break;
                            case AutoNumeric.options.negativePositiveSignPlacement.prefix:
                                // +12|.34€
                                caretPosition = positiveNegativeSignSize + integerSize;
                                break;
                        }
                    } else {
                        // 12|.34€
                        caretPosition = integerSize;
                    }
                } else if (this.settings.caretPositionOnFocus === AutoNumeric.options.caretPositionOnFocus.decimalRight) {
                    if (this.settings.negativePositiveSignPlacement !== AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
                        switch (this.settings.negativePositiveSignPlacement) {
                            case AutoNumeric.options.negativePositiveSignPlacement.suffix: // 12.|34€+
                            case AutoNumeric.options.negativePositiveSignPlacement.right: // 12.|34€+
                            case AutoNumeric.options.negativePositiveSignPlacement.left:
                                // 12.|34+€
                                caretPosition = integerSize + offsetDecimalChar;
                                break;
                            case AutoNumeric.options.negativePositiveSignPlacement.prefix:
                                // +12.|34€
                                caretPosition = positiveNegativeSignSize + integerSize + offsetDecimalChar;
                                break;
                        }
                    } else {
                        // 12.|34€
                        caretPosition = integerSize + offsetDecimalChar;
                    }
                }
            }

            return caretPosition;
        }

        /**
         * Truncate the trailing zeroes to the given number of decimal places
         *
         * @param {string} roundedInputValue
         * @param {int} decimalPlacesNeeded The number of decimal places to keep
         * @returns {string}
         */

    }, {
        key: '_keepAnOriginalSettingsCopy',


        /**
         * Original settings saved for use when the `decimalPlacesShownOnFocus` and `showOnlyNumbersOnFocus` options are used.
         * Those original settings are used exclusively in the `focusin` and `focusout` event handlers.
         */
        value: function _keepAnOriginalSettingsCopy() {
            this.originalDigitGroupSeparator = this.settings.digitGroupSeparator;
            this.originalCurrencySymbol = this.settings.currencySymbol;
            this.originalSuffixText = this.settings.suffixText;
        }

        /**
         * Original settings saved for use when `decimalPlacesShownOnFocus` & `showOnlyNumbersOnFocus` options are being used.
         * This is taken from Quirksmode.
         *
         * @param {string} name
         * @returns {*}
         */

    }, {
        key: '_trimLeadingAndTrailingZeros',


        /**
         * Removes any zeros in excess in the front and back of the given `value`, according to the `settings`.
         * This also manages the cases where the decimal point is on the far left or far right of the `value`.
         *
         * @param {string} value
         * @returns {string|null}
         */
        value: function _trimLeadingAndTrailingZeros(value) {
            // Return the empty string is the value is already empty. This prevent converting that value to '0'.
            if (value === '' || value === null) {
                return value;
            }

            if (this.settings.leadingZero !== AutoNumeric.options.leadingZero.keep) {
                if (Number(value) === 0) {
                    // Return '0' if the value is zero
                    return '0';
                }

                // Trim the leading zeros, while leaving one zero to the left of the decimal point if needed
                value = value.replace(/^(-)?0+(?=\d)/g, '$1');
            }

            //TODO remove this from that function and use `trimPaddedZerosFromDecimalPlaces()` instead
            // Trim the trailing zeros after the last decimal place not being a zero (ie. 1.2300 -> 1.23)
            if (_AutoNumericHelper2.default.contains(value, '.')) {
                value = value.replace(/(\.[0-9]*?)0+$/, '$1');
            }

            // Remove any trailing decimal point
            value = value.replace(/\.$/, '');

            return value;
        }

        /**
         * Generate the name for the persistent stored data variable
         * @private
         */

    }, {
        key: '_setPersistentStorageName',
        value: function _setPersistentStorageName() {
            if (this.settings.saveValueToSessionStorage) {
                if (this.domElement.name !== '' && !_AutoNumericHelper2.default.isUndefined(this.domElement.name)) {
                    this.rawValueStorageName = '' + this.storageNamePrefix + decodeURIComponent(this.domElement.name);
                } else {
                    this.rawValueStorageName = '' + this.storageNamePrefix + this.domElement.id;
                }
            }
        }

        /**
         * Save the raw Value into sessionStorage or a cookie depending on what the browser is supporting.
         * @private
         */

    }, {
        key: '_saveValueToPersistentStorage',
        value: function _saveValueToPersistentStorage() {
            if (this.settings.saveValueToSessionStorage) {
                if (this.sessionStorageAvailable) {
                    sessionStorage.setItem(this.rawValueStorageName, this.rawValue);
                } else {
                    // Use cookies for obsolete browsers that do not support sessionStorage (ie. IE 6 & 7)
                    document.cookie = this.rawValueStorageName + '=' + this.rawValue + '; expires= ; path=/';
                }
            }
        }

        /**
         * Retrieve the raw value from sessionStorage or the cookie depending on what the browser is supporting.
         *
         * @returns {*}
         * @private
         */

    }, {
        key: '_getValueFromPersistentStorage',
        value: function _getValueFromPersistentStorage() {
            if (this.settings.saveValueToSessionStorage) {
                var result = void 0;
                if (this.sessionStorageAvailable) {
                    result = sessionStorage.getItem(this.rawValueStorageName);
                } else {
                    result = this.constructor._readCookie(this.rawValueStorageName);
                }

                return result;
            }

            _AutoNumericHelper2.default.warning('`_getValueFromPersistentStorage()` is called but `settings.saveValueToSessionStorage` is false. There must be an error that needs fixing.', this.settings.showWarnings);

            return null;
        }

        /**
         * Remove the raw value data from sessionStorage or the cookie depending on what the browser is supporting.
         * @private
         */

    }, {
        key: '_removeValueFromPersistentStorage',
        value: function _removeValueFromPersistentStorage() {
            if (this.settings.saveValueToSessionStorage) {
                if (this.sessionStorageAvailable) {
                    sessionStorage.removeItem(this.rawValueStorageName);
                } else {
                    var date = new Date();
                    date.setTime(date.getTime() - 86400000); // -86400000 === -1 * 24 * 60 * 60 * 1000
                    var expires = '; expires=' + date.toUTCString();
                    document.cookie = this.rawValueStorageName + '=\'\' ;' + expires + '; path=/';
                }
            }
        }

        /**
         * Get the default value from the html `value` attribute.
         * Return the empty string if such attribute is not found.
         *
         * @param {HTMLElement} domElement
         *
         * @returns {string}
         * @private
         */

    }, {
        key: '_getDefaultValue',
        value: function _getDefaultValue(domElement) {
            // Get the default html value
            // Note: we do not use the simpler `return domElement.defaultValue;` code since the given domElement can sometime be a `contenteditable` element which does not support the `defaultValue` attribute.
            var value = domElement.getAttribute('value');

            if (_AutoNumericHelper2.default.isNull(value)) {
                return '';
            }

            return value;
        }

        /**
         * Handler for 'focusin' and 'mouseenter' events
         * On focusin, multiple things happens :
         * - If `Alt` is pressed, unformat
         * - Remove the separators if `showOnlyNumbersOnFocus` is set
         * - Depending on `emptyInputBehavior`, reformat the empty formatted value
         * - Display the correct number of decimal places (on focus/blur)
         * - Place the caret correctly if the element is empty
         *
         * Note: On focusin, the `rawValue` is never changed. Only the formatted value can be modified.
         *
         * @param {KeyboardEvent|MouseEvent} e
         * @private
         */

    }, {
        key: '_onFocusInAndMouseEnter',
        value: function _onFocusInAndMouseEnter(e) {
            //TODO Create separate handlers for the focus and mouseenter events
            this.isEditing = false; // Just in case no `keyUp` event have been sent (ie. if the user lost the focus from the current window while typing)

            if (!this.formulaMode && this.settings.unformatOnHover && e.type === 'mouseenter' && e.altKey) {
                this.constructor._unformatAltHovered(this);

                return;
            }

            if (e.type === 'focus') {
                //TODO Move that back to the 'focus' event handler when the separation between the 'focus' and 'mouseenter' handler will be done
                // Keep track if the element is currently focused
                this.isFocused = true;
                this.rawValueOnFocus = this.rawValue; // Keep track of the initial rawValue. This is needed to define if a change event must be dispatched later
            }

            if (e.type === 'focus' && this.settings.unformatOnHover && this.hoveredWithAlt) {
                this.constructor._reformatAltHovered(this);
            }

            if (e.type === 'focus' || e.type === 'mouseenter' && !this.isFocused) {
                var elementValueToSet = null; // Store the value we want to set on the element, and only call `_setElementValue()` once

                if (this.settings.emptyInputBehavior === AutoNumeric.options.emptyInputBehavior.focus && this.rawValue < 0 && this.settings.negativeBracketsTypeOnBlur !== null && this.settings.isNegativeSignAllowed) {
                    //FIXME this is called a second time in _addGroupSeparators too. Prevent this, if possible.
                    // Only remove the brackets if the value is negative
                    elementValueToSet = this.constructor._removeBrackets(_AutoNumericHelper2.default.getElementValue(this.domElement), this.settings);
                    //FIXME The element value is set here, why continue and set it again later in that same parent logic block?
                }

                // Use the `rawValue`, multiplied by `rawValueDivisor` if defined
                var rawValueToFormat = this._getRawValueToFormat(this.rawValue);

                // Modify the element value according to the number of decimal places to show on focus or the `showOnlyNumbersOnFocus` option
                if (rawValueToFormat !== '') {
                    // Round the given value according to the object state (focus/unfocused)
                    var roundedValue = this.constructor._roundFormattedValueShownOnFocusOrBlur(rawValueToFormat, this.settings, this.isFocused);

                    if (this.settings.showOnlyNumbersOnFocus === AutoNumeric.options.showOnlyNumbersOnFocus.onlyNumbers) {
                        //TODO Use a `this.settingsOverride` object instead of modifying the `this.settings` object
                        this.settings.digitGroupSeparator = '';
                        this.settings.currencySymbol = '';
                        this.settings.suffixText = '';
                        elementValueToSet = roundedValue.replace('.', this.settings.decimalCharacter);
                    } else {
                        var formattedValue = void 0;
                        if (_AutoNumericHelper2.default.isNull(roundedValue)) {
                            formattedValue = '';
                        } else {
                            formattedValue = this.constructor._addGroupSeparators(roundedValue.replace('.', this.settings.decimalCharacter), this.settings, this.isFocused, rawValueToFormat);
                        }

                        elementValueToSet = formattedValue;
                    }
                }

                // In order to send a 'native' change event when blurring the input, we need to first store the initial input value on focus.
                if (_AutoNumericHelper2.default.isNull(elementValueToSet)) {
                    this.valueOnFocus = '';
                } else {
                    this.valueOnFocus = elementValueToSet;
                }

                this.lastVal = this.valueOnFocus;
                var isEmptyValue = this.constructor._isElementValueEmptyOrOnlyTheNegativeSign(this.valueOnFocus, this.settings);
                var orderedValue = this.constructor._orderValueCurrencySymbolAndSuffixText(this.valueOnFocus, this.settings, true); // This displays the currency sign on hover even if the rawValue is empty
                var orderedValueTest = isEmptyValue && orderedValue !== '' && this.settings.emptyInputBehavior === AutoNumeric.options.emptyInputBehavior.focus;
                if (orderedValueTest) {
                    elementValueToSet = orderedValue;
                }

                if (!_AutoNumericHelper2.default.isNull(elementValueToSet)) {
                    this._setElementValue(elementValueToSet);
                }

                if (orderedValueTest && orderedValue === this.settings.currencySymbol && this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.suffix) {
                    // If there is a currency symbol and its on the right hand side, then we place the caret accordingly on the far left side
                    _AutoNumericHelper2.default.setElementSelection(e.target, 0);
                }
            }
        }

        /**
         * Handler for the 'focus' event.
         * We update the info of the focused state in the `this.isFocused` variable when the element gets focused.
         * @private
         */

    }, {
        key: '_onFocus',
        value: function _onFocus() {
            if (this.settings.isCancellable) {
                // Save the current unformatted value for later use by the 'cancellable' feature
                this._saveCancellableValue();
            }
        }

        /**
         * Handler for the 'focusin' event.
         * This is called before the 'focus' event, and is necessary to change the selection on focus under Firefox for instance.
         *
         * @param {Event} e
         * @private
         */

    }, {
        key: '_onFocusIn',
        value: function _onFocusIn(e) {
            if (this.settings.selectOnFocus) {
                // The whole input content is selected on focus (following the `selectOnFocus` and `selectNumberOnly` options)
                //XXX Firefox <47 does not respect this selection...Oh well.
                this.select();
            } else {
                // Or we decide where to put the caret using the `caretPositionOnFocus` option
                if (!_AutoNumericHelper2.default.isNull(this.settings.caretPositionOnFocus)) {
                    _AutoNumericHelper2.default.setElementSelection(e.target, this._initialCaretPosition(_AutoNumericHelper2.default.getElementValue(this.domElement)));
                }
            }
        }

        /**
         * Enter the special 'formula mode' where users can enter a math expression that will be evaluated on blur and `enter`
         * @private
         */

    }, {
        key: '_enterFormulaMode',
        value: function _enterFormulaMode() {
            if (this.settings.formulaMode) {
                this.formulaMode = true; // 'Deactivate' the normal event listeners behavior
                // Clear the input and add a '=' sign to it
                _AutoNumericHelper2.default.setElementValue(this.domElement, '=');
                // Put the caret after the `=` character
                _AutoNumericHelper2.default.setElementSelection(this.domElement, 1);
            }
        }

        /**
         * Exit the formula mode
         * Tries to parse and evaluate the math expression, then `set()` the result if it's correct, otherwise reformat with the previous `rawValue`
         * @private
         */

    }, {
        key: '_exitFormulaMode',
        value: function _exitFormulaMode() {
            // Parse the formula
            var formula = _AutoNumericHelper2.default.getElementValue(this.domElement);
            formula = formula.replace(/^\s*=/, ''); // Remove all the leading whitespaces and the equal sign from the formula
            var result = void 0;
            try {
                var ast = new _Parser2.default(formula, this.settings.decimalCharacter);
                result = new _Evaluator2.default().evaluate(ast);
            } catch (e) {
                // Error when parsing the math expression
                this._triggerEvent(AutoNumeric.events.invalidFormula, this.domElement, {
                    formula: formula,
                    aNElement: this
                });
                this.reformat();
                this.formulaMode = false;

                return;
            }

            // The math expression is correctly parsed
            this._triggerEvent(AutoNumeric.events.validFormula, this.domElement, {
                formula: formula,
                result: result,
                aNElement: this
            });
            this.set(result); // Note: we can have a valid formula, but an invalid value (ie. out of the min/max range)
            this.formulaMode = false;
        }

        /**
         * Returns `true` if the non printable key is accepted in formula mode
         *
         * @returns {boolean}
         * @private
         */

    }, {
        key: '_acceptNonPrintableKeysInFormulaMode',
        value: function _acceptNonPrintableKeysInFormulaMode() {
            return this.eventKey === _AutoNumericEnum2.default.keyName.Backspace || this.eventKey === _AutoNumericEnum2.default.keyName.Delete || this.eventKey === _AutoNumericEnum2.default.keyName.LeftArrow || this.eventKey === _AutoNumericEnum2.default.keyName.RightArrow || this.eventKey === _AutoNumericEnum2.default.keyName.Home || this.eventKey === _AutoNumericEnum2.default.keyName.End;
        }

        /**
         * Handler for 'keydown' events.
         * The user just started pushing any key, hence one event is sent.
         *
         * Note :
         * By default a 'normal' input output those events in the right order when inputting a character key (ie. 'a') :
         * - keydown
         * - keypress
         * - input
         * - keyup
         *
         * ...when inputting a modifier key (ie. 'ctrl') :
         * - keydown
         * - keyup
         *
         * If 'delete' or 'backspace' is entered, the following events are sent :
         * - keydown
         * - input
         * - keyup
         *
         * If 'enter' is entered and the value has not changed, the following events are sent :
         * - keydown
         * - keypress
         * - keyup
         *
         * If 'enter' is entered and the value has been changed, the following events are sent :
         * - keydown
         * - keypress
         * - change
         * - keyup
         *
         * When a paste is done, the following events are sent :
         * - input (if paste is done with the mouse)
         *
         * - keydown (if paste is done with ctrl+v)
         * - keydown
         * - input
         * - keyup
         * - keyup
         *
         * @param {KeyboardEvent} e
         */

    }, {
        key: '_onKeydown',
        value: function _onKeydown(e) {
            this.formatted = false; // Keep track if the element has been formatted already. If that's the case, prevent further format calculations.
            this.isEditing = true; // Keep track if the user is currently editing the element manually

            if (!this.formulaMode && !this.isFocused && this.settings.unformatOnHover && e.altKey && this.domElement === _AutoNumericHelper2.default.getHoveredElement()) {
                // Here I prevent calling _unformatAltHovered if the element is already focused, since the global 'keydown' listener will pick it up as well
                this.constructor._unformatAltHovered(this);

                return;
            }

            this._updateEventKeyInfo(e);
            this.initialValueOnKeydown = _AutoNumericHelper2.default.getElementValue(e.target); // This is needed in `onKeyup()` to check if the value as changed during the key press
            this.initialRawValueOnKeydown = this.rawValue;

            if (this.formulaMode) {
                if (this.eventKey === _AutoNumericEnum2.default.keyName.Esc) {
                    // Cancel the formula
                    this.formulaMode = false;
                    this.reformat();

                    return;
                }

                if (this.eventKey === _AutoNumericEnum2.default.keyName.Enter) {
                    // Calculate the formula
                    this._exitFormulaMode();

                    return;
                }

                // Accept the backspace, delete, arrow, home and end keys
                if (this._acceptNonPrintableKeysInFormulaMode()) {
                    return;
                }

                //TODO Manage the undo/redo events *while* editing a math expression
                //TODO Manage the cut/paste events *while* editing a math expression
            } else if (this.eventKey === _AutoNumericEnum2.default.keyName.Equal) {
                this._enterFormulaMode();

                return;
            }

            if (this.domElement.readOnly || this.settings.readOnly || this.domElement.disabled) {
                this.processed = true;

                return;
            }

            if (this.eventKey === _AutoNumericEnum2.default.keyName.Esc) {
                //XXX The default 'Escape' key behavior differs between Firefox and Chrome, Firefox already having a built-in 'cancellable-like' feature. This is why we call `e.preventDefault()` here instead of just when `isCancellable` is set to `true`. This allow us to keep the same behavior across browsers.
                e.preventDefault();

                if (this.settings.isCancellable) {
                    // If the user wants to cancel his modifications:
                    // We set back the saved value
                    if (this.rawValue !== this.savedCancellableValue) {
                        // Do not set the value again if it has not changed
                        this.set(this.savedCancellableValue);
                        // And we need to send an 'input' event when setting back the initial value in order to make other scripts aware of the value change...
                        this._triggerEvent(AutoNumeric.events.native.input, e.target);
                    }
                }

                // ..and lastly we update the caret selection, even if the option `isCancellable` is false
                this.select();
                //TODO Add an option to select either the integer or decimal part with `Esc`
            }

            // The "enter" key throws a `change` event if the raw value has changed since the `focus` event
            var targetValue = _AutoNumericHelper2.default.getElementValue(e.target);
            if (this.eventKey === _AutoNumericEnum2.default.keyName.Enter && this.rawValue !== this.rawValueOnFocus) {
                this._triggerEvent(AutoNumeric.events.native.change, e.target);
                this.valueOnFocus = targetValue;
                this.rawValueOnFocus = this.rawValue;

                if (this.settings.isCancellable) {
                    // If the user activated the 'cancellable' feature, we save the validated value when 'Enter' is hit
                    this._saveCancellableValue();
                }
            }

            this._updateInternalProperties(e);

            if (this._processNonPrintableKeysAndShortcuts(e)) {
                this.processed = true;

                return;
            }

            // Check if the key is a delete/backspace key
            if (this.eventKey === _AutoNumericEnum2.default.keyName.Backspace || this.eventKey === _AutoNumericEnum2.default.keyName.Delete) {
                this._processCharacterDeletion(); // Because backspace and delete only triggers keydown and keyup events, not keypress
                this.processed = true;
                this._formatValue(e);

                // If and only if the resulting value has changed after that backspace/delete, then we have to send an 'input' event like browsers normally do.
                targetValue = _AutoNumericHelper2.default.getElementValue(e.target); // Update the value since it could have been changed during the deletion
                if (targetValue !== this.lastVal && this.throwInput) {
                    // Throw an input event when a character deletion is detected
                    this._triggerEvent(AutoNumeric.events.native.input, e.target);
                    e.preventDefault(); // ...and immediately prevent the browser to delete a second character
                }

                this.lastVal = targetValue;
                this.throwInput = true;
            }
        }

        /**
         * Handler for 'keypress' events.
         * The user is still pressing the key, which will output a character (ie. '2') continuously until he releases the key.
         * Note: 'keypress' events are not sent for delete keys like Backspace/Delete.
         *
         * @param {KeyboardEvent} e
         */

    }, {
        key: '_onKeypress',
        value: function _onKeypress(e) {
            if (this.formulaMode) {
                // Accept the backspace, delete, arrow, home and end keys
                if (this._acceptNonPrintableKeysInFormulaMode()) {
                    return;
                }

                //TODO Prevent keys to be entered on the left-hand side of the '=' sign?...Or just let the user see what they are wrongly doing?
                if (this.settings.formulaChars.test(this.eventKey)) {
                    // Accept the custom decimal character too
                    return; // Accept the key in the formula (and do not accept the '=' character here again)
                } else {
                    e.preventDefault(); // Reject the key
                }

                return;
            }

            if (this.eventKey === _AutoNumericEnum2.default.keyName.Insert) {
                return;
            }

            var processed = this.processed;
            this._updateInternalProperties(e);

            if (this._processNonPrintableKeysAndShortcuts(e)) {
                return;
            }

            if (processed) {
                e.preventDefault();

                return;
            }

            var isCharacterInsertionAllowed = this._processCharacterInsertion();
            if (isCharacterInsertionAllowed) {
                this._formatValue(e);
                var targetValue = _AutoNumericHelper2.default.getElementValue(e.target);
                if (targetValue !== this.lastVal && this.throwInput) {
                    // Throws input event on adding a character
                    this._triggerEvent(AutoNumeric.events.native.input, e.target);
                    e.preventDefault(); // ...and immediately prevent the browser to add a second character
                } else {
                    if ((this.eventKey === this.settings.decimalCharacter || this.eventKey === this.settings.decimalCharacterAlternative) && _AutoNumericHelper2.default.getElementSelection(e.target).start === _AutoNumericHelper2.default.getElementSelection(e.target).end && _AutoNumericHelper2.default.getElementSelection(e.target).start === targetValue.indexOf(this.settings.decimalCharacter)) {
                        var position = _AutoNumericHelper2.default.getElementSelection(e.target).start + 1;
                        _AutoNumericHelper2.default.setElementSelection(e.target, position);
                    }

                    e.preventDefault();
                }

                this.lastVal = _AutoNumericHelper2.default.getElementValue(e.target);
                this.throwInput = true;

                return;
            }

            e.preventDefault();
        }

        /**
         * Handler for 'keyup' events.
         * The user just released any key, hence one event is sent.
         *
         * @param {KeyboardEvent} e
         */

    }, {
        key: '_onKeyup',
        value: function _onKeyup(e) {
            this.isEditing = false;

            if (this.formulaMode) {
                return;
            }

            if (this.settings.isCancellable && this.eventKey === _AutoNumericEnum2.default.keyName.Esc) {
                // If the user wants to cancel its modifications, we drop the 'keyup' event for the Esc key
                e.preventDefault();

                return;
            }

            // Manage the undo/redo events
            if (this.eventKey === _AutoNumericEnum2.default.keyName.Z || this.eventKey === _AutoNumericEnum2.default.keyName.z) {
                if (e.ctrlKey && e.shiftKey) {
                    // Redo
                    e.preventDefault();
                    this._historyTableRedo();
                    this.onGoingRedo = true;

                    return;
                } else if (e.ctrlKey && !e.shiftKey) {
                    if (this.onGoingRedo) {
                        // Prevent an 'undo' to be launch when releasing the shift key before the ctrl key after a 'redo' shortcut
                        this.onGoingRedo = false;
                    } else {
                        e.preventDefault();
                        // Undo
                        this._historyTableUndo();

                        return;
                    }
                }
            }

            if (this.onGoingRedo && (e.ctrlKey || e.shiftKey)) {
                // Special case where if the user has entered `Control+Shift+z`, then release `z`, keeping `Control` or `Shift` pressed, then `this.onGoingRedo` is never changed back to `false` when the user release `Control` or `Shift`
                this.onGoingRedo = false;
            }

            // Manage the Cut event
            if ((e.ctrlKey || e.metaKey) && this.eventKey === _AutoNumericEnum2.default.keyName.x) {
                // Save the caret position at the start of the selection
                var caretPosition = _AutoNumericHelper2.default.getElementSelection(this.domElement).start;
                // Convert the remaining 'formatted' numbers in a Js number
                var cutNumber = this.constructor._toNumericValue(_AutoNumericHelper2.default.getElementValue(e.target), this.settings);
                // Try to set that value with `set()`
                this.set(cutNumber);
                // Set back the initial caret position
                this._setCaretPosition(caretPosition);
            }

            // Manage the reformat when hovered with the Alt key pressed
            if (this.eventKey === _AutoNumericEnum2.default.keyName.Alt && this.settings.unformatOnHover && this.hoveredWithAlt) {
                this.constructor._reformatAltHovered(this);

                return;
            }

            this._updateInternalProperties(e);

            var skip = this._processNonPrintableKeysAndShortcuts(e);
            delete this.valuePartsBeforePaste;
            var targetValue = _AutoNumericHelper2.default.getElementValue(e.target);
            if (skip || targetValue === '') {
                return;
            }

            // Added to properly place the caret when only the currency sign is present
            if (targetValue === this.settings.currencySymbol) {
                if (this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.suffix) {
                    _AutoNumericHelper2.default.setElementSelection(e.target, 0);
                } else {
                    _AutoNumericHelper2.default.setElementSelection(e.target, this.settings.currencySymbol.length);
                }
            } else if (this.eventKey === _AutoNumericEnum2.default.keyName.Tab) {
                _AutoNumericHelper2.default.setElementSelection(e.target, 0, targetValue.length);
            }

            if (targetValue === this.settings.suffixText || this.rawValue === '' && this.settings.currencySymbol !== '' && this.settings.suffixText !== '') {
                _AutoNumericHelper2.default.setElementSelection(e.target, 0);
            }

            // Saves the extended decimal to preserve the data when navigating away from the page
            if (this.settings.decimalPlacesShownOnFocus !== null) {
                this._saveValueToPersistentStorage();
            }

            if (!this.formatted) {
                //TODO Is this line needed? Considering that onKeydown and onKeypress both finish by setting it to false...
                this._formatValue(e);
            }

            // Force the `rawValue` update on Android Chrome
            this._saveRawValueForAndroid();

            // If the input value has changed during the key press event chain, an event is sent to alert that a formatting has been done (cf. Issue #187)
            if (targetValue !== this.initialValueOnKeydown) {
                this._triggerEvent(AutoNumeric.events.formatted, e.target, {
                    oldValue: this.initialValueOnKeydown,
                    newValue: targetValue,
                    oldRawValue: this.initialRawValueOnKeydown,
                    newRawValue: this.rawValue,
                    isPristine: this.isPristine(false),
                    error: null,
                    aNElement: this
                });
            }

            // Update the selection of the current element of the history table
            if (this.historyTable.length > 1) {
                var selection = _AutoNumericHelper2.default.getElementSelection(this.domElement);
                this.selectionStart = selection.start;
                this.selectionEnd = selection.end;
                this.historyTable[this.historyTableIndex].start = this.selectionStart;
                this.historyTable[this.historyTableIndex].end = this.selectionEnd;
            }
        }

        /**
         * On Android Chrome, the `rawValue` is not updated when the user changes the input value.
         * This function updates the `rawValue` accordingly.
         * @private
         */

    }, {
        key: '_saveRawValueForAndroid',
        value: function _saveRawValueForAndroid() {
            if (this.eventKey === _AutoNumericEnum2.default.keyName.AndroidDefault) {
                var normalizedValue = this.constructor._stripAllNonNumberCharactersExceptCustomDecimalChar(this.getFormatted(), this.settings, true, this.isFocused);
                normalizedValue = this.constructor._convertToNumericString(normalizedValue, this.settings);

                this._setRawValue(normalizedValue);
            }
        }

        /**
         * Handler for 'focusout' events
         * On focusout, multiple things happens :
         * - The element value is formatted back if the `Alt` key was pressed,
         * - The element value is formatted back if `showOnlyNumbersOnFocus` was set to only show numbers,
         * - The element value is multiplied by `rawValueDivisor` on `blur`
         *
         * Note: On focusout, the `rawValue` is never changed. Only the formatted value can be modified.
         *
         * @param {Event} e
         */

    }, {
        key: '_onFocusOutAndMouseLeave',
        value: function _onFocusOutAndMouseLeave(e) {
            //TODO Create separate handlers for blur and mouseleave
            this.isEditing = false; // Just in case no `keyUp` event have been sent (if the user lost the focus to the window while typing)

            if (e.type === 'mouseleave' && this.formulaMode) {
                return;
            }

            //FIXME Do not call `set()` if the current raw value is the same as the one we are trying to set (currently, on focus out, `set()` is always called, even if the value has not changed
            if (this.settings.unformatOnHover && e.type === 'mouseleave' && this.hoveredWithAlt) {
                this.constructor._reformatAltHovered(this);

                return;
            }

            if (e.type === 'mouseleave' && !this.isFocused || e.type === 'blur') {
                if (e.type === 'blur' && this.formulaMode) {
                    this._exitFormulaMode();
                }

                this._saveValueToPersistentStorage();
                if (this.settings.showOnlyNumbersOnFocus === AutoNumeric.options.showOnlyNumbersOnFocus.onlyNumbers) {
                    this.settings.digitGroupSeparator = this.originalDigitGroupSeparator;
                    this.settings.currencySymbol = this.originalCurrencySymbol;
                    this.settings.suffixText = this.originalSuffixText;
                }

                // Use the rawValue, multiplied by `rawValueDivisor` if defined
                var rawValueToFormat = this._getRawValueToFormat(this.rawValue);
                var isRawValueNull = _AutoNumericHelper2.default.isNull(rawValueToFormat);

                var _constructor$_checkIf5 = this.constructor._checkIfInRangeWithOverrideOption(rawValueToFormat, this.settings),
                    _constructor$_checkIf6 = _slicedToArray(_constructor$_checkIf5, 2),
                    minTest = _constructor$_checkIf6[0],
                    maxTest = _constructor$_checkIf6[1];

                // Directly set the formatted value if the `rawValue` is found in `valuesToStrings`


                var elementValueIsAlreadySet = false;
                if (rawValueToFormat !== '' && !isRawValueNull) {
                    if (!minTest) {
                        this._triggerEvent(AutoNumeric.events.minRangeExceeded, this.domElement);
                    }

                    if (!maxTest) {
                        this._triggerEvent(AutoNumeric.events.maxRangeExceeded, this.domElement);
                    }

                    if (this.settings.valuesToStrings && this._checkValuesToStrings(rawValueToFormat)) {
                        // Set the formatted value with the corresponding string
                        this._setElementValue(this.settings.valuesToStrings[rawValueToFormat]);
                        elementValueIsAlreadySet = true;
                    }
                }

                // Only generate the formatted value if no `valuesToStrings` have been found
                if (!elementValueIsAlreadySet) {
                    var value = void 0;
                    if (isRawValueNull || rawValueToFormat === '') {
                        value = rawValueToFormat;
                    } else {
                        value = String(rawValueToFormat);
                    }

                    if (rawValueToFormat !== '' && !isRawValueNull) {
                        if (minTest && maxTest && !this.constructor._isElementValueEmptyOrOnlyTheNegativeSign(rawValueToFormat, this.settings)) {
                            value = this._modifyNegativeSignAndDecimalCharacterForRawValue(value);

                            if (this.settings.divisorWhenUnfocused && !_AutoNumericHelper2.default.isNull(value)) {
                                value = value / this.settings.divisorWhenUnfocused;
                                value = value.toString();
                            }

                            value = this.constructor._roundFormattedValueShownOnBlur(value, this.settings);
                            value = this.constructor._modifyNegativeSignAndDecimalCharacterForFormattedValue(value, this.settings);
                        } else {
                            if (!minTest) {
                                this._triggerEvent(AutoNumeric.events.minRangeExceeded, this.domElement);
                            }

                            if (!maxTest) {
                                this._triggerEvent(AutoNumeric.events.maxRangeExceeded, this.domElement);
                            }
                        }
                    } else if (rawValueToFormat === '') {
                        switch (this.settings.emptyInputBehavior) {
                            case AutoNumeric.options.emptyInputBehavior.zero:
                                this._setRawValue('0');
                                value = this.constructor._roundValue('0', this.settings, 0);
                                break;
                            case AutoNumeric.options.emptyInputBehavior.min:
                                this._setRawValue(this.settings.minimumValue);
                                value = this.constructor._roundFormattedValueShownOnFocusOrBlur(this.settings.minimumValue, this.settings, this.isFocused);
                                break;
                            case AutoNumeric.options.emptyInputBehavior.max:
                                this._setRawValue(this.settings.maximumValue);
                                value = this.constructor._roundFormattedValueShownOnFocusOrBlur(this.settings.maximumValue, this.settings, this.isFocused);
                                break;
                            default:
                                if (_AutoNumericHelper2.default.isNumber(this.settings.emptyInputBehavior)) {
                                    this._setRawValue(this.settings.emptyInputBehavior);
                                    value = this.constructor._roundFormattedValueShownOnFocusOrBlur(this.settings.emptyInputBehavior, this.settings, this.isFocused);
                                }
                        }
                    }

                    var groupedValue = this.constructor._orderValueCurrencySymbolAndSuffixText(value, this.settings, false);
                    if (!(this.constructor._isElementValueEmptyOrOnlyTheNegativeSign(value, this.settings) || isRawValueNull && this.settings.emptyInputBehavior === AutoNumeric.options.emptyInputBehavior.null)) {
                        groupedValue = this.constructor._addGroupSeparators(value, this.settings, false, rawValueToFormat);
                    }

                    // Testing for `allowDecimalPadding.never` or `allowDecimalPadding.floats` is needed to make sure we do not keep a trailing decimalCharacter (like '500.') in the element, since the raw value would still be a correctly formatted integer ('500')
                    if (groupedValue !== rawValueToFormat || rawValueToFormat === '' || // This make sure we get rid on any currency symbol or suffix that might have been added on focus
                    this.settings.allowDecimalPadding === AutoNumeric.options.allowDecimalPadding.never || this.settings.allowDecimalPadding === AutoNumeric.options.allowDecimalPadding.floats) {
                        if (this.settings.symbolWhenUnfocused && rawValueToFormat !== '' && rawValueToFormat !== null) {
                            groupedValue = '' + groupedValue + this.settings.symbolWhenUnfocused;
                        }

                        this._setElementValue(groupedValue);
                    }
                }

                if (e.type === 'blur') {
                    //TODO Create separate handlers for blur and mouseleave, really.
                    this._onBlur(e);
                }
            }
        }

        /**
         * Handler for 'paste' event
         *
         * @param {Event|ClipboardEvent} e
         */

    }, {
        key: '_onPaste',
        value: function _onPaste(e) {
            //FIXME When pasting '000' on a thousand group selection, the whole selection gets deleted, and only one '0' is pasted (cf. issue #302)
            // The event is prevented by default, since otherwise the user would be able to paste invalid characters into the input
            e.preventDefault();

            if (this.settings.readOnly || this.domElement.readOnly || this.domElement.disabled) {
                // Do not allow pasting in a readonly element (fix issue #505)
                return;
            }

            var rawPastedText = void 0;
            if (window.clipboardData && window.clipboardData.getData) {
                // Special case for the obsolete and non-standard IE browsers 10 and 11
                rawPastedText = window.clipboardData.getData('Text');
            } else if (e.clipboardData && e.clipboardData.getData) {
                // Normal case with modern browsers
                rawPastedText = e.clipboardData.getData('text/plain');
            } else {
                _AutoNumericHelper2.default.throwError('Unable to retrieve the pasted value. Please use a modern browser (ie. Firefox or Chromium).');
            }

            // Fix for firefox paste handling on `contenteditable` elements where `e.target` is the the text node, not the element
            var eventTarget = void 0;
            if (!e.target.tagName) {
                eventTarget = e.explicitOriginalTarget;
            } else {
                eventTarget = e.target;
            }

            // 0. Special case if the user has selected all the input text before pasting
            var initialFormattedValue = _AutoNumericHelper2.default.getElementValue(eventTarget);
            var selectionStart = eventTarget.selectionStart || 0;
            var selectionEnd = eventTarget.selectionEnd || 0;
            var selectionSize = selectionEnd - selectionStart;

            if (selectionSize === initialFormattedValue.length) {
                // If all the element text is selected
                //TODO Refactor this with the tests below
                // Since the whole element content will be replaced, no need to complicate things and directly test for the validity of the pasted content, then set the `rawValue` and caret position (fix issue #482)
                // 1. Strip all thousand separators, brackets and currency sign, and convert the decimal character to a dot
                var _untranslatedPastedText = this._preparePastedText(rawPastedText);
                var pastedRawValue = _AutoNumericHelper2.default.arabicToLatinNumbers(_untranslatedPastedText, false, false, false); // Allow pasting arabic numbers

                // 2. Check that the paste is a valid number once it has been normalized to a raw value
                if (pastedRawValue === '.' || pastedRawValue === '' || pastedRawValue !== '.' && !_AutoNumericHelper2.default.isNumber(pastedRawValue)) {
                    this.formatted = true; // This prevent the `keyup` event on the `v` key during a paste to try to format an empty value.
                    // If the user tries to paste a single decimal character (that has been translated to '.' already) or the empty value, ignore the paste
                    if (this.settings.onInvalidPaste === AutoNumeric.options.onInvalidPaste.error) {
                        _AutoNumericHelper2.default.throwError('The pasted value \'' + rawPastedText + '\' is not a valid paste content.');
                    }

                    return;
                }

                // 3. Then try to set it as the new value. The `set()` method will run the additional tests (ie. limits) as needed.
                this.set(pastedRawValue);
                this.formatted = true;

                // 4. On a 'normal' non-autoNumeric input, an `input` event is sent when a paste is done. We mimic that.
                this._triggerEvent(AutoNumeric.events.native.input, eventTarget);

                // 5. Return since the job is done
                return;
            }

            // 1. Check if the paste has a negative sign (only if it's the first character), and store that information for later use
            var isPasteNegative = _AutoNumericHelper2.default.isNegativeStrict(rawPastedText, this.settings.negativeSignCharacter);
            if (isPasteNegative) {
                // 1a. Remove the negative sign from the pasted text
                rawPastedText = rawPastedText.slice(1, rawPastedText.length);
            }

            // 2. Strip all thousand separators, brackets and currency sign, and convert the decimal character to a dot
            var untranslatedPastedText = this._preparePastedText(rawPastedText);

            var pastedText = void 0;
            if (untranslatedPastedText === '.') {
                // Special case : If the user tries to paste a single decimal character (that has been translated to '.' already)
                pastedText = '.';
            } else {
                // Normal case
                // Allow pasting arabic numbers
                pastedText = _AutoNumericHelper2.default.arabicToLatinNumbers(untranslatedPastedText, false, false, false);
            }

            // 3. Test if the paste is valid (only has numbers and eventually a decimal character). If it's not valid, stop here.
            if (pastedText !== '.' && (!_AutoNumericHelper2.default.isNumber(pastedText) || pastedText === '')) {
                this.formatted = true; // This prevent the `keyup` event on the `v` key during a paste to try to format an empty value (fix issue #484)
                if (this.settings.onInvalidPaste === AutoNumeric.options.onInvalidPaste.error) {
                    _AutoNumericHelper2.default.throwError('The pasted value \'' + rawPastedText + '\' is not a valid paste content.');
                }

                return;
            }

            // 4. Calculate the paste result
            var caretPositionOnInitialTextAfterPasting = void 0;
            var isInitialValueNegative = _AutoNumericHelper2.default.isNegativeStrict(this.getNumericString(), this.settings.negativeSignCharacter);
            var isPasteNegativeAndInitialValueIsPositive = void 0;
            var result = void 0;

            // If the pasted content is negative, then the result will be negative too
            if (isPasteNegative && !isInitialValueNegative) {
                isInitialValueNegative = true;
                isPasteNegativeAndInitialValueIsPositive = true;
            } else {
                isPasteNegativeAndInitialValueIsPositive = false;
            }

            // 1. Generate the unformatted result
            var leftFormattedPart = initialFormattedValue.slice(0, selectionStart);
            var rightFormattedPart = initialFormattedValue.slice(selectionEnd, initialFormattedValue.length);

            if (selectionStart !== selectionEnd) {
                // a. If there is a selection, remove the selected part, and return the left and right part
                result = this._preparePastedText(leftFormattedPart + rightFormattedPart);
            } else {
                // b. Else if this is only one caret (and therefore no selection), then return the left and right part
                result = this._preparePastedText(initialFormattedValue);
            }

            // Add back the negative sign if needed
            if (isInitialValueNegative) {
                result = _AutoNumericHelper2.default.setRawNegativeSign(result);
            }

            // Build the unformatted result string
            caretPositionOnInitialTextAfterPasting = _AutoNumericHelper2.default.convertCharacterCountToIndexPosition(_AutoNumericHelper2.default.countNumberCharactersOnTheCaretLeftSide(initialFormattedValue, selectionStart, this.settings.decimalCharacter));
            if (isPasteNegativeAndInitialValueIsPositive) {
                // If the initial paste is negative and the initial value is not, then I must offset the caret position by one place to the right to take the additional hyphen into account
                caretPositionOnInitialTextAfterPasting++;
                //TODO Quid if the negative sign is not on the left (negativePositiveSignPlacement and currencySymbolPlacement)?
                //TODO Quid if the positive sign is shown?
            }

            var leftPart = result.slice(0, caretPositionOnInitialTextAfterPasting);
            var rightPart = result.slice(caretPositionOnInitialTextAfterPasting, result.length);
            var leftPartContainedADot = false;
            if (pastedText === '.') {
                if (_AutoNumericHelper2.default.contains(leftPart, '.')) {
                    // If I remove a dot here, then I need to update the caret position (decrement it by 1) when positioning it
                    // To do so, we keep that info in order to modify the caret position later
                    leftPartContainedADot = true;
                    leftPart = leftPart.replace('.', '');
                }

                rightPart = rightPart.replace('.', '');
            }

            // Manage the case where a negative number is pasted onto another negative number that is entirely selected (cf. issue #593)
            var negativePasteOnNegativeNumber = false;
            if (leftPart === '' && rightPart === '-') {
                leftPart = '-';
                rightPart = '';
                // When pasting a negative number on a negative number, we need to offset the caret position one place to the right to take into account the negative sign
                negativePasteOnNegativeNumber = true;
            }

            // -- Here, we are good to go to continue on the same basis for each value of the `onInvalidPaste` option

            switch (this.settings.onInvalidPaste) {
                /* 4a. Truncate paste behavior:
                 * Insert as many numbers as possible on the right hand side of the caret from the pasted text content, until the input reach its range limit.
                 * If there is more characters in the clipboard once a limit is reached, drop the extraneous characters.
                 * Otherwise paste all the numbers from the clipboard.
                 * While doing so, we check if the result is within the minimum and maximum values allowed, and stop as soon as we encounter one of those.
                 *
                 * 4b. Replace paste behavior:
                 * Idem than the 'truncate' paste behavior, except that when a range limit is hit, we try to replace the subsequent initial numbers with the pasted ones, until we hit the range limit a second (and last) time, or we run out of numbers to paste
                 */
                /* eslint no-case-declarations: 0 */
                case AutoNumeric.options.onInvalidPaste.truncate:
                case AutoNumeric.options.onInvalidPaste.replace:
                    // c. Add numbers one by one at the caret position, while testing if the result is valid and within the range of the minimum and maximum value
                    //    Continue until you either run out of numbers to paste, or that you get out of the range limits
                    var minParse = _AutoNumericHelper2.default.parseStr(this.settings.minimumValue);
                    var maxParse = _AutoNumericHelper2.default.parseStr(this.settings.maximumValue);
                    var lastGoodKnownResult = result; // This is set as the default, in case we do not add even one number
                    var pastedTextIndex = 0;
                    var modifiedLeftPart = leftPart;

                    while (pastedTextIndex < pastedText.length) {
                        // Modify the result with another pasted character
                        modifiedLeftPart += pastedText[pastedTextIndex];
                        result = modifiedLeftPart + rightPart;

                        // Check the range limits
                        if (!this.constructor._checkIfInRange(result, minParse, maxParse)) {
                            // The result is out of the range limits, stop the loop here
                            break;
                        }

                        // Save the last good known result
                        lastGoodKnownResult = result;

                        // Update the local variables for the next loop
                        pastedTextIndex++;
                    }

                    // Update the last caret position where to insert a new number
                    caretPositionOnInitialTextAfterPasting += pastedTextIndex;
                    if (negativePasteOnNegativeNumber) caretPositionOnInitialTextAfterPasting++;

                    //XXX Here we have the result for the `truncate` option
                    if (this.settings.onInvalidPaste === AutoNumeric.options.onInvalidPaste.truncate) {
                        //TODO If the user as defined a truncate callback and there are still some numbers (that will be dropped), then call this callback with the initial paste as well as the remaining numbers
                        result = lastGoodKnownResult;

                        if (leftPartContainedADot) {
                            // If a dot has been removed for the part on the left of the caret, we decrement the caret index position
                            caretPositionOnInitialTextAfterPasting--;
                        }
                        break;
                    }
                    //XXX ...else we need to continue modifying the result for the 'replace' option

                    // d. Until there are numbers to paste, replace the initial numbers one by one, and still do the range test.
                    //    Stop when you have no more numbers to paste, or if you are out of the range limits.
                    //    If you do get to the range limits, use the previous known good value within those limits.
                    //    Note: The numbers are replaced one by one, in the integer then decimal part, while ignoring the decimal character
                    //TODO What should happen if the user try to paste a decimal number? Should we override the current initial decimal character in favor of this new one? If we do, then we have to recalculate the vMin/vMax from the start in order to take into account this new decimal character position..
                    var lastGoodKnownResultIndex = caretPositionOnInitialTextAfterPasting;
                    var lastGoodKnownResultSize = lastGoodKnownResult.length;

                    while (pastedTextIndex < pastedText.length && lastGoodKnownResultIndex < lastGoodKnownResultSize) {
                        if (lastGoodKnownResult[lastGoodKnownResultIndex] === '.') {
                            // We skip the decimal character 'replacement'. That way, we do not change the decimal character position regarding the remaining numbers.
                            lastGoodKnownResultIndex++;
                            continue;
                        }

                        // This replace one character at a time
                        result = _AutoNumericHelper2.default.replaceCharAt(lastGoodKnownResult, lastGoodKnownResultIndex, pastedText[pastedTextIndex]);

                        // Check the range limits
                        if (!this.constructor._checkIfInRange(result, minParse, maxParse)) {
                            // The result is out of the range limits, stop the loop here
                            break;
                        }

                        // Save the last good known result
                        lastGoodKnownResult = result;

                        // Update the local variables for the next loop
                        pastedTextIndex++;
                        lastGoodKnownResultIndex++;
                    }

                    // Update the last caret position where to insert a new number
                    caretPositionOnInitialTextAfterPasting = lastGoodKnownResultIndex;

                    if (leftPartContainedADot) {
                        // If a dot has been removed for the part on the left of the caret, we decrement the caret index position
                        caretPositionOnInitialTextAfterPasting--;
                    }

                    result = lastGoodKnownResult;

                    break;
                /* 4c. Normal paste behavior:
                 * Insert the pasted number inside the current unformatted text, at the correct caret position or selection
                 */
                case AutoNumeric.options.onInvalidPaste.error:
                case AutoNumeric.options.onInvalidPaste.ignore:
                case AutoNumeric.options.onInvalidPaste.clamp:
                default:
                    // Generate the unformatted result
                    result = '' + leftPart + pastedText + rightPart;

                    // 2. Calculate the caret position in the unformatted value, for later use
                    if (selectionStart === selectionEnd) {
                        // There is no selection, then the caret position is set after the pasted text
                        var indexWherePastedTextHasBeenInserted = _AutoNumericHelper2.default.convertCharacterCountToIndexPosition(_AutoNumericHelper2.default.countNumberCharactersOnTheCaretLeftSide(initialFormattedValue, selectionStart, this.settings.decimalCharacter));
                        caretPositionOnInitialTextAfterPasting = indexWherePastedTextHasBeenInserted + pastedText.length; // I must not count the characters that have been removed from the pasted text (ie. '.')
                    } else if (rightPart === '') {
                        // If the user selected from the caret position to the end of the input (on the far right)
                        caretPositionOnInitialTextAfterPasting = _AutoNumericHelper2.default.convertCharacterCountToIndexPosition(_AutoNumericHelper2.default.countNumberCharactersOnTheCaretLeftSide(initialFormattedValue, selectionStart, this.settings.decimalCharacter)) + pastedText.length;
                        if (negativePasteOnNegativeNumber) caretPositionOnInitialTextAfterPasting++;
                    } else {
                        // Usual case
                        var indexSelectionEndInRawValue = _AutoNumericHelper2.default.convertCharacterCountToIndexPosition(_AutoNumericHelper2.default.countNumberCharactersOnTheCaretLeftSide(initialFormattedValue, selectionEnd, this.settings.decimalCharacter));

                        // Here I must not count the characters that have been removed from the pasted text (ie. '.'), or the thousand separators in the initial selected text
                        var selectedText = _AutoNumericHelper2.default.getElementValue(eventTarget).slice(selectionStart, selectionEnd);
                        caretPositionOnInitialTextAfterPasting = indexSelectionEndInRawValue - selectionSize + _AutoNumericHelper2.default.countCharInText(this.settings.digitGroupSeparator, selectedText) + pastedText.length;
                    }

                    // Modify the caret position for special cases, only if the whole input has not been selected
                    if (isPasteNegativeAndInitialValueIsPositive) {
                        // If the pasted value has a negative sign ('-'), but the initial value does not, offset the index by one
                        caretPositionOnInitialTextAfterPasting++;
                    }

                    if (leftPartContainedADot) {
                        // If a dot has been removed for the part on the left of the caret, we decrement the caret index position
                        caretPositionOnInitialTextAfterPasting--;
                    }
            }

            // 5. Check if the result is a valid number, if not, drop the paste and do nothing.
            if (!_AutoNumericHelper2.default.isNumber(result) || result === '') {
                if (this.settings.onInvalidPaste === AutoNumeric.options.onInvalidPaste.error) {
                    _AutoNumericHelper2.default.throwError('The pasted value \'' + rawPastedText + '\' would result into an invalid content \'' + result + '\'.'); //TODO Should we send a warning instead of throwing an error?
                    //TODO This is not DRY ; refactor with above
                }
                return;
            }

            // 6. If it's a valid number, check if it falls inside the minimum and maximum value. If this fails, modify the value following this procedure :
            /*
             * If 'error' (this is the default) :
             *      - Normal paste behavior.
             *      - Try to set the new value, if it fails, then throw an error in the console.
             *      - Do not change the input value, do not change the current selection.
             * If 'ignore' :
             *      - Normal paste behavior.
             *      - Try to set the new value, if it fails, do nothing more.
             *      - Do not change the input value, do not change the current selection.
             * If 'clamp' :
             *      - Normal paste behavior.
             *      - Try to set the new value, if it fails, set the value to the minimum or maximum limit, whichever is closest to the
             *        paste result.
             *      - Change the caret position to be positioned on the left hand side of the decimal character.
             * If 'truncate' :
             *      - Truncate paste behavior.
             *      - Try to set the new value, until it fails (if the result is out of the min and max value limits).
             *      - Drop the remaining non-pasted numbers, and keep the last known non-failing result.
             *      - Change the caret position to be positioned after the last pasted character.
             * If 'replace' :
             *      - Replace paste behavior.
             *      - Try to set the new value, until it fails (if the result is out of the min and max value limits).
             *      - Then try to replace as many numbers as possible with the pasted ones. Once it fails, keep the last known non-failing result.
             *      - Change the caret position to be positioned after the last pasted character.
             */
            var valueHasBeenSet = false;
            var valueHasBeenClamped = false;
            try {
                this.set(result);
                valueHasBeenSet = true;
            } catch (error) {
                var clampedValue = void 0;
                switch (this.settings.onInvalidPaste) {
                    case AutoNumeric.options.onInvalidPaste.clamp:
                        clampedValue = _AutoNumericHelper2.default.clampToRangeLimits(result, this.settings);
                        try {
                            this.set(clampedValue);
                        } catch (error) {
                            _AutoNumericHelper2.default.throwError('Fatal error: Unable to set the clamped value \'' + clampedValue + '\'.');
                        }

                        valueHasBeenClamped = true;
                        valueHasBeenSet = true;
                        result = clampedValue; // This is used only for setting the caret position later
                        break;
                    case AutoNumeric.options.onInvalidPaste.error:
                    case AutoNumeric.options.onInvalidPaste.truncate:
                    case AutoNumeric.options.onInvalidPaste.replace:
                        // Throw an error message
                        _AutoNumericHelper2.default.throwError('The pasted value \'' + rawPastedText + '\' results in a value \'' + result + '\' that is outside of the minimum [' + this.settings.minimumValue + '] and maximum [' + this.settings.maximumValue + '] value range.');
                    // falls through
                    case AutoNumeric.options.onInvalidPaste.ignore:
                    // Do nothing
                    // falls through
                    default:
                        return; // ...and nothing else should be changed
                }
            }

            // 7. Then lastly, set the caret position at the right logical place
            var targetValue = _AutoNumericHelper2.default.getElementValue(eventTarget);
            var caretPositionInFormattedNumber = void 0;
            if (valueHasBeenSet) {
                switch (this.settings.onInvalidPaste) {
                    case AutoNumeric.options.onInvalidPaste.clamp:
                        if (valueHasBeenClamped) {
                            if (this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.suffix) {
                                _AutoNumericHelper2.default.setElementSelection(eventTarget, targetValue.length - this.settings.currencySymbol.length); // This puts the caret on the right of the last decimal place
                            } else {
                                _AutoNumericHelper2.default.setElementSelection(eventTarget, targetValue.length); // ..and this on the far right
                            }

                            break;
                        } // else if the value has not been clamped, the default behavior is used...
                    // falls through
                    case AutoNumeric.options.onInvalidPaste.error:
                    case AutoNumeric.options.onInvalidPaste.ignore:
                    case AutoNumeric.options.onInvalidPaste.truncate:
                    case AutoNumeric.options.onInvalidPaste.replace:
                    default:
                        // Whenever one or multiple characters are pasted, this means we have to manage the potential thousand separators that could be added by the formatting
                        caretPositionInFormattedNumber = _AutoNumericHelper2.default.findCaretPositionInFormattedNumber(result, caretPositionOnInitialTextAfterPasting, targetValue, this.settings.decimalCharacter);
                        _AutoNumericHelper2.default.setElementSelection(eventTarget, caretPositionInFormattedNumber);
                }
            }

            // 8. We make sure we send an input event only if the result is different than the initial value before the paste
            if (valueHasBeenSet && initialFormattedValue !== targetValue) {
                // On a 'normal' non-autoNumeric input, an `input` event is sent when a paste is done. We mimic that.
                this._triggerEvent(AutoNumeric.events.native.input, eventTarget);
            }
        }

        /**
         * When focusing out of the input, we check if the value has changed, and if it has, then we send a `change` event (since the native one would have been prevented by `e.preventDefault()` called in the other event listeners).
         * We also update the info of the focused state in the `this.isFocused` variable.
         *
         * @param {Event} e
         */

    }, {
        key: '_onBlur',
        value: function _onBlur(e) {
            // Keep track if the element is currently focused
            this.isFocused = false;
            // Keep track if the user is currently editing the element
            this.isEditing = false;

            // Send a `change` event if the raw value has been changed since the last focus or 'enter' validation
            if (this.rawValue !== this.rawValueOnFocus) {
                this._triggerEvent(AutoNumeric.events.native.change, e.target);
            }

            this.rawValueOnFocus = void 0; // Reset the tracker
        }

        /**
         * Handler for 'wheel' event
         *
         * @param {WheelEvent} e
         */

    }, {
        key: '_onWheel',
        value: function _onWheel(e) {
            if (this.formulaMode) {
                return;
            }

            if (this.settings.readOnly || this.domElement.readOnly || this.domElement.disabled) {
                // Do not allow scrolling in a readonly element (fix issue #541)
                return;
            }

            if (this.settings.modifyValueOnWheel) {
                if (this.settings.wheelOn === AutoNumeric.options.wheelOn.focus) {
                    if (this.isFocused) {
                        if (!e.shiftKey) {
                            this.wheelAction(e);
                        }
                    } else if (e.shiftKey) {
                        this.wheelAction(e);
                    }
                } else if (this.settings.wheelOn === AutoNumeric.options.wheelOn.hover) {
                    if (!e.shiftKey) {
                        this.wheelAction(e);
                    } else {
                        // Note: When not `defaultPrevented`, Shift + mouse wheel is reserved by the browsers for horizontal scrolling.
                        // Hence, using the Shift key with the `wheelOn` 'hover' option will only scroll the page if we prevent the default behavior
                        e.preventDefault(); // Do not scroll horizontally

                        // Scroll vertically
                        window.scrollBy(0, _AutoNumericHelper2.default.isNegativeStrict(String(e.deltaY)) ? -50 : 50); // `e.deltaY` is usually too small compared to how the page is scrolled. That's why we use a fixed offset.
                    }
                } else {
                    _AutoNumericHelper2.default.throwError('Unknown `wheelOn` option.');
                }
            }
        }

        /**
         * Increment or decrement the element value according to the `wheelStep` option chosen
         *
         * @param {WheelEvent} e The `wheel` event
         */

    }, {
        key: 'wheelAction',
        value: function wheelAction(e) {
            this.isWheelEvent = true; // Keep the info that we are currently managing a mouse wheel event

            // 0) First, save the caret position so we can set it back once the value has been changed
            var selectionStart = e.target.selectionStart || 0;
            var selectionEnd = e.target.selectionEnd || 0;

            // 1) Get the unformatted value
            var currentUnformattedValue = this.rawValue;

            var result = void 0;
            if (_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(currentUnformattedValue)) {
                // If by default the input is empty, start at '0'
                if (this.settings.minimumValue > 0 || this.settings.maximumValue < 0) {
                    // or if '0' is not between min and max value, 'minimumValue' if the user does a wheelup, 'maximumValue' if the user does a wheeldown
                    if (_AutoNumericHelper2.default.isWheelUpEvent(e)) {
                        result = this.settings.minimumValue;
                    } else if (_AutoNumericHelper2.default.isWheelDownEvent(e)) {
                        result = this.settings.maximumValue;
                    } else {
                        _AutoNumericHelper2.default.throwError('The event is not a \'wheel\' event.');
                    }
                } else {
                    result = 0;
                }
            } else {
                result = currentUnformattedValue;
            }

            result = +result; // Typecast to a number needed for the following addition/subtraction

            // 2) Increment/Decrement the value
            // But first, choose the increment/decrement method ; fixed or progressive
            if (_AutoNumericHelper2.default.isNumber(this.settings.wheelStep)) {
                var step = +this.settings.wheelStep; // Typecast to a number needed for the following addition/subtraction
                // Fixed method
                // This is the simplest method, where a fixed offset in added/subtracted from the current value
                if (_AutoNumericHelper2.default.isWheelUpEvent(e)) {
                    // Increment
                    result += step;
                } else if (_AutoNumericHelper2.default.isWheelDownEvent(e)) {
                    // Decrement
                    result -= step;
                }
            } else {
                // Progressive method
                // For this method, we calculate an offset that is in relation to the size of the current number (using only the integer part size).
                // The bigger the number, the bigger the offset (usually the number count in the integer part minus 3, except for small numbers where a different behavior is better for the user experience).
                //TODO Known limitation : The progressive method does not play well with numbers between 0 and 1 where to modify the decimal places the rawValue first has to go from '1' to '0'
                if (_AutoNumericHelper2.default.isWheelUpEvent(e)) {
                    // Increment
                    result = _AutoNumericHelper2.default.addAndRoundToNearestAuto(result, this.settings.decimalPlacesRawValue);
                } else if (_AutoNumericHelper2.default.isWheelDownEvent(e)) {
                    // Decrement
                    result = _AutoNumericHelper2.default.subtractAndRoundToNearestAuto(result, this.settings.decimalPlacesRawValue);
                }
            }

            // 3) Set the new value so it gets formatted
            // First clamp the result if needed
            result = _AutoNumericHelper2.default.clampToRangeLimits(result, this.settings);
            if (result !== +currentUnformattedValue) {
                // Only 'set' the value if it has changed. For instance 'set' should not happen if the user hits a limit and continue to try to go past it since we clamp the value.
                this.set(result);

                // Since we changed the input value, we send a native `input` event
                this._triggerEvent(AutoNumeric.events.native.input, e.target);
            }

            //XXX Do not prevent if the value is not modified? From a UX point of view, preventing the wheel event when the user use it on top of an autoNumeric element should always be done, even if the value does not change. Perhaps that could affect other scripts relying on this event to be sent though.
            e.preventDefault(); // We prevent the page to scroll while we increment/decrement the value

            // 4) Finally, we set back the caret position/selection
            // There is no need to take into account the fact that the number count could be different at the end of the wheel event ; it would be too complex and most of the time unreliable
            this._setSelection(selectionStart, selectionEnd);

            this.isWheelEvent = false; // Set back the mouse wheel indicator to its default
        }

        /**
         * Handler for 'drop' event
         *
         * @param {DragEvent} e
         */

    }, {
        key: '_onDrop',
        value: function _onDrop(e) {
            if (this.formulaMode) {
                // Dropping while in formula mode shouldn't be possible. This is done 'just in case'
                return;
            }

            // Note: by default browsers already prevent the drop on readOnly and disabled elements
            this.isDropEvent = true;
            e.preventDefault();
            var format = void 0;
            if (_AutoNumericHelper2.default.isIE11()) {
                format = 'text';
            } else {
                format = 'text/plain';
            }

            var droppedText = e.dataTransfer.getData(format);
            var cleanedValue = this.unformatOther(droppedText);
            this.set(cleanedValue);
            this.isDropEvent = false;
        }

        /**
         * Handler for 'submit' events happening on the parent <form> element.
         * If `unformatOnSubmit` is set to `true`, the element value is first unformatted before the form is submitted.
         *
         * @returns {boolean}
         */

    }, {
        key: '_onFormSubmit',
        value: function _onFormSubmit() {
            var _this10 = this;

            // Search for all the AutoNumeric children of the form element and call the `_unformatOnSubmit()` function
            var inputElements = this._getFormAutoNumericChildren(this.parentForm);
            var aNElements = inputElements.map(function (aNElement) {
                return _this10.constructor.getAutoNumericElement(aNElement);
            });
            aNElements.forEach(function (aNElement) {
                return aNElement._unformatOnSubmit();
            });

            return true;
        }

        /**
         * Handler for 'reset' events caught on the parent <form> element.
         * When such event is detected, then every child AutoNumeric elements must format their default value that the browser is forcing upon them.
         *
         * @private
         */

    }, {
        key: '_onFormReset',
        value: function _onFormReset() {
            var _this11 = this;

            var inputElements = this._getFormAutoNumericChildren(this.parentForm);
            var aNElements = inputElements.map(function (aNElement) {
                return _this11.constructor.getAutoNumericElement(aNElement);
            });
            // Tell all the AutoNumeric children to format their default value
            aNElements.forEach(function (aNElement) {
                var val = _this11._getDefaultValue(aNElement.node());
                // aNElement.set(val); //XXX If I use that line, the format is first correctly done, but the form reset is still not finished and will overwrite the formatting. This is why we need to use the following setTimeout line.
                setTimeout(function () {
                    return aNElement.set(val);
                }, 0); //XXX This is an ugly hack, but it seems to be the accepted answer to this problem (https://stackoverflow.com/a/8152960/2834898). This is sad. Do note that I use '0ms' here since using `setTimeout` will push that code on the event stack, and as soon as the reset will be finished, this will be run (see https://stackoverflow.com/a/23987283/2834898).
            });
        }

        /**
         * Unformat the element value according to the `unformatOnSubmit` option
         *
         * @private
         */

    }, {
        key: '_unformatOnSubmit',
        value: function _unformatOnSubmit() {
            if (this.settings.unformatOnSubmit) {
                this._setElementValue(this.rawValue);
            }
        }

        /**
         * Listen for the `alt` key keydown event globally, and if the event is caught, unformat the AutoNumeric element that is hovered by the mouse.
         *
         * @param {KeyboardEvent} e
         * @private
         */

    }, {
        key: '_onKeydownGlobal',
        value: function _onKeydownGlobal(e) {
            //TODO Find a way to keep the caret position between the alt keyup/keydown states
            if (_AutoNumericHelper2.default.character(e) === _AutoNumericEnum2.default.keyName.Alt) {
                var hoveredElement = _AutoNumericHelper2.default.getHoveredElement();
                if (AutoNumeric.isManagedByAutoNumeric(hoveredElement)) {
                    var anElement = AutoNumeric.getAutoNumericElement(hoveredElement);
                    if (!anElement.formulaMode && anElement.settings.unformatOnHover) {
                        this.constructor._unformatAltHovered(anElement);
                    }
                }
            }
        }

        /**
         * Listen for the `alt` key keyup event globally, and if the event is caught, reformat the AutoNumeric element that is hovered by the mouse.
         *
         * @param {KeyboardEvent} e
         * @private
         */

    }, {
        key: '_onKeyupGlobal',
        value: function _onKeyupGlobal(e) {
            if (_AutoNumericHelper2.default.character(e) === _AutoNumericEnum2.default.keyName.Alt) {
                var hoveredElement = _AutoNumericHelper2.default.getHoveredElement();
                if (AutoNumeric.isManagedByAutoNumeric(hoveredElement)) {
                    var anElement = AutoNumeric.getAutoNumericElement(hoveredElement);
                    if (anElement.formulaMode || !anElement.settings.unformatOnHover) {
                        return;
                    }

                    this.constructor._reformatAltHovered(anElement);
                }
            }
        }

        /**
         * Return `true` if the DOM element is supported by autoNumeric.
         * A supported element is an element whitelisted in the `allowedTagList`.
         *
         * @returns {boolean}
         * @private
         */

    }, {
        key: '_isElementTagSupported',
        value: function _isElementTagSupported() {
            if (!_AutoNumericHelper2.default.isElement(this.domElement)) {
                _AutoNumericHelper2.default.throwError('The DOM element is not valid, ' + this.domElement + ' given.');
            }

            return _AutoNumericHelper2.default.isInArray(this.domElement.tagName.toLowerCase(), this.allowedTagList);
        }

        /**
         * Return `true` in the DOM element is an <input>.
         *
         * @returns {boolean}
         * @private
         */

    }, {
        key: '_isInputElement',
        value: function _isInputElement() {
            return this.domElement.tagName.toLowerCase() === 'input';
        }

        /**
         * Return `true` if the input type is supported by AutoNumeric
         *
         * @returns {boolean}
         * @throws
         */

    }, {
        key: '_isInputTypeSupported',
        value: function _isInputTypeSupported() {
            return this.domElement.type === 'text' || this.domElement.type === 'hidden' || this.domElement.type === 'tel' || _AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(this.domElement.type);
        }

        /**
         * Check if the DOM element is supported by autoNumeric.
         * A supported element is either an <input> element with the correct 'type' attribute, or a tag whitelisted in the `allowedTagList` array.
         * If the check fails, this method throws.
         * This function also sets the info `this.isInputElement` which keep tracks if the DOM element is an <input> or not, and the `this.isContentEditable` if the element has the `contenteditable` attribute set to `true` initially.
         *
         * @throws
         * @private
         */

    }, {
        key: '_checkElement',
        value: function _checkElement() {
            var currentElementTag = this.domElement.tagName.toLowerCase();

            if (!this._isElementTagSupported()) {
                _AutoNumericHelper2.default.throwError('The <' + currentElementTag + '> tag is not supported by autoNumeric');
            }

            if (this._isInputElement()) {
                if (!this._isInputTypeSupported()) {
                    _AutoNumericHelper2.default.throwError('The input type "' + this.domElement.type + '" is not supported by autoNumeric');
                }

                this.isInputElement = true;
            } else {
                this.isInputElement = false;
                this.isContentEditable = this.domElement.hasAttribute('contenteditable') && this.domElement.getAttribute('contenteditable') === 'true';
            }
        }

        /**
         * Formats the default value on page load.
         * This is called only if the `formatOnPageLoad` option is set to `true`.
         *
         * @param {number|string|null} forcedInitialValue The value that should be used for initialization, in place on the eventual html one
         */

    }, {
        key: '_formatDefaultValueOnPageLoad',
        value: function _formatDefaultValueOnPageLoad() {
            var forcedInitialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var setValue = true;
            var currentValue = void 0;
            if (!_AutoNumericHelper2.default.isNull(forcedInitialValue)) {
                currentValue = forcedInitialValue;
            } else {
                // Make sure the initial value does not have any superfluous whitespaces around it (Fix issue #479)
                currentValue = _AutoNumericHelper2.default.getElementValue(this.domElement).trim();
                // Correct the DOM attribute in case some whitespaces were present
                this.domElement.setAttribute('value', currentValue);
            }

            if (this.isInputElement || this.isContentEditable) {
                /*
                 * If the input value has been set by the dev, but not directly as an attribute in the html, then it takes
                 * precedence and should get formatted during the initialization (if this input value is a valid number and that the
                 * developer wants it formatted on init (cf. the `settings.formatOnPageLoad` option)).
                 * Note; this is true whatever the developer has set for `data-default-value-override` in the html (asp.net users).
                 *
                 * In other words : if `defaultValueOverride` is not null, it means the developer is trying to prevent postback problems.
                 * But if `input.value` is set to a number, and the html `value` attribute is not set, then it means the dev has
                 * changed the input value, and then it means we should not overwrite his own decision to do so.
                 * Hence, if `defaultValueOverride` is not null, but `input.value` is a number and `this.domElement.hasAttribute('value')`
                 * is false, we should ignore `defaultValueOverride` altogether.
                 */
                var unLocalizedCurrentValue = this.constructor._toNumericValue(currentValue, this.settings); // This allows to use a localized value on startup
                if (!this.domElement.hasAttribute('value') || this.domElement.getAttribute('value') === '') {
                    // Check if the `value` is valid or not
                    if (!isNaN(Number(unLocalizedCurrentValue)) && Infinity !== unLocalizedCurrentValue) {
                        this.set(unLocalizedCurrentValue);
                        setValue = false;
                    } else {
                        // If not, inform the developer that nothing usable has been provided
                        _AutoNumericHelper2.default.throwError('The value [' + currentValue + '] used in the input is not a valid value autoNumeric can work with.');
                    }
                } else {
                    /* Checks for :
                     * - page reload from back button, and
                     * - ASP.net form post back
                     *      The following HTML data attribute is REQUIRED (data-an-default="same value as the value attribute")
                     *      example: <asp:TextBox runat="server" id="someID" text="1234.56" data-an-default="1234.56">
                     */
                    if (this.settings.defaultValueOverride !== null && this.settings.defaultValueOverride.toString() !== currentValue || this.settings.defaultValueOverride === null && currentValue !== '' && currentValue !== this.domElement.getAttribute('value') || currentValue !== '' && this.domElement.getAttribute('type') === 'hidden' && !_AutoNumericHelper2.default.isNumber(unLocalizedCurrentValue)) {
                        if (this.settings.saveValueToSessionStorage && (this.settings.decimalPlacesShownOnFocus !== null || this.settings.divisorWhenUnfocused)) {
                            this._setRawValue(this._getValueFromPersistentStorage());
                        }

                        // If the decimalPlacesShownOnFocus value should NOT be saved in sessionStorage
                        if (!this.settings.saveValueToSessionStorage) {
                            var toStrip = this.constructor._removeBrackets(currentValue, this.settings);
                            if ((this.settings.negativePositiveSignPlacement === AutoNumeric.options.negativePositiveSignPlacement.suffix || this.settings.negativePositiveSignPlacement !== AutoNumeric.options.negativePositiveSignPlacement.prefix && this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.suffix) && this.settings.negativeSignCharacter !== '' && _AutoNumericHelper2.default.isNegative(currentValue, this.settings.negativeSignCharacter)) {
                                this._setRawValue('-' + this.constructor._stripAllNonNumberCharacters(toStrip, this.settings, true, this.isFocused));
                            } else {
                                this._setRawValue(this.constructor._stripAllNonNumberCharacters(toStrip, this.settings, true, this.isFocused));
                            }
                        }

                        setValue = false;
                    }
                }

                if (currentValue === '') {
                    switch (this.settings.emptyInputBehavior) {
                        case AutoNumeric.options.emptyInputBehavior.focus:
                        case AutoNumeric.options.emptyInputBehavior.null:
                        case AutoNumeric.options.emptyInputBehavior.press:
                            break;
                        case AutoNumeric.options.emptyInputBehavior.always:
                            this._setElementValue(this.settings.currencySymbol);
                            break;
                        case AutoNumeric.options.emptyInputBehavior.min:
                            this.set(this.settings.minimumValue);
                            break;
                        case AutoNumeric.options.emptyInputBehavior.max:
                            this.set(this.settings.maximumValue);
                            break;
                        case AutoNumeric.options.emptyInputBehavior.zero:
                            this.set('0');
                            break;
                        // When `emptyInputBehavior` is a number or a string representing a number
                        default:
                            this.set(this.settings.emptyInputBehavior);
                    }
                } else if (setValue && currentValue === this.domElement.getAttribute('value')) {
                    this.set(currentValue);
                }
            } else if (this.settings.defaultValueOverride === null || this.settings.defaultValueOverride === currentValue) {
                this.set(currentValue);
            }
        }

        /**
         * Enhance the user experience by modifying the default `negativePositiveSignPlacement` option depending on `currencySymbol` and `currencySymbolPlacement`.
         *
         * If the user has not set the placement of the negative sign (`negativePositiveSignPlacement`), but has set a currency symbol (`currencySymbol`),
         * then we modify the default value of `negativePositiveSignPlacement` in order to keep the resulting output logical by default :
         * - "$-1,234.56" instead of "-$1,234.56" ({currencySymbol: "$", negativePositiveSignPlacement: "r"})
         * - "-1,234.56$" instead of "1,234.56-$" ({currencySymbol: "$", currencySymbolPlacement: "s", negativePositiveSignPlacement: "p"})
         *
         * @param {object} settings
         */

    }, {
        key: '_calculateVMinAndVMaxIntegerSizes',


        /**
         * Analyze and save the minimumValue and maximumValue integer size for later uses
         * @private
         */
        value: function _calculateVMinAndVMaxIntegerSizes() {
            var _settings$maximumValu = this.settings.maximumValue.toString().split('.'),
                _settings$maximumValu2 = _slicedToArray(_settings$maximumValu, 1),
                maximumValueIntegerPart = _settings$maximumValu2[0];

            var _ref = !this.settings.minimumValue && this.settings.minimumValue !== 0 ? [] : this.settings.minimumValue.toString().split('.'),
                _ref2 = _slicedToArray(_ref, 1),
                minimumValueIntegerPart = _ref2[0];

            maximumValueIntegerPart = maximumValueIntegerPart.replace(this.settings.negativeSignCharacter, '');
            minimumValueIntegerPart = minimumValueIntegerPart.replace(this.settings.negativeSignCharacter, '');

            this.settings.mIntPos = Math.max(maximumValueIntegerPart.length, 1);
            this.settings.mIntNeg = Math.max(minimumValueIntegerPart.length, 1);
        }

        /**
         * Calculate once what are the `valuesToStrings` option keys.
         * @private
         */

    }, {
        key: '_calculateValuesToStringsKeys',
        value: function _calculateValuesToStringsKeys() {
            if (this.settings.valuesToStrings) {
                this.valuesToStringsKeys = Object.keys(this.settings.valuesToStrings);
            } else {
                this.valuesToStringsKeys = [];
            }
        }

        /**
         * Caches regular expressions for _stripAllNonNumberCharactersExceptCustomDecimalChar
         *
         * @param {object} settings
         * @param {object} regex
         */

    }, {
        key: '_transformOptionsValuesToDefaultTypes',


        /**
         * Modify the user settings to make them 'exploitable' later.
         */
        value: function _transformOptionsValuesToDefaultTypes() {
            for (var key in this.settings) {
                if (this.settings.hasOwnProperty(key)) {
                    var value = this.settings[key];

                    // Convert the strings 'true' and 'false' to booleans
                    if (value === 'true' || value === 'false') {
                        this.settings[key] = value === 'true';
                    }

                    // Convert numbers in options to strings
                    //TODO Only transform the values of type 'Number' to 'String' if it's a currency number (so that we can have big numbers). Do not convert other numbers (ie. `historySize`)
                    if (typeof value === 'number') {
                        this.settings[key] = value.toString();
                    }
                }
            }
        }

        /**
         * Convert the old settings options name to new ones.
         *
         * @param {object} options
         */

    }, {
        key: '_setSettings',


        /**
         * Analyse the settings/options passed by the user, validate and clean them, then set them into `this.settings`.
         * Note: This sets the settings to `null` if somehow the settings objet is undefined or empty
         *       If only `decimalPlaces` is defined in the option, overwrite the other decimalPlaces* options, otherwise, use those options
         *
         * @param {object} options
         * @param {boolean} update - If set to `true`, then the settings already exists and this function only updates them instead of recreating them from scratch
         * @throws
         */
        value: function _setSettings(options) {
            var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            // If the user used old options, we convert them to new ones
            if (update || !_AutoNumericHelper2.default.isNull(options)) {
                this.constructor._convertOldOptionsToNewOnes(options);
            }

            if (update) {
                // The settings are updated
                // Update the original data, if it has changed
                var decimalPlacesRawValueInOptions = 'decimalPlacesRawValue' in options;
                if (decimalPlacesRawValueInOptions) {
                    this.settings.originalDecimalPlacesRawValue = options.decimalPlacesRawValue;
                }

                var decimalPlacesInOptions = 'decimalPlaces' in options;
                if (decimalPlacesInOptions) {
                    this.settings.originalDecimalPlaces = options.decimalPlaces;
                }

                // Then update all the `decimalPlaces*` options
                this.constructor._calculateDecimalPlacesOnUpdate(options, this.settings);

                // Finally generate the updated settings object to use
                this._mergeSettings(options); //TODO Check that the `styleRules` option is correctly cloned (due to depth cloning limitation)
            } else {
                // The settings are generated for the first time
                this.settings = {};
                // If we couldn't grab any settings, create them from the default ones and combine them with the options passed as a parameter as well as with the HTML5 `data-*` info (via `this.domElement.dataset`), if any.
                this._mergeSettings(this.constructor.getDefaultConfig(), this.domElement.dataset, options, { rawValue: this.defaultRawValue });
                this.caretFix = false;
                this.throwInput = true; // Throw input event
                this.allowedTagList = _AutoNumericEnum2.default.allowedTagList;
                this.runOnce = false;
                this.hoveredWithAlt = false; // Keep tracks if the current AutoNumeric element is hovered by the mouse cursor while `Alt` is pressed
            }

            // Modify the user settings to make them 'exploitable'
            this._transformOptionsValuesToDefaultTypes();

            // Immediately run the callbacks that could update the settings object
            this._runCallbacksFoundInTheSettingsObject();

            // Improve the `negativePositiveSignPlacement` option if needed
            this.constructor._correctNegativePositiveSignPlacementOption(this.settings);

            // Set the `caretPositionOnFocus` and `selectOnFocus` options so that they do not conflict, if one of those have been set manually by the user.
            // If order to check that, we take a look at the original options the user passed as an argument, not `this.settings` that have been merged with the default settings. //TODO Check the validity of that comment
            this.constructor._correctCaretPositionOnFocusAndSelectOnFocusOptions(this.settings);

            // Define if the negative or positive signs are allowed
            this.constructor._setNegativePositiveSignPermissions(this.settings);

            // Calculate the number of decimal places (during the element initialization)
            if (!update) {
                // Make sure the `originalDecimalPlaces` info is set
                if (_AutoNumericHelper2.default.isNull(options) || !options.decimalPlaces) {
                    this.settings.originalDecimalPlaces = null;
                } else {
                    this.settings.originalDecimalPlaces = options.decimalPlaces;
                }

                // Save the `originalDecimalPlacesRawValue` info
                this.settings.originalDecimalPlacesRawValue = this.settings.decimalPlacesRawValue;

                // Then update all the `decimalPlaces*` options
                this.constructor._calculateDecimalPlacesOnInit(this.settings);
            }

            // Additional changes to the settings object
            this._calculateVMinAndVMaxIntegerSizes();
            this._setTrailingNegativeSignInfo();
            this.regex = {}; // Create the object that will store the regular expressions
            this.constructor._cachesUsualRegularExpressions(this.settings, this.regex);
            this.constructor._setBrackets(this.settings);
            this._calculateValuesToStringsKeys();

            // Validate the settings. Both tests throws if necessary.
            if (_AutoNumericHelper2.default.isEmptyObj(this.settings)) {
                _AutoNumericHelper2.default.throwError('Unable to set the settings, those are invalid ; an empty object was given.');
            }

            this.constructor.validate(this.settings, false, options);

            // Original settings saved for use when decimalPlacesShownOnFocus, divisorWhenUnfocused & showOnlyNumbersOnFocus options are being used
            this._keepAnOriginalSettingsCopy();
        }

        /**
         * Define if the negative or positive signs are allowed, and update the given settings object directly.
         *
         * @param {object} settings
         * @private
         */

    }, {
        key: '_preparePastedText',


        /**
         * Return the pasted text that will be used, by stripping most non-numeric characters
         *
         * @param {string} text
         * @returns {string}
         */
        value: function _preparePastedText(text) {
            return this.constructor._stripAllNonNumberCharacters(text, this.settings, true, this.isFocused);
        }

        /**
         * Return TRUE if the given value (a number as a string) is within the range set in the settings `minimumValue` and `maximumValue`, FALSE otherwise.
         *
         * @param {string} value
         * @param {object} parsedMinValue Parsed via the `parseStr()` function
         * @param {object} parsedMaxValue Parsed via the `parseStr()` function
         * @returns {boolean}
         */

    }, {
        key: '_updateInternalProperties',


        /**
         * Update the selection values as well as resets the internal state of the current AutoNumeric object.
         * This keeps tracks of the current selection and resets the 'processed' state.
         *
         * Note : This state can change between the keydown, keypress and keyup events, that's why
         *        this function is called on each event handler.
         *
         * @private
         */
        value: function _updateInternalProperties() {
            this.selection = _AutoNumericHelper2.default.getElementSelection(this.domElement);
            this.processed = false;
        }

        /**
         * Update the `event.key` attribute that triggered the given event.
         *
         * `event.key` describes:
         * - the key name (if a non-printable character),
         * - or directly the character that result from the key press used to trigger the event.
         *
         * @link https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
         * The key list is described here:
         * @link https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
         *
         * @param {Event|KeyboardEvent} e
         * @private
         */

    }, {
        key: '_updateEventKeyInfo',
        value: function _updateEventKeyInfo(e) {
            this.eventKey = _AutoNumericHelper2.default.character(e);
        }

        /**
         * Save the unformatted element value.
         * This is used in the 'cancellable' feature where the element value is saved on focus and input validation, to be used if the user wants to cancel his modifications by hitting the 'Escape' key.
         *
         * @private
         */

    }, {
        key: '_saveCancellableValue',
        value: function _saveCancellableValue() {
            this.savedCancellableValue = this.rawValue;
        }

        /**
         * Set the text selection inside the input with the given start and end position.
         *
         * @param {int} start
         * @param {int} end
         * @private
         */

    }, {
        key: '_setSelection',
        value: function _setSelection(start, end) {
            //TODO use this function to replace the direct calls to `setElementSelection()`, wherever possible
            start = Math.max(start, 0);
            end = Math.min(end, _AutoNumericHelper2.default.getElementValue(this.domElement).length);
            this.selection = {
                start: start,
                end: end,
                length: end - start
            };

            _AutoNumericHelper2.default.setElementSelection(this.domElement, start, end);
        }

        /**
         * Set the caret position inside the input at the given position.
         *
         * @param {int} position
         * @private
         */

    }, {
        key: '_setCaretPosition',
        value: function _setCaretPosition(position) {
            this._setSelection(position, position);
        }

        /**
         * Return an array containing the string parts located on the left and right side of the caret or selection.
         * Those parts are left 'untouched', ie. formatted by autoNumeric.
         *
         * @returns {[string, string]} The parts on the left and right of the caret or selection
         * @private
         */

    }, {
        key: '_getLeftAndRightPartAroundTheSelection',
        value: function _getLeftAndRightPartAroundTheSelection() {
            var value = _AutoNumericHelper2.default.getElementValue(this.domElement);
            var left = value.substring(0, this.selection.start);
            var right = value.substring(this.selection.end, value.length);

            return [left, right];
        }

        /**
         * Return an array containing the string parts located on the left and right side of the caret or selection.
         * Those parts are unformatted (stripped) of any non-numbers characters, and any trailing negative character is put back on the left hand side of the number.
         *
         * @returns {[string, string]} The parts on the left and right of the caret or selection, unformatted.
         * @private
         */

    }, {
        key: '_getUnformattedLeftAndRightPartAroundTheSelection',
        value: function _getUnformattedLeftAndRightPartAroundTheSelection() {
            var _getLeftAndRightPartA = this._getLeftAndRightPartAroundTheSelection(),
                _getLeftAndRightPartA2 = _slicedToArray(_getLeftAndRightPartA, 2),
                left = _getLeftAndRightPartA2[0],
                right = _getLeftAndRightPartA2[1];

            if (left === '' && right === '') {
                return ['', ''];
            }

            // If changing the sign and `left` is equal to the number zero, prevent stripping the leading zero(s)
            var stripZeros = true;
            if ((this.eventKey === _AutoNumericEnum2.default.keyName.Hyphen || this.eventKey === _AutoNumericEnum2.default.keyName.Minus) && Number(left) === 0) {
                stripZeros = false;
            }

            //TODO DRY that with `_normalizeParts()` -->
            if (this.isTrailingNegative && (_AutoNumericHelper2.default.isNegative(right, this.settings.negativeSignCharacter) && // The caret is placed on the left of the negative sign
            !_AutoNumericHelper2.default.isNegative(left, this.settings.negativeSignCharacter) || right === '' && // ..or the caret is placed on the far right of the input (Fix issue #481)
            _AutoNumericHelper2.default.isNegative(left, this.settings.negativeSignCharacter, true))) {
                left = left.replace(this.settings.negativeSignCharacter, '');
                right = right.replace(this.settings.negativeSignCharacter, '');
                // This is done here because `_getUnformattedLeftAndRightPartAroundTheSelection()` is called multiple times during the same key event, and at one point the left/right value has been normalized already..
                left = left.replace('-', '');
                right = right.replace('-', '');

                // Then finally set back the normalized minus character at the right place
                left = '-' + left;
            }

            left = AutoNumeric._stripAllNonNumberCharactersExceptCustomDecimalChar(left, this.settings, stripZeros, this.isFocused);
            right = AutoNumeric._stripAllNonNumberCharactersExceptCustomDecimalChar(right, this.settings, false, this.isFocused);

            return [left, right];
        }

        /**
         * Strip parts from excess characters and leading zeros.
         *
         * @param {string} left
         * @param {string} right
         * @returns {[*,*,*]}
         * @private
         */

    }, {
        key: '_normalizeParts',
        value: function _normalizeParts(left, right) {
            //TODO Refactor with `_getUnformattedLeftAndRightPartAroundTheSelection` which share a lot of similar code
            // If changing the sign and left is equal to the number zero - prevents stripping the leading zeros
            var stripZeros = true;
            if ((this.eventKey === _AutoNumericEnum2.default.keyName.Hyphen || this.eventKey === _AutoNumericEnum2.default.keyName.Minus) && Number(left) === 0) {
                stripZeros = false;
            }

            if (this.isTrailingNegative && _AutoNumericHelper2.default.isNegative(right, this.settings.negativeSignCharacter) && !_AutoNumericHelper2.default.isNegative(left, this.settings.negativeSignCharacter)) {
                // Only set the negative sign if the value is negative
                left = '-' + left;
                right = right.replace(this.settings.negativeSignCharacter, '');
            }

            left = AutoNumeric._stripAllNonNumberCharactersExceptCustomDecimalChar(left, this.settings, stripZeros, this.isFocused);
            right = AutoNumeric._stripAllNonNumberCharactersExceptCustomDecimalChar(right, this.settings, false, this.isFocused);

            // Prevents multiple leading zeros from being entered
            if (this.settings.leadingZero === AutoNumeric.options.leadingZero.deny && (this.eventKey === _AutoNumericEnum2.default.keyName.num0 || this.eventKey === _AutoNumericEnum2.default.keyName.numpad0) && Number(left) === 0 &&
            // If `right` is not empty and the first character is not `decimalCharacter`
            !_AutoNumericHelper2.default.contains(left, this.settings.decimalCharacter) && right !== '') {
                left = left.substring(0, left.length - 1);
            }

            // Insert zero there is a leading dot
            var newValue = left + right;
            if (this.settings.decimalCharacter) {
                var m = newValue.match(new RegExp('^' + this.regex.aNegRegAutoStrip + '\\' + this.settings.decimalCharacter));
                if (m) {
                    left = left.replace(m[1], m[1] + '0');
                    newValue = left + right;
                }
            }

            return [left, right, newValue];
        }

        /**
         * Set the formatted element value as well as the `rawValue`.
         * This returns `true` if the element and raw value have been modified, `false` otherwise.
         * This method also adjust the caret position according to the `leadingZero` option and the normalized value. //TODO What about the cursor *selection*?
         *
         * @param {string} left
         * @param {string} right
         * @param {boolean} isPaste
         * @returns {boolean}
         * @private
         */

    }, {
        key: '_setValueParts',
        value: function _setValueParts(left, right) {
            var isPaste = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var _normalizeParts2 = this._normalizeParts(left, right),
                _normalizeParts3 = _slicedToArray(_normalizeParts2, 3),
                normalizedLeft = _normalizeParts3[0],
                normalizedRight = _normalizeParts3[1],
                normalizedNewValue = _normalizeParts3[2];

            var _AutoNumeric$_checkIf = AutoNumeric._checkIfInRangeWithOverrideOption(normalizedNewValue, this.settings),
                _AutoNumeric$_checkIf2 = _slicedToArray(_AutoNumeric$_checkIf, 2),
                minTest = _AutoNumeric$_checkIf2[0],
                maxTest = _AutoNumeric$_checkIf2[1];

            if (minTest && maxTest) {
                // First, set the raw value
                var roundedRawValue = AutoNumeric._truncateDecimalPlaces(normalizedNewValue, this.settings, isPaste, this.settings.decimalPlacesRawValue);
                var testValue = roundedRawValue.replace(this.settings.decimalCharacter, '.');

                if (testValue === '' || testValue === this.settings.negativeSignCharacter) {
                    var valueToSetOnEmpty = void 0;
                    switch (this.settings.emptyInputBehavior) {
                        case AutoNumeric.options.emptyInputBehavior.focus:
                        case AutoNumeric.options.emptyInputBehavior.press:
                        case AutoNumeric.options.emptyInputBehavior.always:
                            valueToSetOnEmpty = '';
                            break;
                        case AutoNumeric.options.emptyInputBehavior.min:
                            valueToSetOnEmpty = this.settings.minimumValue;
                            break;
                        case AutoNumeric.options.emptyInputBehavior.max:
                            valueToSetOnEmpty = this.settings.maximumValue;
                            break;
                        case AutoNumeric.options.emptyInputBehavior.zero:
                            valueToSetOnEmpty = '0';
                            break;
                        case AutoNumeric.options.emptyInputBehavior.null:
                            valueToSetOnEmpty = null;
                            break;
                        // When `emptyInputBehavior` is a number or a string representing a number
                        default:
                            valueToSetOnEmpty = this.settings.emptyInputBehavior;
                    }

                    this._setRawValue(valueToSetOnEmpty);
                } else {
                    this._setRawValue(this._trimLeadingAndTrailingZeros(testValue));
                }

                // Then set the formatted value
                var roundedValueToShow = AutoNumeric._truncateDecimalPlaces(normalizedNewValue, this.settings, isPaste, this.settings.decimalPlacesShownOnFocus);
                var position = normalizedLeft.length;
                if (position > roundedValueToShow.length) {
                    position = roundedValueToShow.length;
                }

                // Make sure when the user enter a '0' on the far left with a leading zero option set to 'deny', that the caret does not moves since the input is dropped (fix issue #283)
                if (position === 1 && normalizedLeft === '0' && this.settings.leadingZero === AutoNumeric.options.leadingZero.deny) {
                    // If the user enter `0`, then the caret is put on the right side of it (Fix issue #299)
                    if (normalizedRight === '' || normalizedLeft === '0' && normalizedRight !== '') {
                        position = 1;
                    } else {
                        position = 0;
                    }
                }

                this._setElementValue(roundedValueToShow, false);
                this._setCaretPosition(position);

                return true;
            }

            if (!minTest) {
                this._triggerEvent(AutoNumeric.events.minRangeExceeded, this.domElement);
            } else if (!maxTest) {
                this._triggerEvent(AutoNumeric.events.maxRangeExceeded, this.domElement);
            }

            return false;
        }

        /**
         * Helper function for `_expandSelectionOnSign()`.
         *
         * @returns {Array} Array containing [signPosition, currencySymbolPosition] of a formatted value
         * @private
         */

    }, {
        key: '_getSignPosition',
        value: function _getSignPosition() {
            var result = void 0;
            if (this.settings.currencySymbol) {
                var currencySymbolLen = this.settings.currencySymbol.length;
                var value = _AutoNumericHelper2.default.getElementValue(this.domElement);
                if (this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.prefix) {
                    var hasNeg = this.settings.negativeSignCharacter && value && value.charAt(0) === this.settings.negativeSignCharacter;
                    if (hasNeg) {
                        result = [1, currencySymbolLen + 1];
                    } else {
                        result = [0, currencySymbolLen];
                    }
                } else {
                    var valueLen = value.length;
                    result = [valueLen - currencySymbolLen, valueLen];
                }
            } else {
                result = [1000, -1];
            }

            return result;
        }

        /**
         * Expands selection to cover whole sign
         * Prevents partial deletion/copying/overwriting of a sign
         * @private
         */

    }, {
        key: '_expandSelectionOnSign',
        value: function _expandSelectionOnSign() {
            var _getSignPosition2 = this._getSignPosition(),
                _getSignPosition3 = _slicedToArray(_getSignPosition2, 2),
                signPosition = _getSignPosition3[0],
                currencySymbolPosition = _getSignPosition3[1];

            var selection = this.selection;

            // If selection catches something except sign and catches only space from sign
            if (selection.start < currencySymbolPosition && selection.end > signPosition) {
                // Then select without empty space
                if ((selection.start < signPosition || selection.end > currencySymbolPosition) && _AutoNumericHelper2.default.getElementValue(this.domElement).substring(Math.max(selection.start, signPosition), Math.min(selection.end, currencySymbolPosition)).match(/^\s*$/)) {
                    if (selection.start < signPosition) {
                        this._setSelection(selection.start, signPosition);
                    } else {
                        this._setSelection(currencySymbolPosition, selection.end);
                    }
                } else {
                    // Else select with whole sign
                    this._setSelection(Math.min(selection.start, signPosition), Math.max(selection.end, currencySymbolPosition));
                }
            }
        }

        /**
         * Try to strip pasted value to digits
         */

    }, {
        key: '_checkPaste',
        value: function _checkPaste() {
            // Do not process anything if the value has already been formatted
            if (this.formatted) {
                return;
            }

            if (!_AutoNumericHelper2.default.isUndefined(this.valuePartsBeforePaste)) {
                var oldParts = this.valuePartsBeforePaste;

                var _getLeftAndRightPartA3 = this._getLeftAndRightPartAroundTheSelection(),
                    _getLeftAndRightPartA4 = _slicedToArray(_getLeftAndRightPartA3, 2),
                    left = _getLeftAndRightPartA4[0],
                    right = _getLeftAndRightPartA4[1];

                // Try to strip the pasted value first


                delete this.valuePartsBeforePaste;

                var modifiedLeftPart = left.substr(0, oldParts[0].length) + AutoNumeric._stripAllNonNumberCharactersExceptCustomDecimalChar(left.substr(oldParts[0].length), this.settings, true, this.isFocused);
                if (!this._setValueParts(modifiedLeftPart, right, true)) {
                    this._setElementValue(oldParts.join(''), false);
                    this._setCaretPosition(oldParts[0].length);
                }
            }
        }

        /**
         * Return `true` if the given key should be ignored or not.
         *
         * @param {string} eventKeyName
         * @returns {boolean}
         * @private
         */

    }, {
        key: '_processNonPrintableKeysAndShortcuts',


        /**
         * Process copying, cutting and pasting, as well as undo/redoing and cursor moving.
         * Return `true` if further processing should not be performed.
         *
         * @param {KeyboardEvent} e
         * @returns {boolean}
         * @private
         */
        value: function _processNonPrintableKeysAndShortcuts(e) {
            // Catch the ctrl up on ctrl-v
            if ((e.ctrlKey || e.metaKey) && e.type === 'keyup' && !_AutoNumericHelper2.default.isUndefined(this.valuePartsBeforePaste) || e.shiftKey && this.eventKey === _AutoNumericEnum2.default.keyName.Insert) {
                //TODO Move this test inside the `onKeyup` handler
                this._checkPaste();

                return false;
            }

            // Skip all function keys (F1-F12), Windows keys, tab and other special keys
            if (this.constructor._shouldSkipEventKey(this.eventKey)) {
                return true;
            }

            // If a "Select all" keyboard shortcut is detected (ctrl + a)
            if ((e.ctrlKey || e.metaKey) && this.eventKey === _AutoNumericEnum2.default.keyName.a) {
                if (this.settings.selectNumberOnly) {
                    // `preventDefault()` is used here to prevent the browser to first select all the input text (including the currency sign), otherwise we would see that whole selection first in a flash, then the selection with only the number part without the currency sign.
                    e.preventDefault();
                    //TODO replace `selectNumber` by `select`?
                    this.selectNumber();
                }

                return true;
            }

            // If a "Copy", "Paste" or "Cut" keyboard shortcut is detected (respectively 'ctrl + c', 'ctrl + v' or 'ctrl + x')
            if ((e.ctrlKey || e.metaKey) && (this.eventKey === _AutoNumericEnum2.default.keyName.c || this.eventKey === _AutoNumericEnum2.default.keyName.v || this.eventKey === _AutoNumericEnum2.default.keyName.x)) {
                if (e.type === 'keydown') {
                    this._expandSelectionOnSign();
                }

                // Try to prevent wrong paste
                if (this.eventKey === _AutoNumericEnum2.default.keyName.v || this.eventKey === _AutoNumericEnum2.default.keyName.Insert) {
                    if (e.type === 'keydown' || e.type === 'keypress') {
                        if (_AutoNumericHelper2.default.isUndefined(this.valuePartsBeforePaste)) {
                            this.valuePartsBeforePaste = this._getLeftAndRightPartAroundTheSelection();
                        }
                    } else {
                        this._checkPaste();
                    }
                }

                return e.type === 'keydown' || e.type === 'keypress' || this.eventKey === _AutoNumericEnum2.default.keyName.c;
            }

            // The undo shortcut
            if (e.ctrlKey || e.metaKey) {
                return !(this.eventKey === _AutoNumericEnum2.default.keyName.Z || this.eventKey === _AutoNumericEnum2.default.keyName.z);
            }

            // Jump over the thousand separator
            //TODO Move this test inside the `onKeydown` handler
            if (this.eventKey === _AutoNumericEnum2.default.keyName.LeftArrow || this.eventKey === _AutoNumericEnum2.default.keyName.RightArrow) {
                if (e.type === 'keydown' && !e.shiftKey) {
                    var value = _AutoNumericHelper2.default.getElementValue(this.domElement);
                    if (this.eventKey === _AutoNumericEnum2.default.keyName.LeftArrow && (value.charAt(this.selection.start - 2) === this.settings.digitGroupSeparator || value.charAt(this.selection.start - 2) === this.settings.decimalCharacter)) {
                        this._setCaretPosition(this.selection.start - 1);
                    } else if (this.eventKey === _AutoNumericEnum2.default.keyName.RightArrow && (value.charAt(this.selection.start + 1) === this.settings.digitGroupSeparator || value.charAt(this.selection.start + 1) === this.settings.decimalCharacter)) {
                        this._setCaretPosition(this.selection.start + 1);
                    }
                }

                return true;
            }

            return _AutoNumericHelper2.default.isInArray(this.eventKey, _AutoNumericEnum2.default.keyName._directionKeys);
        }

        /**
         * Process deletion of characters when the minus sign is to the right of the numeric characters.
         *
         * @param {string} left The part on the left of the caret or selection
         * @param {string} right The part on the right of the caret or selection
         * @returns {[string, string]}
         * @private
         */

    }, {
        key: '_processCharacterDeletionIfTrailingNegativeSign',
        value: function _processCharacterDeletionIfTrailingNegativeSign(_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                left = _ref4[0],
                right = _ref4[1];

            var value = _AutoNumericHelper2.default.getElementValue(this.domElement);
            var isValNegative = _AutoNumericHelper2.default.isNegative(value, this.settings.negativeSignCharacter);

            if (this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.prefix && this.settings.negativePositiveSignPlacement === AutoNumeric.options.negativePositiveSignPlacement.suffix) {
                if (this.eventKey === _AutoNumericEnum2.default.keyName.Backspace) {
                    this.caretFix = this.selection.start >= value.indexOf(this.settings.suffixText) && this.settings.suffixText !== '';
                    if (value.charAt(this.selection.start - 1) === '-') {
                        left = left.substring(1);
                    } else if (this.selection.start <= value.length - this.settings.suffixText.length) {
                        left = left.substring(0, left.length - 1);
                    }
                } else {
                    this.caretFix = this.selection.start >= value.indexOf(this.settings.suffixText) && this.settings.suffixText !== '';
                    if (this.selection.start >= value.indexOf(this.settings.currencySymbol) + this.settings.currencySymbol.length) {
                        right = right.substring(1, right.length);
                    }
                    if (_AutoNumericHelper2.default.isNegative(left, this.settings.negativeSignCharacter) && value.charAt(this.selection.start) === '-') {
                        left = left.substring(1);
                    }
                }
            }

            if (this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.suffix) {
                switch (this.settings.negativePositiveSignPlacement) {
                    case AutoNumeric.options.negativePositiveSignPlacement.left:
                        this.caretFix = this.selection.start >= value.indexOf(this.settings.negativeSignCharacter) + this.settings.negativeSignCharacter.length;
                        if (this.eventKey === _AutoNumericEnum2.default.keyName.Backspace) {
                            if (this.selection.start === value.indexOf(this.settings.negativeSignCharacter) + this.settings.negativeSignCharacter.length && isValNegative) {
                                left = left.substring(1);
                            } else if (left !== '-' && (this.selection.start <= value.indexOf(this.settings.negativeSignCharacter) || !isValNegative)) {
                                left = left.substring(0, left.length - 1);
                            }
                        } else {
                            if (left[0] === '-') {
                                right = right.substring(1);
                            }
                            if (this.selection.start === value.indexOf(this.settings.negativeSignCharacter) && isValNegative) {
                                left = left.substring(1);
                            }
                        }
                        break;
                    case AutoNumeric.options.negativePositiveSignPlacement.right:
                        this.caretFix = this.selection.start >= value.indexOf(this.settings.negativeSignCharacter) + this.settings.negativeSignCharacter.length;
                        if (this.eventKey === _AutoNumericEnum2.default.keyName.Backspace) {
                            if (this.selection.start === value.indexOf(this.settings.negativeSignCharacter) + this.settings.negativeSignCharacter.length) {
                                left = left.substring(1);
                            } else if (left !== '-' && this.selection.start <= value.indexOf(this.settings.negativeSignCharacter) - this.settings.currencySymbol.length) {
                                left = left.substring(0, left.length - 1);
                            } else if (left !== '' && !isValNegative) {
                                left = left.substring(0, left.length - 1);
                            }
                        } else {
                            this.caretFix = this.selection.start >= value.indexOf(this.settings.currencySymbol) && this.settings.currencySymbol !== '';
                            if (this.selection.start === value.indexOf(this.settings.negativeSignCharacter)) {
                                left = left.substring(1);
                            }

                            right = right.substring(1);
                        }
                        break;
                }
            }

            return [left, right];
        }

        /**
         * Process the deletion of characters.
         */

    }, {
        key: '_processCharacterDeletion',
        value: function _processCharacterDeletion() {
            var left = void 0;
            var right = void 0;

            if (!this.selection.length) {
                var _getUnformattedLeftAn = this._getUnformattedLeftAndRightPartAroundTheSelection();

                var _getUnformattedLeftAn2 = _slicedToArray(_getUnformattedLeftAn, 2);

                left = _getUnformattedLeftAn2[0];
                right = _getUnformattedLeftAn2[1];

                if (left === '' && right === '') {
                    this.throwInput = false;
                }

                if (this.isTrailingNegative && _AutoNumericHelper2.default.isNegative(_AutoNumericHelper2.default.getElementValue(this.domElement), this.settings.negativeSignCharacter)) {
                    var _processCharacterDele = this._processCharacterDeletionIfTrailingNegativeSign([left, right]);

                    var _processCharacterDele2 = _slicedToArray(_processCharacterDele, 2);

                    left = _processCharacterDele2[0];
                    right = _processCharacterDele2[1];
                } else {
                    if (this.eventKey === _AutoNumericEnum2.default.keyName.Backspace) {
                        left = left.substring(0, left.length - 1);
                    } else {
                        right = right.substring(1, right.length);
                    }
                }
            } else {
                this._expandSelectionOnSign();

                var _getUnformattedLeftAn3 = this._getUnformattedLeftAndRightPartAroundTheSelection();

                var _getUnformattedLeftAn4 = _slicedToArray(_getUnformattedLeftAn3, 2);

                left = _getUnformattedLeftAn4[0];
                right = _getUnformattedLeftAn4[1];
            }

            this._setValueParts(left, right);
        }

        /**
         * Return `true` if a decimal character is allowed to be typed.
         * If the number of decimal places shown on focus is zero, then the decimal character is not allowed.
         *
         * @returns {boolean}
         * @private
         */

    }, {
        key: '_isDecimalCharacterInsertionAllowed',
        value: function _isDecimalCharacterInsertionAllowed() {
            return String(this.settings.decimalPlacesShownOnFocus) !== String(AutoNumeric.options.decimalPlacesShownOnFocus.none) && String(this.settings.decimalPlaces) !== String(AutoNumeric.options.decimalPlaces.none);
        }

        /**
         * Return `true` if the key is allowed.
         * This function decides if the key pressed should be dropped or accepted, and modify the value 'on-the-fly' accordingly.
         * //TODO This should use another function in order to separate the test and the modification
         *
         * @returns {boolean}
         */

    }, {
        key: '_processCharacterInsertion',
        value: function _processCharacterInsertion() {
            var _getUnformattedLeftAn5 = this._getUnformattedLeftAndRightPartAroundTheSelection(),
                _getUnformattedLeftAn6 = _slicedToArray(_getUnformattedLeftAn5, 2),
                left = _getUnformattedLeftAn6[0],
                right = _getUnformattedLeftAn6[1];

            if (this.eventKey !== _AutoNumericEnum2.default.keyName.AndroidDefault) {
                this.throwInput = true;
            }

            // Start rules when the decimal character key is pressed always use numeric pad dot to insert decimal separator
            // Do not allow decimal character if no decimal part allowed
            if (this.eventKey === this.settings.decimalCharacter || this.settings.decimalCharacterAlternative && this.eventKey === this.settings.decimalCharacterAlternative) {
                if (!this._isDecimalCharacterInsertionAllowed() || !this.settings.decimalCharacter) {
                    return false;
                }

                if (this.settings.alwaysAllowDecimalCharacter) {
                    // Remove any previous decimal character
                    left = left.replace(this.settings.decimalCharacter, '');
                    right = right.replace(this.settings.decimalCharacter, '');
                } else {
                    // Do not allow a decimal character if another decimal character is already present
                    if (_AutoNumericHelper2.default.contains(left, this.settings.decimalCharacter)) {
                        return true;
                    }

                    // Prevent adding a decimal character at the far right of the number
                    if (right.indexOf(this.settings.decimalCharacter) > 0) {
                        return true;
                    }

                    // Remove the decimal character is found on the far left of the right part
                    if (right.indexOf(this.settings.decimalCharacter) === 0) {
                        right = right.substr(1);
                    }
                }

                // If the user is trying to add a decimal character on the far left of the number, we allow it
                if (this.settings.negativeSignCharacter && _AutoNumericHelper2.default.contains(right, this.settings.negativeSignCharacter)) {
                    // We need however to move the negative sign from the right to the left part
                    left = '' + this.settings.negativeSignCharacter + left;
                    right = right.replace(this.settings.negativeSignCharacter, '');
                }

                this._setValueParts(left + this.settings.decimalCharacter, right);

                return true;
            }

            // Prevent entering the minus sign if it's not allowed (Note: `this.settings.isNegativeSignAllowed` is only set to `true` if the minimumValue is lower than zero, allowing negative numbers to be entered)
            if ((this.eventKey === '-' || this.eventKey === '+') && this.settings.isNegativeSignAllowed) {
                // Here, the left and right parts have been normalized already, hence the minus sign usage
                if (left === '' && _AutoNumericHelper2.default.contains(right, '-')) {
                    // The value is originally negative (with a trailing negative sign)
                    right = right.replace('-', '');
                } else if (_AutoNumericHelper2.default.isNegativeStrict(left, '-')) {
                    // The value is originally negative (with a leading negative sign)
                    // Remove the negative sign, effectively converting the value to a positive one
                    left = left.replace('-', ''); //TODO replace with '+' if `showPositiveSign` too?
                } else {
                    // The value is originally positive, so we toggle the state to a negative one (unformatted, which means even with a trailing negative sign, we add the minus sign on the far left)
                    left = '' + this.settings.negativeSignCharacter + left;
                }

                this._setValueParts(left, right);

                return true;
            }

            var eventNumber = Number(this.eventKey);
            if (eventNumber >= 0 && eventNumber <= 9) {
                // If the user tries to insert a digit
                if (this.settings.isNegativeSignAllowed && left === '' && _AutoNumericHelper2.default.contains(right, '-')) {
                    // ...and that digit is before the minus sign
                    left = '-';
                    right = right.substring(1, right.length);
                }

                if (this.settings.maximumValue <= 0 && this.settings.minimumValue < this.settings.maximumValue && !_AutoNumericHelper2.default.contains(_AutoNumericHelper2.default.getElementValue(this.domElement), this.settings.negativeSignCharacter) && this.eventKey !== '0') {
                    left = '-' + left;
                }

                this._setValueParts('' + left + this.eventKey, right);

                return true;
            }

            // Prevent any other characters
            this.throwInput = false;

            return false;
        }

        /**
         * Formatting of just processed value while keeping the cursor position
         *
         * @param {Event} e
         * @private
         */

    }, {
        key: '_formatValue',
        value: function _formatValue(e) {
            //TODO Break apart and simplify this really long function
            var elementValue = _AutoNumericHelper2.default.getElementValue(this.domElement);

            var _getUnformattedLeftAn7 = this._getUnformattedLeftAndRightPartAroundTheSelection(),
                _getUnformattedLeftAn8 = _slicedToArray(_getUnformattedLeftAn7, 1),
                left = _getUnformattedLeftAn8[0];

            // No grouping separator and no currency sign


            if ((this.settings.digitGroupSeparator === '' || this.settings.digitGroupSeparator !== '' && !_AutoNumericHelper2.default.contains(elementValue, this.settings.digitGroupSeparator)) && (this.settings.currencySymbol === '' || this.settings.currencySymbol !== '' && !_AutoNumericHelper2.default.contains(elementValue, this.settings.currencySymbol))) {
                var _elementValue$split = elementValue.split(this.settings.decimalCharacter),
                    _elementValue$split2 = _slicedToArray(_elementValue$split, 1),
                    subParts = _elementValue$split2[0];

                var negativeSign = '';
                if (_AutoNumericHelper2.default.isNegative(subParts, this.settings.negativeSignCharacter)) {
                    negativeSign = this.settings.negativeSignCharacter;
                    subParts = subParts.replace(this.settings.negativeSignCharacter, '');
                    left = left.replace('-', ''); // Here we modify the unformatted value (with the 'normal' minus sign)
                }

                // Strip leading zero on positive value if needed
                if (negativeSign === '' && subParts.length > this.settings.mIntPos && left.charAt(0) === '0') {
                    left = left.slice(1);
                }

                // Strip leading zero on negative value if needed
                if (negativeSign === this.settings.negativeSignCharacter && subParts.length > this.settings.mIntNeg && left.charAt(0) === '0') {
                    left = left.slice(1);
                }

                if (!this.isTrailingNegative) {
                    // Only add the minus sign if it's needed on that side of the numbers
                    left = '' + negativeSign + left;
                }
            }

            var value = this.constructor._addGroupSeparators(elementValue, this.settings, this.isFocused, this.rawValue);
            var position = value.length;
            if (value) {
                // Prepare regexp which searches for cursor position from unformatted left part
                var leftAr = left.split('');

                // Fixes caret position with trailing minus sign
                if ((this.settings.negativePositiveSignPlacement === AutoNumeric.options.negativePositiveSignPlacement.suffix || this.settings.negativePositiveSignPlacement !== AutoNumeric.options.negativePositiveSignPlacement.prefix && this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.suffix) && leftAr[0] === this.settings.negativeSignCharacter && !this.settings.isNegativeSignAllowed) {
                    leftAr.shift(); // Remove the negative sign character

                    if ((this.eventKey === _AutoNumericEnum2.default.keyName.Backspace || this.eventKey === _AutoNumericEnum2.default.keyName.Delete) && this.caretFix) {
                        if (this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.suffix && this.settings.negativePositiveSignPlacement === AutoNumeric.options.negativePositiveSignPlacement.left || this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.prefix && this.settings.negativePositiveSignPlacement === AutoNumeric.options.negativePositiveSignPlacement.suffix) {
                            leftAr.push(this.settings.negativeSignCharacter);
                            this.caretFix = e.type === 'keydown';
                        }

                        if (this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.suffix && this.settings.negativePositiveSignPlacement === AutoNumeric.options.negativePositiveSignPlacement.right) {
                            var signParts = this.settings.currencySymbol.split('');
                            var escapeChr = ['\\', '^', '$', '.', '|', '?', '*', '+', '(', ')', '['];
                            var escapedParts = [];
                            signParts.forEach(function (i, miniParts) {
                                miniParts = signParts[i];
                                if (_AutoNumericHelper2.default.isInArray(miniParts, escapeChr)) {
                                    escapedParts.push('\\' + miniParts);
                                } else {
                                    escapedParts.push(miniParts);
                                }
                            });

                            if (this.eventKey === _AutoNumericEnum2.default.keyName.Backspace && this.settings.negativeSignCharacter === '-') {
                                escapedParts.push('-');
                            }

                            // Pushing the escaped sign
                            leftAr.push(escapedParts.join(''));
                            this.caretFix = e.type === 'keydown';
                        }
                    }
                }

                for (var i = 0; i < leftAr.length; i++) {
                    if (!leftAr[i].match('\\d')) {
                        leftAr[i] = '\\' + leftAr[i];
                    }
                }

                var leftReg = new RegExp('^.*?' + leftAr.join('.*?'));

                // Search cursor position in formatted value
                var newLeft = value.match(leftReg);
                if (newLeft) {
                    position = newLeft[0].length;

                    // If the positive sign is shown, calculate the caret position accordingly
                    if (this.settings.showPositiveSign) {
                        if (position === 0 && newLeft.input.charAt(0) === this.settings.positiveSignCharacter) {
                            position = newLeft.input.indexOf(this.settings.currencySymbol) === 1 ? this.settings.currencySymbol.length + 1 : 1;
                        }

                        if (position === 0 && newLeft.input.charAt(this.settings.currencySymbol.length) === this.settings.positiveSignCharacter) {
                            position = this.settings.currencySymbol.length + 1;
                        }
                    }

                    // If we are just before the sign which is in prefix position
                    if ((position === 0 && value.charAt(0) !== this.settings.negativeSignCharacter || position === 1 && value.charAt(0) === this.settings.negativeSignCharacter) && this.settings.currencySymbol && this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.prefix) {
                        // Place caret after prefix sign
                        //TODO Should the test be 'isNegative' instead of 'isNegativeStrict' in order to search for '-' everywhere in the string?
                        position = this.settings.currencySymbol.length + (_AutoNumericHelper2.default.isNegativeStrict(value, this.settings.negativeSignCharacter) ? 1 : 0);
                    }
                } else {
                    if (this.settings.currencySymbol && this.settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.suffix) {
                        // If we could not find a place for cursor and have a sign as a suffix
                        // Place caret before suffix currency sign
                        position -= this.settings.currencySymbol.length;
                    }

                    if (this.settings.suffixText) {
                        // If we could not find a place for cursor and have a suffix
                        // Place caret before suffix
                        position -= this.settings.suffixText.length;
                    }
                }
            }

            // Only update the value if it has changed. This prevents modifying the selection, if any.
            if (value !== elementValue) {
                this._setElementValue(value, false);
                this._setCaretPosition(position);
            }

            this.formatted = true; //TODO Rename `this.formatted` to `this._formatExecuted`, since it's possible this function does not need to format anything (in the case where the keycode is dropped for instance)
        }

        /**
         * Serialize the form child <input> element values to a string, or an Array.
         * The output format is defined with the `formatType` argument.
         * This is loosely based upon http://stackoverflow.com/a/40705993/2834898.
         *
         * @param {HTMLFormElement} form
         * @param {boolean} intoAnArray If `true`, instead of generating a string, it generates an Array.
         * @param {string} formatType If `'unformatted'`, then the AutoNumeric elements values are unformatted, if `'localized'`, then the AutoNumeric elements values are localized, and if `'formatted'`, then the AutoNumeric elements values are kept formatted. In either way, this function does not modify the value of each DOM element, but only affect the value that is returned by that serialize function.
         * @param {string} serializedSpaceCharacter Can either be the '+' character, or the '%20' string.
         * @param {string|null} forcedOutputFormat If set, then this is the format that is used for the localization, instead of the default `outputFormat` option.
         * @returns {string|Array}
         * @private
         */

    }], [{
        key: 'version',
        value: function version() {
            return '4.5.1';
        }

        /**
         * Take the parameters given to the AutoNumeric object, and output the three variables that are needed to finish initializing it :
         * - domElement : The target DOM element
         * - initialValue : The initial value, or `null` if none is given
         * - userOptions : The option object
         *
         * @param {object|Array|number|string} arg1
         * @param {object|Array|number|string|null} arg2
         * @param {object|Array|number|string|null} arg3
         * @returns {{domElement: *, initialValue: *, userOptions: *}}
         * @throws
         * @private
         */

    }, {
        key: '_setArgumentsValues',
        value: function _setArgumentsValues(arg1, arg2, arg3) {
            // Basic check on the argument count
            if (_AutoNumericHelper2.default.isNull(arg1)) {
                _AutoNumericHelper2.default.throwError('At least one valid parameter is needed in order to initialize an AutoNumeric object');
            }

            // Prepare the arguments in order to create the AutoNumeric object with the right values
            // Test the argument types
            var isArg1Element = _AutoNumericHelper2.default.isElement(arg1);
            var isArg1String = _AutoNumericHelper2.default.isString(arg1);

            var isArg2Object = _AutoNumericHelper2.default.isObject(arg2);
            var isArg2Array = Array.isArray(arg2) && arg2.length > 0;
            var isArg2Number = _AutoNumericHelper2.default.isNumberOrArabic(arg2) || arg2 === '';
            var isArg2PreDefinedOptionName = this._isPreDefinedOptionValid(arg2);
            var isArg2Null = _AutoNumericHelper2.default.isNull(arg2);
            var isArg2EmptyString = _AutoNumericHelper2.default.isEmptyString(arg2);

            var isArg3Object = _AutoNumericHelper2.default.isObject(arg3);
            var isArg3Array = Array.isArray(arg3) && arg3.length > 0;
            var isArg3Null = _AutoNumericHelper2.default.isNull(arg3);
            var isArg3PreDefinedOptionName = this._isPreDefinedOptionValid(arg3);

            // Given the parameters passed, sort the data and return a stable state before the initialization
            var domElement = void 0;
            var userOptions = void 0;
            var initialValue = void 0;

            //TODO Simplify those tests -->
            if (isArg1Element && isArg2Null && isArg3Null) {
                // new AutoNumeric(domElement); // With the default options
                domElement = arg1;
                initialValue = null;
                userOptions = null;
            } else if (isArg1Element && isArg2Number && isArg3Null) {
                // new AutoNumeric(domElement, 12345.789); // With the default options, and an initial value
                // new AutoNumeric(domElement, '12345.789');
                domElement = arg1;
                initialValue = arg2;
                userOptions = null;
            } else if (isArg1Element && isArg2Object && isArg3Null) {
                // new AutoNumeric(domElement, { options }); // With one option object
                domElement = arg1;
                initialValue = null;
                userOptions = arg2;
            } else if (isArg1Element && isArg2PreDefinedOptionName && isArg3Null) {
                // new AutoNumeric(domElement, 'euroPos'); // With one pre-defined option name
                domElement = arg1;
                initialValue = null;
                userOptions = this._getOptionObject(arg2);
            } else if (isArg1Element && isArg2Array && isArg3Null) {
                // new AutoNumeric(domElement, [{ options1 }, { options2 }]); // With multiple option objects (the latest option overwriting the previous ones)
                domElement = arg1;
                initialValue = null;
                userOptions = this.mergeOptions(arg2);
            } else if (isArg1Element && (isArg2Null || isArg2EmptyString) && isArg3Object) {
                // new AutoNumeric(domElement, null, { options }); // With one option object
                domElement = arg1;
                initialValue = null;
                userOptions = arg3;
            } else if (isArg1Element && (isArg2Null || isArg2EmptyString) && isArg3Array) {
                // new AutoNumeric(domElement, null, [{ options1 }, { options2 }]); // With multiple option objects
                domElement = arg1;
                initialValue = null;
                userOptions = this.mergeOptions(arg3);
            } else if (isArg1String && isArg2Null && isArg3Null) {
                // new AutoNumeric('.myCssClass > input');
                domElement = document.querySelector(arg1);
                initialValue = null;
                userOptions = null;
            } else if (isArg1String && isArg2Object && isArg3Null) {
                // new AutoNumeric('.myCssClass > input', { options });
                domElement = document.querySelector(arg1);
                initialValue = null;
                userOptions = arg2;
            } else if (isArg1String && isArg2PreDefinedOptionName && isArg3Null) {
                // new AutoNumeric('.myCssClass > input', 'euroPos');
                domElement = document.querySelector(arg1);
                initialValue = null;
                userOptions = this._getOptionObject(arg2);
            } else if (isArg1String && isArg2Array && isArg3Null) {
                // new AutoNumeric('.myCssClass > input', [{ options1 }, { options2 }]); // With multiple option objects
                domElement = document.querySelector(arg1);
                initialValue = null;
                userOptions = this.mergeOptions(arg2);
            } else if (isArg1String && (isArg2Null || isArg2EmptyString) && isArg3Object) {
                // new AutoNumeric('.myCssClass > input', null, { options });
                domElement = document.querySelector(arg1);
                initialValue = null;
                userOptions = arg3;
            } else if (isArg1String && (isArg2Null || isArg2EmptyString) && isArg3Array) {
                // new AutoNumeric('.myCssClass > input', null, [{ options1 }, { options2 }]); // With multiple option objects
                domElement = document.querySelector(arg1);
                initialValue = null;
                userOptions = this.mergeOptions(arg3);
            } else if (isArg1String && isArg2Number && isArg3Null) {
                // new AutoNumeric('.myCssClass > input', 12345.789);
                // new AutoNumeric('.myCssClass > input', '12345.789');
                // new AutoNumeric('.myCssClass > input', '');
                domElement = document.querySelector(arg1);
                initialValue = arg2;
                userOptions = null;
            } else if (isArg1String && isArg2Number && isArg3Object) {
                // new AutoNumeric('.myCssClass > input', 12345.789, { options });
                // new AutoNumeric('.myCssClass > input', '12345.789', { options });
                // new AutoNumeric('.myCssClass > input', '', { options });
                domElement = document.querySelector(arg1);
                initialValue = arg2;
                userOptions = arg3;
            } else if (isArg1String && isArg2Number && isArg3PreDefinedOptionName) {
                // new AutoNumeric('.myCssClass > input', 12345.789, 'euroPos');
                // new AutoNumeric('.myCssClass > input', '12345.789', 'euroPos');
                // new AutoNumeric('.myCssClass > input', '', 'euroPos');
                domElement = document.querySelector(arg1);
                initialValue = arg2;
                userOptions = this._getOptionObject(arg3);
            } else if (isArg1String && isArg2Number && isArg3Array) {
                // new AutoNumeric('.myCssClass > input', 12345.789, [{ options1 }, 'euroPos', { options2 }]);
                // new AutoNumeric('.myCssClass > input', '12345.789', [{ options1 }, 'euroPos', { options2 }]);
                // new AutoNumeric('.myCssClass > input', '', [{ options1 }, 'euroPos', { options2 }]);
                domElement = document.querySelector(arg1);
                initialValue = arg2;
                userOptions = this.mergeOptions(arg3);
            } else if (isArg1Element && isArg2Number && isArg3Object) {
                // new AutoNumeric(domElement, 12345.789, { options });
                // new AutoNumeric(domElement, '12345.789', { options });
                // new AutoNumeric(domElement, '', { options });
                domElement = arg1;
                initialValue = arg2;
                userOptions = arg3;
            } else if (isArg1Element && isArg2Number && isArg3PreDefinedOptionName) {
                // new AutoNumeric(domElement, 12345.789, 'euroPos');
                // new AutoNumeric(domElement, '12345.789', 'euroPos');
                // new AutoNumeric(domElement, '', 'euroPos');
                domElement = arg1;
                initialValue = arg2;
                userOptions = this._getOptionObject(arg3);
            } else if (isArg1Element && isArg2Number && isArg3Array) {
                // new AutoNumeric(domElement, 12345.789, [{ options1 }, { options2 }]);
                // new AutoNumeric(domElement, '12345.789', [{ options1 }, { options2 }]);
                // new AutoNumeric(domElement, '', [{ options1 }, { options2 }]);
                domElement = arg1;
                initialValue = arg2;
                userOptions = this.mergeOptions(arg3);
            } else {
                _AutoNumericHelper2.default.throwError('The parameters given to the AutoNumeric object are not valid, \'' + arg1 + '\', \'' + arg2 + '\' and \'' + arg3 + '\' given.');
            }

            if (_AutoNumericHelper2.default.isNull(domElement)) {
                _AutoNumericHelper2.default.throwError('The selector \'' + arg1 + '\' did not select any valid DOM element. Please check on which element you called AutoNumeric.');
            }

            return { domElement: domElement, initialValue: initialValue, userOptions: userOptions };
        }

        /**
         * Merge the option objects found in the given array `optionsArray`.
         * If a `string` is found, then we try to get the related pre-defined option using that string as its name.
         * When merging the options, the latest option overwrite any previously set. This allows to fine tune a pre-defined option for instance.
         *
         * @param {Array<object|string>} optionsArray
         * @returns {{}}
         */

    }, {
        key: 'mergeOptions',
        value: function mergeOptions(optionsArray) {
            var _this12 = this;

            // This allows the user to use multiple options (strings or objects) in an array, and overwrite the previous one with the next option element ; this is useful to tune the wanted format
            var mergedOptions = {};
            optionsArray.forEach(function (optionObjectOrPredefinedOptionString) {
                _extends(mergedOptions, _this12._getOptionObject(optionObjectOrPredefinedOptionString));
            });

            return mergedOptions;
        }

        /**
         * Return `true` if the given pre-defined option name is an attribute of the `AutoNumeric.predefinedOptions` object
         *
         * @param {string} preDefinedOptionName
         * @returns {boolean}
         * @private
         */

    }, {
        key: '_isPreDefinedOptionValid',
        value: function _isPreDefinedOptionValid(preDefinedOptionName) {
            return AutoNumeric.predefinedOptions.hasOwnProperty(preDefinedOptionName);
        }

        /**
         * Return an option object based on the given parameter.
         * If `optionObjectOrPredefinedName` is as string, then we retrieve the pre-defined option object, if it's an object, we use it as is.
         *
         * @param {object|string} optionObjectOrPredefinedName
         * @returns {object}
         */

    }, {
        key: '_getOptionObject',
        value: function _getOptionObject(optionObjectOrPredefinedName) {
            var options = void 0;
            if (_AutoNumericHelper2.default.isString(optionObjectOrPredefinedName)) {
                options = AutoNumeric.getPredefinedOptions()[optionObjectOrPredefinedName];
                if (options === void 0 || options === null) {
                    // If the given pre-defined name does not exist, warn that something is wrong, and continue the execution of the initialization
                    _AutoNumericHelper2.default.warning('The given pre-defined option [' + optionObjectOrPredefinedName + '] is not recognized by autoNumeric. Please check that pre-defined option name.', true);
                }
            } else {
                // A `settings` object
                options = optionObjectOrPredefinedName;
            }

            return options;
        }
    }, {
        key: '_doesFormHandlerListExists',
        value: function _doesFormHandlerListExists() {
            var type = _typeof(window.aNFormHandlerMap);

            return type !== 'undefined' && type === 'object';
        }

        /**
         * Create the global form handler list on the `window` object.
         *
         * @private
         */

    }, {
        key: '_createFormHandlerList',
        value: function _createFormHandlerList() {
            window.aNFormHandlerMap = new Map(); // I would have used a `WeakMap` here, but that does not allow using non-object for keys
        }
    }, {
        key: '_checkValuesToStringsArray',
        value: function _checkValuesToStringsArray(key, stringsArray) {
            return _AutoNumericHelper2.default.isInArray(String(key), stringsArray);
        }

        /**
         * Static helper for checking if the given `key` is found in the settings' `valuesToStrings` option object.
         *
         * @param {number|string} key
         * @param {object} settings
         * @returns {boolean}
         * @private
         */

    }, {
        key: '_checkValuesToStringsSettings',
        value: function _checkValuesToStringsSettings(key, settings) {
            return this._checkValuesToStringsArray(key, Object.keys(settings.valuesToStrings));
        }

        /**
         * Static helper for checking if the given `value` is found in the settings' `valuesToStrings` option object.
         *
         * @param {number|string} value
         * @param {object} settings
         * @returns {boolean}
         * @private
         */

    }, {
        key: '_checkStringsToValuesSettings',
        value: function _checkStringsToValuesSettings(value, settings) {
            return this._checkValuesToStringsArray(value, Object.values(settings.valuesToStrings));
        }
    }, {
        key: '_unformatAltHovered',
        value: function _unformatAltHovered(anElement) {
            anElement.hoveredWithAlt = true;
            anElement.unformat();
        }

        /**
         * Reformat the given AutoNumeric element, and update the `hoveredWithAlt` variable.
         *
         * @param {AutoNumeric} anElement
         * @private
         */

    }, {
        key: '_reformatAltHovered',
        value: function _reformatAltHovered(anElement) {
            anElement.hoveredWithAlt = false;
            anElement.reformat();
        }

        /**
         * Return an array of autoNumeric elements, child of the <form> element passed as a parameter.
         *
         * @param {HTMLElement} formNode
         * @returns {Array}
         * @private
         */

    }, {
        key: '_getChildANInputElement',
        value: function _getChildANInputElement(formNode) {
            var _this13 = this;

            //FIXME test this
            var inputList = formNode.getElementsByTagName('input');

            // Loop this list and keep only the inputs that are managed by AutoNumeric
            var autoNumericInputs = [];
            var inputElements = Array.prototype.slice.call(inputList, 0);
            inputElements.forEach(function (input) {
                if (_this13.test(input)) {
                    autoNumericInputs.push(input);
                }
            });

            return autoNumericInputs;
        }

        // Static methods
        /**
         * Test if the given DOM element, or the element selected by the given selector string is already managed by AutoNumeric (if it has been initialized on the current page).
         *
         * @param {HTMLElement|string} domElementOrSelector Accepts either directly a DOM element to test, or a string selector (that will return one and only one element, if any)
         * @returns {boolean}
         */

    }, {
        key: 'test',
        value: function test(domElementOrSelector) {
            return this._isInGlobalList(_AutoNumericHelper2.default.domElement(domElementOrSelector));
        }

        /**
         * Create a WeakMap with the given name.
         *
         * @param {string} weakMapName
         * @private
         */

    }, {
        key: '_createWeakMap',
        value: function _createWeakMap(weakMapName) {
            window[weakMapName] = new WeakMap();
        }

        /**
         * Create a list of all the AutoNumeric elements that are initialized on the current page.
         * This is needed in order to determine if a given dom element is already managed by autoNumeric.
         * This uses a WeakMap in order to limit potential garbage collection problems.
         * (cf. my tests on http://codepen.io/AnotherLinuxUser/pen/pRQGaM?editors=1011)
         * @private
         */

    }, {
        key: '_createGlobalList',
        value: function _createGlobalList() {
            // The check that this global list does not exists already is done in the add and remove functions already
            this.autoNumericGlobalListName = 'autoNumericGlobalList'; //XXX This looks weird to set a variable on `this.` in a static method, but that really declare that variable like a static property
            // Note: I should not get any memory leaks for referencing the DOM element in the `value`, this DOM element also being the `key`, according to the spec : http://www.ecma-international.org/ecma-262/6.0/#sec-weakmap-objects
            this._createWeakMap(this.autoNumericGlobalListName);
        }

        /**
         * Return `true` if the global AutoNumeric element list exists.
         *
         * @returns {boolean}
         * @private
         */

    }, {
        key: '_doesGlobalListExists',
        value: function _doesGlobalListExists() {
            var type = _typeof(window[this.autoNumericGlobalListName]);
            return type !== 'undefined' && type === 'object';
        }

        /**
         * Add the given object to the global AutoNumeric element list.
         *
         * @param {AutoNumeric} autoNumericObject
         * @private
         */

    }, {
        key: '_addToGlobalList',
        value: function _addToGlobalList(autoNumericObject) {
            if (!this._doesGlobalListExists()) {
                this._createGlobalList();
            }

            var domElement = autoNumericObject.node();
            // This checks if the object is not already in the global list before adding it.
            // This could happen if an AutoNumeric element is initialized, then the DOM element is removed directly via `removeChild` (hence the reference does not get removed from the global list), then it get recreated and initialized again
            if (this._isInGlobalList(domElement)) {
                if (this._getFromGlobalList(domElement) === this) {
                    // Do not add this AutoNumeric object again since it's already in that global list
                    return;
                } else {
                    // Print a warning to warn that the domElement already has a reference in the global map (but we cannot for sure starts deleting those old references since they could still be used by another AutoNumeric object)
                    _AutoNumericHelper2.default.warning('A reference to the DOM element you just initialized already exists in the global AutoNumeric element list. Please make sure to not initialize the same DOM element multiple times.', autoNumericObject.getSettings().showWarnings);
                }
            }

            window[this.autoNumericGlobalListName].set(domElement, autoNumericObject);
        }

        /**
         * Remove the given object from the global AutoNumeric element list.
         *
         * @param {AutoNumeric} autoNumericObject
         * @private
         */

    }, {
        key: '_removeFromGlobalList',
        value: function _removeFromGlobalList(autoNumericObject) {
            //FIXME test this
            if (this._doesGlobalListExists()) {
                window[this.autoNumericGlobalListName].delete(autoNumericObject.node());
            }
        }

        /**
         * Return the value associated to the key `domElement` passed as a parameter.
         * The value is the AutoNumeric object that manages the DOM element `domElement`.
         *
         * @param {HTMLElement|HTMLInputElement} domElement
         * @returns {null|AutoNumeric}
         * @private
         */

    }, {
        key: '_getFromGlobalList',
        value: function _getFromGlobalList(domElement) {
            //FIXME test this
            if (this._doesGlobalListExists()) {
                return window[this.autoNumericGlobalListName].get(domElement);
            }

            return null;
        }

        /**
         * Check if the given DOM element is in the global AutoNumeric element list.
         *
         * @param {HTMLElement|HTMLInputElement} domElement
         * @returns {boolean}
         * @private
         */

    }, {
        key: '_isInGlobalList',
        value: function _isInGlobalList(domElement) {
            //FIXME test this
            if (!this._doesGlobalListExists()) {
                return false;
            }

            return window[this.autoNumericGlobalListName].has(domElement);
        }
    }, {
        key: 'validate',
        value: function validate(userOptions) {
            var shouldExtendDefaultOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var originalOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            if (_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(userOptions) || !_AutoNumericHelper2.default.isObject(userOptions)) {
                _AutoNumericHelper2.default.throwError('The userOptions are invalid ; it should be a valid object, [' + userOptions + '] given.');
            }

            var isOriginalOptionAnObject = _AutoNumericHelper2.default.isObject(originalOptions);
            if (!isOriginalOptionAnObject && !_AutoNumericHelper2.default.isNull(originalOptions)) {
                _AutoNumericHelper2.default.throwError('The \'originalOptions\' parameter is invalid ; it should either be a valid option object or `null`, [' + userOptions + '] given.');
            }

            // If the user used old options, we convert them to new ones
            if (!_AutoNumericHelper2.default.isNull(userOptions)) {
                this._convertOldOptionsToNewOnes(userOptions);
            }

            // The user can choose if the `userOptions` has already been extended with the default options, or not
            var options = void 0;
            if (shouldExtendDefaultOptions) {
                options = _extends({}, this.getDefaultConfig(), userOptions);
            } else {
                options = userOptions;
            }

            // First things first, we test that the `showWarnings` option is valid
            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.showWarnings) && !_AutoNumericHelper2.default.isBoolean(options.showWarnings)) {
                _AutoNumericHelper2.default.throwError('The debug option \'showWarnings\' is invalid ; it should be either \'true\' or \'false\', [' + options.showWarnings + '] given.');
            }

            // Define the regular expressions needed for the following tests
            var testPositiveInteger = /^[0-9]+$/;
            var testNumericalCharacters = /[0-9]+/;
            // const testFloatAndPossibleNegativeSign = /^-?[0-9]+(\.?[0-9]+)$/;
            var testFloatOrIntegerAndPossibleNegativeSign = /^-?[0-9]+(\.?[0-9]+)?$/;
            var testPositiveFloatOrInteger = /^[0-9]+(\.?[0-9]+)?$/;

            // Then tests the options individually
            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.allowDecimalPadding) && !_AutoNumericHelper2.default.isBoolean(options.allowDecimalPadding) && options.allowDecimalPadding !== AutoNumeric.options.allowDecimalPadding.floats) {
                _AutoNumericHelper2.default.throwError('The decimal padding option \'allowDecimalPadding\' is invalid ; it should either be `false`, `true` or `\'floats\'`, [' + options.allowDecimalPadding + '] given.');
            }

            if ((options.allowDecimalPadding === AutoNumeric.options.allowDecimalPadding.never || options.allowDecimalPadding === 'false') && (options.decimalPlaces !== AutoNumeric.options.decimalPlaces.none || options.decimalPlacesShownOnBlur !== AutoNumeric.options.decimalPlacesShownOnBlur.none || options.decimalPlacesShownOnFocus !== AutoNumeric.options.decimalPlacesShownOnFocus.none)) {
                _AutoNumericHelper2.default.warning('Setting \'allowDecimalPadding\' to [' + options.allowDecimalPadding + '] will override the current \'decimalPlaces*\' settings [' + options.decimalPlaces + ', ' + options.decimalPlacesShownOnBlur + ' and ' + options.decimalPlacesShownOnFocus + '].', options.showWarnings);
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.alwaysAllowDecimalCharacter) && !_AutoNumericHelper2.default.isBoolean(options.alwaysAllowDecimalCharacter)) {
                _AutoNumericHelper2.default.throwError('The option \'alwaysAllowDecimalCharacter\' is invalid ; it should either be `true` or `false`, [' + options.alwaysAllowDecimalCharacter + '] given.');
            }

            if (!_AutoNumericHelper2.default.isNull(options.caretPositionOnFocus) && !_AutoNumericHelper2.default.isInArray(options.caretPositionOnFocus, [AutoNumeric.options.caretPositionOnFocus.start, AutoNumeric.options.caretPositionOnFocus.end, AutoNumeric.options.caretPositionOnFocus.decimalLeft, AutoNumeric.options.caretPositionOnFocus.decimalRight])) {
                _AutoNumericHelper2.default.throwError('The display on empty string option \'caretPositionOnFocus\' is invalid ; it should either be `null`, \'focus\', \'press\', \'always\' or \'zero\', [' + options.caretPositionOnFocus + '] given.');
            }

            // Special case here for `caretPositionOnFocus` and `selectOnFocus` where we need to check the original non-tempered version of the options in order to check for conflicts, since using the default settings remove those and would prevent us warning the user that his option object is not correct.
            var optionsToUse = void 0;
            if (isOriginalOptionAnObject) {
                optionsToUse = originalOptions;
            } else {
                optionsToUse = this._correctCaretPositionOnFocusAndSelectOnFocusOptions(userOptions);
            }

            if (!_AutoNumericHelper2.default.isNull(optionsToUse) && optionsToUse.caretPositionOnFocus !== AutoNumeric.options.caretPositionOnFocus.doNoForceCaretPosition && optionsToUse.selectOnFocus === AutoNumeric.options.selectOnFocus.select) {
                _AutoNumericHelper2.default.warning('The \'selectOnFocus\' option is set to \'select\', which is in conflict with the \'caretPositionOnFocus\' which is set to \'' + optionsToUse.caretPositionOnFocus + '\'. As a result, if this has been called when instantiating an AutoNumeric object, the \'selectOnFocus\' option is forced to \'doNotSelect\'.', options.showWarnings);
            }

            if (!_AutoNumericHelper2.default.isInArray(options.digitGroupSeparator, [AutoNumeric.options.digitGroupSeparator.comma, AutoNumeric.options.digitGroupSeparator.dot, AutoNumeric.options.digitGroupSeparator.normalSpace, AutoNumeric.options.digitGroupSeparator.thinSpace, AutoNumeric.options.digitGroupSeparator.narrowNoBreakSpace, AutoNumeric.options.digitGroupSeparator.noBreakSpace, AutoNumeric.options.digitGroupSeparator.noSeparator, AutoNumeric.options.digitGroupSeparator.apostrophe, AutoNumeric.options.digitGroupSeparator.arabicThousandsSeparator, AutoNumeric.options.digitGroupSeparator.dotAbove])) {
                _AutoNumericHelper2.default.throwError('The thousand separator character option \'digitGroupSeparator\' is invalid ; it should be \',\', \'.\', \'\u066C\', \'\u02D9\', "\'", \' \', \'\u2009\', \'\u202F\', \'\xA0\' or empty (\'\'), [' + options.digitGroupSeparator + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.showOnlyNumbersOnFocus) && !_AutoNumericHelper2.default.isBoolean(options.showOnlyNumbersOnFocus)) {
                _AutoNumericHelper2.default.throwError('The \'showOnlyNumbersOnFocus\' option is invalid ; it should be either \'true\' or \'false\', [' + options.showOnlyNumbersOnFocus + '] given.');
            }

            if (!_AutoNumericHelper2.default.isInArray(options.digitalGroupSpacing, [AutoNumeric.options.digitalGroupSpacing.two, AutoNumeric.options.digitalGroupSpacing.twoScaled, AutoNumeric.options.digitalGroupSpacing.three, AutoNumeric.options.digitalGroupSpacing.four]) && !(options.digitalGroupSpacing >= 2 && options.digitalGroupSpacing <= 4)) {
                _AutoNumericHelper2.default.throwError('The grouping separator option for thousands \'digitalGroupSpacing\' is invalid ; it should be \'2\', \'2s\', \'3\', or \'4\', [' + options.digitalGroupSpacing + '] given.');
            }

            if (!_AutoNumericHelper2.default.isInArray(options.decimalCharacter, [AutoNumeric.options.decimalCharacter.comma, AutoNumeric.options.decimalCharacter.dot, AutoNumeric.options.decimalCharacter.middleDot, AutoNumeric.options.decimalCharacter.arabicDecimalSeparator, AutoNumeric.options.decimalCharacter.decimalSeparatorKeySymbol])) {
                _AutoNumericHelper2.default.throwError('The decimal separator character option \'decimalCharacter\' is invalid ; it should be \'.\', \',\', \'\xB7\', \'\u2396\' or \'\u066B\', [' + options.decimalCharacter + '] given.');
            }

            // Checks if the decimal and thousand characters are the same
            if (options.decimalCharacter === options.digitGroupSeparator) {
                _AutoNumericHelper2.default.throwError('autoNumeric will not function properly when the decimal character \'decimalCharacter\' [' + options.decimalCharacter + '] and the thousand separator \'digitGroupSeparator\' [' + options.digitGroupSeparator + '] are the same character.');
            }

            if (!_AutoNumericHelper2.default.isNull(options.decimalCharacterAlternative) && !_AutoNumericHelper2.default.isString(options.decimalCharacterAlternative)) {
                _AutoNumericHelper2.default.throwError('The alternate decimal separator character option \'decimalCharacterAlternative\' is invalid ; it should be a string, [' + options.decimalCharacterAlternative + '] given.');
            }

            if (options.currencySymbol !== '' && !_AutoNumericHelper2.default.isString(options.currencySymbol)) {
                _AutoNumericHelper2.default.throwError('The currency symbol option \'currencySymbol\' is invalid ; it should be a string, [' + options.currencySymbol + '] given.');
            }

            if (!_AutoNumericHelper2.default.isInArray(options.currencySymbolPlacement, [AutoNumeric.options.currencySymbolPlacement.prefix, AutoNumeric.options.currencySymbolPlacement.suffix])) {
                _AutoNumericHelper2.default.throwError('The placement of the currency sign option \'currencySymbolPlacement\' is invalid ; it should either be \'p\' (prefix) or \'s\' (suffix), [' + options.currencySymbolPlacement + '] given.');
            }

            if (!_AutoNumericHelper2.default.isInArray(options.negativePositiveSignPlacement, [AutoNumeric.options.negativePositiveSignPlacement.prefix, AutoNumeric.options.negativePositiveSignPlacement.suffix, AutoNumeric.options.negativePositiveSignPlacement.left, AutoNumeric.options.negativePositiveSignPlacement.right, AutoNumeric.options.negativePositiveSignPlacement.none])) {
                _AutoNumericHelper2.default.throwError('The placement of the negative sign option \'negativePositiveSignPlacement\' is invalid ; it should either be \'p\' (prefix), \'s\' (suffix), \'l\' (left), \'r\' (right) or \'null\', [' + options.negativePositiveSignPlacement + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.showPositiveSign) && !_AutoNumericHelper2.default.isBoolean(options.showPositiveSign)) {
                _AutoNumericHelper2.default.throwError('The show positive sign option \'showPositiveSign\' is invalid ; it should be either \'true\' or \'false\', [' + options.showPositiveSign + '] given.');
            }

            if (!_AutoNumericHelper2.default.isString(options.suffixText) || options.suffixText !== '' && (_AutoNumericHelper2.default.isNegative(options.suffixText, options.negativeSignCharacter) || testNumericalCharacters.test(options.suffixText))) {
                _AutoNumericHelper2.default.throwError('The additional suffix option \'suffixText\' is invalid ; it should not contains the negative sign \'' + options.negativeSignCharacter + '\' nor any numerical characters, [' + options.suffixText + '] given.');
            }

            if (!_AutoNumericHelper2.default.isString(options.negativeSignCharacter) || options.negativeSignCharacter.length !== 1 || _AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(options.negativeSignCharacter) || testNumericalCharacters.test(options.negativeSignCharacter)) {
                _AutoNumericHelper2.default.throwError('The negative sign character option \'negativeSignCharacter\' is invalid ; it should be a single character, and cannot be any numerical characters, [' + options.negativeSignCharacter + '] given.');
            }

            if (!_AutoNumericHelper2.default.isString(options.positiveSignCharacter) || options.positiveSignCharacter.length !== 1 || _AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(options.positiveSignCharacter) || testNumericalCharacters.test(options.positiveSignCharacter)) {
                _AutoNumericHelper2.default.throwError('The positive sign character option \'positiveSignCharacter\' is invalid ; it should be a single character, and cannot be any numerical characters, [' + options.positiveSignCharacter + '] given.\nIf you want to hide the positive sign character, you need to set the `showPositiveSign` option to `true`.');
            }

            if (options.negativeSignCharacter === options.positiveSignCharacter) {
                _AutoNumericHelper2.default.throwError('The positive \'positiveSignCharacter\' and negative \'negativeSignCharacter\' sign characters cannot be identical ; [' + options.negativeSignCharacter + '] given.');
            }

            var _ref5 = _AutoNumericHelper2.default.isNull(options.negativeBracketsTypeOnBlur) ? ['', ''] : options.negativeBracketsTypeOnBlur.split(','),
                _ref6 = _slicedToArray(_ref5, 2),
                leftBracket = _ref6[0],
                rightBracket = _ref6[1];

            if (_AutoNumericHelper2.default.contains(options.digitGroupSeparator, options.negativeSignCharacter) || _AutoNumericHelper2.default.contains(options.decimalCharacter, options.negativeSignCharacter) || _AutoNumericHelper2.default.contains(options.decimalCharacterAlternative, options.negativeSignCharacter) || _AutoNumericHelper2.default.contains(leftBracket, options.negativeSignCharacter) || _AutoNumericHelper2.default.contains(rightBracket, options.negativeSignCharacter) || _AutoNumericHelper2.default.contains(options.suffixText, options.negativeSignCharacter)) {
                _AutoNumericHelper2.default.throwError('The negative sign character option \'negativeSignCharacter\' is invalid ; it should not be equal or a part of the digit separator, the decimal character, the decimal character alternative, the negative brackets or the suffix text, [' + options.negativeSignCharacter + '] given.');
            }

            if (_AutoNumericHelper2.default.contains(options.digitGroupSeparator, options.positiveSignCharacter) || _AutoNumericHelper2.default.contains(options.decimalCharacter, options.positiveSignCharacter) || _AutoNumericHelper2.default.contains(options.decimalCharacterAlternative, options.positiveSignCharacter) || _AutoNumericHelper2.default.contains(leftBracket, options.positiveSignCharacter) || _AutoNumericHelper2.default.contains(rightBracket, options.positiveSignCharacter) || _AutoNumericHelper2.default.contains(options.suffixText, options.positiveSignCharacter)) {
                _AutoNumericHelper2.default.throwError('The positive sign character option \'positiveSignCharacter\' is invalid ; it should not be equal or a part of the digit separator, the decimal character, the decimal character alternative, the negative brackets or the suffix text, [' + options.positiveSignCharacter + '] given.');
            }

            if (!_AutoNumericHelper2.default.isNull(options.overrideMinMaxLimits) && !_AutoNumericHelper2.default.isInArray(options.overrideMinMaxLimits, [AutoNumeric.options.overrideMinMaxLimits.ceiling, AutoNumeric.options.overrideMinMaxLimits.floor, AutoNumeric.options.overrideMinMaxLimits.ignore])) {
                _AutoNumericHelper2.default.throwError('The override min & max limits option \'overrideMinMaxLimits\' is invalid ; it should either be \'ceiling\', \'floor\' or \'ignore\', [' + options.overrideMinMaxLimits + '] given.');
            }

            if (!_AutoNumericHelper2.default.isString(options.maximumValue) || !testFloatOrIntegerAndPossibleNegativeSign.test(options.maximumValue)) {
                _AutoNumericHelper2.default.throwError('The maximum possible value option \'maximumValue\' is invalid ; it should be a string that represents a positive or negative number, [' + options.maximumValue + '] given.');
            }

            if (!_AutoNumericHelper2.default.isString(options.minimumValue) || !testFloatOrIntegerAndPossibleNegativeSign.test(options.minimumValue)) {
                _AutoNumericHelper2.default.throwError('The minimum possible value option \'minimumValue\' is invalid ; it should be a string that represents a positive or negative number, [' + options.minimumValue + '] given.');
            }

            if (parseFloat(options.minimumValue) > parseFloat(options.maximumValue)) {
                _AutoNumericHelper2.default.throwError('The minimum possible value option is greater than the maximum possible value option ; \'minimumValue\' [' + options.minimumValue + '] should be smaller than \'maximumValue\' [' + options.maximumValue + '].');
            }

            if (!(_AutoNumericHelper2.default.isInt(options.decimalPlaces) && options.decimalPlaces >= 0 || // If integer option
            _AutoNumericHelper2.default.isString(options.decimalPlaces) && testPositiveInteger.test(options.decimalPlaces)) // If string option
            ) {
                    _AutoNumericHelper2.default.throwError('The number of decimal places option \'decimalPlaces\' is invalid ; it should be a positive integer, [' + options.decimalPlaces + '] given.');
                }

            if (!(_AutoNumericHelper2.default.isNull(options.decimalPlacesRawValue) || _AutoNumericHelper2.default.isInt(options.decimalPlacesRawValue) && options.decimalPlacesRawValue >= 0 || // If integer option
            _AutoNumericHelper2.default.isString(options.decimalPlacesRawValue) && testPositiveInteger.test(options.decimalPlacesRawValue)) // If string option
            ) {
                    _AutoNumericHelper2.default.throwError('The number of decimal places for the raw value option \'decimalPlacesRawValue\' is invalid ; it should be a positive integer or `null`, [' + options.decimalPlacesRawValue + '] given.');
                }

            // Checks if the number of decimal places for the raw value is lower than the `decimalPlaces`, `decimalPlacesShownOnFocus` and/or `decimalPlacesShownOnBlur` options
            this._validateDecimalPlacesRawValue(options);

            if (!_AutoNumericHelper2.default.isNull(options.decimalPlacesShownOnFocus) && !testPositiveInteger.test(String(options.decimalPlacesShownOnFocus))) {
                _AutoNumericHelper2.default.throwError('The number of expanded decimal places option \'decimalPlacesShownOnFocus\' is invalid ; it should be a positive integer or `null`, [' + options.decimalPlacesShownOnFocus + '] given.');
            }

            // Checks if the extended decimal places "decimalPlacesShownOnFocus" is greater than the decimal places number `decimalPlaces`
            if (!_AutoNumericHelper2.default.isNull(options.decimalPlacesShownOnFocus) && Number(options.decimalPlaces) > Number(options.decimalPlacesShownOnFocus)) {
                _AutoNumericHelper2.default.warning('The extended decimal places \'decimalPlacesShownOnFocus\' [' + options.decimalPlacesShownOnFocus + '] should be greater than the \'decimalPlaces\' [' + options.decimalPlaces + '] value. Currently, this will limit the ability of your user to manually change some of the decimal places. Do you really want to do that?', options.showWarnings);
            }

            if (!_AutoNumericHelper2.default.isNull(options.divisorWhenUnfocused) && !testPositiveFloatOrInteger.test(options.divisorWhenUnfocused) || options.divisorWhenUnfocused === 0 || options.divisorWhenUnfocused === '0' || options.divisorWhenUnfocused === 1 || options.divisorWhenUnfocused === '1') {
                _AutoNumericHelper2.default.throwError('The divisor option \'divisorWhenUnfocused\' is invalid ; it should be a positive number higher than one, preferably an integer, [' + options.divisorWhenUnfocused + '] given.');
            }

            if (!_AutoNumericHelper2.default.isNull(options.decimalPlacesShownOnBlur) && !testPositiveInteger.test(options.decimalPlacesShownOnBlur)) {
                _AutoNumericHelper2.default.throwError('The number of decimals shown when unfocused option \'decimalPlacesShownOnBlur\' is invalid ; it should be a positive integer or `null`, [' + options.decimalPlacesShownOnBlur + '] given.');
            }

            if (!_AutoNumericHelper2.default.isNull(options.symbolWhenUnfocused) && !_AutoNumericHelper2.default.isString(options.symbolWhenUnfocused)) {
                _AutoNumericHelper2.default.throwError('The symbol to show when unfocused option \'symbolWhenUnfocused\' is invalid ; it should be a string, [' + options.symbolWhenUnfocused + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.saveValueToSessionStorage) && !_AutoNumericHelper2.default.isBoolean(options.saveValueToSessionStorage)) {
                _AutoNumericHelper2.default.throwError('The save to session storage option \'saveValueToSessionStorage\' is invalid ; it should be either \'true\' or \'false\', [' + options.saveValueToSessionStorage + '] given.');
            }

            if (!_AutoNumericHelper2.default.isInArray(options.onInvalidPaste, [AutoNumeric.options.onInvalidPaste.error, AutoNumeric.options.onInvalidPaste.ignore, AutoNumeric.options.onInvalidPaste.clamp, AutoNumeric.options.onInvalidPaste.truncate, AutoNumeric.options.onInvalidPaste.replace])) {
                _AutoNumericHelper2.default.throwError('The paste behavior option \'onInvalidPaste\' is invalid ; it should either be \'error\', \'ignore\', \'clamp\', \'truncate\' or \'replace\' (cf. documentation), [' + options.onInvalidPaste + '] given.');
            }

            if (!_AutoNumericHelper2.default.isInArray(options.roundingMethod, [AutoNumeric.options.roundingMethod.halfUpSymmetric, AutoNumeric.options.roundingMethod.halfUpAsymmetric, AutoNumeric.options.roundingMethod.halfDownSymmetric, AutoNumeric.options.roundingMethod.halfDownAsymmetric, AutoNumeric.options.roundingMethod.halfEvenBankersRounding, AutoNumeric.options.roundingMethod.upRoundAwayFromZero, AutoNumeric.options.roundingMethod.downRoundTowardZero, AutoNumeric.options.roundingMethod.toCeilingTowardPositiveInfinity, AutoNumeric.options.roundingMethod.toFloorTowardNegativeInfinity, AutoNumeric.options.roundingMethod.toNearest05, AutoNumeric.options.roundingMethod.toNearest05Alt, AutoNumeric.options.roundingMethod.upToNext05, AutoNumeric.options.roundingMethod.downToNext05])) {
                _AutoNumericHelper2.default.throwError('The rounding method option \'roundingMethod\' is invalid ; it should either be \'S\', \'A\', \'s\', \'a\', \'B\', \'U\', \'D\', \'C\', \'F\', \'N05\', \'CHF\', \'U05\' or \'D05\' (cf. documentation), [' + options.roundingMethod + '] given.');
            }

            if (!_AutoNumericHelper2.default.isNull(options.negativeBracketsTypeOnBlur) && !_AutoNumericHelper2.default.isInArray(options.negativeBracketsTypeOnBlur, [AutoNumeric.options.negativeBracketsTypeOnBlur.parentheses, AutoNumeric.options.negativeBracketsTypeOnBlur.brackets, AutoNumeric.options.negativeBracketsTypeOnBlur.chevrons, AutoNumeric.options.negativeBracketsTypeOnBlur.curlyBraces, AutoNumeric.options.negativeBracketsTypeOnBlur.angleBrackets, AutoNumeric.options.negativeBracketsTypeOnBlur.japaneseQuotationMarks, AutoNumeric.options.negativeBracketsTypeOnBlur.halfBrackets, AutoNumeric.options.negativeBracketsTypeOnBlur.whiteSquareBrackets, AutoNumeric.options.negativeBracketsTypeOnBlur.quotationMarks, AutoNumeric.options.negativeBracketsTypeOnBlur.guillemets])) {
                _AutoNumericHelper2.default.throwError('The brackets for negative values option \'negativeBracketsTypeOnBlur\' is invalid ; it should either be \'(,)\', \'[,]\', \'<,>\', \'{,}\', \'\u3008,\u3009\', \'\uFF62,\uFF63\', \'\u2E24,\u2E25\', \'\u27E6,\u27E7\', \'\u2039,\u203A\' or \'\xAB,\xBB\', [' + options.negativeBracketsTypeOnBlur + '] given.');
            }

            if (!(_AutoNumericHelper2.default.isString(options.emptyInputBehavior) || _AutoNumericHelper2.default.isNumber(options.emptyInputBehavior)) || !(_AutoNumericHelper2.default.isInArray(options.emptyInputBehavior, [AutoNumeric.options.emptyInputBehavior.focus, AutoNumeric.options.emptyInputBehavior.press, AutoNumeric.options.emptyInputBehavior.always, AutoNumeric.options.emptyInputBehavior.min, AutoNumeric.options.emptyInputBehavior.max, AutoNumeric.options.emptyInputBehavior.zero, AutoNumeric.options.emptyInputBehavior.null]) || testFloatOrIntegerAndPossibleNegativeSign.test(options.emptyInputBehavior))) {
                _AutoNumericHelper2.default.throwError('The display on empty string option \'emptyInputBehavior\' is invalid ; it should either be \'focus\', \'press\', \'always\', \'min\', \'max\', \'zero\', \'null\', a number, or a string that represents a number, [' + options.emptyInputBehavior + '] given.');
            }

            if (options.emptyInputBehavior === AutoNumeric.options.emptyInputBehavior.zero && (options.minimumValue > 0 || options.maximumValue < 0)) {
                _AutoNumericHelper2.default.throwError('The \'emptyInputBehavior\' option is set to \'zero\', but this value is outside of the range defined by \'minimumValue\' and \'maximumValue\' [' + options.minimumValue + ', ' + options.maximumValue + '].');
            }

            if (testFloatOrIntegerAndPossibleNegativeSign.test(String(options.emptyInputBehavior))) {
                var _checkIfInRangeWithOv = this._checkIfInRangeWithOverrideOption(options.emptyInputBehavior, options),
                    _checkIfInRangeWithOv2 = _slicedToArray(_checkIfInRangeWithOv, 2),
                    minTest = _checkIfInRangeWithOv2[0],
                    maxTest = _checkIfInRangeWithOv2[1];

                if (!minTest || !maxTest) {
                    _AutoNumericHelper2.default.throwError('The \'emptyInputBehavior\' option is set to a number or a string that represents a number, but its value [' + options.emptyInputBehavior + '] is outside of the range defined by the \'minimumValue\' and \'maximumValue\' options [' + options.minimumValue + ', ' + options.maximumValue + '].');
                }
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.eventBubbles) && !_AutoNumericHelper2.default.isBoolean(options.eventBubbles)) {
                _AutoNumericHelper2.default.throwError('The event bubbles option \'eventBubbles\' is invalid ; it should be either \'true\' or \'false\', [' + options.eventBubbles + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.eventIsCancelable) && !_AutoNumericHelper2.default.isBoolean(options.eventIsCancelable)) {
                _AutoNumericHelper2.default.throwError('The event is cancelable option \'eventIsCancelable\' is invalid ; it should be either \'true\' or \'false\', [' + options.eventIsCancelable + '] given.');
            }

            if (!_AutoNumericHelper2.default.isInArray(options.leadingZero, [AutoNumeric.options.leadingZero.allow, AutoNumeric.options.leadingZero.deny, AutoNumeric.options.leadingZero.keep])) {
                _AutoNumericHelper2.default.throwError('The leading zero behavior option \'leadingZero\' is invalid ; it should either be \'allow\', \'deny\' or \'keep\', [' + options.leadingZero + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.formatOnPageLoad) && !_AutoNumericHelper2.default.isBoolean(options.formatOnPageLoad)) {
                _AutoNumericHelper2.default.throwError('The format on initialization option \'formatOnPageLoad\' is invalid ; it should be either \'true\' or \'false\', [' + options.formatOnPageLoad + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.formulaMode) && !_AutoNumericHelper2.default.isBoolean(options.formulaMode)) {
                _AutoNumericHelper2.default.throwError('The formula mode option \'formulaMode\' is invalid ; it should be either \'true\' or \'false\', [' + options.formulaMode + '] given.');
            }

            if (!testPositiveInteger.test(options.historySize) || options.historySize === 0) {
                _AutoNumericHelper2.default.throwError('The history size option \'historySize\' is invalid ; it should be a positive integer, [' + options.historySize + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.selectNumberOnly) && !_AutoNumericHelper2.default.isBoolean(options.selectNumberOnly)) {
                _AutoNumericHelper2.default.throwError('The select number only option \'selectNumberOnly\' is invalid ; it should be either \'true\' or \'false\', [' + options.selectNumberOnly + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.selectOnFocus) && !_AutoNumericHelper2.default.isBoolean(options.selectOnFocus)) {
                _AutoNumericHelper2.default.throwError('The select on focus option \'selectOnFocus\' is invalid ; it should be either \'true\' or \'false\', [' + options.selectOnFocus + '] given.');
            }

            if (!_AutoNumericHelper2.default.isNull(options.defaultValueOverride) && options.defaultValueOverride !== '' && !testFloatOrIntegerAndPossibleNegativeSign.test(options.defaultValueOverride)) {
                _AutoNumericHelper2.default.throwError('The unformatted default value option \'defaultValueOverride\' is invalid ; it should be a string that represents a positive or negative number, [' + options.defaultValueOverride + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.unformatOnSubmit) && !_AutoNumericHelper2.default.isBoolean(options.unformatOnSubmit)) {
                _AutoNumericHelper2.default.throwError('The remove formatting on submit option \'unformatOnSubmit\' is invalid ; it should be either \'true\' or \'false\', [' + options.unformatOnSubmit + '] given.');
            }

            if (!_AutoNumericHelper2.default.isNull(options.valuesToStrings) && !_AutoNumericHelper2.default.isObject(options.valuesToStrings)) {
                _AutoNumericHelper2.default.throwError('The option \'valuesToStrings\' is invalid ; it should be an object, ideally with \'key -> value\' entries, [' + options.valuesToStrings + '] given.');
            }

            if (!_AutoNumericHelper2.default.isNull(options.outputFormat) && !_AutoNumericHelper2.default.isInArray(options.outputFormat, [AutoNumeric.options.outputFormat.string, AutoNumeric.options.outputFormat.number, AutoNumeric.options.outputFormat.dot, AutoNumeric.options.outputFormat.negativeDot, AutoNumeric.options.outputFormat.comma, AutoNumeric.options.outputFormat.negativeComma, AutoNumeric.options.outputFormat.dotNegative, AutoNumeric.options.outputFormat.commaNegative])) {
                _AutoNumericHelper2.default.throwError('The custom locale format option \'outputFormat\' is invalid ; it should either be null, \'string\', \'number\', \'.\', \'-.\', \',\', \'-,\', \'.-\' or \',-\', [' + options.outputFormat + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.isCancellable) && !_AutoNumericHelper2.default.isBoolean(options.isCancellable)) {
                _AutoNumericHelper2.default.throwError('The cancellable behavior option \'isCancellable\' is invalid ; it should be either \'true\' or \'false\', [' + options.isCancellable + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.modifyValueOnWheel) && !_AutoNumericHelper2.default.isBoolean(options.modifyValueOnWheel)) {
                _AutoNumericHelper2.default.throwError('The increment/decrement on mouse wheel option \'modifyValueOnWheel\' is invalid ; it should be either \'true\' or \'false\', [' + options.modifyValueOnWheel + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.watchExternalChanges) && !_AutoNumericHelper2.default.isBoolean(options.watchExternalChanges)) {
                _AutoNumericHelper2.default.throwError('The option \'watchExternalChanges\' is invalid ; it should be either \'true\' or \'false\', [' + options.watchExternalChanges + '] given.');
            }

            if (!_AutoNumericHelper2.default.isInArray(options.wheelOn, [AutoNumeric.options.wheelOn.focus, AutoNumeric.options.wheelOn.hover])) {
                _AutoNumericHelper2.default.throwError('The wheel behavior option \'wheelOn\' is invalid ; it should either be \'focus\' or \'hover\', [' + options.wheelOn + '] given.');
            }

            if (!(_AutoNumericHelper2.default.isString(options.wheelStep) || _AutoNumericHelper2.default.isNumber(options.wheelStep)) || options.wheelStep !== 'progressive' && !testPositiveFloatOrInteger.test(options.wheelStep) || Number(options.wheelStep) === 0) {
                // A step equal to '0' is rejected
                _AutoNumericHelper2.default.throwError('The wheel step value option \'wheelStep\' is invalid ; it should either be the string \'progressive\', or a number or a string that represents a positive number (excluding zero), [' + options.wheelStep + '] given.');
            }

            if (!_AutoNumericHelper2.default.isInArray(options.serializeSpaces, [AutoNumeric.options.serializeSpaces.plus, AutoNumeric.options.serializeSpaces.percent])) {
                _AutoNumericHelper2.default.throwError('The space replacement character option \'serializeSpaces\' is invalid ; it should either be \'+\' or \'%20\', [' + options.serializeSpaces + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.noEventListeners) && !_AutoNumericHelper2.default.isBoolean(options.noEventListeners)) {
                _AutoNumericHelper2.default.throwError('The option \'noEventListeners\' that prevent the creation of event listeners is invalid ; it should be either \'true\' or \'false\', [' + options.noEventListeners + '] given.');
            }

            if (!_AutoNumericHelper2.default.isNull(options.styleRules) && !(_AutoNumericHelper2.default.isObject(options.styleRules) && (options.styleRules.hasOwnProperty('positive') || options.styleRules.hasOwnProperty('negative') || options.styleRules.hasOwnProperty('ranges') || options.styleRules.hasOwnProperty('userDefined')))) {
                _AutoNumericHelper2.default.throwError('The option \'styleRules\' is invalid ; it should be a correctly structured object, with one or more \'positive\', \'negative\', \'ranges\' or \'userDefined\' attributes, [' + options.styleRules + '] given.');
            }

            // Deeper tests of the `styleRules` object : Check that the callback, if defined, is a function
            if (!_AutoNumericHelper2.default.isNull(options.styleRules) && options.styleRules.hasOwnProperty('userDefined') && !_AutoNumericHelper2.default.isNull(options.styleRules.userDefined)) {
                options.styleRules.userDefined.forEach(function (rule) {
                    if (rule.hasOwnProperty('callback') && !_AutoNumericHelper2.default.isFunction(rule.callback)) {
                        _AutoNumericHelper2.default.throwError('The callback defined in the `userDefined` attribute is not a function, ' + _typeof(rule.callback) + ' given.');
                    }
                });
            }

            if (!_AutoNumericHelper2.default.isNull(options.rawValueDivisor) && !testPositiveFloatOrInteger.test(options.rawValueDivisor) || options.rawValueDivisor === 0 || options.rawValueDivisor === '0' || options.rawValueDivisor === 1 || options.rawValueDivisor === '1') {
                _AutoNumericHelper2.default.throwError('The raw value divisor option \'rawValueDivisor\' is invalid ; it should be a positive number higher than one, preferably an integer, [' + options.rawValueDivisor + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.readOnly) && !_AutoNumericHelper2.default.isBoolean(options.readOnly)) {
                _AutoNumericHelper2.default.throwError('The option \'readOnly\' is invalid ; it should be either \'true\' or \'false\', [' + options.readOnly + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.unformatOnHover) && !_AutoNumericHelper2.default.isBoolean(options.unformatOnHover)) {
                _AutoNumericHelper2.default.throwError('The option \'unformatOnHover\' is invalid ; it should be either \'true\' or \'false\', [' + options.unformatOnHover + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.failOnUnknownOption) && !_AutoNumericHelper2.default.isBoolean(options.failOnUnknownOption)) {
                _AutoNumericHelper2.default.throwError('The debug option \'failOnUnknownOption\' is invalid ; it should be either \'true\' or \'false\', [' + options.failOnUnknownOption + '] given.');
            }

            if (!_AutoNumericHelper2.default.isTrueOrFalseString(options.createLocalList) && !_AutoNumericHelper2.default.isBoolean(options.createLocalList)) {
                _AutoNumericHelper2.default.throwError('The debug option \'createLocalList\' is invalid ; it should be either \'true\' or \'false\', [' + options.createLocalList + '] given.');
            }
        }

        /**
         * Check the `decimalPlaces*` options and output the relevant warnings if some of those will get overwritten during the initialization or settings update.
         *
         * @param {object} options
         * @private
         */

    }, {
        key: '_validateDecimalPlacesRawValue',
        value: function _validateDecimalPlacesRawValue(options) {
            // Checks if the number of decimal places for the raw value is lower than the `decimalPlaces`, `decimalPlacesShownOnFocus` and/or `decimalPlacesShownOnBlur` options
            if (!_AutoNumericHelper2.default.isNull(options.decimalPlacesRawValue)) {
                if (options.decimalPlacesRawValue < options.decimalPlaces) {
                    _AutoNumericHelper2.default.warning('The number of decimal places to store in the raw value [' + options.decimalPlacesRawValue + '] is lower than the ones to display [' + options.decimalPlaces + ']. This will likely confuse your users.\nTo solve that, you\'d need to either set `decimalPlacesRawValue` to `null`, or set a number of decimal places for the raw value equal of bigger than `decimalPlaces`.', options.showWarnings);
                }

                if (options.decimalPlacesRawValue < options.decimalPlacesShownOnFocus) {
                    _AutoNumericHelper2.default.warning('The number of decimal places to store in the raw value [' + options.decimalPlacesRawValue + '] is lower than the ones shown on focus [' + options.decimalPlacesShownOnFocus + ']. This will likely confuse your users.\nTo solve that, you\'d need to either set `decimalPlacesRawValue` to `null`, or set a number of decimal places for the raw value equal of bigger than `decimalPlacesShownOnFocus`.', options.showWarnings);
                }

                if (options.decimalPlacesRawValue < options.decimalPlacesShownOnBlur) {
                    _AutoNumericHelper2.default.warning('The number of decimal places to store in the raw value [' + options.decimalPlacesRawValue + '] is lower than the ones shown when unfocused [' + options.decimalPlacesShownOnBlur + ']. This will likely confuse your users.\nTo solve that, you\'d need to either set `decimalPlacesRawValue` to `null`, or set a number of decimal places for the raw value equal of bigger than `decimalPlacesShownOnBlur`.', options.showWarnings);
                }
            }
        }

        /**
         * Return `true` if the settings/options are valid, `false` otherwise.
         *
         * @param {object} options
         * @returns {boolean}
         */

    }, {
        key: 'areSettingsValid',
        value: function areSettingsValid(options) {
            var isValid = true;
            try {
                this.validate(options, true);
            } catch (error) {
                isValid = false;
            }

            return isValid;
        }

        /**
         * Return the default autoNumeric settings.
         *
         * @returns {object}
         */

    }, {
        key: 'getDefaultConfig',
        value: function getDefaultConfig() {
            return AutoNumeric.defaultSettings;
        }

        /**
         * Return all the predefined language options in one object.
         * You can also access a specific language object directly by using `AutoNumeric.getPredefinedOptions().French` for instance.
         *
         * @returns {object}
         */

    }, {
        key: 'getPredefinedOptions',
        value: function getPredefinedOptions() {
            return AutoNumeric.predefinedOptions;
        }

        /**
         * Analyse the given array `options` and return a single 'merged' option objet.
         * `options` can be `null`, or an array of an option objects, or an array containing another array of option objects / strings (pre-defined option names)
         *
         * @param {null|Array<object|string|Array<string|object>>} options
         * @returns {null|object}
         * @private
         */

    }, {
        key: '_generateOptionsObjectFromOptionsArray',
        value: function _generateOptionsObjectFromOptionsArray(options) {
            var _this14 = this;

            var optionsResult = void 0;
            if (_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(options) || options.length === 0) {
                optionsResult = null;
            } else {
                optionsResult = {};
                if (options.length === 1 && Array.isArray(options[0])) {
                    options[0].forEach(function (optionObject) {
                        // Using `_getOptionObject()` allows using pre-defined names in the `options` array
                        _extends(optionsResult, _this14._getOptionObject(optionObject));
                    });
                } else if (options.length >= 1) {
                    options.forEach(function (optionObject) {
                        _extends(optionsResult, _this14._getOptionObject(optionObject));
                    });
                }
            }

            return optionsResult;
        }

        /**
         * Format the given number (or numeric string) with the given options. This returns the formatted value as a string.
         * This can also format the given DOM element value with the given options and returns the formatted value as a string.
         * Note : This function does *not* update that element value with the newly formatted value.
         * This basically allows to get the formatted value without first having to initialize an AutoNumeric object.
         *
         * @param {number|string|HTMLElement|HTMLInputElement} numericStringOrDomElement A number, or a string that represent a javascript number, or a DOM element
         * @param {object|null} options Multiple objects can be passed, the latter overwriting the settings from the former ones
         * @returns {string|null}
         */

    }, {
        key: 'format',
        value: function format(numericStringOrDomElement) {
            if (_AutoNumericHelper2.default.isUndefined(numericStringOrDomElement) || numericStringOrDomElement === null) {
                return null;
            }

            // Retrieve the value to format
            var value = void 0;
            if (_AutoNumericHelper2.default.isElement(numericStringOrDomElement)) {
                value = _AutoNumericHelper2.default.getElementValue(numericStringOrDomElement);
            } else {
                value = numericStringOrDomElement;
            }

            if (!_AutoNumericHelper2.default.isString(value) && !_AutoNumericHelper2.default.isNumber(value)) {
                _AutoNumericHelper2.default.throwError('The value "' + value + '" being "set" is not numeric and therefore cannot be used appropriately.');
            }

            // Manage options

            for (var _len5 = arguments.length, options = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
                options[_key5 - 1] = arguments[_key5];
            }

            var optionsToUse = this._generateOptionsObjectFromOptionsArray(options);

            // Initiate a very basic settings object
            var settings = _extends({}, this.getDefaultConfig(), optionsToUse);
            settings.isNegativeSignAllowed = value < 0;
            settings.isPositiveSignAllowed = value >= 0;
            this._setBrackets(settings);

            var regex = {};
            this._cachesUsualRegularExpressions(settings, regex); // This is needed by `_stripAllNonNumberCharactersExceptCustomDecimalChar` that uses those regex

            // Check the validity of the `value` parameter
            // Convert the value to a numeric string, stripping unnecessary characters in the process
            var valueString = this._toNumericValue(value, settings);
            if (isNaN(Number(valueString))) {
                _AutoNumericHelper2.default.throwError('The value [' + valueString + '] that you are trying to format is not a recognized number.');
            }

            // Basic tests to check if the given valueString is valid

            var _checkIfInRangeWithOv3 = this._checkIfInRangeWithOverrideOption(valueString, settings),
                _checkIfInRangeWithOv4 = _slicedToArray(_checkIfInRangeWithOv3, 2),
                minTest = _checkIfInRangeWithOv4[0],
                maxTest = _checkIfInRangeWithOv4[1];

            if (!minTest || !maxTest) {
                // Throw a custom event
                _AutoNumericHelper2.default.triggerEvent(AutoNumeric.events.formatted, document, {
                    oldValue: null,
                    newValue: null,
                    oldRawValue: null,
                    newRawValue: null,
                    isPristine: null,
                    error: 'Range test failed',
                    aNElement: null
                }, true, true);
                _AutoNumericHelper2.default.throwError('The value [' + valueString + '] being set falls outside of the minimumValue [' + settings.minimumValue + '] and maximumValue [' + settings.maximumValue + '] range set for this element');
            }

            // Directly format any `valuesToStrings` values, if found
            if (settings.valuesToStrings && this._checkValuesToStringsSettings(value, settings)) {
                return settings.valuesToStrings[value];
            }

            // Generate the `negativePositiveSignPlacement` option as needed
            this._correctNegativePositiveSignPlacementOption(settings);
            // Calculate the needed decimal places
            this._calculateDecimalPlacesOnInit(settings);

            // Multiply the raw value with `rawValueDivisor` if defined
            if (!_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(settings.rawValueDivisor) && settings.rawValueDivisor !== 0 && // Only divide if the `rawValueDivisor` option is set
            valueString !== '' && valueString !== null) {
                // Do not modify the `valueString` if it's an empty string or null
                valueString *= settings.rawValueDivisor;
            }

            // Everything is ok, proceed to rounding, formatting and grouping
            valueString = this._roundFormattedValueShownOnFocus(valueString, settings);
            valueString = this._modifyNegativeSignAndDecimalCharacterForFormattedValue(valueString, settings);
            valueString = this._addGroupSeparators(valueString, settings, false, valueString);

            return valueString;
        }

        /**
         * Format the given DOM element value, and set the resulting value back as the element value.
         *
         * @param {HTMLElement|HTMLInputElement} domElement
         * @param {object} options
         * @returns {string|null}
         */

    }, {
        key: 'formatAndSet',
        value: function formatAndSet(domElement) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            //FIXME test this
            var formattedValue = this.format(domElement, options);
            _AutoNumericHelper2.default.setElementValue(domElement, formattedValue);

            return formattedValue;
        }

        /**
         * Unformat the given formatted string with the given options. This returns a numeric string.
         * It can also unformat the given DOM element value with the given options and returns the unformatted numeric string.
         * Note: This does *not* update that element value.
         * This basically allows to get the unformatted value without first having to initialize an AutoNumeric object.
         *
         * @param {string|number|HTMLElement|HTMLInputElement} numericStringOrDomElement A number, or a string that represent a javascript number, or a DOM element
         * @param {object|null} options Multiple objects can be passed, the latter overwriting the settings from the former ones
         * @returns {string|number|NaN}
         */

    }, {
        key: 'unformat',
        value: function unformat(numericStringOrDomElement) {
            if (_AutoNumericHelper2.default.isNumberStrict(numericStringOrDomElement)) {
                // Giving an unformatted value should return the same unformatted value, whatever the options passed as a parameter
                return numericStringOrDomElement;
            }

            // Retrieve the value to unformat
            var value = void 0;
            if (_AutoNumericHelper2.default.isElement(numericStringOrDomElement)) {
                value = _AutoNumericHelper2.default.getElementValue(numericStringOrDomElement);
            } else {
                value = numericStringOrDomElement;
            }

            if (value === '') {
                // This allows to be coherent when serializing forms with empty inputs. Fix issue #512.
                return '';
            }

            if (_AutoNumericHelper2.default.isUndefined(value) || value === null) {
                return null;
            }

            if (_AutoNumericHelper2.default.isArray(value) || _AutoNumericHelper2.default.isObject(value)) {
                // Check the validity of the `value` parameter
                _AutoNumericHelper2.default.throwError('A number or a string representing a number is needed to be able to unformat it, [' + value + '] given.');
            }

            // Manage options

            for (var _len6 = arguments.length, options = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
                options[_key6 - 1] = arguments[_key6];
            }

            var optionsToUse = this._generateOptionsObjectFromOptionsArray(options);

            // Generate the settings
            var settings = _extends({}, this.getDefaultConfig(), optionsToUse);
            settings.isNegativeSignAllowed = false;
            settings.isPositiveSignAllowed = true;
            value = value.toString();

            // Directly unformat any `valuesToStrings` values, if found
            if (settings.valuesToStrings && this._checkStringsToValuesSettings(value, settings)) {
                return _AutoNumericHelper2.default.objectKeyLookup(settings.valuesToStrings, value);
            }

            // This checks if a negative sign is anywhere in the `value`, not just on the very first character (ie. '12345.67-')
            if (_AutoNumericHelper2.default.isNegative(value, settings.negativeSignCharacter)) {
                settings.isNegativeSignAllowed = true;
                settings.isPositiveSignAllowed = false;
            } else if (!_AutoNumericHelper2.default.isNull(settings.negativeBracketsTypeOnBlur)) {
                var _settings$negativeBra = settings.negativeBracketsTypeOnBlur.split(',');

                var _settings$negativeBra2 = _slicedToArray(_settings$negativeBra, 2);

                settings.firstBracket = _settings$negativeBra2[0];
                settings.lastBracket = _settings$negativeBra2[1];

                if (value.charAt(0) === settings.firstBracket && value.charAt(value.length - 1) === settings.lastBracket) {
                    settings.isNegativeSignAllowed = true;
                    settings.isPositiveSignAllowed = false;
                    value = this._removeBrackets(value, settings, false);
                }
            }

            value = this._convertToNumericString(value, settings);
            var unwantedCharacters = new RegExp('[^+-0123456789.]', 'gi');
            if (unwantedCharacters.test(value)) {
                return NaN;
            }

            // Generate the `negativePositiveSignPlacement` option as needed
            this._correctNegativePositiveSignPlacementOption(settings);
            // Calculate the needed decimal places
            if (settings.decimalPlacesRawValue) {
                // `originalDecimalPlacesRawValue` needs to be defined
                settings.originalDecimalPlacesRawValue = settings.decimalPlacesRawValue;
            } else {
                settings.originalDecimalPlacesRawValue = settings.decimalPlaces;
            }

            this._calculateDecimalPlacesOnInit(settings);

            // Divide the raw value with `rawValueDivisor` if defined
            if (!_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(settings.rawValueDivisor) && settings.rawValueDivisor !== 0 && // Only divide if the `rawValueDivisor` option is set
            value !== '' && value !== null) {
                // Do not modify the `value` if it's an empty string or null
                value /= settings.rawValueDivisor;
            }

            value = this._roundRawValue(value, settings);
            value = value.replace(settings.decimalCharacter, '.'); // Here we need to convert back the decimal character to a period since `_roundValue` adds it in some cases
            value = this._toLocale(value, settings.outputFormat, settings);

            return value;
        }

        /**
         * Unformat the given DOM element value, and set the resulting value back as the element value.
         *
         * @param {HTMLElement|HTMLInputElement} domElement
         * @param {object} options
         * @returns {*}
         */

    }, {
        key: 'unformatAndSet',
        value: function unformatAndSet(domElement) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            //FIXME test this
            var unformattedValue = this.unformat(domElement, options);
            _AutoNumericHelper2.default.setElementValue(domElement, unformattedValue);

            return unformattedValue;
        }

        /**
         * Unformat and localize the given formatted string with the given options. This returns a numeric string.
         * It can also unformat and localize the given DOM element value with the given options and returns the unformatted numeric string.
         * Note: This does *not* update that element value.
         * This basically allows to get the localized value without first having to initialize an AutoNumeric object.
         *
         * @param {string|number|HTMLElement|HTMLInputElement} numericStringOrDomElement
         * @param {object} settings
         * @returns {*}
         */

    }, {
        key: 'localize',
        value: function localize(numericStringOrDomElement) {
            var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var value = void 0;
            if (_AutoNumericHelper2.default.isElement(numericStringOrDomElement)) {
                value = _AutoNumericHelper2.default.getElementValue(numericStringOrDomElement);
            } else {
                value = numericStringOrDomElement;
            }

            if (value === '') {
                // This allows to be coherent when serializing forms with empty inputs. Fix issue #512.
                return '';
            }

            if (_AutoNumericHelper2.default.isNull(settings)) {
                settings = AutoNumeric.defaultSettings;
            }

            value = this.unformat(value, settings);

            //XXX The following code is pretty close to the one you can find in `getLocalized()`, but different enough so we won't refactor it.
            if (Number(value) === 0 && settings.leadingZero !== AutoNumeric.options.leadingZero.keep) {
                value = '0';
            }

            var outputFormatToUse = void 0;
            if (_AutoNumericHelper2.default.isNull(settings)) {
                outputFormatToUse = settings.outputFormat;
            } else {
                outputFormatToUse = AutoNumeric.defaultSettings.outputFormat;
            }

            return this._toLocale(value, outputFormatToUse, settings);
        }
    }, {
        key: 'localizeAndSet',
        value: function localizeAndSet(domElement) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            //FIXME test this
            var localizedValue = this.localize(domElement, options);
            _AutoNumericHelper2.default.setElementValue(domElement, localizedValue);

            return localizedValue;
        }

        /**
         * Return `true` if the given DOM element has an AutoNumeric object that manages it.
         * This function also accepts a selector string.
         *
         * @param {HTMLElement|string} domElementOrSelector Accepts either directly a DOM element to test, or a string selector (that will return one and only one element, if any)
         * @returns {boolean}
         */

    }, {
        key: 'isManagedByAutoNumeric',
        value: function isManagedByAutoNumeric(domElementOrSelector) {
            //FIXME test this
            return this._isInGlobalList(_AutoNumericHelper2.default.domElement(domElementOrSelector));
        }

        /**
         * Return the AutoNumeric object that manages the given DOM element.
         * This function also accepts a selector string.
         *
         * @param {HTMLElement|string} domElementOrSelector Accepts either directly a DOM element to test, or a string selector (that will return one and only one element, if any)
         * @returns {null|AutoNumeric}
         */

    }, {
        key: 'getAutoNumericElement',
        value: function getAutoNumericElement(domElementOrSelector) {
            var domElement = _AutoNumericHelper2.default.domElement(domElementOrSelector);

            if (!this.isManagedByAutoNumeric(domElement)) {
                return null;
            }

            return this._getFromGlobalList(domElement);
        }

        /**
         * Set the given element value, and format it immediately.
         * Return `null` if no AutoNumeric object is found, else, return the AutoNumeric object.
         *
         * @param {HTMLElement|string} domElementOrSelector Either a DOM element reference, or a selector string can be used
         * @param {number|string|null} newValue The value must be a Number, a numeric string or `null` (if `emptyInputBehavior` is set to `'null'`)
         * @param {object} options A settings object that will override the current settings. Note: the update is done only if the `newValue` is defined.
         * @param {boolean} saveChangeToHistory If set to `true`, then the change is recorded in the history table
         * @returns {AutoNumeric|null}
         */

    }, {
        key: 'set',
        value: function set(domElementOrSelector, newValue) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var saveChangeToHistory = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

            var domElement = _AutoNumericHelper2.default.domElement(domElementOrSelector);

            if (!this.isManagedByAutoNumeric(domElement)) {
                var showWarnings = void 0;
                if (!_AutoNumericHelper2.default.isNull(options) && options.hasOwnProperty('showWarnings')) {
                    showWarnings = options.showWarnings;
                } else {
                    showWarnings = true;
                }

                _AutoNumericHelper2.default.warning('Impossible to find an AutoNumeric object for the given DOM element or selector.', showWarnings);

                return null;
            }

            return this.getAutoNumericElement(domElement).set(newValue, options, saveChangeToHistory);
        }

        /**
         * Return the unformatted value as a string from the given DOM element or query selector.
         * This can also return `null` if `rawValue` is null.
         *
         * @param {HTMLElement|string} domElementOrSelector
         * @param {function|null} callback
         * @returns {string|null}
         */

    }, {
        key: 'getNumericString',
        value: function getNumericString(domElementOrSelector) {
            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return this._get(domElementOrSelector, 'getNumericString', callback);
        }

        /**
         * Return the current formatted value of the AutoNumeric element as a string, from the given DOM element or query selector.
         *
         * @param {HTMLElement|string} domElementOrSelector
         * @param {function|null} callback
         * @returns {string}
         */

    }, {
        key: 'getFormatted',
        value: function getFormatted(domElementOrSelector) {
            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return this._get(domElementOrSelector, 'getFormatted', callback);
        }

        /**
         * Return the element unformatted value as a real Javascript number, from the given DOM element or query selector.
         * Warning: This can lead to precision problems with big numbers that should be stored as strings.
         *
         * @param {HTMLElement|string} domElementOrSelector
         * @param {function|null} callback
         * @returns {number|null}
         */

    }, {
        key: 'getNumber',
        value: function getNumber(domElementOrSelector) {
            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return this._get(domElementOrSelector, 'getNumber', callback);
        }

        /**
         * DRY the code between the static `get*` functions
         *
         * @param {HTMLElement|string} domElementOrSelector
         * @param {string} getFunction The name of the non-static `get*` function as a string
         * @param {function|null} callback
         * @returns {*}
         * @private
         */

    }, {
        key: '_get',
        value: function _get(domElementOrSelector, getFunction) {
            var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            var domElement = _AutoNumericHelper2.default.domElement(domElementOrSelector);

            if (!this.isManagedByAutoNumeric(domElement)) {
                _AutoNumericHelper2.default.throwError('Impossible to find an AutoNumeric object for the given DOM element or selector.');
            }

            return this.getAutoNumericElement(domElement)[getFunction](callback);
        }

        /**
         * Returns the unformatted value following the `outputFormat` setting, from the given DOM element or query selector.
         * See the non-static `getLocalized()` method documentation for more details.
         *
         * @param {HTMLElement|string} domElementOrSelector
         * @param {null|string|function} forcedOutputFormat
         * @param {function|null} callback
         * @returns {*}
         */

    }, {
        key: 'getLocalized',
        value: function getLocalized(domElementOrSelector) {
            var forcedOutputFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            var domElement = _AutoNumericHelper2.default.domElement(domElementOrSelector);

            if (!this.isManagedByAutoNumeric(domElement)) {
                _AutoNumericHelper2.default.throwError('Impossible to find an AutoNumeric object for the given DOM element or selector.');
            }

            return this.getAutoNumericElement(domElement).getLocalized(forcedOutputFormat, callback);
        }
    }, {
        key: '_stripAllNonNumberCharacters',
        value: function _stripAllNonNumberCharacters(s, settings, stripZeros, isFocused) {
            return this._stripAllNonNumberCharactersExceptCustomDecimalChar(s, settings, stripZeros, isFocused).replace(settings.decimalCharacter, '.');
        }

        /**
         * Strip all unwanted non-number characters except the custom decimal character.
         *
         * It converts the custom negative sign and removes the positive sign (custom or not).
         * This keeps :
         * - the numbers,
         * - the normal negative sign '-' if any,
         * - and the *custom* decimal character.
         *
         * @param {string} s
         * @param {object} settings
         * @param {boolean} stripZeros If set to `false`, then the leading zero(s) are not stripped, otherwise if set to `true`, the `leadingZero` option is followed
         * @param {boolean} isFocused If the element is focused, then this is `true`
         * @returns {string|*}
         */

    }, {
        key: '_stripAllNonNumberCharactersExceptCustomDecimalChar',
        value: function _stripAllNonNumberCharactersExceptCustomDecimalChar(s, settings, stripZeros, isFocused) {
            //XXX Note; this function is static since we need to pass a `settings` object when calling the static `AutoNumeric.format()` method
            //TODO This function is called 10 times (sic!) on each key input, couldn't we lower that number? cf. issue #325
            s = this._normalizeCurrencySuffixAndNegativeSignCharacters(s, settings);

            // Then remove all the characters that are not numbers, the normal negative sign '-', or the custom decimal character (note: this also remove any custom positive sign)
            s = s.replace(settings.allowedAutoStrip, '');

            // Get only number string
            var m = s.match(settings.numRegAutoStrip);
            s = m ? [m[1], m[2], m[3]].join('') : '';

            if (settings.leadingZero === AutoNumeric.options.leadingZero.allow || settings.leadingZero === AutoNumeric.options.leadingZero.keep) {
                var negativeSign = '';

                var _s$split = s.split(settings.decimalCharacter),
                    _s$split2 = _slicedToArray(_s$split, 2),
                    integerPart = _s$split2[0],
                    decimalPart = _s$split2[1];

                var modifiedIntegerPart = integerPart;
                if (_AutoNumericHelper2.default.contains(modifiedIntegerPart, settings.negativeSignCharacter)) {
                    negativeSign = settings.negativeSignCharacter;
                    modifiedIntegerPart = modifiedIntegerPart.replace(settings.negativeSignCharacter, '');
                }

                // Strip leading zero on positive value if needed
                if (negativeSign === '' && modifiedIntegerPart.length > settings.mIntPos && modifiedIntegerPart.charAt(0) === '0') {
                    modifiedIntegerPart = modifiedIntegerPart.slice(1);
                }

                // Strip leading zero on negative value if needed
                if (negativeSign !== '' && modifiedIntegerPart.length > settings.mIntNeg && modifiedIntegerPart.charAt(0) === '0') {
                    modifiedIntegerPart = modifiedIntegerPart.slice(1);
                }

                s = '' + negativeSign + modifiedIntegerPart + (_AutoNumericHelper2.default.isUndefined(decimalPart) ? '' : settings.decimalCharacter + decimalPart);
            }

            if (stripZeros && settings.leadingZero === AutoNumeric.options.leadingZero.deny || !isFocused && settings.leadingZero === AutoNumeric.options.leadingZero.allow) {
                s = s.replace(settings.stripReg, '$1$2');
            }

            return s;
        }

        /**
         * Sets or removes brackets on negative values, depending on the focus state, which is passed as `isFocused`.
         * The focus state is 'stored' in that object property.
         *
         * @param {string} value
         * @param {object} settings
         * @param {boolean} isFocused
         * @returns {*}
         */

    }, {
        key: '_toggleNegativeBracket',
        value: function _toggleNegativeBracket(value, settings, isFocused) {
            //XXX Note; this function is static since we need to pass a `settings` object when calling the static `AutoNumeric.format()` method
            var result = void 0;
            if (isFocused) {
                result = this._removeBrackets(value, settings);
            } else {
                result = this._addBrackets(value, settings);
            }

            return result;
        }

        /**
         * Add the bracket types specified in the `settings` object, to the given string `value`.
         *
         * @param {string} value
         * @param {object} settings
         * @returns {string}
         * @private
         */

    }, {
        key: '_addBrackets',
        value: function _addBrackets(value, settings) {
            if (_AutoNumericHelper2.default.isNull(settings.negativeBracketsTypeOnBlur)) {
                return value;
            }

            return '' + settings.firstBracket + value.replace(settings.negativeSignCharacter, '') + settings.lastBracket;
        }

        /**
         * Remove the bracket types specified in the `settings` object, from the given string `value`.
         *
         * @param {string} value
         * @param {object} settings
         * @param {boolean} rearrangeSignsAndValueOrder If set to `true`, then only the brackets are remove and a negative sign is added, without reordering the negative sign, currency symbol and value according to the settings.
         * @returns {string}
         * @private
         */

    }, {
        key: '_removeBrackets',
        value: function _removeBrackets(value, settings) {
            var rearrangeSignsAndValueOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            var result = void 0;
            if (!_AutoNumericHelper2.default.isNull(settings.negativeBracketsTypeOnBlur) && value.charAt(0) === settings.firstBracket) {
                // Remove the brackets if they are present
                result = value.replace(settings.firstBracket, '');
                result = result.replace(settings.lastBracket, '');

                // Add back the negative sign at the right place
                if (rearrangeSignsAndValueOrder) {
                    // First we need to remove the currency symbol from the value, since we want to be able to add back the negative sign at the right place (including between the value and the currency sign)
                    result = result.replace(settings.currencySymbol, '');
                    result = this._mergeCurrencySignNegativePositiveSignAndValue(result, settings, true, false); //TODO This assume the value is negative and non-empty. Is this always the case?
                } else {
                    // Here we only want to add the negative sign since we removed the brackets, without reordering
                    result = '' + settings.negativeSignCharacter + result;
                }
            } else {
                result = value;
            }

            return result;
        }

        /**
         * Analyze the `negativeBracketsTypeOnBlur` options and keep track of the first and last bracket characters to use.
         *
         * @param {object} settings
         * @private
         */

    }, {
        key: '_setBrackets',
        value: function _setBrackets(settings) {
            if (_AutoNumericHelper2.default.isNull(settings.negativeBracketsTypeOnBlur)) {
                settings.firstBracket = '';
                settings.lastBracket = '';
            } else {
                // Use temporary variables to fix the MS Edge destructuring issue (see pull request #564)
                var _settings$negativeBra3 = settings.negativeBracketsTypeOnBlur.split(','),
                    _settings$negativeBra4 = _slicedToArray(_settings$negativeBra3, 2),
                    firstBracket = _settings$negativeBra4[0],
                    lastBracket = _settings$negativeBra4[1];

                settings.firstBracket = firstBracket;
                settings.lastBracket = lastBracket;
            }
        }

        /**
         * Return a number as a numeric string that can be typecast to a Number that Javascript will understand.
         *
         * This function returns the given string by stripping:
         * - the currency sign (currencySymbol),
         * - the grouping separators (digitalGroupSpacing),
         * - the suffix text (suffixText),
         * - the positive sign (positiveSignCharacter),
         * - the brackets if any,
         * - by replacing the negative sign character with an hyphen,
         * - and by replacing the decimal character (decimalCharacter) by a dot.
         *
         * Lastly, it also put the negative sign back to its normal position if needed.
         * Bonus; it converts any arabic numbers found to the latin ones.
         *
         * @param {string} s
         * @param {object} settings
         * @returns {string|void|*}
         */

    }, {
        key: '_convertToNumericString',
        value: function _convertToNumericString(s, settings) {
            // Remove the custom brackets
            s = this._removeBrackets(s, settings, false);
            s = this._normalizeCurrencySuffixAndNegativeSignCharacters(s, settings);

            // Remove the grouping separators (thousands separators usually)
            s = s.replace(new RegExp('[' + settings.digitGroupSeparator + ']', 'g'), '');

            // Replace the decimal character by a dot
            if (settings.decimalCharacter !== '.') {
                s = s.replace(settings.decimalCharacter, '.');
            }

            // Move the trailing negative sign, if any, to the usual leftmost position
            if (_AutoNumericHelper2.default.isNegative(s) && s.lastIndexOf('-') === s.length - 1) {
                s = s.replace('-', '');
                s = '-' + s;
            }

            // Replace the custom positive sign
            if (settings.showPositiveSign) {
                s = s.replace(settings.positiveSignCharacter, '');
            }

            // Convert arabic numbers to latin ones, if any
            var convertToNumber = settings.leadingZero !== AutoNumeric.options.leadingZero.keep;
            var temp = _AutoNumericHelper2.default.arabicToLatinNumbers(s, convertToNumber, false, false);
            if (!isNaN(temp)) {
                s = temp.toString();
            }

            return s;
        }

        /**
         * Removes the currency symbol and the suffix text from the given string, and replace the custom negative sign with an hyphen.
         *
         * @param {string} s
         * @param {object} settings
         * @returns {string | *}
         * @private
         */

    }, {
        key: '_normalizeCurrencySuffixAndNegativeSignCharacters',
        value: function _normalizeCurrencySuffixAndNegativeSignCharacters(s, settings) {
            s = String(s); // Typecast to to a string, in case that the given value is a number

            // Remove the currency symbol
            if (settings.currencySymbol !== AutoNumeric.options.currencySymbol.none) {
                s = s.replace(settings.currencySymbol, '');
            }

            // Remove the suffixText
            if (settings.suffixText !== AutoNumeric.options.suffixText.none) {
                s = s.replace(settings.suffixText, '');
            }

            // Replace the custom negative sign with an hyphen
            if (settings.negativeSignCharacter !== AutoNumeric.options.negativeSignCharacter.hyphen) {
                s = s.replace(settings.negativeSignCharacter, '-');
            }

            return s;
        }

        /**
         * Converts the ISO numeric string to the locale decimal and minus sign placement.
         * See the "outputFormat" option definition for more details.
         * Note: If the `outputFormat` is set to a number, the custom `negativeSignCharacter` is ignored.
         *
         * @param {string|null} value The unformatted value
         * @param {string|null} locale
         * @param {object} settings
         * @returns {*}
         */

    }, {
        key: '_toLocale',
        value: function _toLocale(value, locale, settings) {
            if (_AutoNumericHelper2.default.isNull(locale) || locale === AutoNumeric.options.outputFormat.string) {
                return value;
            }

            var result = void 0;
            switch (locale) {
                case AutoNumeric.options.outputFormat.number:
                    result = Number(value);
                    break;
                case AutoNumeric.options.outputFormat.dotNegative:
                    result = _AutoNumericHelper2.default.isNegative(value) ? value.replace('-', '') + '-' : value;
                    break;
                case AutoNumeric.options.outputFormat.comma:
                case AutoNumeric.options.outputFormat.negativeComma:
                    result = value.replace('.', ',');
                    break;
                case AutoNumeric.options.outputFormat.commaNegative:
                    result = value.replace('.', ',');
                    result = _AutoNumericHelper2.default.isNegative(result) ? result.replace('-', '') + '-' : result;
                    break;
                // The default case
                case AutoNumeric.options.outputFormat.dot:
                case AutoNumeric.options.outputFormat.negativeDot:
                    result = value;
                    break;
                default:
                    _AutoNumericHelper2.default.throwError('The given outputFormat [' + locale + '] option is not recognized.');
            }

            if (locale !== AutoNumeric.options.outputFormat.number && settings.negativeSignCharacter !== '-') {
                // Modify the default minus sign with the custom one, if any
                result = result.replace('-', settings.negativeSignCharacter);
            }

            return result;
        }
    }, {
        key: '_modifyNegativeSignAndDecimalCharacterForFormattedValue',
        value: function _modifyNegativeSignAndDecimalCharacterForFormattedValue(s, settings) {
            //XXX Note; this function is static since we need to pass a `settings` object when calling the static `AutoNumeric.format()` method
            if (settings.negativeSignCharacter !== '-') {
                s = s.replace('-', settings.negativeSignCharacter);
            }

            if (settings.decimalCharacter !== '.') {
                s = s.replace('.', settings.decimalCharacter);
            }

            return s;
        }

        /**
         * Return `true` if the given value is empty or is equal to the negative sign character defined in the given settings.
         *
         * @param {string} value
         * @param {object} settings
         * @returns {boolean}
         * @private
         */

    }, {
        key: '_isElementValueEmptyOrOnlyTheNegativeSign',
        value: function _isElementValueEmptyOrOnlyTheNegativeSign(value, settings) {
            return value === '' || value === settings.negativeSignCharacter;
        }

        /**
         * Return the value with the currency symbol and the suffix text ordered according to the given settings.
         *
         * @param {string} value
         * @param {object} settings
         * @param {boolean} signOnEmpty
         * @returns {*}
         * @private
         */

    }, {
        key: '_orderValueCurrencySymbolAndSuffixText',
        value: function _orderValueCurrencySymbolAndSuffixText(value, settings, signOnEmpty) {
            var result = void 0;
            if (settings.emptyInputBehavior === AutoNumeric.options.emptyInputBehavior.always || signOnEmpty) {
                switch (settings.negativePositiveSignPlacement) {
                    case AutoNumeric.options.negativePositiveSignPlacement.left:
                    case AutoNumeric.options.negativePositiveSignPlacement.prefix:
                    case AutoNumeric.options.negativePositiveSignPlacement.none:
                        result = value + settings.currencySymbol + settings.suffixText;
                        break;
                    default:
                        result = settings.currencySymbol + value + settings.suffixText;
                }
            } else {
                result = value;
            }

            return result;
        }

        /**
         * Modify the input value by adding the group separators, as defined in the settings, and the negative brackets if needed.
         *
         * @param {string} inputValue The formatted value (ie. with the `decimalCharacter` defined in the settings, not the raw value)
         * @param {object} settings
         * @param {boolean} isFocused
         * @param {number|string|null} currentRawValue The object current raw value (`this.rawValue`)
         * @param {number|string|null} forcedRawValue If this is set, then this rawValue is used instead of the one passed through the `settings` object. This is useful is some very specific cases where we need to set the raw value *after* settings the formatted value, using the `_addGroupSeparators()` method.
         * @returns {*}
         */

    }, {
        key: '_addGroupSeparators',
        value: function _addGroupSeparators(inputValue, settings, isFocused, currentRawValue) {
            var forcedRawValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

            //TODO Test if `inputValue` === '', and return '' directly if that's the case,
            //XXX Note; this function is static since we need to pass a `settings` object when calling the static `AutoNumeric.format()` method
            var isValueNegative = void 0;
            if (!_AutoNumericHelper2.default.isNull(forcedRawValue)) {
                // Prefer directly testing if the raw value is negative in order for the test to be more performant than manipulating the formatted value
                isValueNegative = forcedRawValue < 0;
            } else {
                isValueNegative = _AutoNumericHelper2.default.isNegative(inputValue, settings.negativeSignCharacter) || _AutoNumericHelper2.default.isNegativeWithBrackets(inputValue, settings.firstBracket, settings.lastBracket); // Test if the value is negative before removing the negative sign
            }

            inputValue = this._stripAllNonNumberCharactersExceptCustomDecimalChar(inputValue, settings, false, isFocused);

            if (this._isElementValueEmptyOrOnlyTheNegativeSign(inputValue, settings)) {
                return this._orderValueCurrencySymbolAndSuffixText(inputValue, settings, true);
            }

            var isZeroOrHasNoValue = _AutoNumericHelper2.default.isZeroOrHasNoValue(inputValue);

            // Temporarily remove the negative sign if present
            if (isValueNegative) {
                inputValue = inputValue.replace('-', ''); // At this point the `inputValue` has been normalized with a 'normal' negative sign `'-'` //TODO Check that comment validity, since `_stripAllNonNumberCharactersExceptCustomDecimalChar` *does not* convert the negative sign
            }

            settings.digitalGroupSpacing = settings.digitalGroupSpacing.toString();
            var digitalGroup = void 0;
            switch (settings.digitalGroupSpacing) {
                case AutoNumeric.options.digitalGroupSpacing.two:
                    digitalGroup = /(\d)((\d)(\d{2}?)+)$/;
                    break;
                case AutoNumeric.options.digitalGroupSpacing.twoScaled:
                    digitalGroup = /(\d)((?:\d{2}){0,2}\d{3}(?:(?:\d{2}){2}\d{3})*?)$/;
                    break;
                case AutoNumeric.options.digitalGroupSpacing.four:
                    digitalGroup = /(\d)((\d{4}?)+)$/;
                    break;
                case AutoNumeric.options.digitalGroupSpacing.three:
                default:
                    digitalGroup = /(\d)((\d{3}?)+)$/;
            }

            // Splits the string at the decimal string

            var _inputValue$split = inputValue.split(settings.decimalCharacter),
                _inputValue$split2 = _slicedToArray(_inputValue$split, 2),
                integerPart = _inputValue$split2[0],
                decimalPart = _inputValue$split2[1];

            if (settings.decimalCharacterAlternative && _AutoNumericHelper2.default.isUndefined(decimalPart)) {
                var _inputValue$split3 = inputValue.split(settings.decimalCharacterAlternative);

                var _inputValue$split4 = _slicedToArray(_inputValue$split3, 2);

                integerPart = _inputValue$split4[0];
                decimalPart = _inputValue$split4[1];
            }

            if (settings.digitGroupSeparator !== '') {
                // Re-inserts the thousand separator via a regular expression
                while (digitalGroup.test(integerPart)) {
                    integerPart = integerPart.replace(digitalGroup, '$1' + settings.digitGroupSeparator + '$2');
                }
            }

            // Find out how many decimal places should be kept, depending on the object state (isFocused)
            var decimalPlacesToRoundTo = void 0;
            if (isFocused) {
                decimalPlacesToRoundTo = settings.decimalPlacesShownOnFocus;
            } else {
                decimalPlacesToRoundTo = settings.decimalPlacesShownOnBlur;
            }

            if (decimalPlacesToRoundTo !== 0 && !_AutoNumericHelper2.default.isUndefined(decimalPart)) {
                if (decimalPart.length > decimalPlacesToRoundTo) {
                    // Trim the excessive number of decimal places
                    decimalPart = decimalPart.substring(0, decimalPlacesToRoundTo);
                }

                // Joins the whole number with the decimal value
                inputValue = '' + integerPart + settings.decimalCharacter + decimalPart;
            } else {
                // Otherwise if it's an integer
                inputValue = integerPart;
            }

            // Add back the negative/positive sign and the currency symbol, at the right positions
            inputValue = AutoNumeric._mergeCurrencySignNegativePositiveSignAndValue(inputValue, settings, isValueNegative, isZeroOrHasNoValue); //TODO this function is called again in `_toggleNegativeBracket` if the brackets are removed; let's DRY this

            if (_AutoNumericHelper2.default.isNull(forcedRawValue)) {
                // If the raw value is not forced, use the default one from the settings object
                forcedRawValue = currentRawValue;
            }

            // Toggle the negative sign and brackets
            if (settings.negativeBracketsTypeOnBlur !== null && (forcedRawValue < 0 || _AutoNumericHelper2.default.isNegativeStrict(inputValue, settings.negativeSignCharacter))) {
                inputValue = this._toggleNegativeBracket(inputValue, settings, isFocused);
            }

            var result = void 0;
            if (settings.suffixText) {
                result = '' + inputValue + settings.suffixText;
            } else {
                result = inputValue;
            }

            return result;
        }

        /**
         * Return a semi-formatted string where the input value, the negative or positive sign, and the currency symbol are stitched together at the right positions, using the options set in the `settings` object.
         * Note : the `inputValue` is usually not a numeric string since the grouping symbols are already added to it at this point.
         *
         * @param {string} inputValue
         * @param {object} settings
         * @param {boolean} isValueNegative
         * @param {boolean} isZeroOrHasNoValue
         * @returns {*}
         * @throws
         * @private
         */

    }, {
        key: '_mergeCurrencySignNegativePositiveSignAndValue',
        value: function _mergeCurrencySignNegativePositiveSignAndValue(inputValue, settings, isValueNegative, isZeroOrHasNoValue) {
            var signToUse = '';
            if (isValueNegative) {
                signToUse = settings.negativeSignCharacter;
            } else if (settings.showPositiveSign && !isZeroOrHasNoValue) {
                signToUse = settings.positiveSignCharacter;
            }

            var result = void 0;
            if (settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.prefix) {
                if (settings.negativePositiveSignPlacement !== AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && settings.showPositiveSign && !isZeroOrHasNoValue)) {
                    switch (settings.negativePositiveSignPlacement) {
                        case AutoNumeric.options.negativePositiveSignPlacement.prefix:
                        case AutoNumeric.options.negativePositiveSignPlacement.left:
                            result = '' + signToUse + settings.currencySymbol + inputValue;
                            break;
                        case AutoNumeric.options.negativePositiveSignPlacement.right:
                            result = '' + settings.currencySymbol + signToUse + inputValue;
                            break;
                        case AutoNumeric.options.negativePositiveSignPlacement.suffix:
                            result = '' + settings.currencySymbol + inputValue + signToUse;
                            break;
                    }
                } else {
                    result = settings.currencySymbol + inputValue;
                }
            } else if (settings.currencySymbolPlacement === AutoNumeric.options.currencySymbolPlacement.suffix) {
                if (settings.negativePositiveSignPlacement !== AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && settings.showPositiveSign && !isZeroOrHasNoValue)) {
                    switch (settings.negativePositiveSignPlacement) {
                        case AutoNumeric.options.negativePositiveSignPlacement.suffix:
                        case AutoNumeric.options.negativePositiveSignPlacement.right:
                            result = '' + inputValue + settings.currencySymbol + signToUse;
                            break;
                        case AutoNumeric.options.negativePositiveSignPlacement.left:
                            result = '' + inputValue + signToUse + settings.currencySymbol;
                            break;
                        case AutoNumeric.options.negativePositiveSignPlacement.prefix:
                            result = '' + signToUse + inputValue + settings.currencySymbol;
                            break;
                    }
                } else {
                    result = inputValue + settings.currencySymbol;
                }
            }

            return result;
        }
    }, {
        key: '_truncateZeros',
        value: function _truncateZeros(roundedInputValue, decimalPlacesNeeded) {
            var regex = void 0;
            switch (decimalPlacesNeeded) {
                case 0:
                    // Prevents padding - removes trailing zeros until the first significant digit is encountered
                    regex = /(\.(?:\d*[1-9])?)0*$/;
                    break;
                case 1:
                    // Allows padding when decimalPlacesNeeded equals one - leaves one zero trailing the decimal character
                    regex = /(\.\d(?:\d*[1-9])?)0*$/;
                    break;
                default:
                    // Removes superfluous zeros after the decimalPlacesNeeded length
                    regex = new RegExp('(\\.\\d{' + decimalPlacesNeeded + '}(?:\\d*[1-9])?)0*');
            }

            // If there are no decimal places, we don't need a decimal point at the end
            roundedInputValue = roundedInputValue.replace(regex, '$1');
            if (decimalPlacesNeeded === 0) {
                roundedInputValue = roundedInputValue.replace(/\.$/, '');
            }

            return roundedInputValue;
        }

        /**
         * Round the given `value` with the number of decimal places to keep for the raw value.
         *
         * @param {string|null} value An unformatted numeric value
         * @param {object} settings
         * @returns {*}
         * @private
         */

    }, {
        key: '_roundRawValue',
        value: function _roundRawValue(value, settings) {
            return this._roundValue(value, settings, settings.decimalPlacesRawValue);
        }

        /**
         * Round the given `value` with the number of decimal places to show for the element if focused.
         *
         * @param {string|null} value An unformatted numeric value
         * @param {object} settings
         * @returns {*}
         * @private
         */

    }, {
        key: '_roundFormattedValueShownOnFocus',
        value: function _roundFormattedValueShownOnFocus(value, settings) {
            return this._roundValue(value, settings, Number(settings.decimalPlacesShownOnFocus));
        }

        /**
         * Round the given `value` with the number of decimal places to show for the element if unfocused.
         *
         * @param {string|null} value An unformatted numeric value
         * @param {object} settings
         * @returns {*}
         * @private
         */

    }, {
        key: '_roundFormattedValueShownOnBlur',
        value: function _roundFormattedValueShownOnBlur(value, settings) {
            return this._roundValue(value, settings, Number(settings.decimalPlacesShownOnBlur));
        }

        /**
         * Round the given `value` with the number of decimal places to show for the element based on the value of isFocused.
         *
         * @param {string|null} value An unformatted numeric value
         * @param {object} settings
         * @param {boolean} isFocused
         * @returns {*}
         * @private
         */

    }, {
        key: '_roundFormattedValueShownOnFocusOrBlur',
        value: function _roundFormattedValueShownOnFocusOrBlur(value, settings, isFocused) {
            if (isFocused) {
                return this._roundFormattedValueShownOnFocus(value, settings);
            } else {
                return this._roundFormattedValueShownOnBlur(value, settings);
            }
        }

        /**
         * Round the input value using the rounding method defined in the settings.
         * This function accepts multiple rounding methods. See the documentation for more details about those.
         *
         * Note : This is handled as text since JavaScript math functions can return inaccurate values.
         *
         * @param {string|null} inputValue An unformatted numeric value
         * @param {object} settings
         * @param {int} decimalPlacesToRoundTo
         * @returns {*}
         */

    }, {
        key: '_roundValue',
        value: function _roundValue(inputValue, settings, decimalPlacesToRoundTo) {
            //XXX Note; this function is static since we need to pass a `settings` object when calling the static `AutoNumeric.format()` method
            if (_AutoNumericHelper2.default.isNull(inputValue)) {
                // Prevent rounding a `null` value
                return inputValue;
            }

            //TODO Divide this function to make it easier to understand
            inputValue = inputValue === '' ? '0' : inputValue.toString();
            if (settings.roundingMethod === AutoNumeric.options.roundingMethod.toNearest05 || settings.roundingMethod === AutoNumeric.options.roundingMethod.toNearest05Alt || settings.roundingMethod === AutoNumeric.options.roundingMethod.upToNext05 || settings.roundingMethod === AutoNumeric.options.roundingMethod.downToNext05) {
                return this._roundCloseTo05(inputValue, settings);
            }

            var _AutoNumeric$_prepare = AutoNumeric._prepareValueForRounding(inputValue, settings),
                _AutoNumeric$_prepare2 = _slicedToArray(_AutoNumeric$_prepare, 2),
                negativeSign = _AutoNumeric$_prepare2[0],
                preparedValue = _AutoNumeric$_prepare2[1];

            inputValue = preparedValue;

            var decimalCharacterPosition = inputValue.lastIndexOf('.');
            var inputValueHasNoDot = decimalCharacterPosition === -1; // No dot character is found in the `inputValue`

            var _inputValue$split5 = inputValue.split('.'),
                _inputValue$split6 = _slicedToArray(_inputValue$split5, 2),
                decimalPart = _inputValue$split6[1]; // Here the decimal character is always a period '.'


            var hasDecimals = decimalPart > 0;

            // If no decimals are detected
            if (!hasDecimals && (settings.allowDecimalPadding === AutoNumeric.options.allowDecimalPadding.never || settings.allowDecimalPadding === AutoNumeric.options.allowDecimalPadding.floats)) {
                return Number(inputValue) === 0 ? inputValue : '' + negativeSign + inputValue;
            }

            // Else there are some decimal places that may need to be rounded
            // Sets the truncate zero method
            var temporaryDecimalPlacesOverride = void 0;
            if (settings.allowDecimalPadding === AutoNumeric.options.allowDecimalPadding.always || settings.allowDecimalPadding === AutoNumeric.options.allowDecimalPadding.floats) {
                temporaryDecimalPlacesOverride = decimalPlacesToRoundTo;
            } else {
                temporaryDecimalPlacesOverride = 0;
            }

            // Define the decimal position to use (use the very last position if there are no dot in the initial inputValue)
            var decimalPositionToUse = inputValueHasNoDot ? inputValue.length - 1 : decimalCharacterPosition;
            // Checks decimal places to determine if rounding is required
            var checkDecimalPlaces = inputValue.length - 1 - decimalPositionToUse;
            var inputValueRounded = '';

            // Check if no rounding is required
            if (checkDecimalPlaces <= decimalPlacesToRoundTo) {
                // Check if we need to pad with zeros
                inputValueRounded = inputValue;
                if (checkDecimalPlaces < temporaryDecimalPlacesOverride) {
                    if (inputValueHasNoDot) {
                        inputValueRounded = '' + inputValueRounded + settings.decimalCharacter;
                    }

                    var zeros = '000000'; //TODO Change that string with a longer one to prevent having to loop numerous times in the next `while` statement?
                    while (checkDecimalPlaces < temporaryDecimalPlacesOverride) {
                        zeros = zeros.substring(0, temporaryDecimalPlacesOverride - checkDecimalPlaces);
                        inputValueRounded += zeros;
                        checkDecimalPlaces += zeros.length;
                    }
                } else if (checkDecimalPlaces > temporaryDecimalPlacesOverride) {
                    inputValueRounded = this._truncateZeros(inputValueRounded, temporaryDecimalPlacesOverride);
                } else if (checkDecimalPlaces === 0 && temporaryDecimalPlacesOverride === 0) {
                    // Remove any trailing dot, if any
                    inputValueRounded = inputValueRounded.replace(/\.$/, '');
                }

                return Number(inputValueRounded) === 0 ? inputValueRounded : '' + negativeSign + inputValueRounded;
            }

            // Rounded length of the string after rounding
            var roundedStrLength = void 0;
            if (inputValueHasNoDot) {
                roundedStrLength = decimalPlacesToRoundTo - 1;
            } else {
                roundedStrLength = Number(decimalPlacesToRoundTo) + Number(decimalCharacterPosition);
            }

            var lastDigit = Number(inputValue.charAt(roundedStrLength + 1));
            var inputValueArray = inputValue.substring(0, roundedStrLength + 1).split('');
            var odd = void 0;
            if (inputValue.charAt(roundedStrLength) === '.') {
                odd = inputValue.charAt(roundedStrLength - 1) % 2;
            } else {
                odd = inputValue.charAt(roundedStrLength) % 2;
            }

            if (this._shouldRoundUp(lastDigit, settings, negativeSign, odd)) {
                // Round up the last digit if required, and continue until no more 9's are found
                for (var i = inputValueArray.length - 1; i >= 0; i -= 1) {
                    if (inputValueArray[i] !== '.') {
                        inputValueArray[i] = +inputValueArray[i] + 1;
                        if (inputValueArray[i] < 10) {
                            break;
                        }

                        if (i > 0) {
                            inputValueArray[i] = '0';
                        }
                    }
                }
            }

            // Reconstruct the string, converting any 10's to 0's
            inputValueArray = inputValueArray.slice(0, roundedStrLength + 1);

            // Return the rounded value
            inputValueRounded = this._truncateZeros(inputValueArray.join(''), temporaryDecimalPlacesOverride);

            return Number(inputValueRounded) === 0 ? inputValueRounded : '' + negativeSign + inputValueRounded;
        }

        /**
         * Round the `value` when the rounding method deals with '.05'
         *
         * @param {string} value
         * @param {object} settings
         * @returns {string}
         * @private
         */

    }, {
        key: '_roundCloseTo05',
        value: function _roundCloseTo05(value, settings) {
            switch (settings.roundingMethod) {
                case AutoNumeric.options.roundingMethod.toNearest05:
                case AutoNumeric.options.roundingMethod.toNearest05Alt:
                    value = (Math.round(value * 20) / 20).toString();
                    break;
                case AutoNumeric.options.roundingMethod.upToNext05:
                    value = (Math.ceil(value * 20) / 20).toString();
                    break;
                default:
                    value = (Math.floor(value * 20) / 20).toString();
            }

            var result = void 0;
            if (!_AutoNumericHelper2.default.contains(value, '.')) {
                result = value + '.00';
            } else if (value.length - value.indexOf('.') < 3) {
                result = value + '0';
            } else {
                result = value;
            }

            return result;
        }

        /**
         * Modify the given `value` in order to make it usable for the rest of the rounding function.
         * This convert the `value` to a positive one, trim any leading zeros and make sure it does not starts with a leading dot.
         *
         * @param {string} value The unformatted value
         * @param {object} settings
         * @returns {[string, string]}
         * @private
         */

    }, {
        key: '_prepareValueForRounding',
        value: function _prepareValueForRounding(value, settings) {
            // Checks if `inputValue` is a negative value
            var negativeSign = '';
            if (_AutoNumericHelper2.default.isNegativeStrict(value, '-')) {
                // The value being unformatted, we check for the minus sign
                negativeSign = '-';

                // Removes the negative sign that will be added back later if required
                value = value.replace('-', '');
            }

            // Append a zero if the first character is not a digit (then it is likely a dot)
            if (!value.match(/^\d/)) {
                value = '0' + value;
            }

            // Determines if the value is equal to zero. If it is, remove the negative sign
            if (Number(value) === 0) {
                negativeSign = '';
            }

            // Trims leading zero's as needed
            if (Number(value) > 0 && settings.leadingZero !== AutoNumeric.options.leadingZero.keep || value.length > 0 && settings.leadingZero === AutoNumeric.options.leadingZero.allow) {
                value = value.replace(/^0*(\d)/, '$1');
            }

            return [negativeSign, value];
        }

        /**
         * Return `true` if a round up should be done given the last digit, the settings and other information about the value.
         *
         * @param {number} lastDigit
         * @param {object} settings
         * @param {string} negativeSign This variable comes from `_prepareValueForRounding()`, which return `'-'` if the initial value was negative
         * @param {number} odd
         * @returns {boolean}
         * @private
         */

    }, {
        key: '_shouldRoundUp',
        value: function _shouldRoundUp(lastDigit, settings, negativeSign, odd) {
            return lastDigit > 4 && settings.roundingMethod === AutoNumeric.options.roundingMethod.halfUpSymmetric || // Round half up symmetric
            lastDigit > 4 && settings.roundingMethod === AutoNumeric.options.roundingMethod.halfUpAsymmetric && negativeSign === '' || // Round half up asymmetric positive values
            lastDigit > 5 && settings.roundingMethod === AutoNumeric.options.roundingMethod.halfUpAsymmetric && negativeSign === '-' || // Round half up asymmetric negative values
            lastDigit > 5 && settings.roundingMethod === AutoNumeric.options.roundingMethod.halfDownSymmetric || // Round half down symmetric
            lastDigit > 5 && settings.roundingMethod === AutoNumeric.options.roundingMethod.halfDownAsymmetric && negativeSign === '' || // Round half down asymmetric positive values
            lastDigit > 4 && settings.roundingMethod === AutoNumeric.options.roundingMethod.halfDownAsymmetric && negativeSign === '-' || // Round half down asymmetric negative values
            lastDigit > 5 && settings.roundingMethod === AutoNumeric.options.roundingMethod.halfEvenBankersRounding || lastDigit === 5 && settings.roundingMethod === AutoNumeric.options.roundingMethod.halfEvenBankersRounding && odd === 1 || lastDigit > 0 && settings.roundingMethod === AutoNumeric.options.roundingMethod.toCeilingTowardPositiveInfinity && negativeSign === '' || lastDigit > 0 && settings.roundingMethod === AutoNumeric.options.roundingMethod.toFloorTowardNegativeInfinity && negativeSign === '-' || lastDigit > 0 && settings.roundingMethod === AutoNumeric.options.roundingMethod.upRoundAwayFromZero; // Round up away from zero
        }

        /**
         * Truncates the decimal part of a number to the given number of decimal places `decimalPlacesToRoundTo`.
         *
         * @param {string} value
         * @param {object} settings
         * @param {boolean} isPaste
         * @param {int} decimalPlacesToRoundTo
         * @returns {*}
         */

    }, {
        key: '_truncateDecimalPlaces',
        value: function _truncateDecimalPlaces(value, settings, isPaste, decimalPlacesToRoundTo) {
            if (isPaste) {
                value = this._roundFormattedValueShownOnFocus(value, settings);
            }

            var _value$split = value.split(settings.decimalCharacter),
                _value$split2 = _slicedToArray(_value$split, 2),
                integerPart = _value$split2[0],
                decimalPart = _value$split2[1];

            // Truncate the decimal part to the satisfying length since we would round it anyway


            if (decimalPart && decimalPart.length > decimalPlacesToRoundTo) {
                if (decimalPlacesToRoundTo > 0) {
                    var modifiedDecimalPart = decimalPart.substring(0, decimalPlacesToRoundTo);
                    value = '' + integerPart + settings.decimalCharacter + modifiedDecimalPart;
                } else {
                    value = integerPart;
                }
            }

            return value;
        }

        /**
         * Check that the number satisfy the format conditions
         * and lays between settings.minimumValue and settings.maximumValue
         * and the string length does not exceed the digits in settings.minimumValue and settings.maximumValue
         *
         * @param {string} value
         * @param {object} settings
         * @returns {*}
         */

    }, {
        key: '_checkIfInRangeWithOverrideOption',
        value: function _checkIfInRangeWithOverrideOption(value, settings) {
            if (_AutoNumericHelper2.default.isNull(value) && settings.emptyInputBehavior === AutoNumeric.options.emptyInputBehavior.null) {
                // When the `null` value is accepted as the `rawValue`, the limits are ignored
                return [true, true];
            }

            value = value.toString();
            value = value.replace(',', '.');
            var minParse = _AutoNumericHelper2.default.parseStr(settings.minimumValue);
            var maxParse = _AutoNumericHelper2.default.parseStr(settings.maximumValue);
            var valParse = _AutoNumericHelper2.default.parseStr(value);

            var result = void 0;
            switch (settings.overrideMinMaxLimits) {
                case AutoNumeric.options.overrideMinMaxLimits.floor:
                    result = [_AutoNumericHelper2.default.testMinMax(minParse, valParse) > -1, true];
                    break;
                case AutoNumeric.options.overrideMinMaxLimits.ceiling:
                    result = [true, _AutoNumericHelper2.default.testMinMax(maxParse, valParse) < 1];
                    break;
                case AutoNumeric.options.overrideMinMaxLimits.ignore:
                    result = [true, true];
                    break;
                default:
                    result = [_AutoNumericHelper2.default.testMinMax(minParse, valParse) > -1, _AutoNumericHelper2.default.testMinMax(maxParse, valParse) < 1];
            }

            return result;
        }
    }, {
        key: '_readCookie',
        value: function _readCookie(name) {
            var nameEQ = name + '=';
            var ca = document.cookie.split(';');
            var c = '';
            for (var i = 0; i < ca.length; i += 1) {
                c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEQ) === 0) {
                    return c.substring(nameEQ.length, c.length);
                }
            }

            return null;
        }

        /**
         * Test if sessionStorage is supported.
         * This is taken from Modernizr.
         *
         * @returns {boolean}
         */

    }, {
        key: '_storageTest',
        value: function _storageTest() {
            var mod = 'modernizr';
            try {
                sessionStorage.setItem(mod, mod);
                sessionStorage.removeItem(mod);
                return true;
            } catch (e) {
                return false;
            }
        }
    }, {
        key: '_correctNegativePositiveSignPlacementOption',
        value: function _correctNegativePositiveSignPlacementOption(settings) {
            //XXX Note; this function is static since we need to pass a `settings` object when calling the static `AutoNumeric.format()` method
            // If negativePositiveSignPlacement is already set, we do not overwrite it
            if (!_AutoNumericHelper2.default.isNull(settings.negativePositiveSignPlacement)) {
                return;
            }

            if (!_AutoNumericHelper2.default.isUndefined(settings) && _AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(settings.negativePositiveSignPlacement) && !_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(settings.currencySymbol)) {
                switch (settings.currencySymbolPlacement) {
                    case AutoNumeric.options.currencySymbolPlacement.suffix:
                        settings.negativePositiveSignPlacement = AutoNumeric.options.negativePositiveSignPlacement.prefix; // Default -1,234.56 €
                        break;
                    case AutoNumeric.options.currencySymbolPlacement.prefix:
                        settings.negativePositiveSignPlacement = AutoNumeric.options.negativePositiveSignPlacement.left; // Default -$1,234.56
                        break;
                    default:
                    //
                }
            } else {
                // Sets the default value if `negativePositiveSignPlacement` is `null`
                settings.negativePositiveSignPlacement = AutoNumeric.options.negativePositiveSignPlacement.left;
            }
        }

        /**
         * Correct the `caretPositionOnFocus` and `selectOnFocus` options, since setting both leads to a conflict.
         * This method directly modifies the `options` object passed as a parameter, then returns it.
         * It returns `null` if the given option is `null`.
         *
         * @param {object} options The options passed as an argument by the user
         * @returns {object|null}
         * @private
         */

    }, {
        key: '_correctCaretPositionOnFocusAndSelectOnFocusOptions',
        value: function _correctCaretPositionOnFocusAndSelectOnFocusOptions(options) {
            if (_AutoNumericHelper2.default.isNull(options)) {
                return null;
            }

            // If the user has set the `caretPositionOnFocus` option, do not set `selectOnFocus` to `true` by default
            if (!_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(options.caretPositionOnFocus) && _AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(options.selectOnFocus)) {
                options.selectOnFocus = AutoNumeric.options.selectOnFocus.doNotSelect;
            }

            // If the user has set the `selectOnFocus` option to `true`, set `caretPositionOnFocus` to `doNoForceCaretPosition`
            if (_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(options.caretPositionOnFocus) && !_AutoNumericHelper2.default.isUndefinedOrNullOrEmpty(options.selectOnFocus) && options.selectOnFocus === AutoNumeric.options.selectOnFocus.select) {
                options.caretPositionOnFocus = AutoNumeric.options.caretPositionOnFocus.doNoForceCaretPosition;
            }

            return options;
        }

        /**
         * Calculate the number de decimal places to be used by the AutoNumeric object, for each of its state, and for its formatted and raw value.
         * By default, the `rawValue` precision is the same as the formatted value one.
         *
         * This method is called during the AutoNumeric object initialization. This assumes some internal variable state.
         *
         * This methods set the following options accordingly to their own value and the mandatory `decimalPlaces` option:
         * - decimalPlacesRawValue     (nullable)
         * - decimalPlacesShownOnBlur  (nullable)
         * - decimalPlacesShownOnFocus (nullable)
         *
         * Note: the `decimalPlaces` option is only used here and only serve to define those three previous options value.
         * AutoNumeric will then *only* use `decimalPlacesRawValue`, `decimalPlacesShownOnBlur` and `decimalPlacesShownOnFocus` from there.
         *
         * This methods directly modifies the `settings` object passed as a parameter.
         *
         * @param {object} settings This is an object with the new settings to use.
         * @private
         */

    }, {
        key: '_calculateDecimalPlacesOnInit',
        value: function _calculateDecimalPlacesOnInit(settings) {
            // Check the `decimalPlaces*` options and output any warnings as needed, before modifying those options
            this._validateDecimalPlacesRawValue(settings);

            // Initialization phase
            //XXX This assumes at this stage, `settings.decimalPlaces` as been set from the default options

            // Overwrite the `decimalPlaces*` values if the `decimalPlaces*` options are not set in the `settings`
            // Sets `decimalPlacesShownOnBlur` (previously known as `scaleDecimalPlaces`)
            if (settings.decimalPlacesShownOnFocus === AutoNumeric.options.decimalPlacesShownOnFocus.useDefault) {
                settings.decimalPlacesShownOnFocus = settings.decimalPlaces;
            }

            if (settings.decimalPlacesShownOnBlur === AutoNumeric.options.decimalPlacesShownOnBlur.useDefault) {
                settings.decimalPlacesShownOnBlur = settings.decimalPlaces;
            }

            if (settings.decimalPlacesRawValue === AutoNumeric.options.decimalPlacesRawValue.useDefault) {
                settings.decimalPlacesRawValue = settings.decimalPlaces;
            }

            // Add the additional decimal places to the raw value
            var additionalDecimalPlacesRawValue = 0;
            if (settings.rawValueDivisor && settings.rawValueDivisor !== AutoNumeric.options.rawValueDivisor.none) {
                additionalDecimalPlacesRawValue = String(settings.rawValueDivisor).length - 1; // ie. Dividing by '100' adds 2 decimal places to the needed precision
                if (additionalDecimalPlacesRawValue < 0) {
                    additionalDecimalPlacesRawValue = 0;
                }
            }

            settings.decimalPlacesRawValue = Math.max(Math.max(settings.decimalPlacesShownOnBlur, settings.decimalPlacesShownOnFocus) + additionalDecimalPlacesRawValue, Number(settings.originalDecimalPlacesRawValue) + additionalDecimalPlacesRawValue);
        }

        /**
         * Recalculate the number de decimal places to be used by the AutoNumeric object, for each of its state, and for its formatted and raw value.
         * By default, the `rawValue` precision is the same as the formatted value one.
         *
         * This method is close to the one called during initialization, `_calculateDecimalPlacesOnInit()`, but with slight difference so that the `decimalPlaces*` options are correctly updated as needed.
         *
         * This methods set the following options accordingly to their own value and the mandatory `decimalPlaces` option:
         * - decimalPlacesRawValue     (nullable)
         * - decimalPlacesShownOnBlur  (nullable)
         * - decimalPlacesShownOnFocus (nullable)
         *
         * Note: the `decimalPlaces` option is only used here and only serve to define those three previous options value.
         * AutoNumeric will then *only* use `decimalPlacesRawValue`, `decimalPlacesShownOnBlur` and `decimalPlacesShownOnFocus` from there.
         *
         * This methods directly modifies the `settings` object passed as a parameter.
         *
         * @param {object} settings This is an object with the new settings to use.
         * @param {object} currentSettings This is the current settings (`this.settings`) used by the element.
         * @private
         */

    }, {
        key: '_calculateDecimalPlacesOnUpdate',
        value: function _calculateDecimalPlacesOnUpdate(settings) {
            var currentSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            // Check the `decimalPlaces*` options and output any warnings as needed, before modifying those options
            this._validateDecimalPlacesRawValue(settings);

            // Update phase
            if (_AutoNumericHelper2.default.isNull(currentSettings)) {
                _AutoNumericHelper2.default.throwError('When updating the settings, the previous ones should be passed as an argument.');
            }

            var decimalPlacesInOptions = 'decimalPlaces' in settings;
            if (!(decimalPlacesInOptions || 'decimalPlacesRawValue' in settings || 'decimalPlacesShownOnFocus' in settings || 'decimalPlacesShownOnBlur' in settings || 'rawValueDivisor' in settings)) {
                // Do Nothing if no decimal places-related options are modified
                return;
            }

            // Overwrite the `decimalPlaces*` values if the `decimalPlaces*` options are not set in the `settings`
            if (decimalPlacesInOptions) {
                if (!('decimalPlacesShownOnFocus' in settings) || settings.decimalPlacesShownOnFocus === AutoNumeric.options.decimalPlacesShownOnFocus.useDefault) {
                    settings.decimalPlacesShownOnFocus = settings.decimalPlaces;
                }

                if (!('decimalPlacesShownOnBlur' in settings) || settings.decimalPlacesShownOnBlur === AutoNumeric.options.decimalPlacesShownOnBlur.useDefault) {
                    settings.decimalPlacesShownOnBlur = settings.decimalPlaces;
                }

                if (!('decimalPlacesRawValue' in settings) || settings.decimalPlacesRawValue === AutoNumeric.options.decimalPlacesRawValue.useDefault) {
                    settings.decimalPlacesRawValue = settings.decimalPlaces;
                }
            } else {
                if (_AutoNumericHelper2.default.isUndefined(settings.decimalPlacesShownOnFocus)) {
                    settings.decimalPlacesShownOnFocus = currentSettings.decimalPlacesShownOnFocus;
                }

                if (_AutoNumericHelper2.default.isUndefined(settings.decimalPlacesShownOnBlur)) {
                    settings.decimalPlacesShownOnBlur = currentSettings.decimalPlacesShownOnBlur;
                }
            }

            // Add the additional decimal places to the raw value
            var additionalDecimalPlacesRawValue = 0;
            if (settings.rawValueDivisor && settings.rawValueDivisor !== AutoNumeric.options.rawValueDivisor.none) {
                additionalDecimalPlacesRawValue = String(settings.rawValueDivisor).length - 1; // ie. Dividing by '100' adds 2 decimal places to the needed precision
                if (additionalDecimalPlacesRawValue < 0) {
                    additionalDecimalPlacesRawValue = 0;
                }
            }

            if (!settings.decimalPlaces && !settings.decimalPlacesRawValue) {
                settings.decimalPlacesRawValue = Math.max(Math.max(settings.decimalPlacesShownOnBlur, settings.decimalPlacesShownOnFocus) + additionalDecimalPlacesRawValue, Number(currentSettings.originalDecimalPlacesRawValue) + additionalDecimalPlacesRawValue);
            } else {
                settings.decimalPlacesRawValue = Math.max(Math.max(settings.decimalPlacesShownOnBlur, settings.decimalPlacesShownOnFocus) + additionalDecimalPlacesRawValue, Number(settings.decimalPlacesRawValue) + additionalDecimalPlacesRawValue);
            }
        }
    }, {
        key: '_cachesUsualRegularExpressions',
        value: function _cachesUsualRegularExpressions(settings, regex) {
            // Test if there is a negative character in the string
            var negativeSignReg = void 0;
            if (settings.negativeSignCharacter !== AutoNumeric.options.negativeSignCharacter.hyphen) {
                negativeSignReg = '([-\\' + settings.negativeSignCharacter + ']?)';
            } else {
                negativeSignReg = '(-?)';
            }

            regex.aNegRegAutoStrip = negativeSignReg;
            settings.allowedAutoStrip = new RegExp('[^-0123456789\\' + settings.decimalCharacter + ']', 'g');
            settings.numRegAutoStrip = new RegExp(negativeSignReg + '(?:\\' + settings.decimalCharacter + '?([0-9]+\\' + settings.decimalCharacter + '[0-9]+)|([0-9]*(?:\\' + settings.decimalCharacter + '[0-9]*)?))');

            // Using this regex version `^${regex.aNegRegAutoStrip}0*(\\d|$)` entirely clear the input on blur
            settings.stripReg = new RegExp('^' + regex.aNegRegAutoStrip + '0*([0-9])');

            // All the characters that are accepted during the formula mode
            settings.formulaChars = new RegExp('[0-9' + settings.decimalCharacter + '+\\-*/() ]');
        }
    }, {
        key: '_convertOldOptionsToNewOnes',
        value: function _convertOldOptionsToNewOnes(options) {
            //TODO Delete this function once the old options are not used anymore
            var oldOptionsConverter = {
                // Old option names, with their corresponding new names
                aSep: 'digitGroupSeparator',
                nSep: 'showOnlyNumbersOnFocus',
                dGroup: 'digitalGroupSpacing',
                aDec: 'decimalCharacter',
                altDec: 'decimalCharacterAlternative',
                aSign: 'currencySymbol',
                pSign: 'currencySymbolPlacement',
                pNeg: 'negativePositiveSignPlacement',
                aSuffix: 'suffixText',
                oLimits: 'overrideMinMaxLimits',
                vMax: 'maximumValue',
                vMin: 'minimumValue',
                mDec: 'decimalPlacesOverride',
                eDec: 'decimalPlacesShownOnFocus',
                scaleDecimal: 'decimalPlacesShownOnBlur',
                aStor: 'saveValueToSessionStorage',
                mRound: 'roundingMethod',
                aPad: 'allowDecimalPadding',
                nBracket: 'negativeBracketsTypeOnBlur',
                wEmpty: 'emptyInputBehavior',
                lZero: 'leadingZero',
                aForm: 'formatOnPageLoad',
                sNumber: 'selectNumberOnly',
                anDefault: 'defaultValueOverride',
                unSetOnSubmit: 'unformatOnSubmit',
                outputType: 'outputFormat',
                debug: 'showWarnings',

                // Current options :
                allowDecimalPadding: true,
                alwaysAllowDecimalCharacter: true,
                caretPositionOnFocus: true,
                createLocalList: true,
                currencySymbol: true,
                currencySymbolPlacement: true,
                decimalCharacter: true,
                decimalCharacterAlternative: true,
                decimalPlaces: true,
                decimalPlacesRawValue: true,
                decimalPlacesShownOnBlur: true,
                decimalPlacesShownOnFocus: true,
                defaultValueOverride: true,
                digitalGroupSpacing: true,
                digitGroupSeparator: true,
                divisorWhenUnfocused: true,
                emptyInputBehavior: true,
                eventBubbles: true,
                eventIsCancelable: true,
                failOnUnknownOption: true,
                formatOnPageLoad: true,
                formulaMode: true,
                historySize: true,
                isCancellable: true,
                leadingZero: true,
                maximumValue: true,
                minimumValue: true,
                modifyValueOnWheel: true,
                negativeBracketsTypeOnBlur: true,
                negativePositiveSignPlacement: true,
                negativeSignCharacter: true,
                noEventListeners: true,
                onInvalidPaste: true,
                outputFormat: true,
                overrideMinMaxLimits: true,
                positiveSignCharacter: true,
                rawValueDivisor: true,
                readOnly: true,
                roundingMethod: true,
                saveValueToSessionStorage: true,
                selectNumberOnly: true,
                selectOnFocus: true,
                serializeSpaces: true,
                showOnlyNumbersOnFocus: true,
                showPositiveSign: true,
                showWarnings: true,
                styleRules: true,
                suffixText: true,
                symbolWhenUnfocused: true,
                unformatOnHover: true,
                unformatOnSubmit: true,
                valuesToStrings: true,
                watchExternalChanges: true,
                wheelOn: true,
                wheelStep: true,

                // Additional information that are added to the `settings` object :
                //TODO Find a way to exclude those internal data from the settings object (ideally by using another object, or better yet, class attributes) -->
                allowedAutoStrip: true,
                formulaChars: true,
                isNegativeSignAllowed: true,
                isPositiveSignAllowed: true,
                mIntNeg: true,
                mIntPos: true,
                numRegAutoStrip: true,
                originalDecimalPlaces: true,
                originalDecimalPlacesRawValue: true,
                stripReg: true
            };

            for (var option in options) {
                if (options.hasOwnProperty(option)) {
                    if (oldOptionsConverter[option] === true) {
                        // If the option is a 'new' option, we continue looping
                        continue;
                    }

                    if (oldOptionsConverter.hasOwnProperty(option)) {
                        // Else we have an 'old' option name
                        _AutoNumericHelper2.default.warning('You are using the deprecated option name \'' + option + '\'. Please use \'' + oldOptionsConverter[option] + '\' instead from now on. The old option name will be dropped very soon\u2122.', true);

                        // Then we modify the initial option object to use the new options instead of the old ones
                        options[oldOptionsConverter[option]] = options[option];
                        delete options[option];
                    } else if (options.failOnUnknownOption) {
                        // ...or the option name is unknown. This means there is a problem with the options object, therefore we throw an error.
                        _AutoNumericHelper2.default.throwError('Option name \'' + option + '\' is unknown. Please fix the options passed to autoNumeric');
                    }
                }
            }

            if ('mDec' in options) {
                _AutoNumericHelper2.default.warning('The old `mDec` option has been deprecated in favor of more accurate options ; `decimalPlaces`, `decimalPlacesRawValue`, `decimalPlacesShownOnFocus` and `decimalPlacesShownOnBlur`.', true);
            }
        }
    }, {
        key: '_setNegativePositiveSignPermissions',
        value: function _setNegativePositiveSignPermissions(settings) {
            settings.isNegativeSignAllowed = settings.minimumValue < 0;
            settings.isPositiveSignAllowed = settings.maximumValue >= 0;
        }

        /**
         * Convert the `value` parameter that can either be :
         * - a real number,
         * - a number represented in the scientific notation (ie. -123.4567e-6)
         * - a string representing a real number, or
         * - a string representing a localized number (with specific group separators and decimal character),
         * ...to a string representing a real 'javascript' number (ie. '1234' or '1234.567').
         *
         * This function returns `NaN` if such conversion fails.
         *
         * @param {int|float|string} value
         * @param {object} settings
         * @returns {string|NaN}
         */

    }, {
        key: '_toNumericValue',
        value: function _toNumericValue(value, settings) {
            //XXX Note; this function is static since we need to pass a `settings` object when calling the static `AutoNumeric.format()` method
            var result = void 0;
            if (_AutoNumericHelper2.default.isNumber(Number(value))) {
                // The value has either already been stripped, or a 'real' javascript number is passed as a parameter
                result = _AutoNumericHelper2.default.scientificToDecimal(value);
            } else {
                // Else if it's a string that `Number()` cannot typecast, then we try to convert the localized numeric string to a numeric one
                // Convert the value to a numeric string, stripping unnecessary characters in the process
                result = this._convertToNumericString(value.toString(), settings);

                // If the result is still not a numeric string, then we throw a warning
                if (!_AutoNumericHelper2.default.isNumber(Number(result))) {
                    _AutoNumericHelper2.default.warning('The given value "' + value + '" cannot be converted to a numeric one and therefore cannot be used appropriately.', settings.showWarnings);
                    result = NaN;
                }
            }

            return result;
        }
    }, {
        key: '_checkIfInRange',
        value: function _checkIfInRange(value, parsedMinValue, parsedMaxValue) {
            var parsedValue = _AutoNumericHelper2.default.parseStr(value);
            return _AutoNumericHelper2.default.testMinMax(parsedMinValue, parsedValue) > -1 && _AutoNumericHelper2.default.testMinMax(parsedMaxValue, parsedValue) < 1;
        }
    }, {
        key: '_shouldSkipEventKey',
        value: function _shouldSkipEventKey(eventKeyName) {
            var isFnKeys = _AutoNumericHelper2.default.isInArray(eventKeyName, _AutoNumericEnum2.default.keyName._allFnKeys);
            var isOSKeys = eventKeyName === _AutoNumericEnum2.default.keyName.OSLeft || eventKeyName === _AutoNumericEnum2.default.keyName.OSRight;
            var isContextMenu = eventKeyName === _AutoNumericEnum2.default.keyName.ContextMenu;
            var isSomeNonPrintableKeys = _AutoNumericHelper2.default.isInArray(eventKeyName, _AutoNumericEnum2.default.keyName._someNonPrintableKeys);
            var isOtherNonPrintableKeys = eventKeyName === _AutoNumericEnum2.default.keyName.NumLock || eventKeyName === _AutoNumericEnum2.default.keyName.ScrollLock || eventKeyName === _AutoNumericEnum2.default.keyName.Insert || eventKeyName === _AutoNumericEnum2.default.keyName.Command;
            var isUnrecognizableKeys = eventKeyName === _AutoNumericEnum2.default.keyName.Unidentified;

            return isFnKeys || isOSKeys || isContextMenu || isSomeNonPrintableKeys || isUnrecognizableKeys || isOtherNonPrintableKeys;
        }
    }, {
        key: '_serialize',
        value: function _serialize(form) {
            var intoAnArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var formatType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unformatted';

            var _this15 = this;

            var serializedSpaceCharacter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '+';
            var forcedOutputFormat = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

            var result = [];

            if ((typeof form === 'undefined' ? 'undefined' : _typeof(form)) === 'object' && form.nodeName.toLowerCase() === 'form') {
                Array.prototype.slice.call(form.elements).forEach(function (element) {
                    if (element.name && !element.disabled && ['file', 'reset', 'submit', 'button'].indexOf(element.type) === -1) {
                        if (element.type === 'select-multiple') {
                            Array.prototype.slice.call(element.options).forEach(function (option) {
                                if (option.selected) {
                                    //TODO Should we unformat/format/localize the selection option (which be default should be read-only)?
                                    if (intoAnArray) {
                                        result.push({ name: element.name, value: option.value });
                                    } else {
                                        // into a string
                                        result.push(encodeURIComponent(element.name) + '=' + encodeURIComponent(option.value));
                                    }
                                }
                            });
                        } else if (['checkbox', 'radio'].indexOf(element.type) === -1 || element.checked) {
                            var valueResult = void 0;
                            if (_this15.isManagedByAutoNumeric(element)) {
                                var anObject = void 0;
                                switch (formatType) {
                                    case 'unformatted':
                                        anObject = _this15.getAutoNumericElement(element);
                                        if (!_AutoNumericHelper2.default.isNull(anObject)) {
                                            valueResult = _this15.unformat(element, anObject.getSettings());
                                        }

                                        break;
                                    case 'localized':
                                        anObject = _this15.getAutoNumericElement(element);
                                        if (!_AutoNumericHelper2.default.isNull(anObject)) {
                                            // Here I need to clone the setting object, otherwise I would modify it when changing the `outputFormat` option value
                                            var currentSettings = _AutoNumericHelper2.default.cloneObject(anObject.getSettings());
                                            if (!_AutoNumericHelper2.default.isNull(forcedOutputFormat)) {
                                                currentSettings.outputFormat = forcedOutputFormat;
                                            }

                                            valueResult = _this15.localize(element, currentSettings);
                                        }

                                        break;
                                    case 'formatted':
                                    default:
                                        valueResult = element.value;
                                }
                            } else {
                                valueResult = element.value;
                            }

                            if (_AutoNumericHelper2.default.isUndefined(valueResult)) {
                                _AutoNumericHelper2.default.throwError('This error should never be hit. If it has, something really wrong happened!');
                            }

                            if (intoAnArray) {
                                result.push({ name: element.name, value: valueResult });
                            } else {
                                // into a string
                                result.push(encodeURIComponent(element.name) + '=' + encodeURIComponent(valueResult));
                            }
                        }
                    }
                });
            }

            var finalResult = void 0;

            if (intoAnArray) {
                // Result as an Array
                // Note: `serializedSpaceCharacter` does not affect the array result since we do not change the space character for this one
                finalResult = result;
            } else {
                // Result as a string
                finalResult = result.join('&');

                if ('+' === serializedSpaceCharacter) {
                    finalResult = finalResult.replace(/%20/g, '+');
                }
            }

            return finalResult;
        }

        /**
         * Serialize the form values to a string, outputting numeric strings for each AutoNumeric-managed element values.
         *
         * @param {HTMLFormElement} form
         * @param {string} serializedSpaceCharacter
         * @returns {string}
         */

    }, {
        key: '_serializeNumericString',
        value: function _serializeNumericString(form) {
            var serializedSpaceCharacter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '+';

            return this._serialize(form, false, 'unformatted', serializedSpaceCharacter);
        }

        /**
         * Serialize the form values to a string, outputting the formatted value as strings for each AutoNumeric-managed elements.
         *
         * @param {HTMLFormElement} form
         * @param {string} serializedSpaceCharacter
         * @returns {string}
         */

    }, {
        key: '_serializeFormatted',
        value: function _serializeFormatted(form) {
            var serializedSpaceCharacter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '+';

            return this._serialize(form, false, 'formatted', serializedSpaceCharacter);
        }

        /**
         * Serialize the form values to a string, outputting localized strings for each AutoNumeric-managed element values.
         *
         * @param {HTMLFormElement} form
         * @param {string} serializedSpaceCharacter
         * @param {string|null} forcedOutputFormat If set, then this is the format that is used for the localization, instead of the default `outputFormat` option.
         * @returns {string}
         */

    }, {
        key: '_serializeLocalized',
        value: function _serializeLocalized(form) {
            var serializedSpaceCharacter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '+';
            var forcedOutputFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return this._serialize(form, false, 'localized', serializedSpaceCharacter, forcedOutputFormat);
        }

        /**
         * Generate an Array with the form values, outputting numeric strings for each AutoNumeric-managed element values.
         *
         * @param {HTMLFormElement} form
         * @param {string} serializedSpaceCharacter
         * @returns {Array}
         */

    }, {
        key: '_serializeNumericStringArray',
        value: function _serializeNumericStringArray(form) {
            var serializedSpaceCharacter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '+';

            return this._serialize(form, true, 'unformatted', serializedSpaceCharacter);
        }

        /**
         * Generate an Array with the form values, outputting the formatted value as strings for each AutoNumeric-managed elements.
         *
         * @param {HTMLFormElement} form
         * @param {string} serializedSpaceCharacter
         * @returns {Array}
         */

    }, {
        key: '_serializeFormattedArray',
        value: function _serializeFormattedArray(form) {
            var serializedSpaceCharacter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '+';

            return this._serialize(form, true, 'formatted', serializedSpaceCharacter);
        }

        /**
         * Generate an Array with the form values, outputting localized strings for each AutoNumeric-managed element values.
         *
         * @param {HTMLFormElement} form
         * @param {string} serializedSpaceCharacter
         * @param {string|null} forcedOutputFormat If set, then this is the format that is used for the localization, instead of the default `outputFormat` option.
         * @returns {Array}
         */

    }, {
        key: '_serializeLocalizedArray',
        value: function _serializeLocalizedArray(form) {
            var serializedSpaceCharacter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '+';
            var forcedOutputFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return this._serialize(form, true, 'localized', serializedSpaceCharacter, forcedOutputFormat);
        }
    }]);

    return AutoNumeric;
}();

/**
 * Initialize multiple DOM elements in one call (and possibly pass multiple values that will be mapped to each DOM element).
 *
 * @example
 * // Init multiple DOM elements in one call (and possibly pass multiple values that will be mapped to each DOM element)
 * [anElement1, anElement2, anElement3] = AutoNumeric.multiple([domElement1, domElement2, domElement3], { options });
 * [anElement1, anElement2, anElement3] = AutoNumeric.multiple([domElement1, domElement2, domElement3], [{ options }, 'euroPos']);
 * [anElement1, anElement2, anElement3] = AutoNumeric.multiple([domElement1, domElement2, domElement3], 12345.789, { options });
 * [anElement1, anElement2, anElement3] = AutoNumeric.multiple([domElement1, domElement2, domElement3], 12345.789, [{ options }, 'euroPos']);
 * [anElement1, anElement2, anElement3] = AutoNumeric.multiple.french([domElement1, domElement2, domElement3], [12345.789, 234.78, null], { options });
 * [anElement1, anElement2, anElement3] = AutoNumeric.multiple.french([domElement1, domElement2, domElement3], [12345.789, 234.78, null], [{ options }, 'euroPos']);
 *
 * // Special case, if a <form> element is passed (or any other 'parent' (or 'root') DOM element), then autoNumeric will initialize each child `<input>` elements recursively, ignoring those referenced in the `exclude` attribute
 * [anElement1, anElement2] = AutoNumeric.multiple({ rootElement: formElement }, { options });
 * [anElement1, anElement2] = AutoNumeric.multiple({ rootElement: formElement, exclude : [hiddenElement, tokenElement] }, { options });
 * [anElement1, anElement2] = AutoNumeric.multiple({ rootElement: formElement, exclude : [hiddenElement, tokenElement] }, [12345.789, null], { options });
 *
 * // If you want to select multiple elements via a css selector, then you must use the `multiple` function. Under the hood `QuerySelectorAll` is used.
 * [anElement1, anElement2] = AutoNumeric.multiple('.myCssClass > input', { options }); // This always return an Array, even if there is only one element selected
 * [anElement1, anElement2] = AutoNumeric.multiple('.myCssClass > input', [null, 12345.789], { options }); // Idem above, but with passing the initial values too
 *
 * @param {string|Array|{ rootElement: HTMLElement }|{ rootElement: HTMLElement, exclude: Array<HTMLInputElement>}} arg1
 * @param {number|Array|object|null} initialValue
 * @param {object|Array|null} options
 * @returns {Array}
 */


exports.default = AutoNumeric;
AutoNumeric.multiple = function (arg1) {
    var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var result = [];

    // Analyze the arguments and transform them to make them exploitable
    if (_AutoNumericHelper2.default.isObject(initialValue)) {
        // If the user gave an option object as the second argument, instead of the initial values
        options = initialValue;
        initialValue = null;
    }

    if (_AutoNumericHelper2.default.isString(arg1)) {
        arg1 = [].concat(_toConsumableArray(document.querySelectorAll(arg1))); // Convert a NodeList to an Array (cf. http://stackoverflow.com/a/37297292/2834898)
    } else if (_AutoNumericHelper2.default.isObject(arg1)) {
        if (!arg1.hasOwnProperty('rootElement')) {
            _AutoNumericHelper2.default.throwError('The object passed to the \'multiple\' function is invalid ; no \'rootElement\' attribute found.');
        }

        // Retrieve the DOM element list from the given <form> element
        var elements = [].concat(_toConsumableArray(arg1.rootElement.querySelectorAll('input')));
        if (arg1.hasOwnProperty('exclude')) {
            if (!Array.isArray(arg1.exclude)) {
                _AutoNumericHelper2.default.throwError('The \'exclude\' array passed to the \'multiple\' function is invalid.');
            }

            // Filter out the excluded elements
            arg1 = _AutoNumericHelper2.default.filterOut(elements, arg1.exclude);
        } else {
            arg1 = elements;
        }
    } else if (!_AutoNumericHelper2.default.isArray(arg1)) {
        _AutoNumericHelper2.default.throwError('The given parameters to the \'multiple\' function are invalid.');
    }

    if (arg1.length === 0) {
        var showWarnings = true;
        if (!_AutoNumericHelper2.default.isNull(options) && _AutoNumericHelper2.default.isBoolean(options.showWarnings)) {
            showWarnings = options.showWarnings;
        }

        _AutoNumericHelper2.default.warning('No valid DOM elements were given hence no AutoNumeric object were instantiated.', showWarnings);

        return [];
    }

    // At this point, we know `arg1` is an array of DOM elements

    // This function can be initialized with two types of array, one for the initial values, and/or one for the options.
    // So we need to find out if an array is detected if the user passed an array of initial values, or an array of options
    // Therefore, we analyze the content of the arrays for the second and third arguments
    // ...for the second parameter :
    var isInitialValueArray = _AutoNumericHelper2.default.isArray(initialValue);
    var isInitialValueArrayAndNotEmpty = isInitialValueArray && initialValue.length >= 1;
    var secondArgumentIsInitialValueArray = false;
    var secondArgumentIsOptionArray = false;
    // Any of the arrays can be either an array of initial values, or an array of option object/pre-defined option names
    if (isInitialValueArrayAndNotEmpty) {
        var typeOfFirstArrayElement = _typeof(Number(initialValue[0]));
        // First we test the second argument
        secondArgumentIsInitialValueArray = typeOfFirstArrayElement === 'number' && !isNaN(Number(initialValue[0]));

        if (!secondArgumentIsInitialValueArray) {
            // If the second argument is an array, but not an array of values, check if it's instead an array of options/pre-defined option names
            if (typeOfFirstArrayElement === 'string' || isNaN(typeOfFirstArrayElement) || typeOfFirstArrayElement === 'object') {
                secondArgumentIsOptionArray = true;
            }
        }
    }

    // ...for the third parameter :
    var isOptionsArrayAndNotEmpty = _AutoNumericHelper2.default.isArray(options) && options.length >= 1;
    var thirdArgumentIsOptionArray = false;
    if (isOptionsArrayAndNotEmpty) {
        var _typeOfFirstArrayElement = _typeof(options[0]);
        if (_typeOfFirstArrayElement === 'string' || _typeOfFirstArrayElement === 'object') {
            // If the third argument is an array of options/pre-defined option names
            thirdArgumentIsOptionArray = true;
        }
    }

    // Depending of our findings, we generate the options variable to use `optionsToUse`, either directly, or merged
    var optionsToUse = void 0;
    if (secondArgumentIsOptionArray) {
        optionsToUse = AutoNumeric.mergeOptions(initialValue);
    } else if (thirdArgumentIsOptionArray) {
        optionsToUse = AutoNumeric.mergeOptions(options);
    } else {
        optionsToUse = options;
    }

    // Initialize the initial values
    var isInitialValueNumber = _AutoNumericHelper2.default.isNumber(initialValue);
    var initialValueArraySize = void 0;
    if (secondArgumentIsInitialValueArray) {
        initialValueArraySize = initialValue.length;
    }

    // Instantiate each AutoNumeric objects
    arg1.forEach(function (domElement, index) {
        if (isInitialValueNumber) {
            // We set the same value for each elements
            result.push(new AutoNumeric(domElement, initialValue, optionsToUse));
        } else if (secondArgumentIsInitialValueArray && index <= initialValueArraySize) {
            result.push(new AutoNumeric(domElement, initialValue[index], optionsToUse));
        } else {
            result.push(new AutoNumeric(domElement, null, optionsToUse));
        }
    });

    return result;
};

/**
 * Polyfill for obsolete browsers like IE
 */
(function () {
    // Polyfill for `Array.from()` (Fix issue #495)
    if (!Array.from) {
        Array.from = function (object) {
            return [].slice.call(object);
        };
    }

    // Polyfill for `CustomEvent` (cf. https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent)
    if (typeof window === 'undefined' || typeof window.CustomEvent === 'function') {
        return false;
    }

    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: void 0 };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
})();
module.exports = exports['default'];